// src/components/gex-module/gex-module.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment BundleItemsFragment on ExperienceBundles {\n    calculationDescription\n    header {\n      icon {\n        id\n        theme\n        token\n      }\n      impressionAnalytics {\n        event\n        referrerId\n      }\n      label\n      subText\n      text\n    }\n    scoreExplainer\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment GexPopoverFragment on ExperienceScoreDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      message\n    }\n    content {\n      text\n      contents {\n        text\n      }\n    }\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment GexExperienceScoreDetailsFragment on ExperienceScore {\n    experienceScoreDetails {\n      header {\n        impressionAnalytics {\n          event\n          referrerId\n        }\n        label\n        subText\n        text\n      }\n      seeMoreAction {\n        ...GexPopoverFragment\n      }\n    }\n    bundledScore {\n      bundles {\n        ...BundleItemsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment GexExperienceScoreReviewFragment on PropertyReviews {\n    summary {\n      averageOverallRating {\n        formatted\n      }\n      superlative\n      overallScoreWithDescriptionA11y {\n        value\n      }\n      propertyReviewCountDetails {\n        shortDescription\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  query GexModuleQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    experienceScoreReview(context: $context, propertyId: $propertyId, searchCriteria: $searchCriteria) {\n      ...GexExperienceScoreReviewFragment\n    }\n    experienceScore(context: $context, propertyId: $propertyId, searchCriteria: $searchCriteria, shoppingContext: $shoppingContext) {\n      ...GexExperienceScoreDetailsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment DynamicMapFragment on EGDSBasicMap {\n    label\n    initialViewport\n    center {\n      latitude\n      longitude\n    }\n    zoom\n    bounds {\n      northeast {\n        latitude\n        longitude\n      }\n      southwest {\n        latitude\n        longitude\n      }\n    }\n    computedBoundsOptions {\n      coordinates {\n        latitude\n        longitude\n      }\n      gaiaId\n      lowerQuantile\n      upperQuantile\n      marginMultiplier\n      minMargin\n      minimumPins\n      interpolationRatio\n    }\n    config {\n      ... on EGDSDynamicMapConfig {\n        accessToken\n        egdsMapProvider\n        externalConfigEndpoint {\n          value\n        }\n        mapId\n      }\n    }\n    markers {\n      ... on EGDSMapFeature {\n        id\n        description\n        markerPosition {\n          latitude\n          longitude\n        }\n        type\n        markerStatus\n        qualifiers\n        text\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        onSelectAccessibilityMessage\n        onEnterAccessibilityMessage\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MapCardContentFragment on EGDSImageCard {\n    id\n    title\n    subTitle\n    description\n    image {\n      aspectRatio\n      description\n      thumbnailClickAnalytics {\n        eventType\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      url\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlaceDisplayFragment on PlacesDialog {\n    placesDialogEGDSTextsContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      clearSavedPlaceIcon {\n        id\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlacesTypeaheadFragment on PlacesDialogTypeAheadContentSection {\n    content {\n      label\n      placeholder\n      renderType\n      typeaheadPlaceholder\n      typeaheadEmptyResultPlaceholder\n      typeaheadInfo {\n        client\n        regionType\n        isDestination\n        maxNumberOfResults\n        personalize\n        lineOfBusiness\n        packageType\n        typeaheadFeatures\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlacesSearchFragment on PlacesDialog {\n    placesDialogTypeAheadContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      ...PlacesTypeaheadFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSSwitchFragment on UIToggle {\n    checked\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    checkedLabel\n    enabled\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedLabel\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlacesSwitchesFragment on PlacesDialog {\n    placesDialogUITogglesContentSection {\n      subHeading {\n        text\n      }\n      content {\n        ...LodgingEGDSSwitchFragment\n        ... on FilterOption {\n          filteredValues\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlacesDialogFragment on PlacesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        closeText\n      }\n    }\n    trigger {\n      icon {\n        description\n        token\n      }\n      disabled\n    }\n    ...PlacesSearchFragment\n    ...PlaceDisplayFragment\n    ...PlacesSwitchesFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MapActionsFragment on PropertyInfoMap {\n    callToAction {\n      action {\n        targetRef\n      }\n      button {\n        primary\n      }\n      event {\n        eventName\n        eventType\n        eventVersion\n      }\n    }\n    dialogs {\n      ...PlacesDialogFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  query MapQuery($context: ContextInput!, $propertyId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      summary {\n        map {\n          egdsBasicMap {\n            ...DynamicMapFragment\n          }\n          mapInfoCards {\n            ...MapCardContentFragment\n          }\n          toolbar {\n            title\n            icon {\n              description\n            }\n          }\n          ...MapActionsFragment\n        }\n        location {\n          coordinates {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemGraphicsFragment on PropertyContentItemGraphics {\n    graphics {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemImagesFragment on PropertyContentItemImages {\n    contents {\n      image {\n        description\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemMarkupFragment on PropertyContentItemMarkup {\n    content {\n      text\n      markupType\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemTextFragment on PropertyContentItemText {\n    content {\n      primary {\n        value\n        icon {\n          iconId: id\n        }\n        egdsMark {\n          description\n          url {\n            value\n          }\n        }\n        state\n        subtexts\n      }\n      secondary {\n        value\n      }\n    }\n    expando {\n      expandedLabel\n      collapsedLabel\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemTextsFragment on PropertyContentItemTexts {\n    contents {\n      primary {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SectionHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      iconId: id\n      description\n    }\n    headerImage {\n      description\n      url\n    }\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentFragment on PropertyContent {\n    maxColumns\n    header {\n      ...SectionHeaderFragment\n    }\n    expando {\n      expandButton {\n        text\n      }\n      collapseButton {\n        text\n      }\n    }\n    items {\n      __typename\n      ...PropertyContentItemGraphicsFragment\n      ...PropertyContentItemImagesFragment\n      ...PropertyContentItemMarkupFragment\n      ...PropertyContentItemTextFragment\n      ...PropertyContentItemTextsFragment\n    }\n\n    structuredData {\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSectionDetailedDialogFragment on PropertyContentSectionDetailedDialog {\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n          closeText\n        }\n        closeAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    trigger {\n      message\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSectionDialogFragment on PropertyContentSectionDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      message\n    }\n    content {\n      contents {\n        ... on EGDSParagraph {\n          text\n        }\n        ... on EGDSPlainText {\n          text\n        }\n        ... on EGDSInlineLink {\n          text\n          action {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            target\n          }\n        }\n      }\n    }\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSectionActionFragment on PropertyContentSectionAction {\n    ... on PropertyContentSectionDialog {\n      ...PropertyContentSectionDialogFragment\n    }\n    ... on PropertyContentSectionDetailedDialog {\n      ...PropertyContentSectionDetailedDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...IconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n      ... on HttpURI {\n        relativePath\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    heading\n    background\n    rightIcon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    buttons {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentItemCardFragment on EGDSStandardMessagingCard {\n    ...EGDSStandardMessagingCardFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentElementGroupFragment on PropertyContentElementGroup {\n    elements {\n      ... on PropertyContent {\n        ...PropertyContentFragment\n      }\n      ... on EGDSStandardMessagingCard {\n        ...EGDSStandardMessagingCardFragment\n      }\n    }\n    maxColumns\n  }\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSubSectionFragment on PropertyContentSubSection {\n    header {\n      ...SectionHeaderFragment\n    }\n    elementsV2 {\n      ...PropertyContentElementGroupFragment\n    }\n    expando {\n      expandButton {\n        text\n      }\n      collapseButton {\n        text\n      }\n    }\n    maxColumns\n  }\n\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSectionFragment on PropertyContentSection {\n    sectionName\n    header {\n      ...SectionHeaderFragment\n    }\n    bodySubSections {\n      ...PropertyContentSubSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyContentSectionGroupFragment on PropertyContentSectionGroup {\n    expando {\n      collapseButton {\n        text\n      }\n      expandButton {\n        text\n      }\n    }\n    sectionName\n    sections {\n      ...PropertyContentSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CleanlinessFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria) {\n      cleanliness {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyCleanlinessQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      ...CleanlinessFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PointOfInterestFragment on PointOfInterest {\n    title\n    subtitle\n    poiContent {\n      description\n      image {\n        url\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyDetailsMapQuery($context: ContextInput!, $propertyId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      summary {\n        map {\n          egdsBasicMap {\n            config {\n              ... on EGDSDynamicMapConfig {\n                mapId\n              }\n            }\n          }\n          bounds {\n            northeast {\n              latitude\n              longitude\n            }\n            southwest {\n              latitude\n              longitude\n            }\n          }\n          markers {\n            ... on PointOfInterest {\n              markerId: id\n              mapMarker {\n                icon\n                latLong {\n                  latitude\n                  longitude\n                }\n              }\n              ...PointOfInterestFragment\n            }\n          }\n          toolbar {\n            title\n            icon {\n              description\n            }\n          }\n          zoom\n          ...MapActionsFragment\n        }\n        location {\n          coordinates {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n  fragment GalleryButtonsFragment on PropertyImageGallery {\n    galleryButtons {\n      accessibility\n      icon {\n        description\n        id\n      }\n      action {\n        accessibility\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CarouselContainerFragment on PropertyImageGallery {\n    label\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      lowResImage {\n        url\n      }\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyImageFragment on PropertyImage {\n    alt\n    image {\n      url\n      description\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    lowResImage {\n      url\n    }\n  }\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MosaicContainerFragment on PropertyImageGallery {\n    label\n    images {\n      ...PropertyImageFragment\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MediaGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      thumbnail {\n        url\n        description\n      }\n      fallbackImage {\n        url\n        description\n      }\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        fallbackImage {\n          url\n          description\n        }\n      }\n    }\n    mediaGalleryDialog {\n      toolbar {\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ThumbnailGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      subjectId\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      thumbnail {\n        url\n        description\n      }\n      fallbackImage {\n        url\n        description\n      }\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        fallbackImage {\n          url\n          description\n        }\n      }\n    }\n    thumbnailGalleryDialog {\n      toolbar {\n        title\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        accessibilityLabel\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyImageGalleryFragment on PropertyImageGallery {\n    ...MosaicContainerFragment\n    ...CarouselContainerFragment\n    ...MediaGalleryDialogFragment\n    ...ThumbnailGalleryDialogFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoContentHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      id\n      description\n      size\n    }\n  }\n"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoContentItemFragment on PropertyInfoItem {\n    icon {\n      iconId: id\n      description\n      size\n    }\n    text\n    state\n    moreInfo\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoContentItemsFragment on PropertyInfoContent {\n    items {\n      ...PropertyInfoContentItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingDialogTriggerMessageFragment on LodgingDialogTriggerMessage {\n    accessibilityLabel\n    value\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CleanlinessDialogFragment on CleanlinessDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoContentFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    iconAnalytics {\n      linkName\n      referrerId\n    }\n    ...PropertyInfoContentItemsFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyTakeoverAmenitiesFragment on PropertyTakeoverAmenities {\n    amenityClosures {\n      ...PropertyInfoContentFragment\n    }\n    highlight {\n      ...PropertyInfoContentFragment\n    }\n    property {\n      ...PropertyInfoContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyAmenitiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      summary {\n        amenities(searchCriteria: $searchCriteria) {\n          takeover {\n            ...PropertyTakeoverAmenitiesFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SeeMorePropertyAmenitiesDialogFragment on AmenitiesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SeeMoreActionFragment on SeeMoreAction {\n    __typename\n    ... on AmenitiesDialog {\n      ...SeeMorePropertyAmenitiesDialogFragment\n    }\n    ... on CleanlinessDialog {\n      ...CleanlinessDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoContentWithSeeMoreActionFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    ...PropertyInfoContentItemsFragment\n    seeMoreAction {\n      ...SeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyDescriptionAndMoreInfoSectionFragment on PropertyDetails {\n    description {\n      ...LodgingEGDSParagraphFragment\n    }\n    contentSections {\n      ...PropertyInfoContentWithSeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RatingCountsFragment on PropertyReviewSummary {\n    ratingCounts {\n      count {\n        formatted\n      }\n      percent\n      rating\n      description\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewSummaryDetailsFragment on PropertyReviewSummary {\n    reviewSummaryDetails {\n      label\n      formattedRatingOutOfMaxA11y {\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyFilteredReviewsDialogFragment on PropertyFilteredReviewsDialog {\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n    ratingPercentage {\n      closeAnalytics {\n        referrerId\n        linkName\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewDisclaimerFragment on PropertyReviewSummary {\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    reviewDisclaimerAnalytics {\n      referrerId\n      linkName\n    }\n    reviewDisclaimerUrl {\n      value\n      accessibilityLabel\n      link {\n        url\n      }\n    }\n    reviewDisclaimerAccessibilityLabel\n  }\n"
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewsBreakdownFragment on PropertyReviewSummary {\n    averageOverallRating {\n      formatted\n    }\n    superlative\n    propertyReviewCountDetails {\n      shortDescription\n    }\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    ...ReviewDisclaimerFragment\n    totalCount {\n      raw\n    }\n    ...ReviewSummaryDetailsFragment\n    ...RatingCountsFragment\n    seeAllAction {\n      ...PropertyFilteredReviewsDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyDetailsReviewsBreakdownFragment on PropertyReviewSummary {\n    ...PropertyReviewsBreakdownFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyInfoDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput!\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      propertyDetails(searchCriteria: $searchCriteria) {\n        gallery {\n          ...PropertyImageGalleryFragment\n        }\n        heading {\n          ...LodgingEGDSHeadingFragment\n        }\n        rating {\n          ...LodgingEGDSRatingFragment\n        }\n        ...PropertyDescriptionAndMoreInfoSectionFragment\n      }\n    }\n\n    propertyReviewSummaries(context: $context, propertyIds: [$propertyId], searchCriteria: $searchCriteria) {\n      ...PropertyDetailsReviewsBreakdownFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesFooterFragment on SimilarProperties {\n    footer\n  }\n"
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesHeaderFragment on SimilarProperties {\n    header\n  }\n"
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingHeaderFragment on LodgingHeader {\n    text\n    label\n    subText\n  }\n"
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewsSummaryFragment on PropertyReviewsSummary {\n    localizedScore\n    localizedSubtitleA11y {\n      accessibilityLabel\n    }\n    localizedTotal\n  }\n"
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesActionFragment on SimilarProperty {\n    title {\n      label\n      text\n    }\n    propertyId\n    image {\n      image {\n        url\n      }\n    }\n    price {\n      price {\n        options {\n          displayPrice {\n            amount\n            currencyInfo {\n              name\n            }\n          }\n        }\n      }\n    }\n    action {\n      actionDetails {\n        accessibilityLabel\n      }\n      text\n      linkUrl\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    subText\n    value\n    theme\n    state\n    accessibilityLabel\n    icon {\n      id\n      size\n    }\n    mark {\n      id\n    }\n    egdsMark {\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesItemsFragment on SimilarProperty {\n    items {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesPriceFragment on SimilarProperty {\n    price {\n      qualifier {\n        value\n      }\n      subText {\n        text\n      }\n      price {\n        options {\n          displayPrice {\n            formatted\n          }\n          leadingCaption\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SimilarPropertiesPropertiesFragment on SimilarProperties {\n    header\n    properties {\n      title {\n        ...LodgingHeaderFragment\n      }\n      reviews {\n        ...PropertyReviewsSummaryFragment\n      }\n      featuredMessages {\n        ...LodgingEGDSGraphicTextFragment\n      }\n      image {\n        image {\n          ...LodgingEGDSImageFragment\n        }\n      }\n      ...SimilarPropertiesItemsFragment\n      ...SimilarPropertiesPriceFragment\n      ...SimilarPropertiesActionFragment\n    }\n    galleryCarousel {\n      nextButtonText\n      previousButtonText\n    }\n    lodgingRecommendationClickstreamEvent {\n      recommendationResponseId\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _taggedTemplateLiteral([
        "\n  query SimilarPropertiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $propertyRecommendationStrategy: PropertyRecommendationStrategy\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      id\n      similarProperties(searchCriteria: $searchCriteria, propertyRecommendationStrategy: $propertyRecommendationStrategy) {\n        ...SimilarPropertiesHeaderFragment\n        ...SimilarPropertiesPropertiesFragment\n        ...SimilarPropertiesFooterFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertySpacesQuery($context: ContextInput!, $propertyId: String!) {\n    summary: propertySpaces(context: $context, propertyContentType: SUMMARY, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n    detailed: propertySpaces(context: $context, propertyContentType: DETAILED, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenitiesSimplifiedViewFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingJumpLinkFragment on PropertyInfoJumpLink {\n    icon {\n      iconId: id\n    }\n    sectionName\n    localizedName\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenityDescriptionJumpLinkFragment on PropertyInfoSection {\n    action {\n      ...LodgingJumpLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenityContentFragment on PropertyInfoContent {\n    __typename\n    heading\n    items {\n      __typename\n      text\n    }\n    icon {\n      __typename\n      iconId: id\n    }\n    structuredData {\n      __typename\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n"
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenityHeadingFragment on LodgingHeader {\n    __typename\n    text\n    subText\n  }\n"
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenitySectionFragment on PropertyInfoSection {\n    __typename\n    header {\n      ...AmenityHeadingFragment\n    }\n    contents {\n      ...AmenityContentFragment\n    }\n    ...AmenityDescriptionJumpLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenityDescriptionFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        amenities {\n          ...AmenitySectionFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _taggedTemplateLiteral([
        "\n  fragment BookByPhoneFragment on PropertyInfo {\n    telesales {\n      telesalesNumber {\n        phoneNumber\n        value\n      }\n      description {\n        value\n      }\n      tracking {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject104 = function _templateObject104() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PoliciesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      policies {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject105() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SpecialFeaturesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      specialFeatures {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject106() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ImportantInfoFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      importantInfo {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject107() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AboutThisPropertyFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject108() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _taggedTemplateLiteral([
        "\n  fragment HostProfileFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisHost {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject109 = function _templateObject109() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyDetailedAmenitiesFragment on PropertyInfo {\n    amenitiesSummary: propertyContentSectionGroups(amenitiesPropertyContentType: SUMMARY) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n    detailedAmenitiesContent: propertyContentSectionGroups(amenitiesPropertyContentType: DETAILED) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject110 = function _templateObject110() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _taggedTemplateLiteral([
        "\n  query DirectFeedbackCallToActionQuery($context: ContextInput!, $id: ID!) {\n    directFeedbackPromptById(context: $context, id: $id) {\n      callToAction {\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        icon {\n          id\n          size\n        }\n        primary\n      }\n    }\n  }\n"
    ]);
    _templateObject111 = function _templateObject111() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _taggedTemplateLiteral([
        "\n  fragment __PropertyDirectFeedbackPromptIdFragment on PropertyInfo {\n    directFeedback {\n      __typename\n      promptId\n    }\n  }\n"
    ]);
    _templateObject112 = function _templateObject112() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FaqFragment on PropertyFAQ {\n    question {\n      text\n    }\n    answer {\n      text\n    }\n  }\n"
    ]);
    _templateObject113 = function _templateObject113() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FrequentlyAskedQuestionsFragment on PropertyInfo {\n    id\n    frequentlyAskedQuestions {\n      title {\n        text\n        subText\n      }\n      askAQuestion {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      faqs {\n        ...FaqFragment\n      }\n    }\n    offers(searchCriteria: $searchCriteria) @include(if: $isDateless) {\n      pricingFrequentlyAskedQuestions {\n        ...FaqFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject114 = function _templateObject114() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _taggedTemplateLiteral([
        "\n  fragment GalleryFragment on PropertyInfo {\n    summary {\n      name\n      overview {\n        accessibilityLabel\n      }\n    }\n    propertyGallery {\n      ...PropertyImageGalleryFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject115 = function _templateObject115() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InventorySourceFragment on PropertyInfo {\n    summary {\n      propertySource {\n        accessibilityLabel\n        label\n        graphic {\n          __typename\n          ... on Mark {\n            description\n            id\n            size\n            token\n            url {\n              value\n            }\n          }\n        }\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject116 = function _templateObject116() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LocationHighlightsFragment on PropertyInfo {\n    reviewInfo(searchCriteria: $searchCriteria) {\n      summary {\n        reviewHighlights {\n          ...PropertyInfoContentFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject117 = function _templateObject117() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NavigationBarTabsFragment on PropertySummary {\n    navigationBarTabs {\n      localizedName\n      sectionName\n    }\n  }\n"
    ]);
    _templateObject118 = function _templateObject118() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NavigationBarFragment on PropertyInfo {\n    summary {\n      ...NavigationBarTabsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject119 = function _templateObject119() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RelevantAmenitiesItemFragment on PropertyInfoSection {\n    header {\n      text\n    }\n    contents {\n      items {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject120 = function _templateObject120() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RelevantAmenitiesFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        relevantAmenities {\n          ...RelevantAmenitiesItemFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject121 = function _templateObject121() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject122 = function _templateObject122() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject123 = function _templateObject123() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SaveTripItemFragment on PropertyInfo {\n    saveTripItem(searchCriteria: $searchCriteria) {\n      ...TripsSaveItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject124 = function _templateObject124() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ShortlistFragment on PropertyInfo {\n    summary {\n      name\n    }\n    shortList {\n      button {\n        checked\n        checkedAccessibilityLabel\n        checkedAnalytics {\n          linkName\n          referrerId\n        }\n        uncheckedAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject125 = function _templateObject125() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SpaceOverviewInfoFragment on PropertyInfoContent {\n    items {\n      icon {\n        description\n        iconId: id\n        size\n      }\n      text\n    }\n  }\n"
    ]);
    _templateObject126 = function _templateObject126() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SpaceOverviewTitleFragment on PropertyInfoContent {\n    header {\n      text\n    }\n  }\n"
    ]);
    _templateObject127 = function _templateObject127() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SpaceOverviewFragment on PropertyInfo {\n    propertyHighlightedDetails {\n      ...SpaceOverviewTitleFragment\n      ...SpaceOverviewInfoFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject128 = function _templateObject128() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyInfoTopReviewFragment on PropertyInfo {\n    topReviews(searchCriteria: $searchCriteria) {\n      highlighted {\n        value\n        icon {\n          iconId: id\n          description\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject129 = function _templateObject129() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryReviewsFragment on PropertyInfo {\n    reviewInfo(searchCriteria: $searchCriteria) {\n      summary {\n        averageOverallRating {\n          formatted\n          raw\n        }\n        totalCount {\n          formatted\n          raw\n        }\n        superlative\n        overallScoreWithDescriptionA11y {\n          ...LodgingEnrichedMessageFragment\n        }\n        propertyReviewCountDetails {\n          fullDescription\n          shortDescription\n        }\n        highlightMessage {\n          subtitle {\n            accessibilityLabel\n            text\n          }\n        }\n        seoData {\n          content\n          itemprop\n          itemscope\n        }\n      }\n    }\n    ...PropertyInfoTopReviewFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject130 = function _templateObject130() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenitiesDialogFragment on PropertyAmenities {\n    amenitiesDialog {\n      toolbar {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        icon {\n          iconId: id\n          description\n        }\n        title\n      }\n    }\n    takeover {\n      ...PropertyTakeoverAmenitiesFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject131 = function _templateObject131() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenitiesLinkFragment on PropertyAmenities {\n    amenitiesDialog {\n      trigger {\n        value\n        accessibilityLabel\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject132 = function _templateObject132() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryAmenitiesFragment on PropertyInfo {\n    summary {\n      amenities(searchCriteria: $searchCriteria) {\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n        propertyContentPreferences {\n          ...PropertyContentFragment\n        }\n        ...AmenitiesLinkFragment\n        ...AmenitiesDialogFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject133 = function _templateObject133() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AddressFragment on PropertyLocation {\n    coordinates {\n      latitude\n      longitude\n    }\n    address {\n      addressLine\n      city\n      countryCode\n      firstAddressLine\n      province\n    }\n    ratings {\n      primary\n      accessibilityLabel\n    }\n    mapDialog {\n      trigger {\n        value\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject134 = function _templateObject134() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryMapTriggerFragment on PropertyInfo {\n    summary {\n      location {\n        ...AddressFragment\n        staticImage {\n          description\n          url\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject135 = function _templateObject135() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryNearByPoisFragment on PropertyInfo {\n    summary {\n      nearbyPOIs {\n        heading\n        items {\n          text\n          icon {\n            iconId: id\n            description\n          }\n          moreInfo\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject136 = function _templateObject136() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryBannerMessageFragment on PropertyInfo {\n    summary {\n      bannerMessage {\n        title {\n          icon {\n            id\n            description\n          }\n        }\n        subtitle {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject137 = function _templateObject137() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryHeaderFragment on PropertyInfo {\n    summary {\n      name\n      latinAlphabetName\n      overview {\n        vipMessaging\n        starRating\n        propertyRating {\n          accessibility\n          rating\n        }\n      }\n      starRatingIcon {\n        description\n        iconId: id\n      }\n      featuredMessages {\n        icon {\n          iconId: id\n          description\n        }\n        value\n      }\n      tagline\n      messages {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject138 = function _templateObject138() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryChatbotLaunchFragment on PropertyInfo {\n    summary {\n      lodgingChatbot {\n        header {\n          text\n        }\n        action {\n          primary\n        }\n        content\n      }\n    }\n  }\n"
    ]);
    _templateObject139 = function _templateObject139() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ExperienceScorePopoverFragment on ExperienceScoreDetails {\n    seeMoreAction {\n      ... on ExperienceScoreDialog {\n        trigger {\n          analytics {\n            referrerId\n            linkName\n          }\n          message\n        }\n        dialog {\n          closeAnalytics {\n            referrerId\n            linkName\n          }\n        }\n        content {\n          contents {\n            text\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject140 = function _templateObject140() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ExperienceScoreReviewsFragment on PropertyInfo {\n    experienceScoreReviewInfo(searchCriteria: $searchCriteria) {\n      summary {\n        averageOverallRating {\n          formatted\n        }\n        highlightMessage {\n          subtitle {\n            text\n          }\n        }\n        overallScoreWithDescriptionA11y {\n          value\n        }\n        propertyReviewCountDetails {\n          shortDescription\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject141 = function _templateObject141() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryExperienceScoreFragment on PropertyInfo {\n    experienceScore {\n      header {\n        label\n        text\n        impressionAnalytics {\n          event\n          referrerId\n        }\n      }\n      ...ExperienceScorePopoverFragment\n    }\n    ...ExperienceScoreReviewsFragment @include(if: $showExperienceScoreReviews)\n    ...SummaryReviewsFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject142 = function _templateObject142() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryGeoFragment on PropertyInfo {\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject143 = function _templateObject143() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SummaryFragment on PropertyInfo {\n    ...SummaryAmenitiesFragment\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n    ...SummaryHeaderFragment\n    ...SummaryReviewsFragment\n    ...SummaryBannerMessageFragment\n    ...SummaryChatbotLaunchFragment\n    ...LocationHighlightsFragment\n    ...RelevantAmenitiesFragment\n    ...SummaryExperienceScoreFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject144 = function _templateObject144() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundLinkFragment on LodgingLinkMessage {\n    link {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      uri {\n        value\n      }\n    }\n    value\n    icon {\n      id\n      description\n    }\n  }\n"
    ]);
    _templateObject145 = function _templateObject145() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundEditorialFragment on PropertyEditorial {\n    content\n    crossLinks {\n      ...WhatsAroundLinkFragment\n    }\n    title\n  }\n\n  ",
        "\n"
    ]);
    _templateObject146 = function _templateObject146() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundMapFragment on PropertyWhatsAround {\n    staticImage {\n      description\n      url\n    }\n  }\n"
    ]);
    _templateObject147 = function _templateObject147() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundIconFragment on Icon {\n    iconId: id\n  }\n"
    ]);
    _templateObject148 = function _templateObject148() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundPoisItemFragment on PropertyInfoContent {\n    items {\n      text\n      moreInfo\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject149 = function _templateObject149() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundPoisFragment on PropertyWhatsAround {\n    nearbyPOIs {\n      ...WhatsAroundPoisItemFragment\n      title\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject150 = function _templateObject150() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _taggedTemplateLiteral([
        "\n  fragment WhatsAroundFragment on PropertyInfo {\n    id\n    summary {\n      location {\n        whatsAround {\n          title\n          editorial {\n            ...WhatsAroundEditorialFragment\n          }\n          ...WhatsAroundPoisFragment\n          ...WhatsAroundMapFragment\n        }\n      }\n      map {\n        trigger {\n          value\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject151 = function _templateObject151() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $isDateless: Boolean = true\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n    $showExperienceScoreReviews: Boolean = false\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...AmenityDescriptionFragment\n      ...PoliciesFragment\n      ...PropertyDetailedAmenitiesFragment\n      ...ImportantInfoFragment\n      ...FrequentlyAskedQuestionsFragment\n      ...NavigationBarFragment\n      ...AboutThisPropertyFragment\n      ...WhatsAroundFragment\n      ...GalleryFragment\n      ...SummaryFragment\n      ...BookByPhoneFragment\n      ...SpaceOverviewFragment\n      ...InventorySourceFragment\n      ...ShortlistFragment\n      ...SaveTripItemFragment\n      ...AmenitiesSimplifiedViewFragment\n      ...RelevantAmenitiesFragment\n      ...SpecialFeaturesFragment\n      ...LocationHighlightsFragment\n      ...HostProfileFragment\n      ...__PropertyDirectFeedbackPromptIdFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject152 = function _templateObject152() {
        return data;
    };
    return data;
}
import React5, { useState as useState2 } from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard4, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkBlockSkeleton, UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
// src/components/gex-module/__private/__fragments/bundle-items.tsx
import React, { useState } from "react";
import { gql } from "@apollo/client";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkActionList, UitkActionListItem, UitkActionListItemLink } from "uitk-react-action-list-item";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkCard } from "uitk-react-cards";
import { UitkExpandoList, UitkExpandoListItem } from "uitk-react-expando";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing, UitkSpacingHr } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var __BundleItemsFragment = gql(_templateObject());
var BundleDialog = function(param) {
    var activeBundle = param.activeBundle, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, DialogComponent = param.DialogComponent;
    var _activeBundle_header, _activeBundle_header1, _activeBundle_header2;
    return /* @__PURE__ */ React.createElement(DialogComponent, null, /* @__PURE__ */ React.createElement(UitkCard, null, /* @__PURE__ */ React.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "bottom",
        triggerRef: null
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            blockstart: "half",
            inlineend: "half"
        },
        margin: {
            blockstart: "one",
            inlineend: "one"
        }
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkTertiaryButton, {
        type: "button",
        onClick: closeDialog
    }, /* @__PURE__ */ React.createElement(UitkIcon, {
        name: "close",
        size: UitkIconSize.MEDIUM,
        title: "Close Sheet",
        id: "sheet-close-button"
    }))))), /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            blockstart: "four",
            blockend: "four",
            inlinestart: "six",
            inlineend: "six"
        },
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React.createElement(UitkHeading, {
        size: 5,
        tag: "h4"
    }, activeBundle === null || activeBundle === void 0 ? void 0 : (_activeBundle_header = activeBundle.header) === null || _activeBundle_header === void 0 ? void 0 : _activeBundle_header.label)), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockend: "four"
        },
        padding: {
            blockend: "half"
        }
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        alignItems: "center"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, (activeBundle === null || activeBundle === void 0 ? void 0 : (_activeBundle_header1 = activeBundle.header) === null || _activeBundle_header1 === void 0 ? void 0 : _activeBundle_header1.icon) && /* @__PURE__ */ React.createElement(UitkIcon, {
        name: activeBundle.header.icon.id,
        shadow: true,
        size: UitkIconSize.EXTRA_SMALL,
        theme: activeBundle.header.icon.theme || "default"
    })), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkText, {
        size: 300
    }, activeBundle === null || activeBundle === void 0 ? void 0 : (_activeBundle_header2 = activeBundle.header) === null || _activeBundle_header2 === void 0 ? void 0 : _activeBundle_header2.text))))), /* @__PURE__ */ React.createElement(UitkText, {
        size: 300
    }, activeBundle === null || activeBundle === void 0 ? void 0 : activeBundle.scoreExplainer), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React.createElement(UitkSpacingHr, null)), /* @__PURE__ */ React.createElement(UitkText, {
        size: 300
    }, activeBundle === null || activeBundle === void 0 ? void 0 : activeBundle.calculationDescription))))));
};
var MobileBundleItemList = function(param) {
    var bundles = param.bundles, activeBundle = param.activeBundle, setActiveBundle = param.setActiveBundle;
    var _useDialog = _slicedToArray(useDialog("gex-module-mobile-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var track = useClickTracker();
    var openDialog = function(bundle) {
        var _bundle_header, _bundle_header_impressionAnalytics;
        if (bundle === null || bundle === void 0 ? void 0 : (_bundle_header = bundle.header) === null || _bundle_header === void 0 ? void 0 : (_bundle_header_impressionAnalytics = _bundle_header.impressionAnalytics) === null || _bundle_header_impressionAnalytics === void 0 ? void 0 : _bundle_header_impressionAnalytics.referrerId) {
            track("".concat(bundle.header.impressionAnalytics.referrerId, ".Opened"), "Bundle item click", true);
        }
        setActiveBundle(bundle);
        dialogActions.openDialog();
    };
    var closeDialog = function() {
        var _activeBundle_header;
        if (activeBundle === null || activeBundle === void 0 ? void 0 : (_activeBundle_header = activeBundle.header) === null || _activeBundle_header === void 0 ? void 0 : _activeBundle_header.impressionAnalytics) {
            track("".concat(activeBundle.header.impressionAnalytics.referrerId, ".Closed"), "Bundle item click", true);
        }
        dialogActions.closeDialog();
    };
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkActionList, null, bundles.map(function(bundle, index) {
        var _bundle_header, _bundle_header_impressionAnalytics, _bundle_header1, _bundle_header2, _bundle_header_impressionAnalytics1, _bundle_header3, _bundle_header4, _bundle_header5, _bundle_header6;
        /* @__PURE__ */ return React.createElement(UitkActionListItem, {
            spacing: "standard",
            borderSeparator: true,
            key: index
        }, /* @__PURE__ */ React.createElement(IntersectionTracker, {
            trackOnce: true,
            referrerId: "".concat(bundle === null || bundle === void 0 ? void 0 : (_bundle_header = bundle.header) === null || _bundle_header === void 0 ? void 0 : (_bundle_header_impressionAnalytics = _bundle_header.impressionAnalytics) === null || _bundle_header_impressionAnalytics === void 0 ? void 0 : _bundle_header_impressionAnalytics.referrerId, ".Score.").concat(bundle === null || bundle === void 0 ? void 0 : (_bundle_header1 = bundle.header) === null || _bundle_header1 === void 0 ? void 0 : _bundle_header1.icon.theme),
            linkName: "".concat(bundle === null || bundle === void 0 ? void 0 : (_bundle_header2 = bundle.header) === null || _bundle_header2 === void 0 ? void 0 : (_bundle_header_impressionAnalytics1 = _bundle_header2.impressionAnalytics) === null || _bundle_header_impressionAnalytics1 === void 0 ? void 0 : _bundle_header_impressionAnalytics1.event),
            intersectionOptions: {
                threshold: 1
            },
            key: index
        }, /* @__PURE__ */ React.createElement(UitkActionListItemLink, null, /* @__PURE__ */ React.createElement("button", {
            type: "button",
            onClick: function() {
                openDialog(bundle);
            }
        }, bundle === null || bundle === void 0 ? void 0 : (_bundle_header3 = bundle.header) === null || _bundle_header3 === void 0 ? void 0 : _bundle_header3.label)), /* @__PURE__ */ React.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
            grow: 1
        }, /* @__PURE__ */ React.createElement(UitkSpacing, {
            margin: {
                inlinestart: "unset"
            }
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkHeading, {
            size: 6,
            tag: "h4"
        }, bundle === null || bundle === void 0 ? void 0 : (_bundle_header4 = bundle.header) === null || _bundle_header4 === void 0 ? void 0 : _bundle_header4.label), /* @__PURE__ */ React.createElement(UitkSpacing, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, (bundle === null || bundle === void 0 ? void 0 : (_bundle_header5 = bundle.header) === null || _bundle_header5 === void 0 ? void 0 : _bundle_header5.icon) && /* @__PURE__ */ React.createElement(UitkIcon, {
            name: bundle.header.icon.id,
            shadow: true,
            size: UitkIconSize.EXTRA_SMALL,
            theme: bundle.header.icon.theme || "default"
        })), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
            margin: {
                inlinestart: "three"
            }
        }, /* @__PURE__ */ React.createElement(UitkText, {
            size: 300
        }, bundle === null || bundle === void 0 ? void 0 : (_bundle_header6 = bundle.header) === null || _bundle_header6 === void 0 ? void 0 : _bundle_header6.text)))))))), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
            shrink: 0,
            alignSelf: "center"
        }, /* @__PURE__ */ React.createElement(UitkTertiaryButton, {
            type: "button",
            onClick: function() {
                openDialog(bundle);
            }
        }, /* @__PURE__ */ React.createElement(UitkIcon, {
            name: "navigate_next",
            size: UitkIconSize.SMALL
        }))))));
    })), /* @__PURE__ */ React.createElement(BundleDialog, {
        activeBundle: activeBundle,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog,
        DialogComponent: DialogComponent
    }));
};
var DesktopBundleItem = function(param) {
    var bundle = param.bundle;
    var _header_impressionAnalytics, _header_impressionAnalytics1;
    var _useState = _slicedToArray(useState(false), 2), isVisible = _useState[0], setVisible = _useState[1];
    var track = useClickTracker();
    var header = bundle.header;
    var icon = header.icon, text = header.text;
    var reffererId = (_header_impressionAnalytics = header.impressionAnalytics) === null || _header_impressionAnalytics === void 0 ? void 0 : _header_impressionAnalytics.referrerId;
    var event = (_header_impressionAnalytics1 = header.impressionAnalytics) === null || _header_impressionAnalytics1 === void 0 ? void 0 : _header_impressionAnalytics1.event;
    var toggleDesktopBundleItem = React.useCallback(function() {
        var status = isVisible ? "Closed" : "Opened";
        if (reffererId) {
            track("".concat(reffererId, ".").concat(status), "Bundle item click", true);
        }
        setVisible(!isVisible);
    }, [
        isVisible,
        reffererId,
        track
    ]);
    return /* @__PURE__ */ React.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: "".concat(reffererId, ".Score.").concat(icon === null || icon === void 0 ? void 0 : icon.theme),
        linkName: "".concat(event),
        intersectionOptions: {
            threshold: 1
        }
    }, /* @__PURE__ */ React.createElement(UitkCard, {
        border: true
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "two",
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkExpandoListItem, {
        expandoTitle: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkSpacing, {
            margin: "one"
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkHeading, {
            size: 6,
            tag: "h4"
        }, header.label), /* @__PURE__ */ React.createElement(UitkSpacing, {
            padding: {
                blockstart: "one"
            },
            margin: {
                blockstart: "half",
                blockend: "one"
            }
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
            alignItems: "center"
        }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, icon && /* @__PURE__ */ React.createElement(UitkIcon, {
            name: icon === null || icon === void 0 ? void 0 : icon.id,
            shadow: true,
            size: UitkIconSize.EXTRA_SMALL,
            theme: (icon === null || icon === void 0 ? void 0 : icon.theme) || "default"
        })), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
            margin: {
                inlinestart: "three"
            }
        }, /* @__PURE__ */ React.createElement(UitkText, {
            size: 300
        }, text))))))))),
        expandoDescription: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkSpacing, {
            padding: {
                inlinestart: "three"
            },
            margin: {
                inlinestart: "half",
                inlineend: "unset",
                blockend: "three"
            }
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkText, {
            size: 300
        }, bundle === null || bundle === void 0 ? void 0 : bundle.scoreExplainer), /* @__PURE__ */ React.createElement(UitkSpacing, {
            padding: {
                inlineend: "half"
            },
            margin: {
                inlineend: "four"
            }
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkSpacingHr, {
            blockMargin: "four"
        }))), /* @__PURE__ */ React.createElement(UitkText, {
            size: 300
        }, bundle.calculationDescription)))),
        isVisible: isVisible,
        triggerPosition: "trailing",
        isIndented: false,
        onToggle: toggleDesktopBundleItem
    }))));
};
var BundleItems = function(param) {
    var data = param.data;
    var _useState = _slicedToArray(useState(null), 2), activeBundle = _useState[0], setActiveBundle = _useState[1];
    if (!(data === null || data === void 0 ? void 0 : data.bundles)) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            large: {
                blockstart: "unset",
                inlinestart: "sixteen",
                inlineend: "three"
            },
            medium: {
                inlinestart: "twelve"
            },
            small: {
                blockstart: "two"
            }
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Viewport, null, /* @__PURE__ */ React.createElement(ViewMedium, null, /* @__PURE__ */ React.createElement(UitkExpandoList, null, data.bundles.map(function(bundle, index) {
        return /* @__PURE__ */ React.createElement(DesktopBundleItem, {
            bundle: bundle,
            key: index
        });
    }))), /* @__PURE__ */ React.createElement(ViewSmall, null, /* @__PURE__ */ React.createElement(MobileBundleItemList, {
        bundles: data.bundles,
        activeBundle: activeBundle,
        setActiveBundle: setActiveBundle
    })))));
};
BundleItems.displayName = "BundleItems";
BundleItems.fragment = __BundleItemsFragment;
// src/components/gex-module/__private/__fragments/gex-experience-score-details.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText3 } from "uitk-react-text";
// src/components/gex-module/__private/__fragments/gex-popover.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet2, UitkSheetCloseButton } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText2 } from "uitk-react-text";
var __GexPopoverFragment = gql2(_templateObject1());
var GexPopover = function(props) {
    var _content_contents_;
    var track = useClickTracker2();
    var data = props.data, visible = props.visible, toggleVisibility = props.toggleVisibility, triggerRef = props.triggerRef;
    var trigger = data.trigger, dialog = data.dialog, content = data.content;
    var popoverTitle = trigger.message, triggerAnalytics = trigger.analytics;
    var closeAnalytics = dialog.closeAnalytics;
    var popoverContent = (_content_contents_ = content.contents[0]) === null || _content_contents_ === void 0 ? void 0 : _content_contents_.text;
    var openCallback = React2.useCallback(function() {
        if (triggerAnalytics) {
            track(triggerAnalytics.referrerId, triggerAnalytics.linkName, true);
        }
    }, [
        track,
        triggerAnalytics
    ]);
    var closeCallback = React2.useCallback(function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName, true);
        }
    }, [
        track,
        closeAnalytics
    ]);
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkSheet2, {
        autoFocus: true,
        autoPosition: false,
        width: 240,
        isVisible: visible,
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: toggleVisibility,
        openCallback: openCallback,
        closeCallback: closeCallback
    }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockstart: "unset",
            inlinestart: "unset",
            inlineend: "unset"
        },
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem2, {
        maxWidth: "76x"
    }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six",
            inlinestart: "six",
            inlineend: "unset"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockend: "four"
        },
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React2.createElement(UitkHeading2, {
        size: 7,
        tag: "h4"
    }, popoverTitle)), /* @__PURE__ */ React2.createElement(UitkText2, {
        size: 200
    }, popoverContent)))), /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React2.createElement(UitkSheetCloseButton, {
        alignment: "top"
    }, /* @__PURE__ */ React2.createElement(UitkTertiaryButton2, {
        type: "button",
        onClick: toggleVisibility
    }, /* @__PURE__ */ React2.createElement(UitkIcon2, {
        name: "close",
        size: UitkIconSize2.LARGE,
        title: "close",
        id: "close"
    }))))))));
};
GexPopover.displayName = "GexPopover";
GexPopover.fragment = __GexPopoverFragment;
// src/components/gex-module/__private/__fragments/gex-experience-score-details.tsx
var __GexExperienceScoreDetailsFragment = gql3(_templateObject2(), BundleItems.fragment, GexPopover.fragment);
var GexExperienceScoreDetails = function(props) {
    var data = props.data, toggleVisibility = props.toggleVisibility, triggerRef = props.triggerRef;
    var experienceScoreDetails = data.experienceScoreDetails;
    if (!(experienceScoreDetails === null || experienceScoreDetails === void 0 ? void 0 : experienceScoreDetails.header) || !(experienceScoreDetails === null || experienceScoreDetails === void 0 ? void 0 : experienceScoreDetails.seeMoreAction)) {
        return null;
    }
    var header = experienceScoreDetails.header, seeMoreAction = experienceScoreDetails.seeMoreAction;
    var impressionAnalytics = header.impressionAnalytics, label = header.label, text = header.text, subText = header.subText;
    var trigger = seeMoreAction.trigger;
    return /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem3, {
        grow: 1,
        maxWidth: "96x"
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkLayoutFlex3, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: "".concat(impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId),
        linkName: "".concat(impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.event),
        intersectionOptions: {
            threshold: 1
        }
    }, /* @__PURE__ */ React3.createElement(UitkCard2, {
        border: true
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React3.createElement(UitkText3, {
        size: 800
    }, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        margin: {
            blockstart: "three",
            blockend: "three",
            inlinestart: "three",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, label)))))))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem3, {
        minWidth: 310
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        margin: {
            blockstart: "unset",
            inlinestart: "six"
        },
        padding: {
            blockend: "half",
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkHeading3, {
        size: 5,
        tag: "h4"
    }, text), /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        margin: {
            small: {
                blockstart: "two",
                blockend: "one"
            },
            medium: {
                blockend: "four"
            }
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkText3, {
        size: 200
    }, subText))), /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        margin: {
            medium: {
                blockend: "two"
            }
        },
        padding: {
            medium: {
                blockend: "half"
            }
        }
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex3, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkLink, {
        size: "small",
        onClick: toggleVisibility
    }, /* @__PURE__ */ React3.createElement("button", {
        type: "button",
        ref: triggerRef
    }, trigger.message)))))))))))));
};
GexExperienceScoreDetails.displayName = "GexExperienceScoreDetails";
GexExperienceScoreDetails.fragment = __GexExperienceScoreDetailsFragment;
// src/components/gex-module/__private/__fragments/gex-experience-score-review.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText4 } from "uitk-react-text";
var _obj;
// src/components/summary/analytics.ts
var SummaryAnalyticsMapping = (_obj = {}, _defineProperty(_obj, "REVIEWS" /* REVIEWS */ , [
    "HOT.HIS.UGC.ViewAllResults",
    "Display detailed reviews"
]), _defineProperty(_obj, "AMENITIES" /* AMENITIES */ , [
    "HOT.HIS.ViewAllAmenities",
    "View all amenities"
]), _defineProperty(_obj, "MAP_IMAGE" /* MAP_IMAGE */ , [
    "HOT.HIS.Map.StaticMap",
    "Click static map"
]), _defineProperty(_obj, "MAP_LINK" /* MAP_LINK */ , [
    "HOT.HIS.ClickAddressCTALinkViewMap",
    "ClickAddressCTALinkViewMap"
]), _defineProperty(_obj, "CLEANING_AND_SAFETY_LINK" /* CLEANING_AND_SAFETY_LINK */ , [
    "HOT.HIS.ViewAllCleanliness",
    "Click on see all cleanliness link"
]), _obj);
var chatbotAnalyticsSchema = function(chatbotEntryPoint, chatbotName, propertyId) {
    return {
        schemaName: "chatbot",
        messageContent: {
            chatbotEntryPoint: chatbotEntryPoint,
            chatbotName: chatbotName,
            propertyId: propertyId
        }
    };
};
// src/components/gex-module/__private/__fragments/gex-experience-score-review.tsx
var __GexExperienceScoreReviewFragment = gql4(_templateObject3());
var GexExperienceScoreReview = function(props) {
    var data = props.data, isMobile = props.isMobile, onClickReviews = props.onClickReviews;
    var summary = data.summary;
    var superlative = summary.superlative, averageOverallRating = summary.averageOverallRating, overallScoreWithDescriptionA11y = summary.overallScoreWithDescriptionA11y, propertyReviewCountDetails = summary.propertyReviewCountDetails;
    var track = useClickTracker3();
    var handleClick = React4.useCallback(function() {
        var _SummaryAnalyticsMapping_REVIEWS = _slicedToArray(SummaryAnalyticsMapping["REVIEWS" /* REVIEWS */ ], 2), id = _SummaryAnalyticsMapping_REVIEWS[0], description = _SummaryAnalyticsMapping_REVIEWS[1];
        track(id, description, true);
        onClickReviews();
    }, [
        onClickReviews,
        track
    ]);
    return /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem4, {
        grow: 1,
        maxWidth: "96x"
    }, /* @__PURE__ */ React4.createElement("div", null, superlative && /* @__PURE__ */ React4.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: "HOT.HIS.GuestReviewScore.".concat(averageOverallRating.formatted),
        linkName: "Guest review score view impression.",
        intersectionOptions: {
            threshold: 1
        }
    }, /* @__PURE__ */ React4.createElement(UitkCard3, {
        border: isMobile
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex4, {
        alignItems: "center"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem4, {
        minWidth: "18x"
    }, /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        margin: {
            blockstart: "four",
            blockend: "four",
            inlinestart: "three",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkText4, {
        size: 500,
        inline: "strong"
    }, overallScoreWithDescriptionA11y === null || overallScoreWithDescriptionA11y === void 0 ? void 0 : overallScoreWithDescriptionA11y.value)))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        margin: {
            inlinestart: "two",
            blockstart: "three"
        }
    }, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkLayoutFlex4, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkHeading4, {
        size: 6,
        tag: "h4"
    }, superlative)))), /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        margin: {
            blockstart: "two",
            blockend: "three",
            inlinestart: "unset"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex4, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkLink2, {
        onClick: handleClick
    }, /* @__PURE__ */ React4.createElement("button", {
        type: "button"
    }, propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))))))))))))));
};
GexExperienceScoreReview.displayName = "GexExperienceScoreReview";
GexExperienceScoreReview.fragment = __GexExperienceScoreReviewFragment;
// src/components/gex-module/gex-module.tsx
var __Query = gql5(_templateObject4(), GexExperienceScoreReview.fragment, GexExperienceScoreDetails.fragment);
var GexModuleSkeleton = function() {
    return /* @__PURE__ */ React5.createElement(UitkCard4, null, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        stid: "gex-module-skeleton",
        padding: {
            large: "six",
            small: {
                blockstart: "three"
            }
        },
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGrid, {
        columns: {
            small: [
                "1fr"
            ],
            medium: [
                "1fr",
                "1fr"
            ],
            large: [
                "1fr",
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, {
        maxWidth: 80,
        grow: 1
    }, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            inlinestart: "two",
            inlineend: "two"
        },
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkFigure, {
        imageFit: "cover",
        ratio: UitkFigureAspectRatioType.R1_1
    }, /* @__PURE__ */ React5.createElement(UitkBlockSkeleton, {
        type: "rounded"
    })))))), /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            inlinestart: "four",
            inlineend: "six"
        },
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, {
        grow: 1
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, {
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            blockstart: "one",
            inlineend: "two"
        },
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    }))), /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    })), /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            blockstart: "three",
            blockend: "one"
        },
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))))))))), /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            large: {
                inlinestart: "sixteen",
                blockstart: "unset"
            },
            small: {
                blockstart: "six",
                inlineend: "three"
            }
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R4_1
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React5.createElement(UitkBlockSkeleton, {
        type: "rounded"
    }))))))))))));
};
var GexContent = function(props) {
    var isMobile = props.isMobile, Wrapper = props.Wrapper, experienceScore = props.experienceScore, experienceScoreReview = props.experienceScoreReview, triggerRef = props.triggerRef, toggleVisibility = props.toggleVisibility, onClickReviews = props.onClickReviews;
    var bundledScore = experienceScore.bundledScore;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Wrapper, null, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React5.createElement(GexExperienceScoreDetails, {
        data: experienceScore,
        toggleVisibility: toggleVisibility,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React5.createElement(GexExperienceScoreReview, {
        data: experienceScoreReview,
        isMobile: isMobile,
        onClickReviews: onClickReviews
    })))), /* @__PURE__ */ React5.createElement(Wrapper, null, /* @__PURE__ */ React5.createElement("div", null, bundledScore && /* @__PURE__ */ React5.createElement(BundleItems, {
        data: bundledScore
    }))));
};
var GexModule = function(param) {
    var inputs = param.inputs, onClickReviews = param.onClickReviews;
    var _inputs_searchCriteria_secondary, _data_experienceScore;
    var context = useBexApi().context;
    var searchCriteria = inputs.searchCriteria && {
        primary: inputs.searchCriteria.primary,
        secondary: _objectSpreadProps(_objectSpread({}, inputs.searchCriteria.secondary), {
            booleans: _toConsumableArray(((_inputs_searchCriteria_secondary = inputs.searchCriteria.secondary) === null || _inputs_searchCriteria_secondary === void 0 ? void 0 : _inputs_searchCriteria_secondary.booleans) || []).concat([
                {
                    id: "includeExperienceScoreModuleReview",
                    value: true
                }
            ])
        })
    };
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context,
        searchCriteria: searchCriteria
    });
    var triggerRef = React5.createRef();
    var _useState2 = _slicedToArray(useState2(false), 2), visible = _useState2[0], setVisible = _useState2[1];
    var toggleVisibility = function() {
        setVisible(!visible);
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: false,
        errorPolicy: "all"
    }), data = _useQuery.data, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React5.createElement(GexModuleSkeleton, null);
    }
    if (!(data === null || data === void 0 ? void 0 : (_data_experienceScore = data.experienceScore) === null || _data_experienceScore === void 0 ? void 0 : _data_experienceScore.experienceScoreDetails)) {
        return null;
    }
    var experienceScoreReview = data.experienceScoreReview, experienceScore = data.experienceScore;
    var experienceScoreDetails = experienceScore.experienceScoreDetails;
    var seeMoreAction = experienceScoreDetails === null || experienceScoreDetails === void 0 ? void 0 : experienceScoreDetails.seeMoreAction;
    return /* @__PURE__ */ React5.createElement("div", {
        "data-stid": "gex-module"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React5.createElement(UitkCard4, {
        className: "uitk-flat-border-top"
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkCardContentSection, null, /* @__PURE__ */ React5.createElement(UitkSpacing5, {
        padding: {
            large: {
                blockstart: "three",
                blockend: "four",
                inlinestart: "four"
            },
            medium: {
                inlinestart: "four"
            },
            small: {
                blockstart: "three"
            }
        },
        margin: {
            large: {
                inlinestart: "one"
            },
            medium: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(Viewport2, null, /* @__PURE__ */ React5.createElement(ViewMedium2, null, /* @__PURE__ */ React5.createElement(UitkLayoutGrid, {
        columns: {
            medium: [
                "1fr",
                "1fr"
            ],
            large: [
                "1fr",
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React5.createElement(GexContent, {
        Wrapper: UitkLayoutGridItem,
        experienceScore: experienceScore,
        experienceScoreReview: experienceScoreReview,
        onClickReviews: onClickReviews,
        triggerRef: triggerRef,
        toggleVisibility: toggleVisibility
    }))), /* @__PURE__ */ React5.createElement(ViewSmall2, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, /* @__PURE__ */ React5.createElement(GexContent, {
        Wrapper: UitkLayoutFlexItem5,
        isMobile: true,
        experienceScore: experienceScore,
        experienceScoreReview: experienceScoreReview,
        onClickReviews: onClickReviews,
        triggerRef: triggerRef,
        toggleVisibility: toggleVisibility
    }))))))))), seeMoreAction && /* @__PURE__ */ React5.createElement(GexPopover, {
        data: seeMoreAction,
        visible: visible,
        toggleVisibility: toggleVisibility,
        triggerRef: triggerRef
    }))));
};
GexModule.displayName = "GexModule";
// src/components/map/map.tsx
import React15 from "react";
import { gql as gql15, useQuery as useQuery2 } from "@apollo/client";
import distance from "@turf/distance";
import { point } from "@turf/helpers";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/map/dynamic-map.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkEGMaps, UitkEGMapsType } from "uitk-react-map";
// ../internal/src/components/map/geometry-utils.ts
var roundCoordinate = function(num) {
    var ONE_MILLION = 1e6;
    return Math.round((num + Number.EPSILON) * ONE_MILLION) / ONE_MILLION;
};
var boundingBoxToString = function(southwest, northeast) {
    var roundedSouthwest = southwest.map(roundCoordinate);
    var roundedNortheast = northeast.map(roundCoordinate);
    return "".concat(roundedSouthwest, ", ").concat(roundedNortheast);
};
var egBoundsToString = function(bounds) {
    var boundingBox = [
        [
            bounds.sw[0],
            bounds.sw[1]
        ],
        [
            bounds.ne[0],
            bounds.ne[1]
        ]
    ];
    return boundingBoxToString(boundingBox[0], boundingBox[1]);
};
// ../internal/src/components/map/analytics/eg-clickstream-events.tsx
import { useClickTracker as useClickTracker4, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var INTERACTION = "Interaction";
var IMPRESSION = "Impression";
var EVENT_CATEGORY = "maps";
var buildEvent = function(eventName, eventType, eventVersion) {
    return {
        event_name: eventName,
        event_type: eventType,
        event_version: eventVersion,
        event_category: EVENT_CATEGORY
    };
};
var buildData = function(event, attributes) {
    return _objectSpreadProps(_objectSpread({}, attributes), {
        event: event
    });
};
function useEgMapClickstream() {
    var clickstreamTrack = useEgClickstream();
    var track = function(data) {
        if (clickstreamTrack) {
            clickstreamTrack(data);
        }
    };
    var trackMapInit = function(mapType, selectionId) {
        var event = buildEvent("map.initiated", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        var attributes = {
            map_obj: {
                map_provider: mapType,
                map_selection_type: "property",
                map_selection_id: selectionId
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPresented = function(boundingBox, mapId, viewMode) {
        var event = buildEvent("map.presented", IMPRESSION, "2.4.0" /* TWO_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                map_identifier: mapId,
                visible_bounding_box: boundingBox,
                view_mode: viewMode
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapViewportMoved = function(boundingBox, movementType, zoomLevel) {
        var event = buildEvent("map_viewport.viewed", INTERACTION, "3.2.0" /* THREE_TWO_ZERO */ );
        var attributes = {
            map_obj: {
                visible_bounding_box: boundingBox,
                movement_type: movementType,
                zoom_level: zoomLevel
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapContentPresented = function(options) {
        var event = buildEvent("map_content.presented", IMPRESSION, "3.4.0" /* THREE_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                tile_sets: options.tileSets,
                content_origin: options.origin
            },
            destination: {
                places_of_interest_count: options.placesOfInterestCount,
                restaurant_count: options.restaurantCount,
                grocery_count: options.groceryCount,
                transportation_count: options.transportationCount
            },
            map_product_detail: {
                product_cluster_count: options.productClusterCount,
                property_count: options.propertyCount
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlaceSelected = function(selectionId, geometryType, selectionType) {
        var event = buildEvent("map_place.selected", INTERACTION, "2.4.0" /* TWO_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType,
                geometry_type_name: geometryType
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPropertySelected = function(selectionId, selectionType) {
        var event = buildEvent("map_product.selected", INTERACTION, "1.0.1" /* ONE_ZERO_ONE */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceAdded = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.added", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceRemoved = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.removed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlacesDialogOpened = function() {
        var event = buildEvent("map_dialog.opened", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapPlacesDialogClosed = function() {
        var event = buildEvent("map_dialog.closed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapHidden = function() {
        var event = buildEvent("map.hidden", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        track(buildData(event, {}));
    };
    var clickTracker = useClickTracker4();
    var trackMapFilterChanged = function(id, desc) {
        clickTracker(id, desc);
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapViewportMoved: trackMapViewportMoved,
        trackMapContentPresented: trackMapContentPresented,
        trackMapPlaceSelected: trackMapPlaceSelected,
        trackMapPropertySelected: trackMapPropertySelected,
        trackMapHidden: trackMapHidden,
        trackMapFilterChanged: trackMapFilterChanged,
        trackMapCustomPlaceAdded: trackMapCustomPlaceAdded,
        trackMapCustomPlaceRemoved: trackMapCustomPlaceRemoved,
        trackMapPlacesDialogOpened: trackMapPlacesDialogOpened,
        trackMapPlacesDialogClosed: trackMapPlacesDialogClosed
    };
}
// ../internal/src/components/map/analytics/event-helper.ts
import { UitkEGMapsQualifier } from "uitk-react-map";
var getVisibleFeatureCount = function(mapObj, featureFilter) {
    var combinedFilter = function(feature) {
        return featureFilter(feature) && feature.visible;
    };
    return mapObj.listFeatures(combinedFilter, mapObj.getBounds()).length;
};
var filterTransport = function(feature) {
    var _feature_qualifiers, _feature_qualifiers1, _feature_qualifiers2, _feature_qualifiers3, _feature_qualifiers4;
    return ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.AIRPORT)) || ((_feature_qualifiers1 = feature.qualifiers) === null || _feature_qualifiers1 === void 0 ? void 0 : _feature_qualifiers1.includes(UitkEGMapsQualifier.TRANSPORTATION)) || ((_feature_qualifiers2 = feature.qualifiers) === null || _feature_qualifiers2 === void 0 ? void 0 : _feature_qualifiers2.includes(UitkEGMapsQualifier.BUS_STATION)) || ((_feature_qualifiers3 = feature.qualifiers) === null || _feature_qualifiers3 === void 0 ? void 0 : _feature_qualifiers3.includes(UitkEGMapsQualifier.TRANSIT)) || ((_feature_qualifiers4 = feature.qualifiers) === null || _feature_qualifiers4 === void 0 ? void 0 : _feature_qualifiers4.includes(UitkEGMapsQualifier.METRO_STATION));
};
var getContentPresentedOptions = function(mapObj, origin) {
    var enabledTilesets = mapObj === null || mapObj === void 0 ? void 0 : mapObj.getActiveTilesets();
    var clusterCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "cluster";
    });
    var propertyCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "property";
    });
    var transportationCount = getVisibleFeatureCount(mapObj, filterTransport);
    var poiCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.POINT_OF_INTEREST);
    });
    var groceryCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.GROCERY);
    });
    var restaurantCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.RESTAURANT);
    });
    return {
        transportationCount: transportationCount,
        groceryCount: groceryCount,
        restaurantCount: restaurantCount,
        placesOfInterestCount: poiCount,
        tileSets: enabledTilesets,
        productClusterCount: clusterCount,
        propertyCount: propertyCount,
        origin: origin
    };
};
var CONTENT_PRESENTED_DELAY = 200;
// ../internal/src/components/map/map-markers.tsx
var convertMarkers = function(mapMarkers) {
    return (mapMarkers !== null && mapMarkers !== void 0 ? mapMarkers : []).map(function(marker, index) {
        var type = (marker.type || "place").toString().toLowerCase();
        var status = (marker.markerStatus || "unknown").toString().toLowerCase();
        var ariaLabels;
        if (marker.onSelectAccessibilityMessage || marker.onEnterAccessibilityMessage) {
            ariaLabels = {
                default: marker.onEnterAccessibilityMessage || "",
                onSelect: marker.onSelectAccessibilityMessage || ""
            };
        }
        var _marker_text;
        return {
            id: marker.id || "index-".concat(index),
            name: (_marker_text = marker.text) !== null && _marker_text !== void 0 ? _marker_text : void 0,
            lat: marker.markerPosition.latitude,
            lng: marker.markerPosition.longitude,
            type: type,
            status: status,
            qualifiers: _toConsumableArray(marker.qualifiers),
            text: type === "place" ? marker.text || void 0 : void 0,
            price: type === "property" ? marker.text : void 0,
            ariaLabels: ariaLabels
        };
    });
};
// ../internal/src/components/map/dynamic-map.tsx
var trackMapViewportBoundChangedId = "trackMapViewportBoundChangedCb";
var trackMarkerSelectionId = "trackMarkerSelectionId";
var trackMapContentPresentedId = "trackMapContentPresentedId";
var __Fragment = gql6(_templateObject5());
var DynamicMap = function(param) {
    var children = param.children, className = param.className, data = param.data, beforeInit = param.beforeInit, onInit = param.onInit, supplementalFeatures = param.supplementalFeatures, onFeaturesPushed = param.onFeaturesPushed, egMapsConfig = param.egMapsConfig, selectedFeatureId = param.selectedFeatureId, viewMode = param.viewMode, _param_egDistancesEnabled = param.egDistancesEnabled, egDistancesEnabled = _param_egDistancesEnabled === void 0 ? false : _param_egDistancesEnabled, clientPadding = param.clientPadding, _param_height = param.height, height = _param_height === void 0 ? "100vh" : _param_height, _param_updateViewport = param.updateViewport, updateViewport = _param_updateViewport === void 0 ? true : _param_updateViewport;
    var _ref = data || {}, initialViewport = _ref.initialViewport, center = _ref.center, zoom = _ref.zoom, bounds = _ref.bounds, computedBoundsOptions = _ref.computedBoundsOptions, config = _ref.config, markers = _ref.markers;
    var mapRef = React6.useRef();
    var initDone = React6.useRef(false);
    var backupMapFragment = React6.useRef();
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapViewportMoved = _useEgMapClickstream.trackMapViewportMoved, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapPlaceSelected = _useEgMapClickstream.trackMapPlaceSelected, trackMapPropertySelected = _useEgMapClickstream.trackMapPropertySelected, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var _useBexApi2 = useBexApi2(), _useBexApi2_context = _useBexApi2.context, locale = _useBexApi2_context.locale, currency = _useBexApi2_context.currency;
    React6.useEffect(function() {
        if (data) {
            backupMapFragment.current = data;
        }
    }, [
        data
    ]);
    var dynamicMapConfig = React6.useMemo(function() {
        var _backupMapFragment_current;
        return config || ((_backupMapFragment_current = backupMapFragment.current) === null || _backupMapFragment_current === void 0 ? void 0 : _backupMapFragment_current.config);
    }, [
        config
    ]);
    React6.useEffect(function() {
        return trackMapHidden;
    }, []);
    React6.useEffect(function() {
        if (dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider) {
            var provider = (dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider) === "MAPBOX" /* MAPBOX */  ? "mapbox" : "google-maps";
            trackMapInit(provider, selectedFeatureId);
        }
    }, [
        dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider
    ]);
    var cfg = React6.useMemo(function() {
        if (dynamicMapConfig) {
            var _dynamicMapConfig_externalConfigEndpoint;
            var ret = egMapsConfig ? _objectSpread({}, egMapsConfig) : {};
            if (className) {
                ret.additionalCssClass = className;
            }
            if (locale) {
                ret.locale = locale;
            }
            if (currency) {
                ret.iso4217CurrencyCode = currency;
            }
            if ((_dynamicMapConfig_externalConfigEndpoint = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint.value) {
                var _dynamicMapConfig_externalConfigEndpoint1;
                ret.externalConfigEndpoint = (_dynamicMapConfig_externalConfigEndpoint1 = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint1 === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint1.value;
            }
            if (dynamicMapConfig.mapId) {
                switch(dynamicMapConfig.egdsMapProvider){
                    default:
                    case "GOOGLE" /* GOOGLE */ :
                        if (!ret.googleMaps) {
                            ret.googleMaps = {};
                        }
                        if (!ret.googleMaps.gmapsAddConfig) {
                            ret.googleMaps.gmapsAddConfig = {};
                        }
                        ret.googleMaps.gmapsAddConfig.mapId = dynamicMapConfig.mapId;
                        break;
                    case "MAPBOX" /* MAPBOX */ :
                        if (!ret.mapbox) {
                            ret.mapbox = {};
                        }
                        if (!ret.mapbox.mapboxAddConf) {
                            ret.mapbox.mapboxAddConf = {};
                        }
                        ret.mapbox.mapboxAddConf.style = dynamicMapConfig.mapId;
                        break;
                }
            }
            return ret;
        }
    }, [
        dynamicMapConfig,
        locale,
        currency,
        egMapsConfig
    ]);
    var accessToken = dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.accessToken;
    var identifyMapType = function() {
        switch(dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider){
            case "MAPBOX" /* MAPBOX */ :
                return UitkEGMapsType.MAPBOX;
            case "GOOGLE" /* GOOGLE */ :
            default:
                return UitkEGMapsType.GOOGLE;
        }
    };
    var mapType = identifyMapType();
    var features = React6.useMemo(function() {
        return _toConsumableArray(convertMarkers(markers === null || markers === void 0 ? void 0 : markers.map(function(m) {
            return m;
        }))).concat(_toConsumableArray(supplementalFeatures || []));
    }, [
        markers,
        supplementalFeatures
    ]);
    var featureCoordinates = React6.useMemo(function() {
        return features === null || features === void 0 ? void 0 : features.map(function(f) {
            return [
                f.lat,
                f.lng
            ];
        });
    }, [
        features
    ]);
    var computeBoundsViewport = function(b) {
        return {
            sw: [
                b === null || b === void 0 ? void 0 : b.southwest.latitude,
                b === null || b === void 0 ? void 0 : b.southwest.longitude
            ],
            ne: [
                b === null || b === void 0 ? void 0 : b.northeast.latitude,
                b === null || b === void 0 ? void 0 : b.northeast.longitude
            ]
        };
    };
    var computeCenterAndZoomViewport = function(c, z) {
        return {
            center: [
                c === null || c === void 0 ? void 0 : c.latitude,
                c === null || c === void 0 ? void 0 : c.longitude
            ],
            zoom: z
        };
    };
    var computeBoundsComputedViewport = function(coordinates, options) {
        return {
            useBoundsComputation: true,
            options: {
                gaiaId: (options === null || options === void 0 ? void 0 : options.gaiaId) && !Number.isNaN(Number(options === null || options === void 0 ? void 0 : options.gaiaId)) ? Number(options === null || options === void 0 ? void 0 : options.gaiaId) : void 0,
                lowerQuantile: options === null || options === void 0 ? void 0 : options.lowerQuantile,
                upperQuantile: options === null || options === void 0 ? void 0 : options.upperQuantile,
                marginMultiplier: options === null || options === void 0 ? void 0 : options.marginMultiplier,
                minMargin: options === null || options === void 0 ? void 0 : options.minMargin,
                minimumPins: options === null || options === void 0 ? void 0 : options.minimumPins,
                interpolationRatio: options === null || options === void 0 ? void 0 : options.interpolationRatio
            },
            coordinates: options.coordinates.length > 0 ? options.coordinates.map(function(c) {
                return [
                    c.latitude,
                    c.longitude
                ];
            }) : coordinates
        };
    };
    React6.useEffect(function() {
        var map = mapRef.current;
        if (initDone.current && map && updateViewport) {
            if (bounds) {
                var _computeBoundsViewport = computeBoundsViewport(bounds), sw = _computeBoundsViewport.sw, ne = _computeBoundsViewport.ne;
                map.fitBounds(sw, ne, void 0, clientPadding);
            } else if (center !== null && zoom !== null) {
                var _computeCenterAndZoomViewport = computeCenterAndZoomViewport(center, zoom), c = _computeCenterAndZoomViewport.center, z = _computeCenterAndZoomViewport.zoom;
                map.centerAndZoomMap(c, z, clientPadding);
            } else if (computedBoundsOptions) {
                var _computeBoundsComputedViewport = computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions), useBoundsComputation = _computeBoundsComputedViewport.useBoundsComputation, options = _computeBoundsComputedViewport.options, coordinates = _computeBoundsComputedViewport.coordinates;
                map.boundsContaining(coordinates, useBoundsComputation, options).then(function(boundsWithCenter) {
                    var sw = boundsWithCenter.sw, ne = boundsWithCenter.ne;
                    map.fitBounds(sw, ne, void 0, clientPadding);
                });
            } else if ((featureCoordinates === null || featureCoordinates === void 0 ? void 0 : featureCoordinates.length) > 0) {
                map.fitLatLongs(featureCoordinates, void 0, clientPadding);
            }
        }
    }, [
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates,
        updateViewport,
        clientPadding
    ]);
    var initialViewportObject = React6.useMemo(function() {
        switch(initialViewport){
            case "BOUNDS" /* BOUNDS */ :
                return bounds ? computeBoundsViewport(bounds) : void 0;
            case "CENTER_AND_ZOOM" /* CENTER_AND_ZOOM */ :
                return center && zoom !== null ? computeCenterAndZoomViewport(center, zoom) : void 0;
            case "COMPUTED_BOUNDS" /* COMPUTED_BOUNDS */ :
                return computedBoundsOptions ? computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions) : void 0;
            case "FIT_MARKERS" /* FIT_MARKERS */ :
            default:
                return featureCoordinates;
        }
    }, [
        initialViewport,
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates
    ]);
    var trackMapViewportBoundChangedCb = React6.useCallback(function(event) {
        var boundChangeMovementMapping = {
            zoomIn: "zoom_in" /* ZOOM_IN */ ,
            zoomOut: "zoom_out" /* ZOOM_OUT */ ,
            drag: "pan" /* PAN */ ,
            zoomInKeyboard: "zoom_in" /* ZOOM_IN */ ,
            zoomOutKeyboard: "zoom_out" /* ZOOM_OUT */ ,
            pitch: "pan" /* PAN */ ,
            rotate: "pan" /* PAN */ ,
            touch: "pan" /* PAN */ ,
            moveKeyboard: "pan" /* PAN */ ,
            clusterExtent: "zoom_in" /* ZOOM_IN */ 
        };
        var boundsChangeType = event === null || event === void 0 ? void 0 : event.originalEvent;
        var movementType = boundChangeMovementMapping[boundsChangeType];
        if (movementType !== void 0) {
            trackMapViewportMoved(egBoundsToString(event.bounds), movementType, event.zoom);
        }
    }, [
        trackMapViewportMoved
    ]);
    var trackMarkerClick = React6.useCallback(function(feature) {
        if (feature) {
            var type = feature.type, _feature_id = feature.id, id = _feature_id === void 0 ? null : _feature_id;
            if (type && id !== null) {
                switch(type){
                    case "place":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , "destination" /* DESTINATION */ );
                        break;
                    case "property":
                        trackMapPropertySelected(id.toString(), "property" /* PROPERTY */ );
                        break;
                    case "cluster":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , "cluster" /* CLUSTER */ );
                        break;
                    default:
                        break;
                }
            }
        }
    }, [
        trackMapPlaceSelected,
        trackMapPropertySelected
    ]);
    var tilesContentLoadedCallback = React6.useCallback(function() {
        setTimeout(function() {
            var options = getContentPresentedOptions(mapRef.current, "tile" /* TILE */ );
            trackMapContentPresented(options);
        }, CONTENT_PRESENTED_DELAY);
    }, [
        trackMapContentPresented
    ]);
    var trackMarkerSelectionCb = React6.useCallback(function(event) {
        if (event.action === "select") {
            trackMarkerClick(event.feature);
        }
    }, [
        trackMarkerClick
    ]);
    React6.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        }
    }, [
        trackMapViewportBoundChangedCb
    ]);
    React6.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        }
    }, [
        trackMarkerSelectionCb
    ]);
    React6.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        }
    }, [
        tilesContentLoadedCallback
    ]);
    var internalBeforeInit = React6.useCallback(function(map) {
        mapRef.current = map;
        map.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        map.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        map.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        if (beforeInit) {
            beforeInit(map);
        }
    }, []);
    var onInitInternal = React6.useCallback(function(map) {
        initDone.current = true;
        if (map) {
            var mapId = "";
            switch(mapType){
                default:
                case UitkEGMapsType.GOOGLE:
                    mapId = map.readConfigParam("googleMaps,gmapsAddConfig,mapId");
                    break;
                case UitkEGMapsType.MAPBOX:
                    mapId = map.readConfigParam("mapbox,mapboxAddConf,style");
                    break;
            }
            var bbox = map.getBounds();
            if (bbox) {
                var bboxString = boundingBoxToString(bbox.sw, bbox.ne);
                trackMapPresented(bboxString, mapId, viewMode);
            }
        }
        if (onInit) {
            onInit(map);
        }
    }, [
        onInit,
        trackMapPresented,
        viewMode,
        mapType
    ]);
    var onFeaturesPushedInternal = React6.useCallback(function(map, b) {
        if (b) {
            setTimeout(function() {
                var options = getContentPresentedOptions(map, "user" /* USER */ );
                trackMapContentPresented(options);
            }, CONTENT_PRESENTED_DELAY);
            if (onFeaturesPushed) {
                onFeaturesPushed(map, b);
            }
        }
    }, [
        onFeaturesPushed,
        trackMapContentPresented
    ]);
    if (!data && !initDone.current) {
        return /* @__PURE__ */ React6.createElement("div", {
            style: {
                height: height
            }
        }, /* @__PURE__ */ React6.createElement(UitkLayoutPosition2, {
            type: "relative",
            position: {
                top: "center",
                left: "center"
            }
        }, /* @__PURE__ */ React6.createElement(UitkPageLoader, {
            visible: true
        })));
    }
    return /* @__PURE__ */ React6.createElement(UitkEGMaps, {
        accessToken: accessToken,
        mapType: mapType,
        initialViewport: initialViewportObject,
        beforeInit: internalBeforeInit,
        onInit: onInitInternal,
        height: height,
        mapConfig: cfg,
        features: features,
        onFeaturesPushed: onFeaturesPushedInternal,
        egDistancesEnabled: egDistancesEnabled,
        clientPadding: clientPadding
    }, children);
};
DynamicMap.displayName = "DynamicMap";
DynamicMap.fragment = __Fragment;
// ../internal/src/components/map/map-card-content.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkFigure as UitkFigure2, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
var fragment = gql7(_templateObject6());
var MapCardContent = function(param) {
    var data = param.data;
    if (!data || !data.title) {
        return null;
    }
    var description = data.description, image = data.image, title = data.title, subTitle = data.subTitle;
    var imageUrl = image === null || image === void 0 ? void 0 : image.url;
    var imageDescription = image === null || image === void 0 ? void 0 : image.description;
    return /* @__PURE__ */ React7.createElement(UitkSheet3, {
        isVisible: true,
        triggerRef: null
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlex6, null, imageUrl && /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem6, {
        grow: 1,
        minWidth: "twenty_four"
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkFigure2, {
        imageFit: "cover"
    }, /* @__PURE__ */ React7.createElement(UitkImage, {
        src: imageUrl,
        alt: imageDescription,
        placeholderImage: true
    })))), /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem6, {
        grow: 3,
        minWidth: "seventy_two"
    }, /* @__PURE__ */ React7.createElement(UitkSpacing6, {
        padding: {
            block: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkText5, {
        size: 400,
        weight: "bold"
    }, title), /* @__PURE__ */ React7.createElement(UitkSpacing6, {
        padding: {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React7.createElement(UitkText5, null, subTitle)), description && /* @__PURE__ */ React7.createElement(UitkSpacing6, {
        padding: {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React7.createElement(UitkText5, null, description)))))));
};
MapCardContent.fragment = fragment;
MapCardContent.displayName = "MapCardContent";
// src/components/map/map.tsx
import { UitkEGMapsQualifier as UitkEGMapsQualifier2 } from "uitk-react-map";
import { UitkSheet as UitkSheet5 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
// src/components/map/analytics/map-analytics.tsx
var BASE_RFRR = "HOT.HIS.Module.Map";
var _obj1;
var MapTracksDictionary = (_obj1 = {}, _defineProperty(_obj1, "PAN" /* PAN */ , [
    "".concat(BASE_RFRR, ".Pan"),
    "User panning PWA HIS Map"
]), _defineProperty(_obj1, "ZOOM_IN" /* ZOOM_IN */ , [
    "".concat(BASE_RFRR, ".Zoom.In"),
    "User zooming in on PWA HIS Map"
]), _defineProperty(_obj1, "ZOOM_OUT" /* ZOOM_OUT */ , [
    "".concat(BASE_RFRR, ".Zoom.Out"),
    "User zooming out on PWA HIS Map"
]), _defineProperty(_obj1, "CLOSE" /* CLOSE */ , [
    "".concat(BASE_RFRR, ".Link.Close"),
    "Close map dialog"
]), _obj1);
var _obj2;
var MarkerTracksDictionary = (_obj2 = {}, _defineProperty(_obj2, "HOTEL" /* HOTEL */ , [
    "".concat(BASE_RFRR, ".HotelMarkerSelect"),
    "A hotel marker selected on HIS map"
]), _defineProperty(_obj2, "LANDMARK" /* LANDMARK */ , [
    "".concat(BASE_RFRR, ".PlaceMarkerSelect"),
    "A landmark marker selected on HIS map"
]), _defineProperty(_obj2, "AIRPORT" /* AIRPORT */ , [
    "".concat(BASE_RFRR, ".AirportMarkerSelect"),
    "An Airport marker selected on HIS map"
]), _defineProperty(_obj2, "RESTAURANT" /* RESTAURANT */ , [
    "".concat(BASE_RFRR, ".RestaurantMarkerSelect"),
    "A restaurant marker selected on HIS map"
]), _defineProperty(_obj2, "METRO" /* METRO */ , [
    "".concat(BASE_RFRR, ".TransitMarkerSelect"),
    "A train marker selected on HIS map"
]), _defineProperty(_obj2, "TRAIN" /* TRAIN */ , [
    "".concat(BASE_RFRR, ".TransitMarkerSelect"),
    "A train marker selected on HIS map"
]), _defineProperty(_obj2, "CIRCLE" /* CIRCLE */ , [
    "".concat(BASE_RFRR, ".CircleMarkerSelect"),
    "A circle marker selected on HIS map"
]), _obj2);
var _obj3;
var FilterTracksDictionary = (_obj3 = {}, _defineProperty(_obj3, "RESTAURANT_APPLIED" /* RESTAURANT */ , [
    "".concat(BASE_RFRR, ".RestaurantsFilterApplied"),
    "Show restaurants on HIS map"
]), _defineProperty(_obj3, "LANDMARK_APPLIED" /* LANDMARK */ , [
    "".concat(BASE_RFRR, ".LandmarksFilterApplied"),
    "Show landmarks on HIS map"
]), _defineProperty(_obj3, "BOTH_APPLIED" /* BOTH */ , [
    "".concat(BASE_RFRR, ".BothFiltersApplied"),
    "Show landmarks and restaurants on HIS map"
]), _defineProperty(_obj3, "NONE_APPLIED" /* NONE */ , [
    "".concat(BASE_RFRR, ".NoFiltersApplied"),
    "Show only airports and hotel on HIS map"
]), _obj3);
function useAnalytics(onCloseCallback) {
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapViewportMoved = _useEgMapClickstream.trackMapViewportMoved, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapPlaceSelected = _useEgMapClickstream.trackMapPlaceSelected, trackMapPropertySelected = _useEgMapClickstream.trackMapPropertySelected, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var onMapBoundsChanged = function(event) {
        switch(event.originalEvent){
            case "zoomOut":
            case "zoomOutKeyboard":
                trackMapViewportMoved(boundingBoxToString(event.bounds.sw, event.bounds.ne), "zoom_out" /* ZOOM_OUT */ , event.zoom);
                break;
            case "zoomIn":
            case "zoomInKeyboard":
            case "clusterExtent":
                trackMapViewportMoved(boundingBoxToString(event.bounds.sw, event.bounds.ne), "zoom_in" /* ZOOM_IN */ , event.zoom);
                break;
            case "drag":
            case "rotate":
            case "moveKeyboard":
            case "pitch":
            case "touch":
                trackMapViewportMoved(boundingBoxToString(event.bounds.sw, event.bounds.ne), "pan" /* PAN */ , event.zoom);
                break;
        }
    };
    var onSelectionChange = function(event) {
        if (event) {
            var feature = event.feature;
            switch(feature.type){
                case "property":
                    trackMapPropertySelected(feature.id.toString(), "property" /* PROPERTY */ );
                    break;
                case "place":
                    var _feature_id;
                    trackMapPlaceSelected((_feature_id = feature.id) === null || _feature_id === void 0 ? void 0 : _feature_id.toString(), "Point" /* POINT */ , "destination" /* DESTINATION */ );
                    break;
                case "cluster":
                    trackMapPlaceSelected(feature.id.toString(), "Point" /* POINT */ , "cluster" /* CLUSTER */ );
                    break;
            }
        }
    };
    var onClose = function() {
        if (onCloseCallback) {
            onCloseCallback();
        }
        trackMapHidden();
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapContentPresented: trackMapContentPresented,
        onMapBoundsChanged: onMapBoundsChanged,
        onSelectionChange: onSelectionChange,
        onClose: onClose
    };
}
// src/components/map/map-actions.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { useRefTargetScroll } from "@shared-ui/ref-context";
import { UitkButtonSize, UitkFloatingButton } from "uitk-react-button";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
// src/components/map/places-dialog.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { ViewLarge as ViewLarge2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet4, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/map/place-display.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkSubheading, UitkText as UitkText6 } from "uitk-react-text";
var __PlaceDisplayFragment = gql8(_templateObject7());
var PlaceDisplay = function(props) {
    var _data_placesDialogEGDSTextsContentSection, _data_placesDialogEGDSTextsContentSection_heading, _data_placesDialogEGDSTextsContentSection1;
    var data = props.data, savedFeature = props.savedFeature, saveCustomPlace = props.saveCustomPlace;
    var heading = data === null || data === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection = data.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection_heading = _data_placesDialogEGDSTextsContentSection.heading) === null || _data_placesDialogEGDSTextsContentSection_heading === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection_heading.text;
    var clearSavedPlaceIcon = data === null || data === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection1 = data.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection1 === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection1.clearSavedPlaceIcon;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(UitkSpacing7, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React8.createElement(UitkHeading5, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React8.createElement(UitkSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex7, {
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React8.createElement(UitkIcon3, {
        name: "place",
        size: UitkIconSize3.SMALL
    })), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem7, {
        grow: 10
    }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(UitkText6, {
        weight: "bold"
    }, savedFeature.name), /* @__PURE__ */ React8.createElement(UitkSpacing7, null, /* @__PURE__ */ React8.createElement(UitkSubheading, null, savedFeature.text)))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React8.createElement("button", {
        onClick: function() {
            return saveCustomPlace(void 0);
        },
        type: "button"
    }, /* @__PURE__ */ React8.createElement(UitkIcon3, {
        id: clearSavedPlaceIcon === null || clearSavedPlaceIcon === void 0 ? void 0 : clearSavedPlaceIcon.id,
        name: "close",
        size: UitkIconSize3.SMALL,
        title: clearSavedPlaceIcon === null || clearSavedPlaceIcon === void 0 ? void 0 : clearSavedPlaceIcon.description
    }))))));
};
PlaceDisplay.fragment = __PlaceDisplayFragment;
PlaceDisplay.displayName = "placeDisplay";
// src/components/map/places-search.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { ViewLarge, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText7 } from "uitk-react-text";
import { TypeaheadRenderType as TypeaheadRenderType2 } from "uitk-react-typeahead";
// src/components/map/places-typeahead.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ESSAdapter, UitkTypeahead } from "uitk-react-typeahead";
var __PlacesTypeaheadFragment = gql9(_templateObject8());
var PlacesTypeahead = function(props) {
    var _typeaheadContent_typeaheadInfo, _typeaheadContent_typeaheadInfo1, _typeaheadContent_typeaheadInfo2;
    var data = props.data, handleChange = props.handleChange, essLogger = props.essLogger, strictFullscreen = props.strictFullscreen, renderType = props.renderType;
    var context = useBexApi3().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
    var isProduction = process.env.NODE_ENV === "production";
    var _ref = identity || {}, guid = _ref.duaid;
    var typeaheadContent = data === null || data === void 0 ? void 0 : data.content;
    var _typeaheadContent_label;
    var label = (_typeaheadContent_label = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.label) !== null && _typeaheadContent_label !== void 0 ? _typeaheadContent_label : "";
    var _typeaheadContent_placeholder;
    var placeholder = (_typeaheadContent_placeholder = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.placeholder) !== null && _typeaheadContent_placeholder !== void 0 ? _typeaheadContent_placeholder : "";
    var _typeaheadContent_typeaheadEmptyResultPlaceholder;
    var noResultsPlaceholder = (_typeaheadContent_typeaheadEmptyResultPlaceholder = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : typeaheadContent.typeaheadEmptyResultPlaceholder) !== null && _typeaheadContent_typeaheadEmptyResultPlaceholder !== void 0 ? _typeaheadContent_typeaheadEmptyResultPlaceholder : "";
    var _typeaheadContent_typeaheadInfo_client, _typeaheadContent_typeaheadInfo_maxNumberOfResults, _typeaheadContent_typeaheadInfo_regionType;
    var adapter = new ESSAdapter({
        client: (_typeaheadContent_typeaheadInfo_client = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo === void 0 ? void 0 : _typeaheadContent_typeaheadInfo.client) !== null && _typeaheadContent_typeaheadInfo_client !== void 0 ? _typeaheadContent_typeaheadInfo_client : "Homepage",
        domain: isProduction ? void 0 : "https://www.expedia.com/",
        dest: true,
        expuserid: expuserid,
        features: "ta_hierarchy|postal_code|contextual_ta",
        guid: guid,
        lob: "HOTELS",
        locale: locale,
        maxResults: (_typeaheadContent_typeaheadInfo_maxNumberOfResults = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo1 = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo1 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo1.maxNumberOfResults) !== null && _typeaheadContent_typeaheadInfo_maxNumberOfResults !== void 0 ? _typeaheadContent_typeaheadInfo_maxNumberOfResults : 10,
        regionType: (_typeaheadContent_typeaheadInfo_regionType = typeaheadContent === null || typeaheadContent === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo2 = typeaheadContent.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo2 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo2.regionType) !== null && _typeaheadContent_typeaheadInfo_regionType !== void 0 ? _typeaheadContent_typeaheadInfo_regionType : 2047,
        siteId: siteId,
        personalize: true,
        essLogger: essLogger
    });
    return /* @__PURE__ */ React9.createElement(UitkTypeahead, {
        adapter: adapter,
        icon: "place",
        name: "placesTypeAhead",
        onUpdate: handleChange,
        stid: "typeahead-adaptive",
        value: "",
        strictFullscreen: strictFullscreen,
        typeaheadPlaceholder: placeholder,
        typeaheadEmptyResultPlaceholder: noResultsPlaceholder,
        id: "placesTypeAhead",
        label: label,
        renderType: renderType
    });
};
PlacesTypeahead.fragment = __PlacesTypeaheadFragment;
PlacesTypeahead.displayName = "PlacesTypeahead";
// src/components/map/places-search.tsx
var __PlacesSearchFragment = gql10(_templateObject9(), PlacesTypeahead.fragment);
var PlacesSearch = function(props) {
    var _typeAheadData_heading, _typeAheadData_subHeading;
    var data = props.data, handleChange = props.handleChange, essLogger = props.essLogger;
    var typeAheadData = data === null || data === void 0 ? void 0 : data.placesDialogTypeAheadContentSection;
    var heading = typeAheadData === null || typeAheadData === void 0 ? void 0 : (_typeAheadData_heading = typeAheadData.heading) === null || _typeAheadData_heading === void 0 ? void 0 : _typeAheadData_heading.text;
    var subHeading = typeAheadData === null || typeAheadData === void 0 ? void 0 : (_typeAheadData_subHeading = typeAheadData.subHeading) === null || _typeAheadData_subHeading === void 0 ? void 0 : _typeAheadData_subHeading.text;
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkSpacing8, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React10.createElement(UitkHeading6, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React10.createElement(UitkSpacing8, {
        padding: {
            blockstart: "one",
            blockend: "three"
        }
    }, subHeading && /* @__PURE__ */ React10.createElement(UitkHeading6, {
        tag: "h4"
    }, /* @__PURE__ */ React10.createElement(UitkText7, {
        weight: "regular",
        inline: true
    }, subHeading))), typeAheadData && /* @__PURE__ */ React10.createElement(Viewport3, null, /* @__PURE__ */ React10.createElement(ViewSmall3, null, /* @__PURE__ */ React10.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        essLogger: essLogger,
        strictFullscreen: true,
        renderType: TypeaheadRenderType2.DIALOG
    })), /* @__PURE__ */ React10.createElement(ViewLarge, null, /* @__PURE__ */ React10.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        essLogger: essLogger
    }))));
};
PlacesSearch.fragment = __PlacesSearchFragment;
PlacesSearch.displayName = "PlacesSearch";
// src/components/map/places-switches.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/lodging-egds-switch/lodging-egds-switch.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkSwitch } from "uitk-react-switch";
var __Fragment2 = gql11(_templateObject10());
var LodgingEGDSSwitch = function(_param) {
    var data = _param.data, checked = _param.checked, handleToggle = _param.handleToggle, props = _objectWithoutProperties(_param, [
        "data",
        "checked",
        "handleToggle"
    ]);
    var initialCheck = data.checked, checkedAnalytics = data.checkedAnalytics, checkedLabel = data.checkedLabel, enabled = data.enabled, uncheckedAnalytics = data.uncheckedAnalytics, uncheckedLabel = data.uncheckedLabel;
    var _React11_useState = _slicedToArray(React11.useState(checked !== null && checked !== void 0 ? checked : initialCheck), 2), isChecked = _React11_useState[0], setIsChecked = _React11_useState[1];
    React11.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : initialCheck);
    }, [
        checked,
        initialCheck
    ]);
    var track = useClickTracker5();
    var handleChange = React11.useCallback(function(event) {
        var _event_currentTarget = event.currentTarget, wasChecked = _event_currentTarget.checked;
        setIsChecked(wasChecked);
        if (checkedAnalytics && !wasChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && wasChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        handleToggle === null || handleToggle === void 0 ? void 0 : handleToggle(wasChecked);
    }, [
        checkedAnalytics,
        handleToggle,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React11.createElement(UitkSwitch, _objectSpread({
        id: isChecked ? checkedLabel : uncheckedLabel,
        disabled: !enabled,
        checked: isChecked,
        label: isChecked ? checkedLabel : uncheckedLabel,
        onChange: handleChange
    }, props));
};
LodgingEGDSSwitch.displayName = "EGDSSwitch";
LodgingEGDSSwitch.fragment = __Fragment2;
// src/components/map/places-switches.tsx
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkText as UitkText8 } from "uitk-react-text";
var __PlacesSwitchesFragment = gql12(_templateObject11(), LodgingEGDSSwitch.fragment);
function isFilterOption(content) {
    return content.__typename === "FilterOption";
}
var findToggledFilterIndex = function(toggledFilters, filteredValues) {
    return toggledFilters.map(function(qualifiers) {
        return qualifiers.join(",");
    }).indexOf(filteredValues.join(","));
};
var isToggledFilterSelected = function(toggledFilters, filteredValues) {
    return findToggledFilterIndex(toggledFilters, filteredValues) < 0;
};
var PlacesSwitches = function(param) {
    var data = param.data, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters;
    var _data_placesDialogUITogglesContentSection_subHeading;
    React12.useEffect(function() {
        if (!toggledFilters) {
            var _data_placesDialogUITogglesContentSection_content_filter_filter, _data_placesDialogUITogglesContentSection_content_filter, _data_placesDialogUITogglesContentSection, _data_placesDialogUITogglesContentSection_content;
            var values = ((_data_placesDialogUITogglesContentSection_content_filter_filter = (_data_placesDialogUITogglesContentSection_content_filter = data === null || data === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection = data.placesDialogUITogglesContentSection) === null || _data_placesDialogUITogglesContentSection === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content = _data_placesDialogUITogglesContentSection.content) === null || _data_placesDialogUITogglesContentSection_content === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content.filter(isFilterOption)) === null || _data_placesDialogUITogglesContentSection_content_filter === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content_filter.filter(function(toggle) {
                return !toggle.checked;
            })) === null || _data_placesDialogUITogglesContentSection_content_filter_filter === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content_filter_filter.map(function(toggle) {
                return toggle.filteredValues;
            })) || [];
            setToggledFilters(values);
        }
    }, [
        toggledFilters
    ]);
    var handleToggle = React12.useCallback(function(checked, filteredValues) {
        var foundIndex = toggledFilters !== void 0 ? findToggledFilterIndex(toggledFilters, filteredValues) : -1;
        if (toggledFilters && foundIndex >= 0 && checked) {
            setToggledFilters(_toConsumableArray(toggledFilters.slice(0, foundIndex)).concat(_toConsumableArray(toggledFilters.slice(foundIndex + 1))));
        } else if (!checked && foundIndex < 0) {
            var values = toggledFilters ? _toConsumableArray(toggledFilters).concat([
                filteredValues
            ]) : [
                filteredValues
            ];
            setToggledFilters(values);
        }
    }, [
        toggledFilters,
        setToggledFilters
    ]);
    if (!data || !data.placesDialogUITogglesContentSection) {
        return null;
    }
    var subHeading = (_data_placesDialogUITogglesContentSection_subHeading = data.placesDialogUITogglesContentSection.subHeading) === null || _data_placesDialogUITogglesContentSection_subHeading === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_subHeading.text;
    var content = data.placesDialogUITogglesContentSection.content;
    return /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(UitkSpacing9, {
        padding: {
            blockstart: "six"
        }
    }, subHeading && /* @__PURE__ */ React12.createElement(UitkHeading7, {
        tag: "h4"
    }, /* @__PURE__ */ React12.createElement(UitkText8, {
        weight: "regular",
        inline: true
    }, subHeading))), content === null || content === void 0 ? void 0 : content.filter(isFilterOption).map(function(toggle, idx) {
        var filteredValues = toggle.filteredValues, switchData = _objectWithoutProperties(toggle, [
            "filteredValues"
        ]);
        var isChecked = toggledFilters !== void 0 ? isToggledFilterSelected(toggledFilters, filteredValues) : void 0;
        return /* @__PURE__ */ React12.createElement(UitkSpacing9, {
            padding: {
                blockstart: "three",
                blockend: "two"
            },
            key: "switch-".concat(idx)
        }, /* @__PURE__ */ React12.createElement(LodgingEGDSSwitch, {
            data: switchData,
            checked: isChecked,
            handleToggle: function(checked) {
                return handleToggle(checked, filteredValues);
            }
        }));
    }));
};
PlacesSwitches.fragment = __PlacesSwitchesFragment;
PlacesSwitches.displayName = "placesSwitches";
// src/components/map/places-dialog.tsx
var __PlacesDialogFragment = gql13(_templateObject12(), PlacesSearch.fragment, PlaceDisplay.fragment, PlacesSwitches.fragment);
var PlacesDialog = function(param) {
    var data = param.data, setSavedFeature = param.setSavedFeature, savedFeature = param.savedFeature, essLogger = param.essLogger, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters, closeDialog = param.onClosePlacesDialog, showPlacesDialog = param.showPlacesDialog;
    var _data_trigger, _data_trigger_icon, _data_dialog, _data_dialog_toolbar;
    var _useEgMapClickstream = useEgMapClickstream(), trackMapCustomPlaceAdded = _useEgMapClickstream.trackMapCustomPlaceAdded, trackMapCustomPlaceRemoved = _useEgMapClickstream.trackMapCustomPlaceRemoved;
    var saveCustomPlace = function(feature) {
        if (feature) {
            var featureDetail = feature.name || feature.text || feature.id.toString();
            trackMapCustomPlaceAdded("gaia" /* GAIA */ , featureDetail, feature.id.toString());
        } else if (savedFeature) {
            var featureDetail1 = savedFeature.name || savedFeature.text || savedFeature.id.toString();
            trackMapCustomPlaceRemoved("gaia" /* GAIA */ , featureDetail1, savedFeature.id.toString());
        }
        setSavedFeature(feature);
    };
    var getNameAndText = function(fullName, shortName, type) {
        var nameArray;
        if (type === "AIRPORT" /* AIRPORT */ ) {
            nameArray = shortName || fullName ? [
                shortName || fullName
            ] : [];
        } else {
            var _fullName_split;
            nameArray = (_fullName_split = fullName === null || fullName === void 0 ? void 0 : fullName.split(", ")) !== null && _fullName_split !== void 0 ? _fullName_split : [];
        }
        return {
            name: nameArray.shift(),
            text: nameArray.join(", ")
        };
    };
    var handleTypeaheadChange = function(selection) {
        var selectionData = selection.data;
        var _ref = selectionData || {}, regionNames = _ref.regionNames, type = _ref.type, location = _ref.location, essId = _ref.essId;
        var _getNameAndText = getNameAndText(regionNames === null || regionNames === void 0 ? void 0 : regionNames.fullName, regionNames === null || regionNames === void 0 ? void 0 : regionNames.shortName, type), name = _getNameAndText.name, text = _getNameAndText.text;
        var _ref1 = location || {}, lat = _ref1.lat, long = _ref1.long;
        var idFromLatLong = "".concat(lat).concat(long).replace(/\./g, "");
        var _essId_sourceId;
        var feature = {
            id: (_essId_sourceId = essId.sourceId) !== null && _essId_sourceId !== void 0 ? _essId_sourceId : idFromLatLong,
            lat: parseFloat(lat),
            lng: parseFloat(long),
            type: "place",
            status: "unknown",
            name: name,
            text: text,
            qualifiers: [
                "searchedLocation"
            ],
            score: 1
        };
        saveCustomPlace(feature);
        closeDialog();
    };
    var dialogTitle = data === null || data === void 0 ? void 0 : (_data_trigger = data.trigger) === null || _data_trigger === void 0 ? void 0 : (_data_trigger_icon = _data_trigger.icon) === null || _data_trigger_icon === void 0 ? void 0 : _data_trigger_icon.description;
    var _data_dialog_toolbar_closeText;
    var toolbarCloseText = (_data_dialog_toolbar_closeText = data === null || data === void 0 ? void 0 : (_data_dialog = data.dialog) === null || _data_dialog === void 0 ? void 0 : (_data_dialog_toolbar = _data_dialog.toolbar) === null || _data_dialog_toolbar === void 0 ? void 0 : _data_dialog_toolbar.closeText) !== null && _data_dialog_toolbar_closeText !== void 0 ? _data_dialog_toolbar_closeText : "";
    var dialogLayout = /* @__PURE__ */ React13.createElement(UitkLayoutFlex8, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React13.createElement(UitkToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: toolbarCloseText
        },
        toolbarTitle: dialogTitle
    }), /* @__PURE__ */ React13.createElement(UitkSheetContent2, null, savedFeature && /* @__PURE__ */ React13.createElement(PlaceDisplay, {
        data: data,
        savedFeature: savedFeature,
        saveCustomPlace: saveCustomPlace
    }), !savedFeature && /* @__PURE__ */ React13.createElement(PlacesSearch, {
        data: data,
        handleChange: handleTypeaheadChange,
        essLogger: essLogger
    }), /* @__PURE__ */ React13.createElement(PlacesSwitches, {
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        data: data
    })));
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Viewport4, null, /* @__PURE__ */ React13.createElement(ViewSmall4, null, /* @__PURE__ */ React13.createElement(UitkSheet4, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 12
        },
        triggerRef: null
    }, dialogLayout)), /* @__PURE__ */ React13.createElement(ViewLarge2, null, /* @__PURE__ */ React13.createElement(UitkSheet4, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 4
        },
        triggerRef: null
    }, dialogLayout))));
};
PlacesDialog.fragment = __PlacesDialogFragment;
PlacesDialog.displayName = "PlacesDialog";
// src/components/map/map-actions.tsx
var SCROLL_TIMEOUT = 1e3;
var __MapActionsFragment = gql14(_templateObject13(), PlacesDialog.fragment);
var MapActionsComponent = function(param) {
    var data = param.data, onClose = param.onClose, savedFeature = param.savedFeature, essLogger = param.essLogger, onTogglesChanged = param.onTogglesChanged, setSavedFeature = param.setSavedFeature;
    var _placesDialogData_trigger, _placesDialogData_trigger_icon;
    var scrollTo = useRefTargetScroll().scrollTo;
    var _useEgMapClickstream = useEgMapClickstream(), trackMapPlacesDialogOpened = _useEgMapClickstream.trackMapPlacesDialogOpened, trackMapPlacesDialogClosed = _useEgMapClickstream.trackMapPlacesDialogClosed;
    var _React14_useState = _slicedToArray(React14.useState(), 2), toggledFilters = _React14_useState[0], setToggledFilters = _React14_useState[1];
    var clickstreamTrack = useEgClickstream2();
    var placesDialogData = (data === null || data === void 0 ? void 0 : data.dialogs) && (data === null || data === void 0 ? void 0 : data.dialogs[0]);
    var dialogTitle = placesDialogData === null || placesDialogData === void 0 ? void 0 : (_placesDialogData_trigger = placesDialogData.trigger) === null || _placesDialogData_trigger === void 0 ? void 0 : (_placesDialogData_trigger_icon = _placesDialogData_trigger.icon) === null || _placesDialogData_trigger_icon === void 0 ? void 0 : _placesDialogData_trigger_icon.description;
    var _React14_useState1 = _slicedToArray(React14.useState(false), 2), showPlacesDialog = _React14_useState1[0], setShowPlacesDialog = _React14_useState1[1];
    var openPlacesDialog = function() {
        setShowPlacesDialog(true);
        trackMapPlacesDialogOpened();
    };
    var closePlacesDialog = function() {
        setShowPlacesDialog(false);
        trackMapPlacesDialogClosed();
    };
    var getUniqueFilterQualifiers = React14.useCallback(function(values) {
        var filteredQualifiers = values.flatMap(function(v) {
            return v;
        }) || [];
        return filteredQualifiers ? Array.from(new Set(filteredQualifiers)) : [];
    }, []);
    React14.useEffect(function() {
        if (toggledFilters) {
            onTogglesChanged(getUniqueFilterQualifiers(toggledFilters));
        }
    }, [
        toggledFilters
    ]);
    var PlacesButton = /* @__PURE__ */ React14.createElement(UitkFloatingButton, {
        size: UitkButtonSize.LARGE,
        onClick: openPlacesDialog
    }, /* @__PURE__ */ React14.createElement(UitkIcon4, {
        name: "place"
    }), dialogTitle);
    var placesDialog = placesDialogData && /* @__PURE__ */ React14.createElement(PlacesDialog, {
        data: placesDialogData,
        setSavedFeature: setSavedFeature,
        savedFeature: savedFeature,
        essLogger: essLogger,
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        onClosePlacesDialog: closePlacesDialog,
        showPlacesDialog: showPlacesDialog
    });
    var _ref = (data === null || data === void 0 ? void 0 : data.callToAction) || {}, chooseARoomButton = _ref.button, chooseARoomAction = _ref.action, chooseARoomClickStreamEvent = _ref.event;
    var chooseARoomBtnLabel = chooseARoomButton === null || chooseARoomButton === void 0 ? void 0 : chooseARoomButton.primary;
    var onChooseARoomButtonClick = function() {
        trackMapChooseARoomBtnClick();
        onClose();
        var targetRef = (chooseARoomAction || {}).targetRef;
        if (targetRef) {
            setTimeout(function() {
                scrollTo(targetRef, []);
            }, SCROLL_TIMEOUT);
        }
    };
    var trackMapChooseARoomBtnClick = function() {
        var _ref = chooseARoomClickStreamEvent || {}, _ref_eventName = _ref.eventName, eventName = _ref_eventName === void 0 ? "" : _ref_eventName, _ref_eventType = _ref.eventType, eventType = _ref_eventType === void 0 ? "" : _ref_eventType, _ref_eventVersion = _ref.eventVersion, eventVersion = _ref_eventVersion === void 0 ? "" : _ref_eventVersion;
        if (eventName && eventType && eventVersion && clickstreamTrack) {
            var event = buildEvent(eventName, eventType, eventVersion);
            clickstreamTrack(buildData(event, {}));
        }
    };
    return /* @__PURE__ */ React14.createElement(Experiment, {
        name: "PEXO_PDP_choose_a_room_CTA_in_map_modal_EGTNL"
    }, /* @__PURE__ */ React14.createElement(ExperimentControl, null, /* @__PURE__ */ React14.createElement(React14.Fragment, null, !showPlacesDialog && /* @__PURE__ */ React14.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            left: "center",
            bottom: "six"
        }
    }, PlacesButton), placesDialog)), /* @__PURE__ */ React14.createElement(ExperimentVariant, {
        bucket: 1
    }, /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            bottom: "six",
            left: "zero",
            right: "zero"
        }
    }, /* @__PURE__ */ React14.createElement(UitkLayoutFlex9, {
        space: "four",
        justifyContent: "center"
    }, /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem8, null, !showPlacesDialog && PlacesButton), /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem8, null, chooseARoomBtnLabel && /* @__PURE__ */ React14.createElement(UitkFloatingButton, {
        size: UitkButtonSize.LARGE,
        onClick: onChooseARoomButtonClick,
        name: chooseARoomBtnLabel
    }, chooseARoomBtnLabel)))), placesDialog)));
};
MapActionsComponent.displayName = "MapActions";
MapActionsComponent.fragment = __MapActionsFragment;
var MapActions = MapActionsComponent;
// src/components/map/map-viewport.ts
var excludeAirportFilter = function(param) {
    var qualifiers = param.qualifiers;
    return !(qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.find(function(qualifier) {
        return qualifier === "transport__airport";
    }));
};
var mapFeaturesToCoordinates = function(features) {
    return features.filter(excludeAirportFilter).map(function(feature) {
        return [
            feature.lat,
            feature.lng
        ];
    });
};
var getViewport = function(propertyCoordinates) {
    var mapFeatures = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], zoom = arguments.length > 2 ? arguments[2] : void 0;
    var mapCenter = propertyCoordinates ? [
        propertyCoordinates.latitude,
        propertyCoordinates.longitude
    ] : void 0;
    var featureCoordinates = mapFeaturesToCoordinates(mapFeatures);
    if (featureCoordinates.length <= 1 && mapCenter) {
        return {
            center: mapCenter,
            zoom: zoom !== null && zoom !== void 0 ? zoom : 15
        };
    }
    return {
        useBoundsComputation: true,
        options: mapCenter ? {
            centeredOn: mapCenter
        } : void 0,
        coordinates: featureCoordinates
    };
};
// src/components/map/map.tsx
var __MapQuery = gql15(_templateObject14(), DynamicMap.fragment, MapCardContent.fragment, MapActions.fragment);
var QUALIFIER_HIDDEN = "hidden";
var isEgdsMapFeature = function(mapMarker) {
    return mapMarker.__typename === "EGDSMapFeature";
};
var MapComponent = function(props) {
    var _propertyInfo_summary, _propertyInfo_summary_location, _propertyInfo_summary1, _egdsBasicMap_config, _mapData_toolbar, _mapData_toolbar1, _mapData_toolbar_icon;
    var context = useBexApi4().context;
    var locale = context.locale;
    var inputs = props.inputs, beforeInit = props.beforeInit, onInit = props.onInit, onCloseCallback = props.onClose, setSavedFeature = props.setSavedFeature, savedFeature = props.savedFeature, essLogger = props.essLogger, clientPadding = props.clientPadding, triggerRef = props.triggerRef;
    var _React15_useState = _slicedToArray(React15.useState(savedFeature), 2), internalSavedFeature = _React15_useState[0], setInternalSavedFeature = _React15_useState[1];
    var _React15_useState1 = _slicedToArray(React15.useState([]), 2), filteredValues = _React15_useState1[0], setFilteredValues = _React15_useState1[1];
    var centerMapOnCustomFeatureAndSelectIt = React15.useRef(true);
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__MapQuery, {
        variables: variables
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    var mapRef = React15.useRef();
    var track = useClickTracker6();
    var _React15_useState2 = _slicedToArray(React15.useState(), 2), cardContent = _React15_useState2[0], setCardContent = _React15_useState2[1];
    var propertyInfo = (data !== null && data !== void 0 ? data : {}).propertyInfo;
    var propertyCoordinates = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary = propertyInfo.summary) === null || _propertyInfo_summary === void 0 ? void 0 : (_propertyInfo_summary_location = _propertyInfo_summary.location) === null || _propertyInfo_summary_location === void 0 ? void 0 : _propertyInfo_summary_location.coordinates;
    var mapData = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary1 = propertyInfo.summary) === null || _propertyInfo_summary1 === void 0 ? void 0 : _propertyInfo_summary1.map;
    var egdsBasicMap = mapData === null || mapData === void 0 ? void 0 : mapData.egdsBasicMap;
    var dynamicMapId = egdsBasicMap === null || egdsBasicMap === void 0 ? void 0 : (_egdsBasicMap_config = egdsBasicMap.config) === null || _egdsBasicMap_config === void 0 ? void 0 : _egdsBasicMap_config.mapId;
    var egMapsFeatures = egdsBasicMap === null || egdsBasicMap === void 0 ? void 0 : egdsBasicMap.markers;
    var egFeatures = egMapsFeatures ? convertMarkers(egMapsFeatures === null || egMapsFeatures === void 0 ? void 0 : egMapsFeatures.map(function(m) {
        return m;
    })) : [];
    var mapCards = mapData === null || mapData === void 0 ? void 0 : mapData.mapInfoCards;
    var onClose = useAnalytics(onCloseCallback).onClose;
    var doCenterMapOnCustomFeatureAndSelectIt = function(map, allFeatures, customFeature, propCoordinates) {
        var options = propCoordinates ? {
            centeredOn: [
                propCoordinates.latitude,
                propCoordinates.longitude
            ]
        } : void 0;
        var coordinates = mapFeaturesToCoordinates(customFeature ? _toConsumableArray(allFeatures).concat([
            customFeature
        ]) : allFeatures);
        map.boundsContaining(coordinates, true, options).then(function(param) {
            var sw = param.sw, ne = param.ne;
            map.fitBounds(sw, ne, true, clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%");
            if (internalSavedFeature) {
                map.selectFeature(customFeature.id, customFeature.type);
            }
        });
    };
    var openCard = React15.useCallback(function(map) {
        if (centerMapOnCustomFeatureAndSelectIt.current && internalSavedFeature) {
            doCenterMapOnCustomFeatureAndSelectIt(map, egFeatures, internalSavedFeature, propertyCoordinates);
            centerMapOnCustomFeatureAndSelectIt.current = false;
        }
    }, [
        internalSavedFeature,
        egFeatures,
        propertyCoordinates
    ]);
    React15.useEffect(function() {
        if (!internalSavedFeature) {
            centerMapOnCustomFeatureAndSelectIt.current = true;
        }
        if (setSavedFeature) {
            setSavedFeature(internalSavedFeature);
        }
    }, [
        internalSavedFeature
    ]);
    React15.useEffect(function() {
        if (setSavedFeature && internalSavedFeature && propertyCoordinates) {
            var customPlace = point([
                internalSavedFeature.lng,
                internalSavedFeature.lat
            ]);
            var property = point([
                propertyCoordinates.longitude,
                propertyCoordinates.latitude
            ]);
            var d = distance(customPlace, property, {
                units: "miles"
            });
            if (d >= 80) {
                setSavedFeature(void 0);
                setInternalSavedFeature(void 0);
            }
        }
    }, [
        propertyCoordinates
    ]);
    React15.useEffect(function() {
        if (mapRef.current) {
            var featuresToHide = [];
            var featuresToShow = [];
            var map = mapRef.current;
            egFeatures.forEach(function(feature) {
                var _feature_qualifiers;
                if ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.some(function(q) {
                    return filteredValues.includes(q);
                })) {
                    featuresToHide.push({
                        id: feature.id,
                        type: feature.type
                    });
                } else {
                    featuresToShow.push({
                        id: feature.id,
                        type: feature.type
                    });
                }
            });
            map.addQualifierToFeatures(featuresToHide, QUALIFIER_HIDDEN);
            map.removeQualifierFromFeatures(featuresToShow, QUALIFIER_HIDDEN);
        }
    }, [
        egFeatures,
        internalSavedFeature,
        filteredValues
    ]);
    var internalBeforeInit = React15.useCallback(function(mapObj) {
        mapRef.current = mapObj;
        if (beforeInit) {
            beforeInit(mapObj);
        }
    }, []);
    var internalOnInit = React15.useCallback(function(mapObj) {
        mapObj.addSelectionChangeListener(function(event) {
            var feature = event.feature;
            switch(event.action){
                case "select":
                    {
                        var card = mapCards === null || mapCards === void 0 ? void 0 : mapCards.find(function(egCard) {
                            return egCard.id === feature.id;
                        });
                        if (card) {
                            var _egMapsFeatures_filter_find;
                            setCardContent(card);
                            var markerDataAnalytics = (_egMapsFeatures_filter_find = egMapsFeatures === null || egMapsFeatures === void 0 ? void 0 : egMapsFeatures.filter(isEgdsMapFeature).find(function(marker) {
                                return feature.id === marker.id;
                            })) === null || _egMapsFeatures_filter_find === void 0 ? void 0 : _egMapsFeatures_filter_find.clientSideAnalytics;
                            if (markerDataAnalytics) {
                                track(markerDataAnalytics.referrerId, markerDataAnalytics.linkName);
                            }
                        } else {
                            setCardContent(void 0);
                        }
                        break;
                    }
                case "clearSelection":
                    setCardContent(void 0);
                    break;
                default:
                    break;
            }
        });
        if (onInit) {
            onInit(mapObj);
        }
    }, [
        egdsBasicMap
    ]);
    var googleMapsConfig = React15.useMemo(function() {
        return dynamicMapId ? {
            gmapsAddConfig: {
                mapId: dynamicMapId
            }
        } : void 0;
    }, [
        dynamicMapId
    ]);
    var egMapsConfig = React15.useMemo(function() {
        return {
            googleMaps: googleMapsConfig,
            locale: locale,
            markers: {
                place: {
                    show: _defineProperty({}, "unknown#".concat(QUALIFIER_HIDDEN), false),
                    textLabel: {
                        show: _defineProperty({}, UitkEGMapsQualifier2.METRO_STATION, false)
                    }
                }
            }
        };
    }, [
        locale,
        googleMapsConfig
    ]);
    var supplementalFeatures = React15.useMemo(function() {
        if (internalSavedFeature) {
            return [
                internalSavedFeature
            ];
        }
        return void 0;
    }, [
        internalSavedFeature
    ]);
    if (loading || error || !data || !egdsBasicMap) {
        return null;
    }
    return /* @__PURE__ */ React15.createElement(UitkSheet5, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, (mapData === null || mapData === void 0 ? void 0 : mapData.toolbar) ? /* @__PURE__ */ React15.createElement(UitkToolbar2, {
        toolbarTitle: (mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar = mapData.toolbar) === null || _mapData_toolbar === void 0 ? void 0 : _mapData_toolbar.title) || "",
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar1 = mapData.toolbar) === null || _mapData_toolbar1 === void 0 ? void 0 : (_mapData_toolbar_icon = _mapData_toolbar1.icon) === null || _mapData_toolbar_icon === void 0 ? void 0 : _mapData_toolbar_icon.description
        }
    }) : null, /* @__PURE__ */ React15.createElement(DynamicMap, {
        data: egdsBasicMap,
        supplementalFeatures: supplementalFeatures,
        onInit: internalOnInit,
        beforeInit: internalBeforeInit,
        egMapsConfig: egMapsConfig,
        clientPadding: clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%",
        onFeaturesPushed: openCard,
        updateViewport: false
    }, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.title) ? /* @__PURE__ */ React15.createElement(MapCardContent, {
        data: cardContent
    }) : null), mapData && /* @__PURE__ */ React15.createElement(MapActions, {
        setSavedFeature: setInternalSavedFeature,
        savedFeature: internalSavedFeature,
        essLogger: essLogger,
        onTogglesChanged: setFilteredValues,
        onClose: onClose,
        data: mapData
    }));
};
MapComponent.displayName = "Map";
var Map = MapComponent;
// src/components/property-cleanliness/property-cleanliness.tsx
import React45 from "react";
import { gql as gql45, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
// src/components/content-section-groups/cleanliness.tsx
import React44 from "react";
import { gql as gql44 } from "@apollo/client";
// src/components/content-section-groups/__private/__fragments/property-content-section-group.tsx
import React43 from "react";
import { gql as gql43 } from "@apollo/client";
import { ViewLarge as ViewLarge3, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkExpandoPeek as UitkExpandoPeek4 } from "uitk-react-expando";
// src/components/shared/__private/__fragments/property-content.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek as UitkExpandoPeek2 } from "uitk-react-expando";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
// src/components/shared/__private/__fragments/property-content-item-graphics.tsx
import React20 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/common/icon.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
var fragment2 = gql16(_templateObject15());
var _data_title, _data_theme;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    return /* @__PURE__ */ React16.createElement(UitkIcon5, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.size ? UitkIconSize4[data.size] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : void 0
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = fragment2;
// ../internal/src/components/common/illustration.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment3 = gql17(_templateObject16());
var Illustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React17.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment3;
// ../internal/src/components/common/mark.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var fragment4 = gql18(_templateObject17());
var Mark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    /* @__PURE__ */ return React18.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize !== null && markSize !== void 0 ? markSize : data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment4;
// ../internal/src/components/common/ui-graphic.tsx
var __UIGraphicFragment = gql19(_templateObject18(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React19.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React19.createElement(Mark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React19.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/shared/__private/__fragments/property-content-item-graphics.tsx
var fragment5 = gql20(_templateObject19(), UiGraphic.fragment);
var PropertyContentItemGraphics = function(param) {
    var data = param.data;
    var graphics = data.graphics;
    if (!graphics || graphics.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, graphics.map(function(graphic, index) {
        return /* @__PURE__ */ React20.createElement(UiGraphic, {
            key: index,
            data: graphic
        });
    }));
};
PropertyContentItemGraphics.displayName = "PropertyContentItemGraphics";
PropertyContentItemGraphics.fragment = fragment5;
// src/components/shared/__private/__fragments/property-content-item-images.tsx
import React21 from "react";
import Lazyload from "react-lazy-load";
import { gql as gql21 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
var fragment6 = gql21(_templateObject20());
var PropertyContentItemImages = function(_param) {
    var data = _param.data, props = _objectWithoutProperties(_param, [
        "data"
    ]);
    var contents = data.contents;
    var structuredData = props.structuredData;
    if (!contents || contents.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React21.createElement(UitkSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React21.createElement("div", {
        "data-stid": "content-image"
    }, /* @__PURE__ */ React21.createElement(UitkLayoutFlex10, {
        space: "half",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem9, {
            key: index
        }, /* @__PURE__ */ React21.createElement(Lazyload, {
            height: 100
        }, /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement("img", {
            src: content.image.url,
            alt: content.image.description || ""
        }), structuredData && /* @__PURE__ */ React21.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: content.image.description
        }))));
    }))));
};
PropertyContentItemImages.displayName = "PropertyContentItemImages";
PropertyContentItemImages.fragment = fragment6;
// src/components/shared/__private/__fragments/property-content-item-markup.tsx
import React22 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkText as UitkText9 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var fragment7 = gql22(_templateObject21());
var PropertyContentItemMarkup = function(param) {
    var data = param.data;
    var text = data.content.text;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React22.createElement(UitkText9, {
        size: 300,
        spacing: "two",
        overflow: "wrap"
    }, /* @__PURE__ */ React22.createElement("div", {
        "data-stid": "content-markup"
    }, /* @__PURE__ */ React22.createElement(UitkUnformattedHtml, {
        htmlToParse: text
    })));
};
PropertyContentItemMarkup.displayName = "PropertyContentItemMarkup";
PropertyContentItemMarkup.fragment = fragment7;
// src/components/shared/__private/__fragments/property-content-item-text.tsx
import React23 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkIcon as UitkIcon6 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
var fragment8 = gql23(_templateObject22());
var PropertyContentItemText = function(param) {
    var data = param.data;
    var expando = data.expando, content = data.content;
    var _ref = expando || {}, expandedLabel = _ref.expandedLabel, collapsedLabel = _ref.collapsedLabel;
    var primary = content.primary, secondary = content.secondary;
    var value = primary.value, subtexts = primary.subtexts;
    var _React23_useState = _slicedToArray(React23.useState(false), 2), isVisible = _React23_useState[0], setIsVisible = _React23_useState[1];
    var handleClick = React23.useCallback(function() {
        setIsVisible(function(prev) {
            return !prev;
        });
    }, [
        setIsVisible
    ]);
    var Content = React23.useMemo(function() {
        var _primary_icon, _primary_egdsMark;
        /* @__PURE__ */ return React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(UitkLayoutFlex11, {
            alignItems: "center"
        }, ((_primary_icon = primary.icon) === null || _primary_icon === void 0 ? void 0 : _primary_icon.iconId) && /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React23.createElement(UitkSpacing11, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React23.createElement(UitkIcon6, {
            name: primary.icon.iconId
        }))), ((_primary_egdsMark = primary.egdsMark) === null || _primary_egdsMark === void 0 ? void 0 : _primary_egdsMark.url) && /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React23.createElement(UitkSpacing11, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React23.createElement(UitkMark2, {
            url: primary.egdsMark.url.value,
            description: primary.egdsMark.description
        }))), /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React23.createElement(UitkText10, {
            theme: "default",
            size: 300,
            weight: (primary === null || primary === void 0 ? void 0 : primary.state) === "STRONG" ? "bold" : "regular"
        }, value, subtexts && subtexts.length > 0 && /* @__PURE__ */ React23.createElement(React23.Fragment, null, subtexts.map(function(subtext, index) {
            /* @__PURE__ */ return React23.createElement(UitkText10, {
                key: index,
                theme: "default",
                size: 200,
                weight: (primary === null || primary === void 0 ? void 0 : primary.state) === "STRONG" ? "bold" : "regular"
            }, subtext);
        }))))), (secondary === null || secondary === void 0 ? void 0 : secondary.value) && /* @__PURE__ */ React23.createElement(UitkText10, {
            spacing: "two",
            theme: "default",
            size: 300
        }, secondary.value));
    }, [
        primary,
        secondary,
        value,
        subtexts
    ]);
    if (!expando) {
        return Content;
    }
    return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(UitkExpandoPeek, {
        isVisible: isVisible,
        handleClick: handleClick,
        lines: 4,
        expandLabel: collapsedLabel,
        collapseLabel: expandedLabel
    }, Content));
};
PropertyContentItemText.displayName = "PropertyContentItemText";
PropertyContentItemText.fragment = fragment8;
// src/components/shared/__private/__fragments/property-content-item-texts.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkText as UitkText11 } from "uitk-react-text";
var fragment9 = gql24(_templateObject23());
var PropertyContentItemTexts = function(_param) {
    var data = _param.data, props = _objectWithoutProperties(_param, [
        "data"
    ]);
    var contents = data.contents;
    var structuredData = props.structuredData;
    return /* @__PURE__ */ React24.createElement(React24.Fragment, null, contents === null || contents === void 0 ? void 0 : contents.map(function(param, index) {
        var primary = param.primary;
        return primary.value && /* @__PURE__ */ React24.createElement(React24.Fragment, {
            key: "PropertyContentItemTexts-".concat(index)
        }, /* @__PURE__ */ React24.createElement(UitkText11, {
            theme: "default",
            spacing: "two",
            size: 300
        }, primary.value), structuredData && /* @__PURE__ */ React24.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: primary.value
        }));
    }));
};
PropertyContentItemTexts.displayName = "PropertyContentItemTexts";
PropertyContentItemTexts.fragment = fragment9;
// src/components/shared/__private/__fragments/property-section-header.tsx
import React25 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkAvatar } from "uitk-react-avatar";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
import { UitkMark as UitkMark3, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkHeading as UitkHeading8, UitkText as UitkText12 } from "uitk-react-text";
var fragment10 = gql25(_templateObject24());
var SectionHeader = function(_param) {
    var data = _param.data, props = _objectWithoutProperties(_param, [
        "data"
    ]);
    var text = data.text, subText = data.subText, icon = data.icon, mark = data.mark, headerImage = data.headerImage;
    var singleLineHeader = props.singleLineHeader;
    var _ref = mark !== null && mark !== void 0 ? mark : {}, id = _ref.id, description = _ref.description, url = _ref.url;
    var RenderedSubtext = React25.useMemo(function() {
        return /* @__PURE__ */ React25.createElement(UitkText12, {
            inline: singleLineHeader,
            size: 400,
            spacing: "two"
        }, subText);
    }, [
        singleLineHeader,
        subText
    ]);
    if (!text && !mark) {
        return null;
    }
    return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement(UitkLayoutFlex12, {
        space: "six"
    }, icon && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(UitkIcon7, {
        name: icon.iconId,
        description: icon.description
    }))), mark && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React25.createElement(React25.Fragment, null, id && /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(UitkMark3, {
        name: id,
        size: UitkMarkSize2.MEDIUM,
        description: description
    })), !id && (url === null || url === void 0 ? void 0 : url.value) && /* @__PURE__ */ React25.createElement(UitkMark3, {
        url: url.value,
        size: UitkMarkSize2.MEDIUM,
        description: description
    }))), /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React25.createElement(UitkLayoutGrid2, {
        columns: 4
    }, /* @__PURE__ */ React25.createElement(UitkLayoutGridItem2, {
        colSpan: headerImage ? 3 : 4
    }, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(UitkHeading8, _objectSpreadProps(_objectSpread({}, props), {
        tabIndex: -1
    }), text, subText && singleLineHeader && /* @__PURE__ */ React25.createElement(React25.Fragment, null, " ", RenderedSubtext)), subText && !singleLineHeader && RenderedSubtext)), headerImage && /* @__PURE__ */ React25.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React25.createElement(UitkLayoutPosition4, {
        type: "absolute",
        position: {
            right: "three"
        }
    }, /* @__PURE__ */ React25.createElement(UitkAvatar, {
        border: false,
        image: {
            alt: headerImage.description,
            src: headerImage.url
        },
        size: "extra_large"
    })))))));
};
SectionHeader.displayName = "SectionHeader";
SectionHeader.fragment = fragment10;
// src/components/shared/__private/__fragments/property-content.tsx
var fragment11 = gql26(_templateObject25(), PropertyContentItemGraphics.fragment, PropertyContentItemImages.fragment, PropertyContentItemMarkup.fragment, PropertyContentItemText.fragment, PropertyContentItemTexts.fragment, SectionHeader.fragment);
var PropertyContent = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader;
    var clickTracker = useClickTracker7();
    var header = data.header, items = data.items, expando = data.expando, maxColumns = data.maxColumns, structuredData = data.structuredData;
    var _React26_useState = _slicedToArray(React26.useState(false), 2), isVisible = _React26_useState[0], setIsVisible = _React26_useState[1];
    var handleClick = React26.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var analytics = {
        id: "HOT.HIS.propertyContent.".concat(header === null || header === void 0 ? void 0 : header.text),
        description: "Shared ui property content section group expando",
        callback: React26.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    if (items.length === 0) {
        return null;
    }
    var getPropertyContentItemComponent = function(contentItem) {
        switch(contentItem.__typename){
            case "PropertyContentItemMarkup":
                return /* @__PURE__ */ React26.createElement(PropertyContentItemMarkup, {
                    data: contentItem
                });
            case "PropertyContentItemTexts":
                return /* @__PURE__ */ React26.createElement(PropertyContentItemTexts, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemText":
                return /* @__PURE__ */ React26.createElement(PropertyContentItemText, {
                    data: contentItem
                });
            case "PropertyContentItemImages":
                return /* @__PURE__ */ React26.createElement(PropertyContentItemImages, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemGraphics":
                return /* @__PURE__ */ React26.createElement(PropertyContentItemGraphics, {
                    data: contentItem
                });
            default:
                return null;
        }
    };
    var propertyContentItems = items.map(function(item, index) {
        var propertyContentItemComponent = getPropertyContentItemComponent(item);
        return propertyContentItemComponent && /* @__PURE__ */ React26.createElement(UitkLayoutGridItem3, {
            key: index
        }, /* @__PURE__ */ React26.createElement("div", null, propertyContentItemComponent));
    });
    var hasItems = propertyContentItems && (propertyContentItems === null || propertyContentItems === void 0 ? void 0 : propertyContentItems.length) > 0;
    return /* @__PURE__ */ React26.createElement(UitkLayoutGridItem3, {
        colSpan: 1
    }, /* @__PURE__ */ React26.createElement("div", {
        "data-stid": "content-item",
        itemProp: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop
    }, header && /* @__PURE__ */ React26.createElement(SectionHeader, {
        tag: smallerHeader ? "h4" : "h3",
        size: smallerHeader ? 6 : 5,
        data: header
    }), hasItems && /* @__PURE__ */ React26.createElement(UitkSpacing12, {
        padding: {
            inlinestart: (header === null || header === void 0 ? void 0 : header.icon) ? "twelve" : void 0,
            blockstart: "two"
        }
    }, expando ? /* @__PURE__ */ React26.createElement(UitkExpandoPeek2, {
        handleClick: handleClick,
        items: 2,
        isVisible: isVisible,
        expandLabel: expando.expandButton.text,
        collapseLabel: expando.collapseButton.text,
        analytics: analytics
    }, /* @__PURE__ */ React26.createElement(UitkLayoutGrid3, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems)) : /* @__PURE__ */ React26.createElement(UitkLayoutGrid3, {
        space: "four",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems))));
};
PropertyContent.displayName = "PropertyContent";
PropertyContent.fragment = fragment11;
// src/components/content-section-groups/__private/__fragments/property-content-section.tsx
import React42 from "react";
import { gql as gql42 } from "@apollo/client";
import { RefTarget } from "@shared-ui/ref-context";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
// src/components/content-section-groups/__private/__fragments/property-content-section-action.tsx
import React31 from "react";
import { gql as gql29 } from "@apollo/client";
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog.tsx
import React28 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkSheet as UitkSheet6, UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog-context.tsx
import { createContext, useContext } from "react";
var PropertyContentSectionDetailedDialogContext = createContext(void 0);
var usePropertyContentSectionDetailedDialogContext = function() {
    var context = useContext(PropertyContentSectionDetailedDialogContext);
    return context;
};
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog.tsx
var fragment12 = gql27(_templateObject26());
var PropertyContentSectionDetailedDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var dialog = data.dialog, trigger = data.trigger;
    var dialogData = (dialog === null || dialog === void 0 ? void 0 : dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker8();
    var _useDialog2 = _slicedToArray(useDialog2("property-content-section-detailed-dialog-".concat(actionId), "PropertyContentSectionDetailedDialog"), 3), dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var detailedDialogContent = usePropertyContentSectionDetailedDialogContext();
    var closeDialog = React28.useCallback(function() {
        dialogActions.closeDialog();
        if (dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics) {
            clickTracker(dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics.referrerId, dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        clickTracker,
        dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics
    ]);
    var openDialog = React28.useCallback(function() {
        dialogActions.openDialog();
        clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
    }, [
        dialogActions,
        clickTracker,
        trigger.analytics
    ]);
    if (!dialogData) {
        return null;
    }
    var dialogContent = function(sheetType) {
        var _dialogData_toolbar_closeText;
        return /* @__PURE__ */ React28.createElement(UitkSheet6, {
            type: sheetType,
            key: "property-content-section-detailed-dialog",
            returnFocusOnClose: true,
            isVisible: true,
            triggerRef: null
        }, /* @__PURE__ */ React28.createElement(UitkToolbar3, {
            toolbarTitle: dialogData.toolbar.title,
            key: "UitkToolbar",
            navigationContent: {
                onClick: closeDialog,
                navType: "close",
                navButtonLabel: (_dialogData_toolbar_closeText = dialogData.toolbar.closeText) !== null && _dialogData_toolbar_closeText !== void 0 ? _dialogData_toolbar_closeText : void 0
            }
        }), /* @__PURE__ */ React28.createElement(UitkSheetContent3, {
            padded: false
        }, detailedDialogContent));
    };
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(DialogComponent, null, /* @__PURE__ */ React28.createElement(Viewport5, null, /* @__PURE__ */ React28.createElement(ViewSmall5, null, dialogContent("full")), /* @__PURE__ */ React28.createElement(ViewMedium3, null, dialogContent("centered")))), /* @__PURE__ */ React28.createElement(UitkSpacing13, {
        padding: {
            large: {
                inline: "three"
            },
            extra_large: {
                inline: "three"
            }
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkTertiaryButton3, {
        alignLabelToContent: "start",
        onClick: openDialog
    }, trigger.message))));
};
PropertyContentSectionDetailedDialog.displayName = "PropertyContentSectionDetailedDialog";
PropertyContentSectionDetailedDialog.fragment = fragment12;
// src/components/content-section-groups/__private/__fragments/property-content-section-dialog.tsx
import React30 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSheet as UitkSheet7 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
// src/components/content-section-groups/__private/__fragments/property-content-section-action-item.tsx
import React29 from "react";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkParagraph, UitkText as UitkText13 } from "uitk-react-text";
var PropertyContentSectionActionItem = function(param) {
    var contentItem = param.contentItem, key = param.key;
    switch(contentItem.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React29.createElement(UitkSpacing14, {
                key: key,
                padding: {
                    blockend: "three"
                }
            }, /* @__PURE__ */ React29.createElement(UitkParagraph, null, " ", contentItem.text, " "));
        case "EGDSPlainText":
            return /* @__PURE__ */ React29.createElement(UitkText13, {
                key: key,
                inline: true
            }, contentItem.text);
        case "EGDSInlineLink":
            {
                var _contentItem_action;
                var resource = (_contentItem_action = contentItem.action) === null || _contentItem_action === void 0 ? void 0 : _contentItem_action.resource;
                return /* @__PURE__ */ React29.createElement(UitkLink3, {
                    key: key,
                    inline: true
                }, /* @__PURE__ */ React29.createElement("a", {
                    href: resource.value
                }, contentItem.text));
            }
        default:
            return null;
    }
};
PropertyContentSectionActionItem.displayName = "PropertyContentSectionActionItem";
// src/components/content-section-groups/__private/__fragments/property-content-section-dialog.tsx
var fragment13 = gql28(_templateObject27());
var PropertyContentSectionDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _dialogContent_toolbar;
    var _useDialog3 = _slicedToArray(useDialog3("property-content-section-dialog-".concat(actionId), "PropertyContentSectionDialog"), 3), dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    var content = data.content, dialog = data.dialog, trigger = data.trigger;
    var contents = content.contents;
    var dialogContent = (dialog === null || dialog === void 0 ? void 0 : dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker9();
    var closeDialog = React30.useCallback(function() {
        dialogActions.closeDialog();
        if (dialog.closeAnalytics) {
            clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        dialog.closeAnalytics,
        clickTracker
    ]);
    var openDialog = React30.useCallback(function() {
        dialogActions.openDialog();
        clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
    }, [
        dialogActions,
        trigger.analytics,
        clickTracker
    ]);
    return /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(DialogComponent, null, /* @__PURE__ */ React30.createElement(UitkSheet7, {
        type: "centered",
        isVisible: true,
        triggerRef: null,
        returnFocusOnClose: true,
        key: "property-content-section-dialog"
    }, /* @__PURE__ */ React30.createElement(UitkToolbar4, {
        toolbarTitle: dialogContent === null || dialogContent === void 0 ? void 0 : (_dialogContent_toolbar = dialogContent.toolbar) === null || _dialogContent_toolbar === void 0 ? void 0 : _dialogContent_toolbar.title,
        key: "UitkToolbar",
        navigationContent: {
            onClick: closeDialog,
            navType: "close"
        }
    }), /* @__PURE__ */ React30.createElement(UitkDialogContent, null, contents.map(function(contentItem, index) {
        return /* @__PURE__ */ React30.createElement(PropertyContentSectionActionItem, {
            contentItem: contentItem,
            key: index
        });
    })))), /* @__PURE__ */ React30.createElement(UitkLink4, {
        inline: true
    }, /* @__PURE__ */ React30.createElement("button", {
        type: "button",
        onClick: openDialog
    }, trigger.message)));
};
PropertyContentSectionDialog.displayName = "PropertyContentSectionDialog";
PropertyContentSectionDialog.fragment = fragment13;
// src/components/content-section-groups/__private/__fragments/property-content-section-action.tsx
var fragment14 = gql29(_templateObject28(), PropertyContentSectionDialog.fragment, PropertyContentSectionDetailedDialog.fragment);
var PropertyContentSectionAction = function(param) {
    var data = param.data, actionId = param.actionId;
    var __typename = data.__typename;
    if (__typename !== "PropertyContentSectionDetailedDialog" && __typename !== "PropertyContentSectionDialog") {
        return null;
    }
    switch(__typename){
        case "PropertyContentSectionDialog":
            return /* @__PURE__ */ React31.createElement(PropertyContentSectionDialog, {
                data: data,
                actionId: actionId
            });
        case "PropertyContentSectionDetailedDialog":
            return /* @__PURE__ */ React31.createElement(PropertyContentSectionDetailedDialog, {
                data: data,
                actionId: actionId
            });
        default:
            return null;
    }
};
PropertyContentSectionAction.displayName = "PropertyContentSectionAction";
PropertyContentSectionAction.fragment = fragment14;
// src/components/content-section-groups/__private/__fragments/property-content-sub-section.tsx
import React41 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkExpandoPeek as UitkExpandoPeek3 } from "uitk-react-expando";
import { UitkLayoutGrid as UitkLayoutGrid5 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
import React40 from "react";
import { gql as gql40 } from "@apollo/client";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkCard as UitkCard5, UitkCardBackgroundThemes, UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkText as UitkText15 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
import React33 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton as UitkTertiaryButton4 } from "uitk-react-button";
// ../internal/src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql as gql30 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql30(_templateObject29());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics) {
    if (analytics) {
        var track = clickstreamAnalytics.track;
        var referrerId = analytics.referrerId, linkName = analytics.linkName, uisPrimeMessages = analytics.uisPrimeMessages;
        var _analytics_eventType;
        var eventType = referrerMap[(_analytics_eventType = analytics.eventType) !== null && _analytics_eventType !== void 0 ? _analytics_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !(uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.length) ? message : [
            message
        ].concat(_toConsumableArray(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics) {
    var clickstreamAnalytics = useClickstreamAnalytics();
    return useCallback(function() {
        if (analytics) {
            trackAnalyticsList(clickstreamAnalytics, analytics);
        }
    }, [
        analytics,
        clickstreamAnalytics
    ]);
};
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React32 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
var fragment15 = gql31(_templateObject30());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React32.createElement(UitkIcon8, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize5[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment15;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql32 } from "@apollo/client";
var _obj4;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj4 = {}, _defineProperty(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
var fragment16 = gql32(_templateObject31());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment17 = gql33(_templateObject32(), clientSideAnalyticsFragment, fragment16, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton4
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _objectWithoutProperties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps(action);
    var handleClick = React33.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React33.createElement(Button, _objectSpreadProps(_objectSpread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React33.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment17;
LodgingEGDSButton.displayName = "EGDSButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React34 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkFloatingActionButton } from "uitk-react-button";
var fragment18 = gql34(_templateObject33());
var deriveLinkProps2 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _objectWithoutProperties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React34.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React34.createElement(UitkFloatingActionButton, _objectSpread({}, buttonProps), /* @__PURE__ */ React34.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment18;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React35 from "react";
import { gql as gql35 } from "@apollo/client";
import { UitkFloatingButton as UitkFloatingButton2 } from "uitk-react-button";
var fragment19 = gql35(_templateObject34());
var deriveLinkProps3 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _objectWithoutProperties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React35.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React35.createElement(UitkFloatingButton2, _objectSpread({}, buttonProps), icon ? /* @__PURE__ */ React35.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment19;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
import React36 from "react";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkText as UitkText14 } from "uitk-react-text";
var _obj5;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj5 = {}, _defineProperty(_obj5, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj5, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj5, "LARGE" /* LARGE */ , "large"), _obj5);
var _obj6;
var UILinkTargetMap2 = (_obj6 = {}, _defineProperty(_obj6, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj6, "INTERNAL" /* INTERNAL */ , "_self"), _obj6);
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
var fragment20 = gql36(_templateObject35(), Icon.fragment);
var EGDSStandardLink = function(_param) {
    var _param_data = _param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text, dataStid = _param.dataStid, uitkLinkProps = _objectWithoutProperties(_param, [
        "data",
        "dataStid"
    ]);
    var clickTracker = useClickTracker10();
    var onClick = React36.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    var path = React36.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React36.createElement(UitkLink5, _objectSpread({
        "data-stid": dataStid,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        disabled: disabled
    }, uitkLinkProps), /* @__PURE__ */ React36.createElement("a", {
        target: UILinkTargetMap2[target],
        href: path
    }, standardLinkIcon ? /* @__PURE__ */ React36.createElement(React36.Fragment, null, iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React36.createElement(Icon, {
        data: standardLinkIcon
    }), text, iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React36.createElement(Icon, {
        data: standardLinkIcon
    })) : text, accessibility && /* @__PURE__ */ React36.createElement(UitkText14, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment20;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds/egds-ui-link-action/egds-ui-link-action.tsx
import React37 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
var __fragment = gql37(_templateObject36());
var EGDSUILinkAction = function(param) {
    var data = param.data;
    var resource = data.resource, target = data.target, analytics = data.analytics, accessibility = data.accessibility, useRelativePath = data.useRelativePath;
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var clickTracker = useClickTracker11();
    var onClickCapture = React37.useCallback(function() {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker
    ]);
    var path = React37.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React37.createElement("a", {
        href: path,
        target: navigationTarget,
        rel: "noopener noreferrer",
        onClickCapture: onClickCapture,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
    }, accessibility);
};
EGDSUILinkAction.fragment = __fragment;
EGDSUILinkAction.displayName = "EGDSUILinkAction";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
var fragment21 = gql38(_templateObject37(), Icon.fragment, UiGraphic.fragment, EGDSStandardLink.fragment, LodgingEGDSButton.fragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data, dataStid = param.dataStid, markSize = param.markSize, className = param.className, actionProps = param.actionProps, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? true : _param_showBorder;
    var message = data.message, _data_background = data.background, background = _data_background === void 0 ? UitkCardBackgroundThemes.PRIMARY : _data_background, links = data.links, graphic = data.graphic, heading = data.heading, rightIcon = data.rightIcon, buttons = data.buttons;
    var cardPadding = background === UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD ? {
        inline: "three",
        block: "three"
    } : {
        inline: "one",
        block: "one"
    };
    var isBgColored = background !== null && background !== UitkCardBackgroundThemes.PRIMARY && background !== UitkCardBackgroundThemes.SECONDARY;
    var egdsLinksMemo = React38.useMemo(function() {
        /* @__PURE__ */ return React38.createElement(UitkSpacing15, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, null, links === null || links === void 0 ? void 0 : links.map(function(linkData, linkIndex) {
            return /* @__PURE__ */ React38.createElement(UitkSpacing15, {
                margin: {
                    inlinestart: linkIndex === 0 ? "unset" : "two"
                },
                key: linkIndex
            }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSStandardLink, {
                data: linkData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(linkData.__typename) : void 0,
                theme: isBgColored ? "inverse" : "default"
            }))));
        })));
    }, [
        links,
        isBgColored
    ]);
    var egdsButtonsMemo = React38.useMemo(function() {
        /* @__PURE__ */ return React38.createElement(UitkSpacing15, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, null, buttons === null || buttons === void 0 ? void 0 : buttons.map(function(buttonData, buttonIndex) {
            return /* @__PURE__ */ React38.createElement(UitkSpacing15, {
                margin: {
                    inlinestart: buttonIndex === 0 ? "unset" : "two"
                },
                key: buttonIndex
            }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement(LodgingEGDSButton, {
                data: buttonData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(buttonData.__typename) : void 0,
                size: UitkButtonSize2.SMALL,
                inverse: isBgColored && buttonData.__typename === "UITertiaryButton"
            })));
        })));
    }, [
        buttons,
        isBgColored
    ]);
    var messageOrHeader = React38.useMemo(function() {
        if (!message) {
            return null;
        }
        if (heading) {
            return /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
                margin: {
                    blockstart: "".concat(heading ? "half" : "unset")
                }
            }, /* @__PURE__ */ React38.createElement(UitkText15, {
                theme: isBgColored ? "inverse" : "default"
            }, message)));
        }
        return /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement(UitkHeading9, {
            className: isBgColored ? "uitk-text-inverse-theme" : ""
        }, message));
    }, [
        message,
        heading,
        isBgColored
    ]);
    return /* @__PURE__ */ React38.createElement(UitkCard5, {
        className: className,
        border: showBorder,
        padded: true,
        backgroundTheme: background
    }, /* @__PURE__ */ React38.createElement(UitkCardContentSection2, {
        "data-stid": dataStid
    }, /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        padding: cardPadding
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, {
        alignItems: "center"
    }, graphic && /* @__PURE__ */ React38.createElement(UitkSpacing15, {
        margin: {
            small: {
                inlineend: "three"
            },
            medium: {
                inlineend: isBgColored ? "six" : "three"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UiGraphic, {
        data: graphic,
        markSize: markSize
    })), /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, {
        grow: 1
    }, /* @__PURE__ */ React38.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        space: "two",
        wrap: rightIcon ? "nowrap" : "wrap"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, {
        grow: 1,
        minWidth: "88x"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, {
        direction: "column"
    }, heading && /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement(UitkHeading9, {
        className: isBgColored ? "uitk-text-inverse-theme" : ""
    }, heading)), messageOrHeader)), /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex13, {
        alignItems: "center",
        space: "four",
        justifyContent: "end"
    }, buttons && buttons.length > 0 && /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, egdsButtonsMemo), links && links.length > 0 && /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, egdsLinksMemo))), rightIcon && /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(Icon, {
        data: rightIcon
    })))))))), actionProps && /* @__PURE__ */ React38.createElement(UitkCardLink, null, /* @__PURE__ */ React38.createElement(EGDSUILinkAction, {
        data: actionProps
    }))));
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment21;
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
import { UitkLayoutGrid as UitkLayoutGrid4 } from "uitk-react-layout-grid";
// src/components/content-section-groups/__private/__fragments/property-content-item-card.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
var fragment22 = gql39(_templateObject38(), EGDSStandardMessagingCard.fragment);
var PropertyContentItemCard = function(props) {
    var data = props.data;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React39.createElement(EGDSStandardMessagingCard, {
        data: data
    });
};
PropertyContentItemCard.displayName = "PropertyContentItemCard";
PropertyContentItemCard.fragment = fragment22;
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
var fragment23 = gql40(_templateObject39(), EGDSStandardMessagingCard.fragment);
var PropertyContentElementGroup = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader;
    var elements = data.elements, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var renderedElements = elements.map(function(element, indexElement) {
        switch(element.__typename){
            case "PropertyContent":
                return /* @__PURE__ */ React40.createElement(PropertyContent, {
                    key: indexElement,
                    data: element,
                    smallerHeader: smallerHeader
                });
            case "EGDSStandardMessagingCard":
                return /* @__PURE__ */ React40.createElement(PropertyContentItemCard, {
                    key: indexElement,
                    data: element
                });
            default:
                return null;
        }
    });
    if (maxColumns === 1) {
        return /* @__PURE__ */ React40.createElement(React40.Fragment, null, renderedElements);
    }
    return /* @__PURE__ */ React40.createElement(UitkLayoutGrid4, {
        space: "three",
        columns: maxColumns
    }, renderedElements);
};
PropertyContentElementGroup.displayName = "PropertyContentElementGroup";
PropertyContentElementGroup.fragment = fragment23;
// src/components/content-section-groups/__private/__fragments/property-content-sub-section.tsx
var fragment24 = gql41(_templateObject40(), PropertyContentElementGroup.fragment);
var PropertyContentSubSection = function(param) {
    var data = param.data;
    var header = data.header, elementsV2 = data.elementsV2, expando = data.expando, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var _React41_useState = _slicedToArray(React41.useState(false), 2), isVisible = _React41_useState[0], setIsVisible = _React41_useState[1];
    var subSectionContent = /* @__PURE__ */ React41.createElement(React41.Fragment, null, elementsV2.map(function(elementV2, i) {
        return /* @__PURE__ */ React41.createElement(PropertyContentElementGroup, {
            data: elementV2,
            smallerHeader: Boolean(header),
            key: i
        });
    }));
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, header && /* @__PURE__ */ React41.createElement(SectionHeader, {
        tag: "h3",
        size: 5,
        singleLineHeader: true,
        data: header
    }), /* @__PURE__ */ React41.createElement(UitkSpacing16, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLayoutGrid5, {
        space: "three",
        columns: {
            medium: 1,
            large: maxColumns
        }
    }, !expando ? subSectionContent : /* @__PURE__ */ React41.createElement(UitkExpandoPeek3, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: 1,
        expandLabel: expando.expandButton.text,
        collapseLabel: expando.collapseButton.text
    }, subSectionContent))));
};
PropertyContentSubSection.displayName = "PropertyContentSubSection";
PropertyContentSubSection.fragment = fragment24;
// src/components/content-section-groups/__private/__fragments/property-content-section.tsx
var fragment25 = gql42(_templateObject41(), SectionHeader.fragment, PropertyContentSubSection.fragment, PropertyContentSectionAction.fragment);
var PropertyContentSection = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_isInDialog = param.isInDialog, isInDialog = _param_isInDialog === void 0 ? false : _param_isInDialog, _param_isFirstSection = param.isFirstSection, isFirstSection = _param_isFirstSection === void 0 ? false : _param_isFirstSection, _param_isLastSection = param.isLastSection, isLastSection = _param_isLastSection === void 0 ? false : _param_isLastSection, actionId = param.actionId;
    var subSectionName = data.sectionName, header = data.header, bodySubSections = data.bodySubSections, sectionAction = data.action;
    var border = !isLastSection ? "bottom" : void 0;
    return /* @__PURE__ */ React42.createElement(UitkCardContentSection3, {
        border: border,
        padded: false
    }, /* @__PURE__ */ React42.createElement(RefTarget, {
        name: subSectionName,
        tabIndex: -1
    }, /* @__PURE__ */ React42.createElement(UitkSpacing17, {
        padding: {
            small: {
                inline: isInDialog ? "three" : "unset"
            },
            medium: {
                inline: isInDialog ? "three" : "unset"
            },
            large: {
                inline: "three"
            },
            extra_large: {
                inline: "three"
            },
            blockend: isLastSection ? "three" : "six",
            blockstart: isFirstSection ? "three" : "six"
        }
    }, /* @__PURE__ */ React42.createElement(UitkLayoutGrid6, {
        space: "six",
        columns: {
            medium: 1,
            large: columns
        }
    }, showHeader && /* @__PURE__ */ React42.createElement(UitkLayoutGridItem4, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: bodySubSections.length
        }
    }, header && /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(SectionHeader, {
        tag: "h2",
        size: 4,
        data: header
    }))), bodySubSections.map(function(bodySubSection, i) {
        return /* @__PURE__ */ React42.createElement(UitkLayoutGridItem4, {
            colSpan: {
                medium: 1,
                large: columns === 1 ? 1 : Math.max(columns - 1, 1)
            },
            key: i
        }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(PropertyContentSubSection, {
            data: bodySubSection
        })));
    }), sectionAction && /* @__PURE__ */ React42.createElement(UitkLayoutGridItem4, {
        colStart: {
            medium: 1,
            large: columns === 1 ? 1 : 2
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(PropertyContentSectionAction, {
        data: sectionAction,
        actionId: actionId
    })))))));
};
PropertyContentSection.displayName = "PropertyContentSection";
PropertyContentSection.fragment = fragment25;
// src/components/content-section-groups/__private/__fragments/property-content-section-group.tsx
var fragment26 = gql43(_templateObject42(), SectionHeader.fragment, PropertyContent.fragment, PropertyContentSection.fragment, PropertyContentSectionAction.fragment, PropertyContentSubSection.fragment);
var PropertyContentSectionGroup = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_actionId = param.actionId, actionId = _param_actionId === void 0 ? "id" : _param_actionId;
    var expando = data.expando, sections = data.sections, action = data.action;
    var _ref = expando || {}, collapseButton = _ref.collapseButton, expandButton = _ref.expandButton;
    var _React43_useState = _slicedToArray(React43.useState(false), 2), isVisible = _React43_useState[0], setIsVisible = _React43_useState[1];
    if (!sections || sections.length === 0) {
        return null;
    }
    var sectionContent = sections.map(function(section, index) {
        return /* @__PURE__ */ React43.createElement(PropertyContentSection, {
            data: section,
            columns: columns,
            showHeader: showHeader,
            isFirstSection: index === 0,
            isLastSection: index === sections.length - 1,
            key: "section-".concat(index),
            actionId: "".concat(actionId, "-section-").concat(index)
        });
    });
    return /* @__PURE__ */ React43.createElement(UitkCard6, null, /* @__PURE__ */ React43.createElement(UitkCardContentSection4, null, /* @__PURE__ */ React43.createElement(Viewport6, null, /* @__PURE__ */ React43.createElement(ViewSmall6, null, /* @__PURE__ */ React43.createElement("section", null, !collapseButton || !expandButton ? /* @__PURE__ */ React43.createElement(UitkCard6, null, sectionContent, " ") : /* @__PURE__ */ React43.createElement(UitkCard6, null, /* @__PURE__ */ React43.createElement(UitkExpandoPeek4, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: 1,
        expandLabel: expandButton.text,
        collapseLabel: collapseButton.text
    }, /* @__PURE__ */ React43.createElement(React43.Fragment, null, sectionContent))))), /* @__PURE__ */ React43.createElement(ViewLarge3, null, /* @__PURE__ */ React43.createElement("section", null, sectionContent))), action && /* @__PURE__ */ React43.createElement(PropertyContentSectionAction, {
        data: action,
        actionId: actionId
    })));
};
PropertyContentSectionGroup.displayName = "PropertyContentSectionGroup";
PropertyContentSectionGroup.fragment = fragment26;
// src/components/content-section-groups/cleanliness.tsx
var __CleanlinessFragment = gql44(_templateObject43(), PropertyContentSectionGroup.fragment);
var Cleanliness = function(props) {
    var data = props.data, contentProps = _objectWithoutProperties(props, [
        "data"
    ]);
    var content = data.propertyContentSectionGroups.cleanliness;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React44.createElement(PropertyContentSectionGroup, _objectSpread({
        data: content
    }, contentProps));
};
Cleanliness.fragment = __CleanlinessFragment;
Cleanliness.displayName = "Cleanliness";
// src/components/property-cleanliness/property-cleanliness.tsx
var __Query2 = gql45(_templateObject44(), Cleanliness.fragment);
var PropertyCleanliness = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi5().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query2, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery3.data, loading = _useQuery3.loading;
    if (loading || !data) {
        return null;
    }
    return /* @__PURE__ */ React45.createElement(Cleanliness, {
        data: data.propertyInfo,
        columns: 1,
        showHeader: false
    });
};
PropertyCleanliness.displayName = "PropertyCleanliness";
// src/components/map/property-details-map.tsx
import React47 from "react";
import { gql as gql47, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { UitkEGMaps as UitkEGMaps2, UitkEGMapsQualifier as UitkEGMapsQualifier4, UitkEGMapsType as UitkEGMapsType2 } from "uitk-react-map";
import { UitkSheet as UitkSheet9 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar5 } from "uitk-react-toolbar";
// src/components/map/__private/__fragments/poi.tsx
import React46 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkFigure as UitkFigure3, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet8 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkText as UitkText16 } from "uitk-react-text";
var __PointOfInterestFragment = gql46(_templateObject45());
var PointOfInterest = function(param) {
    var data = param.data;
    if (!data || !data.title) {
        return null;
    }
    var poiContent = data.poiContent, title = data.title, subtitle = data.subtitle;
    var _ref = poiContent !== null && poiContent !== void 0 ? poiContent : {}, description = _ref.description, image = _ref.image;
    var imageUrl = image === null || image === void 0 ? void 0 : image.url;
    var imageDescription = image === null || image === void 0 ? void 0 : image.description;
    return /* @__PURE__ */ React46.createElement(UitkSheet8, {
        isVisible: true,
        triggerRef: null
    }, /* @__PURE__ */ React46.createElement(UitkLayoutFlex14, null, imageUrl && /* @__PURE__ */ React46.createElement(UitkLayoutFlexItem13, {
        grow: 1,
        minWidth: "twenty_four"
    }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(UitkFigure3, {
        imageFit: "cover"
    }, /* @__PURE__ */ React46.createElement(UitkImage2, {
        src: imageUrl,
        alt: imageDescription,
        placeholderImage: true
    })))), /* @__PURE__ */ React46.createElement(UitkLayoutFlexItem13, {
        grow: 3,
        minWidth: "seventy_two"
    }, /* @__PURE__ */ React46.createElement(UitkSpacing18, {
        padding: {
            block: "three",
            inline: "three"
        }
    }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(UitkText16, {
        size: 400,
        weight: "bold",
        className: "uitk cell"
    }, title), /* @__PURE__ */ React46.createElement(UitkSpacing18, {
        padding: {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React46.createElement(UitkText16, null, subtitle)), description && /* @__PURE__ */ React46.createElement(UitkSpacing18, {
        padding: {
            blockstart: "half",
            blockend: "one"
        }
    }, /* @__PURE__ */ React46.createElement(UitkText16, null, description)))))));
};
PointOfInterest.fragment = __PointOfInterestFragment;
PointOfInterest.displayName = "PoiContent";
var poi_default = PointOfInterest;
// src/components/map/map-markers.ts
import { UitkEGMapsQualifier as UitkEGMapsQualifier3 } from "uitk-react-map";
var DEFAULT_MARKERS = [
    "AIRPORT" /* AIRPORT */ ,
    "HOTEL" /* HOTEL */ ,
    "CIRCLE" /* CIRCLE */ 
];
var _obj7;
var IconPropertiesDictionary = (_obj7 = {}, _defineProperty(_obj7, "AIRPORT" /* AIRPORT */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.AIRPORT
    ],
    status: "unknown"
}), _defineProperty(_obj7, "SOLD_OUT" /* SOLD_OUT */ , {
    type: "property",
    status: "sold_out",
    qualifiers: [
        UitkEGMapsQualifier3.NOT_CLUSTERED
    ]
}), _defineProperty(_obj7, "LANDMARK" /* LANDMARK */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.POINT_OF_INTEREST
    ],
    status: "unknown"
}), _defineProperty(_obj7, "RESTAURANT" /* RESTAURANT */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.RESTAURANT
    ],
    status: "unknown"
}), _defineProperty(_obj7, "CIRCLE" /* CIRCLE */ , {
    type: "property",
    qualifiers: [
        UitkEGMapsQualifier3.OBFUSCATED_PIN
    ],
    status: "available"
}), _defineProperty(_obj7, "GROCERY" /* GROCERY */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.GROCERY
    ],
    status: "unknown"
}), _defineProperty(_obj7, "METRO" /* METRO */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.METRO_STATION
    ],
    status: "unknown"
}), _defineProperty(_obj7, "RESTAURANT" /* RESTAURANT */ , {
    type: "place",
    qualifiers: [
        UitkEGMapsQualifier3.RESTAURANT
    ],
    status: "unknown"
}), _defineProperty(_obj7, "HOTEL" /* HOTEL */ , {
    type: "property",
    qualifiers: [
        UitkEGMapsQualifier3.FOCAL,
        UitkEGMapsQualifier3.HOTEL
    ],
    status: "available"
}), _defineProperty(_obj7, "VACATION_RENTAL" /* VACATION_RENTAL */ , {
    type: "property",
    qualifiers: [
        UitkEGMapsQualifier3.FOCAL,
        UitkEGMapsQualifier3.VACATION_RENTAL
    ],
    status: "available"
}), _obj7);
var defaultStatusTypeAndQualifier = {
    type: "place",
    qualifiers: [],
    status: "unknown"
};
var findStatusTypeAndQualifier = function(icon) {
    return icon && IconPropertiesDictionary[icon] || defaultStatusTypeAndQualifier;
};
var markersToFeatures = function(mapMarkers, propertyId) {
    return mapMarkers.map(function(marker) {
        return _objectSpread({
            id: marker.markerId,
            lat: marker.mapMarker.latLong.latitude,
            lng: marker.mapMarker.latLong.longitude,
            name: marker.title,
            score: marker.markerId === propertyId ? 2 : 0
        }, findStatusTypeAndQualifier(marker.mapMarker.icon));
    });
};
var getMarker = function(feature, markers) {
    return markers === null || markers === void 0 ? void 0 : markers.find(function(markerItem) {
        return markerItem.markerId === (feature === null || feature === void 0 ? void 0 : feature.id);
    });
};
// src/components/map/property-details-map.tsx
var EXTERNAL_CONFIG_ENDPOINT = "https://www.expedia.com/eg-maps-config-service/PDP_Map";
var __MapQuery2 = gql47(_templateObject46(), MapActions.fragment, poi_default.fragment);
var removeMetroLabel = {
    place: {
        textLabel: {
            show: _defineProperty({}, UitkEGMapsQualifier4.METRO_STATION, false)
        }
    }
};
var filterFeatures = function(egMapsFeatures, filteredQualifiers) {
    return egMapsFeatures === null || egMapsFeatures === void 0 ? void 0 : egMapsFeatures.filter(function(param) {
        var _param_qualifiers = param.qualifiers, qualifiers = _param_qualifiers === void 0 ? [] : _param_qualifiers;
        return !qualifiers.some(function(q) {
            return filteredQualifiers.includes(q);
        });
    });
};
var MapComponent2 = function(props) {
    var _propertyInfo_summary, _propertyInfo_summary_location, _propertyInfo_summary1, _mapData_egdsBasicMap, _mapData_egdsBasicMap_config, _mapData_toolbar, _mapData_toolbar1, _mapData_toolbar_icon;
    var context = useBexApi6().context;
    var locale = context.locale;
    var inputs = props.inputs, onInit = props.onInit, beforeInit = props.beforeInit, onCloseCallback = props.onClose, setSavedFeature = props.setSavedFeature, savedFeature = props.savedFeature, essLogger = props.essLogger, clientPadding = props.clientPadding, triggerRef = props.triggerRef;
    var _React47_useState = _slicedToArray(React47.useState(), 2), selectedFeature = _React47_useState[0], setSelectedFeature = _React47_useState[1];
    var _React47_useState1 = _slicedToArray(React47.useState(), 2), mapFeatures = _React47_useState1[0], setMapFeatures = _React47_useState1[1];
    var _React47_useState2 = _slicedToArray(React47.useState(savedFeature), 2), internalSavedFeature = _React47_useState2[0], setInternalSavedFeature = _React47_useState2[1];
    var _React47_useState3 = _slicedToArray(React47.useState([]), 2), filteredValues = _React47_useState3[0], setFilteredValues = _React47_useState3[1];
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__MapQuery2, {
        variables: variables
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    var mapRef = React47.useRef();
    var propertyInfo = (data !== null && data !== void 0 ? data : {}).propertyInfo;
    var _propertyInfo_id;
    var propertyId = (_propertyInfo_id = propertyInfo === null || propertyInfo === void 0 ? void 0 : propertyInfo.id) !== null && _propertyInfo_id !== void 0 ? _propertyInfo_id : "";
    var propertyCoordinates = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary = propertyInfo.summary) === null || _propertyInfo_summary === void 0 ? void 0 : (_propertyInfo_summary_location = _propertyInfo_summary.location) === null || _propertyInfo_summary_location === void 0 ? void 0 : _propertyInfo_summary_location.coordinates;
    var mapData = propertyInfo === null || propertyInfo === void 0 ? void 0 : (_propertyInfo_summary1 = propertyInfo.summary) === null || _propertyInfo_summary1 === void 0 ? void 0 : _propertyInfo_summary1.map;
    var dynamicMapId = mapData === null || mapData === void 0 ? void 0 : (_mapData_egdsBasicMap = mapData.egdsBasicMap) === null || _mapData_egdsBasicMap === void 0 ? void 0 : (_mapData_egdsBasicMap_config = _mapData_egdsBasicMap.config) === null || _mapData_egdsBasicMap_config === void 0 ? void 0 : _mapData_egdsBasicMap_config.mapId;
    var markers = mapData === null || mapData === void 0 ? void 0 : mapData.markers;
    var egMapsFeatures = markers ? markersToFeatures(markers, propertyId) : void 0;
    var _useAnalytics = useAnalytics(onCloseCallback), trackMapInit = _useAnalytics.trackMapInit, trackMapPresented = _useAnalytics.trackMapPresented, trackMapContentPresented = _useAnalytics.trackMapContentPresented, onMapBoundsChanged = _useAnalytics.onMapBoundsChanged, onSelectionChange = _useAnalytics.onSelectionChange, onClose = _useAnalytics.onClose;
    var updateMapFeatures = React47.useCallback(function() {
        var shouldUpdateBounds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var _mapRef_current;
        var filteredEGMapsFeatures = filterFeatures(egMapsFeatures, filteredValues || []);
        var updatedFeatures = internalSavedFeature ? _toConsumableArray(filteredEGMapsFeatures !== null && filteredEGMapsFeatures !== void 0 ? filteredEGMapsFeatures : []).concat([
            internalSavedFeature
        ]) : filteredEGMapsFeatures !== null && filteredEGMapsFeatures !== void 0 ? filteredEGMapsFeatures : [];
        setMapFeatures(updatedFeatures);
        setSavedFeature === null || setSavedFeature === void 0 ? void 0 : setSavedFeature(internalSavedFeature);
        if (((_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.map) && updatedFeatures.length > 0) {
            var map = mapRef.current.map();
            var options = propertyCoordinates ? {
                centeredOn: [
                    propertyCoordinates.latitude,
                    propertyCoordinates.longitude
                ]
            } : void 0;
            var coordinates = mapFeaturesToCoordinates(updatedFeatures);
            var boundsPromise = map === null || map === void 0 ? void 0 : map.boundsContaining(coordinates, true, options);
            boundsPromise === null || boundsPromise === void 0 ? void 0 : boundsPromise.then(function(result) {
                if (shouldUpdateBounds) {
                    map === null || map === void 0 ? void 0 : map.fitBounds(result.sw, result.ne, true, clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%");
                }
                if (internalSavedFeature) {
                    map === null || map === void 0 ? void 0 : map.selectFeature(internalSavedFeature.id, internalSavedFeature.type);
                }
            });
        }
    }, [
        clientPadding,
        egMapsFeatures,
        propertyCoordinates,
        setSavedFeature,
        internalSavedFeature,
        filteredValues
    ]);
    React47.useEffect(function() {
        trackMapInit(UitkEGMapsType2.GOOGLE, propertyId);
    }, []);
    React47.useEffect(function() {
        setMapFeatures(egMapsFeatures);
    }, [
        data
    ]);
    React47.useEffect(function() {
        updateMapFeatures();
    }, [
        internalSavedFeature,
        setInternalSavedFeature
    ]);
    React47.useEffect(function() {
        updateMapFeatures(false);
    }, [
        filteredValues
    ]);
    var onMarkerSelectionChanged = React47.useCallback(function(event) {
        var action = event.action, feature = event.feature;
        switch(action){
            default:
            case "clearSelection":
                setSelectedFeature(void 0);
                break;
            case "select":
                onSelectionChange(event);
                setSelectedFeature(feature);
                break;
        }
    }, [
        onSelectionChange
    ]);
    var onTogglesChanged = React47.useCallback(function(values) {
        setFilteredValues(values);
    }, [
        setFilteredValues
    ]);
    var internalBeforeInit = React47.useCallback(function(egMap) {
        if (egMap) {
            var tilesContentLoadedCallback = function() {
                setTimeout(function() {
                    var options = getContentPresentedOptions(egMap, "tile" /* TILE */ );
                    trackMapContentPresented(options);
                }, CONTENT_PRESENTED_DELAY);
            };
            egMap.addTilesContentLoadedListener(tilesContentLoadedCallback);
            egMap.addBoundChangeListener(onMapBoundsChanged);
            egMap.addSelectionChangeListener(onMarkerSelectionChanged);
            if (beforeInit) {
                beforeInit(egMap);
            }
        }
    }, [
        onMapBoundsChanged,
        onMarkerSelectionChanged,
        trackMapContentPresented
    ]);
    var internalOnInit = React47.useCallback(function(egMap) {
        if (egMap) {
            var bounds = egMap.getBounds();
            var mapId = egMap.readConfigParam("googleMaps,gmapsAddConfig,mapId");
            trackMapPresented(boundingBoxToString(bounds.sw, bounds.ne), mapId, "full");
            if (onInit) {
                onInit(egMap);
            }
        }
    }, [
        trackMapPresented
    ]);
    var onFeaturesPushed = function(egMap) {
        if (egMap) {
            setTimeout(function() {
                var options = getContentPresentedOptions(egMap, "user" /* USER */ );
                trackMapContentPresented(options);
            }, CONTENT_PRESENTED_DELAY);
        }
    };
    if (loading || error || !data) {
        return null;
    }
    var initialViewport = getViewport(propertyCoordinates, mapFeatures, mapData === null || mapData === void 0 ? void 0 : mapData.zoom);
    var googleMapsConfig = dynamicMapId ? {
        gmapsAddConfig: {
            mapId: dynamicMapId
        }
    } : void 0;
    return /* @__PURE__ */ React47.createElement(UitkSheet9, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React47.createElement(UitkToolbar5, {
        toolbarTitle: (mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar = mapData.toolbar) === null || _mapData_toolbar === void 0 ? void 0 : _mapData_toolbar.title) || "",
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: mapData === null || mapData === void 0 ? void 0 : (_mapData_toolbar1 = mapData.toolbar) === null || _mapData_toolbar1 === void 0 ? void 0 : (_mapData_toolbar_icon = _mapData_toolbar1.icon) === null || _mapData_toolbar_icon === void 0 ? void 0 : _mapData_toolbar_icon.description
        }
    }), /* @__PURE__ */ React47.createElement(UitkEGMaps2, {
        accessToken: "AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68",
        mapType: UitkEGMapsType2.GOOGLE,
        features: mapFeatures,
        mapConfig: {
            externalConfigEndpoint: EXTERNAL_CONFIG_ENDPOINT,
            googleMaps: googleMapsConfig,
            locale: locale,
            markers: removeMetroLabel
        },
        initialViewport: initialViewport,
        clientPadding: clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%",
        beforeInit: internalBeforeInit,
        onInit: internalOnInit,
        onFeaturesPushed: onFeaturesPushed,
        innerRef: mapRef
    }, selectedFeature && /* @__PURE__ */ React47.createElement(poi_default, {
        data: getMarker(selectedFeature, markers)
    })), mapData && /* @__PURE__ */ React47.createElement(MapActions, {
        setSavedFeature: setInternalSavedFeature,
        savedFeature: internalSavedFeature,
        essLogger: essLogger,
        onTogglesChanged: onTogglesChanged,
        onClose: onClose,
        data: mapData
    }));
};
MapComponent2.displayName = "PropertyDetailsMap";
var PropertyDetailsMap = MapComponent2;
// src/components/property-info-details/property-info-details.tsx
import React88 from "react";
import { gql as gql84, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
// ../internal/src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React48 from "react";
import { gql as gql48 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var fragment27 = gql48(_templateObject47());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React48.createElement(UitkRating, {
        icon: icon === null || icon === void 0 ? void 0 : icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment27;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React52 from "react";
import { gql as gql52 } from "@apollo/client";
import { UitkText as UitkText18 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React49 from "react";
import { gql as gql49 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink6 } from "uitk-react-link";
var fragment28 = gql49(_templateObject48());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker12();
    var onClick = React49.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React49.createElement(UitkLink6, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React49.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap2[target]
    }, text, accessibility && /* @__PURE__ */ React49.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment28;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React50 from "react";
import { gql as gql50 } from "@apollo/client";
import { UitkParagraph as UitkParagraph2 } from "uitk-react-text";
var fragment29 = gql50(_templateObject49());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React50.createElement(UitkParagraph2, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment29;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React51 from "react";
import { gql as gql51 } from "@apollo/client";
import { UitkText as UitkText17 } from "uitk-react-text";
var _obj8;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj8 = {}, _defineProperty(_obj8, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj8, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj8, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj8, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj8, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj8, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj8, "INVERSE" /* INVERSE */ , "inverse"), _obj8);
var _obj9;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj9 = {}, _defineProperty(_obj9, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj9, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj9, "REGULAR" /* REGULAR */ , "regular"), _obj9);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment30 = gql51(_templateObject50());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _objectWithoutProperties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _objectSpread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React51.createElement(Decorative, null, data.text) : data.text;
    return /* @__PURE__ */ React51.createElement(UitkText17, _objectSpread({}, textProps), content, accessibility && /* @__PURE__ */ React51.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment30;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment31 = gql52(_templateObject51(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React52.createElement(UitkText18, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React52.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React52.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React52.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment31;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React53 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkHeading as UitkHeading10 } from "uitk-react-text";
var fragment32 = gql53(_templateObject52());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React53.createElement(UitkHeading10, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment32;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React57 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkText as UitkText21 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React56 from "react";
import { gql as gql56 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React54 from "react";
import { gql as gql54 } from "@apollo/client";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkText as UitkText19 } from "uitk-react-text";
var fragment33 = gql54(_templateObject53());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React54.createElement("div", null, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React54.createElement(UitkSpacing19, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React54.createElement(UitkIcon9, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize6[graphic.size] : UitkIconSize6.EXTRA_SMALL
    })), /* @__PURE__ */ React54.createElement(UitkText19, _objectSpreadProps(_objectSpread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment33;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React55 from "react";
import { gql as gql55 } from "@apollo/client";
import { UitkText as UitkText20 } from "uitk-react-text";
var fragment34 = gql55(_templateObject54());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React55.createElement(UitkText20, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment34;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment35 = gql56(_templateObject55(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React56.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React56.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React56.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment35;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment36 = gql57(_templateObject56(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _objectWithoutProperties(props, [
        "align",
        "data"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React57.createElement(UitkText21, _objectSpreadProps(_objectSpread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React57.createElement(React57.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React57.createElement(React57.Fragment, null, /* @__PURE__ */ React57.createElement(EGDSSpannableTextContent, _objectSpreadProps(_objectSpread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React57.createElement(React57.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React57.createElement(React57.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React57.createElement(EGDSSpannableTextContent, _objectSpread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment36;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React58 from "react";
import { gql as gql58 } from "@apollo/client";
var fragment37 = gql58(_templateObject57());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React58.createElement(React58.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment37;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// src/components/property-info-details/property-info-details.tsx
import { UitkLayoutGrid as UitkLayoutGrid11, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
// src/components/gallery/property-image-gallery.tsx
import React67 from "react";
import { gql as gql65 } from "@apollo/client";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium6, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
import React60 from "react";
import { gql as gql60 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
// src/components/gallery/__private/utils/to-uitk-images.ts
function toUitkImages(images, useLowRes) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_image2, _img_thumbnail, _img_fallbackImage;
        var src = useLowRes && img.lowResImage ? img.lowResImage.url : (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.url;
        var _img_image_description, _img_alt;
        return {
            src: src,
            caption: (_img_image_description = (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image2 = img.image) === null || _img_image2 === void 0 ? void 0 : _img_image2.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url
        };
    });
}
// src/components/gallery/__private/__fragments/gallery-buttons/gallery-buttons.tsx
import React59 from "react";
import { gql as gql59 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { UitkOverlayButton } from "uitk-react-button";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex15 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
var __GalleryButtonsFragment = gql59(_templateObject58());
var TRIGGER_POSITION = {
    position: {
        zindex: "layer2",
        bottom: "three",
        right: "three"
    },
    type: "absolute"
};
var GalleryButtons = function(props) {
    var data = props.data, onThumbnailGalleryClick = props.onThumbnailGalleryClick, onVirtualTourClick = props.onVirtualTourClick, thumbnailButtonText = props.thumbnailButtonText, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel;
    var galleryButtons = data.galleryButtons;
    var track = useClickTracker13();
    var handleVirtualTourClick = React59.useCallback(function(index) {
        var _galleryButtons_index, _galleryButtons_index_action;
        if (galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index = galleryButtons[index]) === null || _galleryButtons_index === void 0 ? void 0 : (_galleryButtons_index_action = _galleryButtons_index.action) === null || _galleryButtons_index_action === void 0 ? void 0 : _galleryButtons_index_action.resource) {
            var _galleryButtons_index1, _galleryButtons_index_action1, _galleryButtons_index_action_resource;
            var btnVal = (galleryButtons === null || galleryButtons === void 0 ? void 0 : (_galleryButtons_index1 = galleryButtons[index]) === null || _galleryButtons_index1 === void 0 ? void 0 : (_galleryButtons_index_action1 = _galleryButtons_index1.action) === null || _galleryButtons_index_action1 === void 0 ? void 0 : (_galleryButtons_index_action_resource = _galleryButtons_index_action1.resource) === null || _galleryButtons_index_action_resource === void 0 ? void 0 : _galleryButtons_index_action_resource.value) || "";
            onVirtualTourClick(btnVal);
        }
    }, [
        galleryButtons,
        onVirtualTourClick
    ]);
    var thubnailButtonAnalytics = React59.useMemo(function() {
        return {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Open Room Gallery dialog",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    return /* @__PURE__ */ React59.createElement(UitkLayoutPosition5, _objectSpread({}, TRIGGER_POSITION), /* @__PURE__ */ React59.createElement(UitkLayoutFlex15, {
        space: "two",
        wrap: "nowrap"
    }, galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.map(function(galleryButton, buttonIndex) {
        var _galleryButton_icon, _galleryButton_icon1;
        /* @__PURE__ */ return React59.createElement(UitkOverlayButton, {
            key: "gallery-mosaic-action-".concat((_galleryButton_icon = galleryButton.icon) === null || _galleryButton_icon === void 0 ? void 0 : _galleryButton_icon.id),
            "aria-label": "gallery-mosaic-action",
            onClick: function() {
                return handleVirtualTourClick(buttonIndex);
            }
        }, /* @__PURE__ */ React59.createElement(UitkIcon10, {
            name: ((_galleryButton_icon1 = galleryButton.icon) === null || _galleryButton_icon1 === void 0 ? void 0 : _galleryButton_icon1.id) || "",
            id: "gallery-mosaic-action-trigger"
        }), galleryButton.accessibility);
    }), /* @__PURE__ */ React59.createElement(UitkOverlayButton, {
        "aria-label": thumbnailDialogTriggerAccessibilityLabel || "",
        onClick: onThumbnailGalleryClick,
        analytics: thubnailButtonAnalytics
    }, /* @__PURE__ */ React59.createElement(UitkIcon10, {
        name: "photo_library",
        id: "gallery-mosaic-thumbnail-trigger"
    }), thumbnailButtonText)));
};
GalleryButtons.displayName = "GalleryButtons";
GalleryButtons.fragment = __GalleryButtonsFragment;
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
var __CarouselContainerFragment = gql60(_templateObject59(), GalleryButtons.fragment);
var CarouselContainer = function(props) {
    var data = props.data, onImageClick = props.onImageClick, onVirtualTourClick = props.onVirtualTourClick, onTriggerClick = props.onTriggerClick, imageIndexState = props.imageIndexState;
    var galleryButtons = data.galleryButtons, images = data.images, label = data.label;
    var track = useClickTracker14();
    var _React60_useState = _slicedToArray(React60.useState(false), 2), logExposure = _React60_useState[0], setLogExposure = _React60_useState[1];
    var _imageIndexState = _slicedToArray(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var controlAnalytics = React60.useMemo(function() {
        return {
            id: "HOT.HIS.Main",
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    var handleIndexChange = React60.useCallback(function(index) {
        setImageIndex(index);
        setLogExposure(true);
    }, [
        setImageIndex,
        setLogExposure
    ]);
    var handleImageClick = React60.useCallback(function() {
        var _images_imageIndex;
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click");
        var image = (_images_imageIndex = images[imageIndex]) === null || _images_imageIndex === void 0 ? void 0 : _images_imageIndex.image;
        if (image === null || image === void 0 ? void 0 : image.thumbnailClickAnalytics) {
            var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        onImageClick();
        setLogExposure(true);
    }, [
        track,
        onImageClick
    ]);
    var handleMediaButtonClick = React60.useCallback(function() {
        track("HOT.HIS.PhotoGalleryTrigger", "Open Room Gallery dialog");
        onTriggerClick();
        setLogExposure(true);
    }, [
        track,
        onTriggerClick
    ]);
    var virtualTourButton = galleryButtons === null || galleryButtons === void 0 ? void 0 : galleryButtons.find(function(button) {
        var _button_action, _button_action_resource;
        return (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value;
    });
    var handleonVirtualTourButtonClick = React60.useCallback(function() {
        if (virtualTourButton === null || virtualTourButton === void 0 ? void 0 : virtualTourButton.action) {
            onVirtualTourClick(virtualTourButton.action.resource.value);
        }
    }, [
        onVirtualTourClick,
        virtualTourButton
    ]);
    var uitkImages = React60.useMemo(function() {
        return toUitkImages(images);
    }, [
        images
    ]);
    var buttonText;
    if (virtualTourButton === null || virtualTourButton === void 0 ? void 0 : virtualTourButton.accessibility) {
        buttonText = {
            virtualTourButton: virtualTourButton === null || virtualTourButton === void 0 ? void 0 : virtualTourButton.accessibility
        };
    }
    var GalleryCarousel = /* @__PURE__ */ React60.createElement(UitkGalleryCarousel, {
        carouselId: "property-details-carousel",
        allyHeadingLevel: 2,
        analytics: controlAnalytics,
        allyHeadingText: label || "",
        buttonText: buttonText,
        carouselName: "PhotoGallery",
        images: uitkImages,
        onImageClick: handleImageClick,
        onIndexChange: handleIndexChange,
        showGalleryButton: true,
        showVirtualTourButton: Boolean(virtualTourButton),
        onMediaButtonClick: handleMediaButtonClick,
        onVirtualTourClick: handleonVirtualTourButtonClick,
        currentIndex: imageIndex,
        enablePreload: false,
        fetchPriority: "high"
    });
    return /* @__PURE__ */ React60.createElement(Experiment2, {
        name: "mWeb_PDP_Full_image_gallery_ranking_algorithm_with_new_scene_classifier",
        logExposure: logExposure
    }, /* @__PURE__ */ React60.createElement(ExperimentControl2, null, GalleryCarousel), /* @__PURE__ */ React60.createElement(ExperimentVariant2, {
        bucket: 1
    }, GalleryCarousel));
};
CarouselContainer.displayName = "CarouselContainer";
CarouselContainer.fragment = __CarouselContainerFragment;
// src/components/gallery/__private/__fragments/containers/mosaic-container.tsx
import React62 from "react";
import { gql as gql62 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
// src/components/gallery/__private/__fragments/images/property-image.tsx
import React61 from "react";
import { gql as gql61 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage3, UitkImageLink } from "uitk-react-images";
var __PropertyImageFragment = gql61(_templateObject60());
var PropertyImage = function(props) {
    var data = props.data, onClick = props.onClick, index = props.index, className = props.className, fetchPriority = props.fetchPriority, attributes = _objectWithoutProperties(props, [
        "data",
        "onClick",
        "index",
        "className",
        "fetchPriority"
    ]);
    var alt = data.alt, image = data.image, lowResImage = data.lowResImage;
    var track = useClickTracker15();
    var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
    var handleClick = React61.useCallback(function() {
        if (thumbnailClickAnalytics) {
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        onClick(index);
    }, [
        onClick,
        index
    ]);
    var galleryImage = /* @__PURE__ */ React61.createElement(React61.Fragment, null, /* @__PURE__ */ React61.createElement(UitkImage3, {
        alt: alt || image.description,
        placeholderImage: true,
        src: lowResImage ? lowResImage.url : image.url,
        additionalProps: {
            fetchPriority: fetchPriority
        }
    }), /* @__PURE__ */ React61.createElement(UitkImageLink, null, /* @__PURE__ */ React61.createElement("button", {
        onClick: handleClick,
        type: "button"
    }, /* @__PURE__ */ React61.createElement("span", {
        className: "is-visually-hidden"
    }, image.description))));
    return /* @__PURE__ */ React61.createElement(UitkFigure4, _objectSpreadProps(_objectSpread({}, attributes), {
        className: className,
        ratio: UitkFigureAspectRatioType2.R16_9
    }), thumbnailClickAnalytics ? /* @__PURE__ */ React61.createElement(IntersectionTracker4, {
        trackOnce: true,
        referrerId: thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId,
        linkName: thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName
    }, galleryImage) : galleryImage);
};
PropertyImage.displayName = "PropertyImage";
PropertyImage.fragment = __PropertyImageFragment;
// src/components/gallery/__private/__fragments/containers/mosaic-container.tsx
var __MosaicContainerFragment = gql62(_templateObject61(), PropertyImage.fragment, GalleryButtons.fragment);
function numberOfColumns(numberOfImages) {
    switch(numberOfImages){
        case 5:
            return 4;
        case 3:
            return 3;
        default:
            return 1;
    }
}
var MosaicContainer = function(props) {
    var data = props.data, imagesToShow = props.imagesToShow, onVirtualTourClick = props.onVirtualTourClick, onImageClick = props.onImageClick, onTriggerClick = props.onTriggerClick, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel;
    var images = data.images, label = data.label;
    var track = useClickTracker16();
    var handleImageClick = React62.useCallback(function(index) {
        track("HOT.HIS.ClickMosaicTileImage.".concat(index + 1), "Property mosaic tile image click");
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click");
        onImageClick(index);
    }, [
        track,
        onImageClick
    ]);
    var mosaicImages = React62.useMemo(function() {
        var imageSlice = images.slice(0, imagesToShow);
        if (imageSlice.length % 2 === 0) {
            imageSlice.pop();
        }
        return imageSlice;
    }, [
        images,
        imagesToShow
    ]);
    var columns = numberOfColumns(mosaicImages.length);
    var overlayButtonText = images.length === 1 ? "1" : "".concat(images.length - 1, "+");
    return /* @__PURE__ */ React62.createElement(UitkLayoutPosition6, {
        type: "relative"
    }, /* @__PURE__ */ React62.createElement(UitkLayoutGrid7, {
        columns: columns,
        rows: 2,
        space: "half"
    }, /* @__PURE__ */ React62.createElement("meta", {
        itemProp: "image",
        content: mosaicImages[0].image.url
    }), /* @__PURE__ */ React62.createElement("h2", {
        className: "is-visually-hidden"
    }, label), mosaicImages.map(function(img, index) {
        return /* @__PURE__ */ React62.createElement(UitkLayoutGridItem5, {
            key: "mosaic-image-".concat(index),
            colSpan: index === 0 ? 2 : 1,
            rowSpan: index === 0 ? 2 : 1
        }, /* @__PURE__ */ React62.createElement(PropertyImage, {
            data: img,
            onClick: handleImageClick,
            index: index,
            fetchPriority: index === 0 ? "high" : void 0
        }));
    }), /* @__PURE__ */ React62.createElement(GalleryButtons, {
        data: data,
        onThumbnailGalleryClick: onTriggerClick,
        onVirtualTourClick: onVirtualTourClick,
        thumbnailButtonText: overlayButtonText,
        thumbnailDialogTriggerTitle: thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerAccessibilityLabel: thumbnailDialogTriggerAccessibilityLabel
    })));
};
MosaicContainer.fragment = __MosaicContainerFragment;
MosaicContainer.displayName = "MosaicContainer";
// src/components/gallery/__private/__fragments/dialogs/media-gallery-dialog.tsx
import React63 from "react";
import { gql as gql63 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from "uitk-react-media-gallery";
var __MediaGalleryDialogFragment = gql63(_templateObject62());
var MediaGalleryDialog = function(props) {
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, imageIndexState = props.imageIndexState, categoryImageIndexState = props.categoryImageIndexState, categoryIndexState = props.categoryIndexState;
    var categories = data.categories, images = data.images, mediaGalleryDialog = data.mediaGalleryDialog;
    var _imageIndexState = _slicedToArray(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var _categoryImageIndexState = _slicedToArray(categoryImageIndexState, 2), categoryImageIndex = _categoryImageIndexState[0], setCategoryImageIndex = _categoryImageIndexState[1];
    var _categoryIndexState = _slicedToArray(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var track = useClickTracker17();
    var galleryImages = React63.useMemo(function() {
        if (categoryIndex < 0) {
            return toUitkImages(images);
        }
        var currentCategory = categories ? categories[categoryIndex] : null;
        return toUitkImages((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.images) || []);
    }, [
        categoryIndex,
        categories,
        images
    ]);
    var toolbarProps = React63.useMemo(function() {
        var _mediaGalleryDialog_toolbar, _mediaGalleryDialog_toolbar_icon, _mediaGalleryDialog_toolbar1, _mediaGalleryDialog_toolbar_icon1;
        return {
            type: mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon = _mediaGalleryDialog_toolbar.icon) === null || _mediaGalleryDialog_toolbar_icon === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon.iconId,
            navIconLabel: mediaGalleryDialog === null || mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar1 = mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar1 === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon1 = _mediaGalleryDialog_toolbar1.icon) === null || _mediaGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon1.description
        };
    }, [
        mediaGalleryDialog
    ]);
    var _React63_useMemo = _slicedToArray(React63.useMemo(function() {
        var callback = function(id, description) {
            return track(id, description);
        };
        var dialog = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Close review gallery dialog",
            callback: callback
        };
        var galleryControl = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Change image in media gallery",
            callback: callback
        };
        return [
            dialog,
            galleryControl
        ];
    }, [
        track
    ]), 2), dialogAnalytics = _React63_useMemo[0], galleryControlAnalytics = _React63_useMemo[1];
    var handleIndexChange = React63.useCallback(function(index) {
        if (categoryIndex < 0) {
            setImageIndex(index);
            return;
        }
        setCategoryImageIndex(index);
    }, [
        categoryIndex,
        setCategoryImageIndex,
        setImageIndex
    ]);
    if (!(galleryImages === null || galleryImages === void 0 ? void 0 : galleryImages.length)) {
        return null;
    }
    var mediaGalleryImageViewProps = {
        currentIndex: categoryIndex >= 0 ? categoryImageIndex : imageIndex,
        onIndexChange: handleIndexChange,
        galleryName: "Dialog",
        analytics: galleryControlAnalytics
    };
    return /* @__PURE__ */ React63.createElement(UitkMediaGalleryImageDialog, _objectSpread({
        dialogShow: isDialogOpen,
        onDismiss: onDialogDismiss,
        strictFullscreen: true,
        analytics: dialogAnalytics
    }, toolbarProps), /* @__PURE__ */ React63.createElement(UitkMediaGalleryImageView, _objectSpreadProps(_objectSpread({}, mediaGalleryImageViewProps), {
        images: galleryImages,
        stretchToFill: false
    })));
};
MediaGalleryDialog.displayName = "MediaGalleryDialog";
MediaGalleryDialog.fragment = __MediaGalleryDialogFragment;
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
import React66 from "react";
import { gql as gql64 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet10, UitkSheetContent as UitkSheetContent4 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar6 } from "uitk-react-toolbar";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-tabs.tsx
import React65 from "react";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium4, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition7 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkHeading as UitkHeading11 } from "uitk-react-text";
// src/components/gallery/__private/utils/to-uitk-images-with-thumbnail-analytics.ts
function toUitkImagesWithThumbnailAnalytics(images, useLowRes) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_image2, _img_thumbnail, _img_fallbackImage, _img_image3;
        var src = useLowRes && img.lowResImage ? img.lowResImage.url : (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.url;
        var _img_image_description, _img_alt;
        return {
            src: src,
            caption: (_img_image_description = (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image2 = img.image) === null || _img_image2 === void 0 ? void 0 : _img_image2.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url,
            thumbnailClickAnalytics: (_img_image3 = img.image) === null || _img_image3 === void 0 ? void 0 : _img_image3.thumbnailClickAnalytics
        };
    });
}
// src/components/gallery/__private/__fragments/dialogs/media-gallery-thumbnail-view.tsx
import React64 from "react";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkList } from "uitk-react-list";
import { UitkMediaGalleryThumbnail } from "uitk-react-media-gallery";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkText as UitkText22 } from "uitk-react-text";
var MediaGalleryThumbnailView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, columns = param.columns, space = param.space, imagesRatio = param.imagesRatio, focusIndex = param.focusIndex, containerRef = param.containerRef;
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    return /* @__PURE__ */ React64.createElement(UitkList, {
        bullet: "no-bullet",
        spacing: false
    }, /* @__PURE__ */ React64.createElement(UitkLayoutGrid8, {
        columns: columns,
        space: space
    }, images.map(function(image, index) {
        var _image_thumbnailClickAnalytics, _image_thumbnailClickAnalytics1;
        /* @__PURE__ */ return React64.createElement(UitkLayoutGridItem6, {
            key: index
        }, /* @__PURE__ */ React64.createElement("div", {
            "data-stid": "image-thumbnail-view-with-label"
        }, image.thumbnailClickAnalytics && /* @__PURE__ */ React64.createElement(IntersectionTracker5, {
            trackOnce: true,
            referrerId: (_image_thumbnailClickAnalytics = image.thumbnailClickAnalytics) === null || _image_thumbnailClickAnalytics === void 0 ? void 0 : _image_thumbnailClickAnalytics.referrerId,
            linkName: (_image_thumbnailClickAnalytics1 = image.thumbnailClickAnalytics) === null || _image_thumbnailClickAnalytics1 === void 0 ? void 0 : _image_thumbnailClickAnalytics1.linkName
        }, /* @__PURE__ */ React64.createElement(UitkMediaGalleryThumbnail, _objectSpreadProps(_objectSpread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        }))), !image.thumbnailClickAnalytics && /* @__PURE__ */ React64.createElement(UitkMediaGalleryThumbnail, _objectSpreadProps(_objectSpread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        })), /* @__PURE__ */ React64.createElement(UitkSpacing20, {
            padding: {
                blockstart: "two",
                blockend: "three"
            }
        }, /* @__PURE__ */ React64.createElement(UitkText22, {
            align: "left",
            overflow: "truncate"
        }, image.caption))));
    })));
};
MediaGalleryThumbnailView.displayName = "MediaGalleryThumbnailView";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-tabs.tsx
var ThumbnailGalleryTabs = function(param) {
    var categories = param.categories, images = param.images, _param_useCenteredSheet = param.useCenteredSheet, useCenteredSheet = _param_useCenteredSheet === void 0 ? false : _param_useCenteredSheet, onImageClick = param.onImageClick, categoryIndexState = param.categoryIndexState, imageIndexState = param.imageIndexState;
    var _imageIndexState = _slicedToArray(imageIndexState, 1), imageIndex = _imageIndexState[0];
    var _categoryIndexState = _slicedToArray(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var track = useClickTracker18();
    var _React65_useState = _slicedToArray(React65.useState(categoryIndex >= 0 || !(categories === null || categories === void 0 ? void 0 : categories.length) ? categoryIndex : 0), 2), currentLocalCategoryIndex = _React65_useState[0], setCurrentLocalCategoryIndex = _React65_useState[1];
    var handleTabSelect = React65.useCallback(function(selectedCategoryIndex) {
        if (categories) {
            var selectedCategoryId = selectedCategoryIndex >= 0 ? categories[selectedCategoryIndex].categoryId : "";
            track("HOT.HIS.PhotoGalleryTrigger.".concat(selectedCategoryId, ".").concat(selectedCategoryIndex), "Selected gallery tab");
        }
        setCurrentLocalCategoryIndex(selectedCategoryIndex);
    }, [
        setCurrentLocalCategoryIndex,
        categories,
        track
    ]);
    var handleImageSelected = React65.useCallback(function(index) {
        if (currentLocalCategoryIndex) {
            var _localCategory_images_index;
            var localCategory = categories ? categories[currentLocalCategoryIndex] : null;
            var localCategoryId = (localCategory === null || localCategory === void 0 ? void 0 : localCategory.categoryId) || "";
            var imageSubjectId = localCategory === null || localCategory === void 0 ? void 0 : localCategory.images[index].subjectId;
            var thumbnailClickAnalytics = (_localCategory_images_index = localCategory === null || localCategory === void 0 ? void 0 : localCategory.images[index]) === null || _localCategory_images_index === void 0 ? void 0 : _localCategory_images_index.image.thumbnailClickAnalytics;
            track("HOT.HIS.ClickThumbnailImage.".concat(localCategoryId, ".").concat(imageSubjectId, ".").concat(index), "Launch Thumbnail Gallery From Image Click");
            if (thumbnailClickAnalytics) {
                track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        } else {
            var imageSubjectId1 = images[index].subjectId;
            var thumbnailClickAnalytics1 = images[index].image.thumbnailClickAnalytics;
            track("HOT.HIS.ClickThumbnailImage.".concat(imageSubjectId1, ".").concat(index), "Launch Thumbnail Gallery From Image Click");
            if (thumbnailClickAnalytics1) {
                track(thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.referrerId, thumbnailClickAnalytics1 === null || thumbnailClickAnalytics1 === void 0 ? void 0 : thumbnailClickAnalytics1.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        }
    }, [
        currentLocalCategoryIndex,
        onImageClick,
        categories,
        track,
        images
    ]);
    var thumbnailViewWithImageLabel = React65.useCallback(function(galleryImages, columns) {
        return /* @__PURE__ */ React65.createElement(MediaGalleryThumbnailView, {
            imagesRatio: UitkFigureAspectRatioType3.R16_9,
            images: galleryImages,
            onImageSelected: handleImageSelected,
            columns: columns,
            space: "three",
            focusIndex: imageIndex
        });
    }, [
        handleImageSelected,
        imageIndex
    ]);
    var mediaGalleryThumbnailViewBody = React65.useCallback(function(galleryImages, title, columns, headingSize, headingTag) {
        var hasSpacing = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
        var body = /* @__PURE__ */ React65.createElement(React65.Fragment, null, title && /* @__PURE__ */ React65.createElement(UitkSpacing21, {
            padding: {
                blockend: "three"
            }
        }, /* @__PURE__ */ React65.createElement(UitkHeading11, {
            tag: headingTag,
            size: headingSize
        }, title)), thumbnailViewWithImageLabel(galleryImages, columns));
        if (hasSpacing || useCenteredSheet) {
            return /* @__PURE__ */ React65.createElement(UitkSpacing21, {
                padding: {
                    inline: "three"
                }
            }, /* @__PURE__ */ React65.createElement("div", null, body));
        }
        return body;
    }, [
        thumbnailViewWithImageLabel,
        useCenteredSheet
    ]);
    var mediaGalleryThumbnailView = React65.useCallback(function(galleryImages, title) {
        return /* @__PURE__ */ React65.createElement(Viewport7, null, /* @__PURE__ */ React65.createElement(ViewSmall7, null, mediaGalleryThumbnailViewBody(galleryImages, title, 1, 4, "h4")), /* @__PURE__ */ React65.createElement(ViewMedium4, null, mediaGalleryThumbnailViewBody(galleryImages, title, 2, 3, "h3")), /* @__PURE__ */ React65.createElement(ViewLarge4, null, mediaGalleryThumbnailViewBody(galleryImages, title, 2, 3, "h3", false)));
    }, [
        mediaGalleryThumbnailViewBody
    ]);
    var tabContent = React65.useCallback(function(category) {
        var defaultTabView = mediaGalleryThumbnailView(toUitkImagesWithThumbnailAnalytics(category.images), category.name);
        return defaultTabView;
    }, [
        mediaGalleryThumbnailView,
        useCenteredSheet
    ]);
    if (!(categories === null || categories === void 0 ? void 0 : categories.length)) {
        return mediaGalleryThumbnailView(toUitkImagesWithThumbnailAnalytics(images));
    }
    var tabsContent = /* @__PURE__ */ React65.createElement(UitkTabs, {
        tabsType: UitkTabsType.NATURAL,
        selectedTab: currentLocalCategoryIndex,
        onTabSelect: handleTabSelect
    }, categories.map(function(category) {
        return /* @__PURE__ */ React65.createElement(UitkTab, {
            key: "thumbail-gallery-tab-".concat(category.categoryId),
            id: category.categoryId,
            name: category.name,
            targetURI: "#"
        }, tabContent(category));
    }));
    if (useCenteredSheet) {
        return /* @__PURE__ */ React65.createElement(UitkLayoutPosition7, {
            type: "sticky",
            position: {
                top: "zero",
                zindex: "layer2"
            },
            cloneElement: true
        }, tabsContent);
    }
    return tabsContent;
};
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
var __ThumbnailGalleryDialogFragment = gql64(_templateObject63());
var ThumbnailGalleryDialog = function(props) {
    var _thumbnailGalleryDialog_toolbar, _thumbnailGalleryDialog_toolbar_icon, _thumbnailGalleryDialog_toolbar1, _thumbnailGalleryDialog_toolbar_icon1, _thumbnailGalleryDialog_toolbar2;
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, onImageClick = props.onImageClick, categoryIndexState = props.categoryIndexState, imageIndexState = props.imageIndexState, triggerRef = props.triggerRef;
    var categories = data.categories, thumbnailGalleryDialog = data.thumbnailGalleryDialog, images = data.images;
    var _React66_useState = _slicedToArray(React66.useState(0), 2), sheetHeight = _React66_useState[0], setSheetHeight = _React66_useState[1];
    var VERTICAL_MARGINS = 48;
    React66.useEffect(function() {
        setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        var handleWindowResize = function() {
            setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var track = useClickTracker19();
    var toolbarAnalytics = {
        id: "HOT.HIS.PhotoGalleryTrigger",
        description: "Close thumbnail gallery dialog",
        callback: function(id, desc) {
            return track(id, desc);
        }
    };
    var toolbarComponent = thumbnailGalleryDialog && /* @__PURE__ */ React66.createElement(UitkToolbar6, {
        navigationContent: {
            onClick: onDialogDismiss,
            onClickAnalytics: toolbarAnalytics,
            navType: (_thumbnailGalleryDialog_toolbar = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon = _thumbnailGalleryDialog_toolbar.icon) === null || _thumbnailGalleryDialog_toolbar_icon === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon.iconId,
            navIconLabel: (_thumbnailGalleryDialog_toolbar1 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar1 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon1 = _thumbnailGalleryDialog_toolbar1.icon) === null || _thumbnailGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon1.description
        },
        toolbarTitle: ((_thumbnailGalleryDialog_toolbar2 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar2 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar2.title) || ""
    });
    var centeredSheetThumbnailGalleryTabs = /* @__PURE__ */ React66.createElement(ThumbnailGalleryTabs, {
        categories: categories,
        images: images,
        useCenteredSheet: true,
        onImageClick: onImageClick,
        categoryIndexState: categoryIndexState,
        imageIndexState: imageIndexState
    });
    var sheetProps = {
        returnFocusOnClose: true,
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    var sheetContent = /* @__PURE__ */ React66.createElement(React66.Fragment, null, toolbarComponent, /* @__PURE__ */ React66.createElement(UitkSheetContent4, {
        padded: false
    }, centeredSheetThumbnailGalleryTabs));
    var fullScreenDialog = /* @__PURE__ */ React66.createElement(UitkSheet10, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, toolbarComponent, /* @__PURE__ */ React66.createElement(UitkSheetContent4, {
        padded: false
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlex16, {
        justifyContent: "center"
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem14, {
        maxWidth: "312x",
        grow: 1
    }, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(ThumbnailGalleryTabs, {
        categories: categories,
        images: images,
        useCenteredSheet: false,
        onImageClick: onImageClick,
        categoryIndexState: categoryIndexState,
        imageIndexState: imageIndexState
    }))))));
    return /* @__PURE__ */ React66.createElement(Viewport8, null, /* @__PURE__ */ React66.createElement(ViewSmall8, null, /* @__PURE__ */ React66.createElement(UitkSheet10, _objectSpreadProps(_objectSpread({}, sheetProps), {
        type: "full"
    }), sheetContent)), /* @__PURE__ */ React66.createElement(ViewMedium5, null, /* @__PURE__ */ React66.createElement(Experiment3, {
        name: "PEXO_PDP_centered_sheet_gallery_followup_test_EGTNL"
    }, /* @__PURE__ */ React66.createElement(ExperimentControl3, null, fullScreenDialog), /* @__PURE__ */ React66.createElement(ExperimentVariant3, {
        bucket: 1
    }, /* @__PURE__ */ React66.createElement(UitkSheet10, _objectSpreadProps(_objectSpread({}, sheetProps), {
        type: "centered",
        height: sheetHeight
    }), sheetContent)))));
};
ThumbnailGalleryDialog.displayName = "ThumbnailGalleryDialog";
ThumbnailGalleryDialog.fragment = __ThumbnailGalleryDialogFragment;
// src/components/gallery/property-image-gallery.tsx
var __PropertyImageGalleryFragment = gql65(_templateObject64(), MosaicContainer.fragment, CarouselContainer.fragment, MediaGalleryDialog.fragment, ThumbnailGalleryDialog.fragment);
var PropertyImageGallery = function(param) {
    var data = param.data, className = param.className;
    var _data_thumbnailGalleryDialog, _data_thumbnailGalleryDialog_trigger, _data_thumbnailGalleryDialog1, _data_thumbnailGalleryDialog_trigger1, _data_images;
    var _useDialog4 = _slicedToArray(useDialog4("media-gallery", "pwaDialogNested"), 3), isMediaGalleryDialogOpen = _useDialog4[0], mediaGalleryDialogActions = _useDialog4[1], MediaGalleryDialogWrapper = _useDialog4[2];
    var _useDialog41 = _slicedToArray(useDialog4("thumbnail-gallery", "pwaThumbnailDialog"), 3), isThumbnailGalleryDialogOpen = _useDialog41[0], thumbnailGalleryDialogActions = _useDialog41[1], ThumbnailGalleryDialogWrapper = _useDialog41[2];
    var triggerBtn = React67.useRef(null);
    var triggerImageBtn = React67.useRef(null);
    var imageIndexState = React67.useState(0);
    var categoryIndexState = React67.useState(-1);
    var categoryImageIndexState = React67.useState(0);
    var _imageIndexState = _slicedToArray(imageIndexState, 2), setImageIndex = _imageIndexState[1];
    var _categoryIndexState = _slicedToArray(categoryIndexState, 2), setCategoryIndex = _categoryIndexState[1];
    var _categoryImageIndexState = _slicedToArray(categoryImageIndexState, 2), setCategoryImageIndex = _categoryImageIndexState[1];
    var onMosaicImageClick = React67.useCallback(function(index) {
        setImageIndex(index);
        setCategoryIndex(-1);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex,
        setImageIndex
    ]);
    var onVirtualTourClick = React67.useCallback(function(imageResource) {
        if (typeof window !== "undefined") {
            window.open(imageResource);
        }
    }, []);
    var onCarouselImageClick = React67.useCallback(function() {
        setCategoryIndex(-1);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex
    ]);
    var onThumbnailImageClick = React67.useCallback(function(index, categoryIndex) {
        triggerImageBtn.current = document.activeElement;
        setCategoryIndex(categoryIndex);
        setCategoryImageIndex(index);
        if (categoryIndex < 0) {
            setImageIndex(index);
        }
        mediaGalleryDialogActions.openDialog();
    }, [
        setCategoryIndex,
        setCategoryImageIndex,
        mediaGalleryDialogActions,
        setImageIndex
    ]);
    var onOpenThumbnailGalleryDialog = React67.useCallback(function() {
        var activeEl = document.activeElement;
        triggerBtn.current = activeEl;
        setImageIndex(0);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setImageIndex
    ]);
    var onDialogDismiss = React67.useCallback(function() {
        thumbnailGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        }, 0);
    }, [
        thumbnailGalleryDialogActions
    ]);
    var onMediaDialogDismiss = React67.useCallback(function() {
        mediaGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerImageBtn_current;
            (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
        }, 0);
    }, [
        mediaGalleryDialogActions
    ]);
    var controlProps = {
        imageIndexState: imageIndexState,
        categoryImageIndexState: categoryImageIndexState,
        categoryIndexState: categoryIndexState
    };
    var containerProps = _objectSpread({
        onTriggerClick: onOpenThumbnailGalleryDialog,
        thumbnailDialogTriggerTitle: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger = _data_thumbnailGalleryDialog.trigger) === null || _data_thumbnailGalleryDialog_trigger === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger.value,
        thumbnailDialogTriggerAccessibilityLabel: data === null || data === void 0 ? void 0 : (_data_thumbnailGalleryDialog1 = data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog1 === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger1 = _data_thumbnailGalleryDialog1.trigger) === null || _data_thumbnailGalleryDialog_trigger1 === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger1.accessibilityLabel
    }, controlProps);
    if (!(data === null || data === void 0 ? void 0 : (_data_images = data.images) === null || _data_images === void 0 ? void 0 : _data_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React67.createElement("div", {
        className: className
    }, /* @__PURE__ */ React67.createElement(Viewport9, null, /* @__PURE__ */ React67.createElement(ViewSmall9, null, /* @__PURE__ */ React67.createElement(CarouselContainer, _objectSpreadProps(_objectSpread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: onCarouselImageClick
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog
    }))), /* @__PURE__ */ React67.createElement(ViewMedium6, null, /* @__PURE__ */ React67.createElement(MosaicContainer, _objectSpreadProps(_objectSpread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 3
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog
    }))), /* @__PURE__ */ React67.createElement(ViewLarge5, null, /* @__PURE__ */ React67.createElement(MosaicContainer, _objectSpreadProps(_objectSpread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 5
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog
    })))), /* @__PURE__ */ React67.createElement(ThumbnailGalleryDialogWrapper, null, /* @__PURE__ */ React67.createElement(ThumbnailGalleryDialog, _objectSpread({
        data: data,
        isDialogOpen: isThumbnailGalleryDialogOpen,
        onDialogDismiss: onDialogDismiss,
        onImageClick: onThumbnailImageClick,
        triggerRef: triggerBtn
    }, controlProps))), /* @__PURE__ */ React67.createElement(MediaGalleryDialogWrapper, null, /* @__PURE__ */ React67.createElement(MediaGalleryDialog, _objectSpread({
        data: data,
        isDialogOpen: isMediaGalleryDialogOpen,
        onDialogDismiss: onMediaDialogDismiss
    }, controlProps))));
};
PropertyImageGallery.displayName = "PropertyImageGallery";
PropertyImageGallery.fragment = __PropertyImageGalleryFragment;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
import React80 from "react";
import { gql as gql77 } from "@apollo/client";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
import React79 from "react";
import { gql as gql76 } from "@apollo/client";
import { ViewLarge as ViewLarge7, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex18 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid10, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
// src/components/summary/__private/__fragments/shared/property-info-content-header.tsx
import React68 from "react";
import { gql as gql66 } from "@apollo/client";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12, UitkText as UitkText23 } from "uitk-react-text";
var __PropertyInfoContentHeader = gql66(_templateObject65());
var PropertyInfoContentHeader = function(param) {
    var data = param.data;
    var text = data.text, subText = data.subText;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React68.createElement(UitkSpacing22, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React68.createElement(UitkHeading12, {
        tag: "h3",
        size: 5
    }, text), subText && /* @__PURE__ */ React68.createElement(UitkSpacing22, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React68.createElement(UitkText23, {
        spacing: "two"
    }, subText)));
};
PropertyInfoContentHeader.displayName = "PropertyInfoContentHeader";
PropertyInfoContentHeader.fragment = __PropertyInfoContentHeader;
// src/components/summary/__private/__fragments/shared/property-info-content-items.tsx
import React69 from "react";
import { gql as gql67 } from "@apollo/client";
import { UitkIcon as UitkIcon11 } from "uitk-react-icons";
import { UitkLayoutGrid as UitkLayoutGrid9 } from "uitk-react-layout-grid";
import { UitkList as UitkList2, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
import { UitkText as UitkText24 } from "uitk-react-text";
var __PropertyInfoContentItem = gql67(_templateObject66());
var PropertyInfoContentItem = function(param) {
    var className = param.className, data = param.data;
    var icon = data.icon, text = data.text, state = data.state, moreInfo = data.moreInfo, accessibilityLabel = data.accessibilityLabel;
    var iconTheme = moreInfo ? "positive" : "default";
    return /* @__PURE__ */ React69.createElement(UitkListItem, {
        key: "amenity-".concat(text),
        className: className
    }, icon && /* @__PURE__ */ React69.createElement(UitkSpacing23, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React69.createElement(UitkIcon11, {
        name: icon.iconId.toLocaleLowerCase(),
        description: icon.description,
        theme: iconTheme
    })), state === "DISABLED" ? /* @__PURE__ */ React69.createElement("s", {
        "aria-hidden": true
    }, /* @__PURE__ */ React69.createElement(UitkText24, {
        size: 300,
        inline: true
    }, text)) : /* @__PURE__ */ React69.createElement(UitkText24, {
        size: 300,
        inline: true
    }, text), accessibilityLabel && /* @__PURE__ */ React69.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), moreInfo && /* @__PURE__ */ React69.createElement(UitkSpacing23, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React69.createElement(UitkText24, {
        size: 200,
        inline: true
    }, moreInfo)));
};
PropertyInfoContentItem.displayName = "PropertyInfoContentItem";
PropertyInfoContentItem.fragment = __PropertyInfoContentItem;
var __PropertyInfoContentItems = gql67(_templateObject67(), PropertyInfoContentItem.fragment);
var PropertyInfoContentItems = function(param) {
    var columns = param.columns, rows = param.rows, data = param.data, space = param.space, prefix = param.prefix, subset = param.subset, autoflow = param.autoflow;
    var items = data.items;
    var contentItems = subset && subset > 0 ? items.slice(0, subset) : items;
    var numberOfRows = rows !== null && rows !== void 0 ? rows : contentItems && Math.ceil(contentItems.length / columns);
    var bullet = contentItems.length > 0 && contentItems[0].icon ? "icon-alternate" : "default";
    return /* @__PURE__ */ React69.createElement(UitkList2, {
        spacing: false,
        bullet: bullet,
        size: 2,
        type: "unordered"
    }, /* @__PURE__ */ React69.createElement(UitkLayoutGrid9, {
        columns: columns,
        space: space,
        autoFlow: autoflow,
        rows: numberOfRows
    }, contentItems.map(function(item, idx) {
        return /* @__PURE__ */ React69.createElement(PropertyInfoContentItem, {
            key: "".concat(prefix, "-item-").concat(idx),
            data: item
        });
    })));
};
PropertyInfoContentItems.displayName = "PropertyInfoContentItems";
PropertyInfoContentItems.fragment = __PropertyInfoContentItems;
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
import React78 from "react";
import { gql as gql75 } from "@apollo/client";
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
import React73 from "react";
import { gql as gql70 } from "@apollo/client";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React70 from "react";
import { gql as gql68 } from "@apollo/client";
import { UitkToolbar as UitkToolbar7 } from "uitk-react-toolbar";
var fragment38 = gql68(_templateObject68());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React70.createElement(UitkToolbar7, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment38;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/lodging-dialog-trigger-message/lodging-dialog-trigger-message.tsx
import React71 from "react";
import { gql as gql69 } from "@apollo/client";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink7 } from "uitk-react-link";
var fragment39 = gql69(_templateObject69(), LodgingEGDSIcon.fragment);
var LodgingDialogTriggerMessage = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, value = _param_data.value, accessibilityLabel = _param_data.accessibilityLabel, icon = _param_data.icon, clientSideAnalytics = _param_data.clientSideAnalytics;
    var track = useClickTracker20();
    var onClick = function() {
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
        onClickAction();
    };
    return /* @__PURE__ */ React71.createElement(UitkLink7, null, /* @__PURE__ */ React71.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0,
        onClick: onClick
    }, value, icon && /* @__PURE__ */ React71.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingDialogTriggerMessage.fragment = fragment39;
LodgingDialogTriggerMessage.displayName = "LodgingDialogTriggerMessage";
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet11 } from "uitk-react-sheet";
// src/components/property-info-details/property-info-details-inputs-provider.tsx
import React72 from "react";
var PropertyInfoDetailsInputsContext = React72.createContext(void 0);
var usePropertyInfoDetailsInputs = function() {
    var context = React72.useContext(PropertyInfoDetailsInputsContext);
    if (context === void 0) {
        throw new Error("usePropertyInfoDetailsInputs must be used with a PropertyInfoDetailsInputContext provider");
    }
    return context;
};
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
var fragment40 = gql70(_templateObject70(), EGDSDialogToolbar.fragment, LodgingDialogTriggerMessage.fragment);
var CleanlinessDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog5 = _slicedToArray(useDialog5("PropertyCleaningAndSafetyPracticesDialog", "pwaDialogNested"), 3), cleanlinessDialogActions = _useDialog5[1], CleanlinessDialogComponent = _useDialog5[2];
    var track = useClickTracker21();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React73.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        cleanlinessDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(LodgingDialogTriggerMessage, {
        onClickAction: cleanlinessDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React73.createElement(CleanlinessDialogComponent, null, /* @__PURE__ */ React73.createElement(UitkSheet11, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React73.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React73.createElement(UitkDialogContent2, null, /* @__PURE__ */ React73.createElement(PropertyCleanliness, {
        inputs: propertyId
    })))));
};
CleanlinessDialog.displayName = "CleanlinessDialog";
CleanlinessDialog.fragment = fragment40;
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
import React77 from "react";
import { gql as gql74 } from "@apollo/client";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet12 } from "uitk-react-sheet";
// src/components/property-amenities/property-amenities.tsx
import React76 from "react";
import { gql as gql73, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
import React75 from "react";
import { gql as gql72 } from "@apollo/client";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/shared/property-info-content.tsx
import React74 from "react";
import { gql as gql71 } from "@apollo/client";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge6, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
import { UitkDialog, UitkDialogContent as UitkDialogContent3, UitkDialogFooter } from "uitk-react-dialog";
import { UitkIcon as UitkIcon12 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex17 } from "uitk-react-layout-flex";
import { UitkList as UitkList3, UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
var __PropertyInfoContent = gql71(_templateObject71(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, PropertyInfoContentItem.fragment);
var PropertyInfoContent = function(param) {
    var data = param.data, small = param.small, large = param.large;
    var _header_icon;
    var header = data.header, icon = data.icon, iconAnalytics = data.iconAnalytics;
    var dialogKey = React74.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var dialogId = "location-highlights-".concat(dialogKey);
    var _useDialog6 = _slicedToArray(useDialog6(dialogId), 3), isDialogOpen = _useDialog6[0], dialogActions = _useDialog6[1], DialogComponent = _useDialog6[2];
    var trackIconAnalytics = useClickTracker22();
    var _header_subText, _header_icon_description;
    var dialog = /* @__PURE__ */ React74.createElement(DialogComponent, null, /* @__PURE__ */ React74.createElement(UitkDialog, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React74.createElement(UitkDialogContent3, null, (_header_subText = header === null || header === void 0 ? void 0 : header.subText) !== null && _header_subText !== void 0 ? _header_subText : "", /* @__PURE__ */ React74.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_header_icon_description = header === null || header === void 0 ? void 0 : (_header_icon = header.icon) === null || _header_icon === void 0 ? void 0 : _header_icon.description) !== null && _header_icon_description !== void 0 ? _header_icon_description : "",
            type: "tertiary"
        }
    }))));
    var handleClick = React74.useCallback(function() {
        dialogActions.openDialog();
        if (iconAnalytics) {
            trackIconAnalytics(iconAnalytics.referrerId, iconAnalytics.linkName, true);
        }
    }, [
        dialogActions,
        trackIconAnalytics,
        iconAnalytics
    ]);
    return /* @__PURE__ */ React74.createElement(React74.Fragment, null, /* @__PURE__ */ React74.createElement(UitkLayoutFlex17, {
        direction: "column"
    }, /* @__PURE__ */ React74.createElement(UitkLayoutFlex17, {
        alignItems: "start"
    }, header && /* @__PURE__ */ React74.createElement(PropertyInfoContentHeader, {
        data: header
    }), icon && /* @__PURE__ */ React74.createElement("button", {
        type: "button",
        onClick: handleClick,
        "aria-label": "property-info-content_icon"
    }, /* @__PURE__ */ React74.createElement(UitkSpacing24, {
        padding: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React74.createElement(UitkIcon12, {
        name: icon.id
    })))), /* @__PURE__ */ React74.createElement(Viewport10, null, /* @__PURE__ */ React74.createElement(ViewSmall10, null, /* @__PURE__ */ React74.createElement(PropertyInfoContentItems, _objectSpreadProps(_objectSpread({}, small), {
        data: data
    }))), /* @__PURE__ */ React74.createElement(ViewLarge6, null, /* @__PURE__ */ React74.createElement(PropertyInfoContentItems, _objectSpreadProps(_objectSpread({}, large), {
        data: data
    }))))), dialog);
};
PropertyInfoContent.displayName = "PropertyInfoContent";
PropertyInfoContent.fragment = __PropertyInfoContent;
var PropertyInfoContentList = function(param) {
    var data = param.data, prefix = param.prefix;
    var header = data.header, items = data.items;
    return /* @__PURE__ */ React74.createElement(React74.Fragment, null, header && /* @__PURE__ */ React74.createElement(PropertyInfoContentHeader, {
        data: header
    }), /* @__PURE__ */ React74.createElement(UitkList3, {
        spacing: false
    }, items.map(function(item, idx) {
        return /* @__PURE__ */ React74.createElement(UitkListItem2, {
            key: "".concat(prefix, "-item-").concat(idx)
        }, item.text);
    })));
};
PropertyInfoContentList.displayName = "PropertyInfoContentList";
PropertyInfoContentList.fragment = __PropertyInfoContent;
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
var __PropertyTakeoverAmenitiesFragment = gql72(_templateObject72(), PropertyInfoContent.fragment);
var PropertyTakeoverAmenities = function(param) {
    var _param_data = param.data, amenityClosures = _param_data.amenityClosures, highlight = _param_data.highlight, property = _param_data.property;
    var _amenityClosures_items;
    if (highlight.length === 0 && property.length === 0) {
        return null;
    }
    var baseIconItemsProps = {
        columns: 2
    };
    var smallIconItemsProps = _objectSpreadProps(_objectSpread({}, baseIconItemsProps), {
        space: "two"
    });
    var largeIconItemsProps = _objectSpreadProps(_objectSpread({}, baseIconItemsProps), {
        space: "three"
    });
    return /* @__PURE__ */ React75.createElement("div", null, (amenityClosures === null || amenityClosures === void 0 ? void 0 : amenityClosures.items) && (amenityClosures === null || amenityClosures === void 0 ? void 0 : (_amenityClosures_items = amenityClosures.items) === null || _amenityClosures_items === void 0 ? void 0 : _amenityClosures_items.length) > 0 && /* @__PURE__ */ React75.createElement(UitkSpacing25, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(PropertyInfoContent, {
        data: amenityClosures,
        small: _objectSpreadProps(_objectSpread({}, smallIconItemsProps), {
            prefix: "temporaryClosures"
        }),
        large: _objectSpreadProps(_objectSpread({}, largeIconItemsProps), {
            prefix: "temporaryClosures"
        })
    }))), highlight.map(function(section, idx) {
        return section.items.length > 0 && /* @__PURE__ */ React75.createElement(UitkSpacing25, {
            key: "highlightedAmenities-section-".concat(idx),
            padding: {
                blockend: "four"
            }
        }, /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(PropertyInfoContent, {
            data: section,
            small: _objectSpreadProps(_objectSpread({}, smallIconItemsProps), {
                prefix: "highlightedAmenities"
            }),
            large: _objectSpreadProps(_objectSpread({}, largeIconItemsProps), {
                prefix: "highlightedAmenities"
            })
        })));
    }), property.map(function(section, idx) {
        return section.items.length > 0 && /* @__PURE__ */ React75.createElement(UitkSpacing25, {
            key: "propertyAmenities-section-".concat(idx),
            padding: {
                blockend: "four"
            }
        }, /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(PropertyInfoContentList, {
            data: section,
            prefix: "propertyAmenities"
        })));
    }));
};
PropertyTakeoverAmenities.fragment = __PropertyTakeoverAmenitiesFragment;
PropertyTakeoverAmenities.displayName = "PropertyTakeoverAmenities";
// src/components/property-amenities/property-amenities.tsx
var __Query3 = gql73(_templateObject73(), PropertyTakeoverAmenities.fragment);
var PropertyAmenities = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyInfo, _data_propertyInfo_summary, _data_propertyInfo_summary_amenities;
    var context = useBexApi7().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__Query3, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery5.data, loading = _useQuery5.loading;
    var takeover = data === null || data === void 0 ? void 0 : (_data_propertyInfo = data.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : (_data_propertyInfo_summary = _data_propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : (_data_propertyInfo_summary_amenities = _data_propertyInfo_summary.amenities) === null || _data_propertyInfo_summary_amenities === void 0 ? void 0 : _data_propertyInfo_summary_amenities.takeover;
    if (loading || !takeover) {
        return null;
    }
    return /* @__PURE__ */ React76.createElement(PropertyTakeoverAmenities, {
        data: takeover
    });
};
PropertyAmenities.displayName = "PropertyAmenities";
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
var fragment41 = gql74(_templateObject74(), EGDSDialogToolbar.fragment, LodgingDialogTriggerMessage.fragment);
var SeeMorePropertyAmenitiesDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog7 = _slicedToArray(useDialog7("PropertyAmenitiesDialog", "pwaDialogNested"), 3), seeMorePropertyAmenitiesDialogActions = _useDialog7[1], SeeMorePropertyAmenitiesDialogComponent = _useDialog7[2];
    var track = useClickTracker23();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React77.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        seeMorePropertyAmenitiesDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React77.createElement(React77.Fragment, null, /* @__PURE__ */ React77.createElement(LodgingDialogTriggerMessage, {
        data: trigger,
        onClickAction: seeMorePropertyAmenitiesDialogActions.openDialog,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React77.createElement(SeeMorePropertyAmenitiesDialogComponent, null, /* @__PURE__ */ React77.createElement(UitkSheet12, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React77.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React77.createElement(UitkDialogContent4, null, /* @__PURE__ */ React77.createElement(PropertyAmenities, {
        inputs: propertyId
    })))));
};
SeeMorePropertyAmenitiesDialog.displayName = "SeeMorePropertyAmenitiesDialog";
SeeMorePropertyAmenitiesDialog.fragment = fragment41;
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
var fragment42 = gql75(_templateObject75(), SeeMorePropertyAmenitiesDialog.fragment, CleanlinessDialog.fragment);
var SeeMoreAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "AmenitiesDialog":
            return /* @__PURE__ */ React78.createElement(SeeMorePropertyAmenitiesDialog, {
                data: data
            });
        case "CleanlinessDialog":
            return /* @__PURE__ */ React78.createElement(CleanlinessDialog, {
                data: data
            });
        default:
            return null;
    }
};
SeeMoreAction.displayName = "SeeMoreAction";
SeeMoreAction.fragment = fragment42;
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
var __PropertyInfoContentWithSeeMoreAction = gql76(_templateObject76(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, SeeMoreAction.fragment);
var PropertyInfoContentWithSeeMoreAction = function(param) {
    var data = param.data, small = param.small, large = param.large;
    var header = data.header, seeMoreAction = data.seeMoreAction;
    return /* @__PURE__ */ React79.createElement(UitkLayoutFlex18, {
        direction: "column"
    }, header && /* @__PURE__ */ React79.createElement(PropertyInfoContentHeader, {
        data: header
    }), /* @__PURE__ */ React79.createElement(Viewport11, null, /* @__PURE__ */ React79.createElement(ViewSmall11, null, /* @__PURE__ */ React79.createElement(React79.Fragment, null, /* @__PURE__ */ React79.createElement(PropertyInfoContentItems, _objectSpreadProps(_objectSpread({}, small), {
        data: data
    })), seeMoreAction && /* @__PURE__ */ React79.createElement(SeeMoreAction, {
        data: seeMoreAction
    }))), /* @__PURE__ */ React79.createElement(ViewLarge7, null, /* @__PURE__ */ React79.createElement(UitkLayoutGrid10, {
        space: "three",
        columns: 1
    }, /* @__PURE__ */ React79.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(PropertyInfoContentItems, _objectSpreadProps(_objectSpread({}, large), {
        data: data
    })))), /* @__PURE__ */ React79.createElement(UitkLayoutGridItem7, {
        justifySelf: "end"
    }, /* @__PURE__ */ React79.createElement("div", null, seeMoreAction && /* @__PURE__ */ React79.createElement(SeeMoreAction, {
        data: seeMoreAction
    })))))));
};
PropertyInfoContentWithSeeMoreAction.displayName = "PropertyInfoContentWithSeeMoreAction";
PropertyInfoContentWithSeeMoreAction.fragment = __PropertyInfoContentWithSeeMoreAction;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
var fragment43 = gql77(_templateObject77(), LodgingEGDSParagraph.fragment, PropertyInfoContentWithSeeMoreAction.fragment);
var contentItemsProps = Object.freeze({
    overflow: "wrap",
    prefix: "cleaningAndSafety",
    space: "four",
    subset: 6,
    autoflow: "column",
    columns: 2
});
var PropertyDescriptionAndMoreInfoSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React80.createElement("div", null, data.description && /* @__PURE__ */ React80.createElement(LodgingEGDSParagraph, {
        data: data.description,
        size: 2
    }), data.contentSections.map(function(contentSection, index) {
        return /* @__PURE__ */ React80.createElement(UitkSpacing26, {
            margin: {
                blockstart: "six"
            },
            key: index
        }, /* @__PURE__ */ React80.createElement("div", null, /* @__PURE__ */ React80.createElement(PropertyInfoContentWithSeeMoreAction, {
            data: contentSection,
            small: contentItemsProps,
            large: contentItemsProps
        })));
    }));
};
PropertyDescriptionAndMoreInfoSection.displayName = "PropertyDescriptionAndMoreInfoSection";
PropertyDescriptionAndMoreInfoSection.fragment = fragment43;
// src/components/property-info-details/__private/__fragments/property-details-reviews-breakdown.tsx
import React87 from "react";
import { gql as gql83 } from "@apollo/client";
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
import React86 from "react";
import { gql as gql82 } from "@apollo/client";
import { Experiment as Experiment5, ExperimentControl as ExperimentControl5, ExperimentVariant as ExperimentVariant5 } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex21, UitkLayoutFlexItem as UitkLayoutFlexItem17 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink9 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading14, UitkText as UitkText27 } from "uitk-react-text";
// ../internal/src/components/property-review-summary/utils/structured-data.ts
var getStructuredDataProps = function(itemProp, required) {
    if (!required) {
        return null;
    }
    var baseProps = {
        itemProp: itemProp
    };
    if (itemProp === "aggregateRating") {
        baseProps = _objectSpreadProps(_objectSpread({}, baseProps), {
            itemScope: true,
            itemType: "http://schema.org/AggregateRating"
        });
    }
    return baseProps;
};
// ../internal/src/components/property-review-summary/__private/__fragments/rating-counts.tsx
import React81 from "react";
import { gql as gql78 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex19, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkProgressBar } from "uitk-react-progress-bar";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
var fragment44 = gql78(_templateObject78());
var RatingCounts = function(param) {
    var data = param.data;
    var ratingCounts = data.ratingCounts;
    if (!ratingCounts || ratingCounts.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React81.createElement(UitkSpacing27, {
        margin: {
            blockstart: "two",
            blockend: "four"
        }
    }, /* @__PURE__ */ React81.createElement(UitkLayoutFlex19, {
        space: "two",
        direction: "column"
    }, ratingCounts.map(function(ratingCount) {
        /* @__PURE__ */ return React81.createElement(UitkLayoutFlexItem15, {
            minWidth: "full_width",
            key: "rating-".concat(ratingCount.rating)
        }, /* @__PURE__ */ React81.createElement(UitkProgressBar, {
            accessibilityLabel: (ratingCount === null || ratingCount === void 0 ? void 0 : ratingCount.accessibilityLabel) || "",
            percent: ratingCount.percent,
            progressDescription: ratingCount.count.formatted,
            title: ratingCount.description
        }));
    })));
};
RatingCounts.displayName = "RatingCounts";
RatingCounts.fragment = fragment44;
// ../internal/src/components/property-review-summary/__private/__fragments/summary-details.tsx
import React82 from "react";
import { gql as gql79 } from "@apollo/client";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex20, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading13, UitkText as UitkText25 } from "uitk-react-text";
var fragment45 = gql79(_templateObject79());
var SummaryDetails = function(param) {
    var data = param.data;
    var _reviewSummaryDetails_;
    var reviewSummaryDetails = data.reviewSummaryDetails;
    var track = useClickTracker24();
    React82.useEffect(function() {
        var _reviewSummaryDetails_;
        var cleanlinessRate = reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value;
        if (cleanlinessRate) {
            track("HOT.HIS.cleanliness.".concat(cleanlinessRate), "Property cleanliness score");
        }
    }, [
        reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value
    ]);
    if (!reviewSummaryDetails || reviewSummaryDetails.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React82.createElement(UitkLayoutFlex20, {
        wrap: "wrap"
    }, reviewSummaryDetails.map(function(reviewSummaryDetailItem) {
        var formattedRatingOutOfMaxA11y = reviewSummaryDetailItem.formattedRatingOutOfMaxA11y, label = reviewSummaryDetailItem.label;
        var _formattedRatingOutOfMaxA11y_accessibilityLabel;
        return /* @__PURE__ */ React82.createElement(UitkLayoutFlexItem16, {
            minWidth: "half_width",
            key: "category-".concat(label)
        }, /* @__PURE__ */ React82.createElement(UitkSpacing28, {
            margin: {
                block: "three"
            }
        }, /* @__PURE__ */ React82.createElement(UitkLayoutFlex20, {
            direction: "column"
        }, /* @__PURE__ */ React82.createElement(UitkHeading13, {
            "aria-label": (_formattedRatingOutOfMaxA11y_accessibilityLabel = formattedRatingOutOfMaxA11y.accessibilityLabel) !== null && _formattedRatingOutOfMaxA11y_accessibilityLabel !== void 0 ? _formattedRatingOutOfMaxA11y_accessibilityLabel : void 0,
            tag: "h3",
            size: 5
        }, formattedRatingOutOfMaxA11y.value), /* @__PURE__ */ React82.createElement(UitkText25, {
            size: 300
        }, label))));
    }));
};
SummaryDetails.displayName = "SummaryDetails";
SummaryDetails.fragment = fragment45;
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
import React84 from "react";
import { gql as gql80 } from "@apollo/client";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent5 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet13 } from "uitk-react-sheet";
// ../internal/src/components/property-review-summary/__private/providers/property-filtered-reviews-dialog-provider.tsx
import React83 from "react";
var PropertyFilteredReviewsDialogContext = React83.createContext(void 0);
var usePropertyFilteredReviewsDialogContext = function() {
    var context = React83.useContext(PropertyFilteredReviewsDialogContext);
    if (context === void 0) {
        throw new Error("usePropertyFilteredReviewsDialogContext must be used with a PropertyFilteredReviewsDialogContext.Provider");
    }
    return context;
};
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
var fragment46 = gql80(_templateObject80(), LodgingDialogTriggerMessage.fragment, EGDSDialogToolbar.fragment);
var PropertyFilteredReviewsDialog = function(param) {
    var _param_data = param.data, ratingPercentage = _param_data.ratingPercentage, trigger = _param_data.trigger;
    var PropertyFilteredReviewsDialogContent = usePropertyFilteredReviewsDialogContext().PropertyFilteredReviewsDialogContent;
    var _useDialog8 = _slicedToArray(useDialog8("PropertyDetailsReviewsBreakdownDialog", "pwaDialogNested"), 3), isVisible = _useDialog8[0], _useDialog8_ = _useDialog8[1], openDialog = _useDialog8_.openDialog, closeDialog = _useDialog8_.closeDialog, ReviewsDialog = _useDialog8[2];
    var track = useClickTracker25();
    var memoizedCloseDialog = React84.useCallback(function() {
        if (ratingPercentage.closeAnalytics) {
            var closeAnalytics = ratingPercentage.closeAnalytics;
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        closeDialog();
    }, [
        closeDialog,
        ratingPercentage,
        track
    ]);
    return /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(LodgingDialogTriggerMessage, {
        onClickAction: openDialog,
        data: trigger
    }), /* @__PURE__ */ React84.createElement(ReviewsDialog, null, /* @__PURE__ */ React84.createElement(UitkSheet13, {
        type: "full",
        isVisible: isVisible,
        triggerRef: null,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React84.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: memoizedCloseDialog,
        data: ratingPercentage.toolbar
    }), /* @__PURE__ */ React84.createElement(UitkDialogContent5, null, /* @__PURE__ */ React84.createElement(PropertyFilteredReviewsDialogContent, null)))));
};
PropertyFilteredReviewsDialog.displayName = "PropertyFilteredReviewsDialog";
PropertyFilteredReviewsDialog.fragment = fragment46;
// ../internal/src/components/property-review-summary/review-disclaimer.tsx
import React85, { useState as useState3 } from "react";
import { gql as gql81 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4 } from "@shared-ui/experiment-context";
import { UitkIcon as UitkIcon13, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLink as UitkLink8 } from "uitk-react-link";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph3, UitkText as UitkText26 } from "uitk-react-text";
var fragment47 = gql81(_templateObject81());
var ReviewDisclaimer = function(param) {
    var reviewPage = param.reviewPage, data = param.data;
    var _React85_useState = _slicedToArray(React85.useState(false), 2), showMenu = _React85_useState[0], setShowMenu = _React85_useState[1];
    var reviewDisclaimer = data.reviewDisclaimer, reviewDisclaimerAccessibilityLabel = data.reviewDisclaimerAccessibilityLabel, reviewDisclaimerLabel = data.reviewDisclaimerLabel, reviewDisclaimerUrl = data.reviewDisclaimerUrl, reviewDisclaimerAnalytics = data.reviewDisclaimerAnalytics;
    var _useState3 = _slicedToArray(useState3(false), 2), isVerifyReviewsAccordionOpen = _useState3[0], setIsVerifyReviewsAccordionOpen = _useState3[1];
    var clickTracker = useClickTracker26();
    if (!reviewDisclaimer || reviewDisclaimer.length === 0) {
        return null;
    }
    var handleReviewDisclaimerLabelClick = function() {
        if (!showMenu && reviewDisclaimerAnalytics && reviewPage) {
            clickTracker(reviewDisclaimerAnalytics.referrerId, reviewDisclaimerAnalytics.linkName);
        }
        setShowMenu(!showMenu);
    };
    var renderReviewDisclaimerVrbexGeneric = function() {
        return (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement(UitkSpacing29, {
            padding: {
                blockstart: "four",
                blockend: "two"
            }
        }, /* @__PURE__ */ React85.createElement(UitkText26, {
            weight: "regular",
            size: 200
        }, reviewDisclaimer)), /* @__PURE__ */ React85.createElement(UitkSpacing29, {
            padding: {
                blockend: "four"
            }
        }, reviewDisclaimerUrl && /* @__PURE__ */ React85.createElement(UitkLink8, null, /* @__PURE__ */ React85.createElement("a", {
            href: reviewDisclaimerUrl.link.url,
            target: "_blank",
            rel: "noreferrer noopener"
        }, reviewDisclaimerUrl.value, /* @__PURE__ */ React85.createElement("span", {
            className: "is-visually-hidden"
        }, reviewDisclaimerUrl.accessibilityLabel)))));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    return /* @__PURE__ */ React85.createElement(React85.Fragment, null, reviewsDisclaimerView && /* @__PURE__ */ React85.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: handleReviewDisclaimerLabelClick
    }, /* @__PURE__ */ React85.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React85.createElement(UitkLink8, null, /* @__PURE__ */ React85.createElement("button", {
        type: "button",
        "aria-label": reviewDisclaimerAccessibilityLabel !== null && reviewDisclaimerAccessibilityLabel !== void 0 ? reviewDisclaimerAccessibilityLabel : void 0
    }, reviewDisclaimerLabel, /* @__PURE__ */ React85.createElement(UitkSpacing29, {
        padding: {
            inline: "one",
            block: "half"
        }
    }, /* @__PURE__ */ React85.createElement(UitkIcon13, {
        name: "info_outline",
        size: UitkIconSize7.SMALL
    }))))), /* @__PURE__ */ React85.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 300
    }, /* @__PURE__ */ React85.createElement(UitkSpacing29, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React85.createElement(UitkParagraph3, {
        size: 1
    }, reviewDisclaimer, reviewDisclaimerUrl && /* @__PURE__ */ React85.createElement(UitkLink8, null, /* @__PURE__ */ React85.createElement("a", {
        href: reviewDisclaimerUrl.link.url,
        target: "_blank",
        rel: "noreferrer noopener"
    }, reviewDisclaimerUrl.value, /* @__PURE__ */ React85.createElement("span", {
        className: "is-visually-hidden"
    }, reviewDisclaimerUrl.accessibilityLabel))))))), /* @__PURE__ */ React85.createElement(Experiment4, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React85.createElement(ExperimentControl4, null), /* @__PURE__ */ React85.createElement(ExperimentVariant4, {
        bucket: 1
    }, renderReviewDisclaimerVrbexGeneric())));
};
ReviewDisclaimer.displayName = "ReviewDisclaimer";
ReviewDisclaimer.fragment = fragment47;
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
var fragment48 = gql82(_templateObject82(), ReviewDisclaimer.fragment, SummaryDetails.fragment, RatingCounts.fragment, PropertyFilteredReviewsDialog.fragment);
var PropertyReviewsBreakdown = function(param) {
    var data = param.data, onClickLink = param.onClickLink, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, reviewPage = param.reviewPage;
    var averageOverallRating = data.averageOverallRating, superlative = data.superlative, propertyReviewCountDetails = data.propertyReviewCountDetails, reviewDisclaimer = data.reviewDisclaimer, totalCount = data.totalCount, seeAllAction = data.seeAllAction, reviewDisclaimerLabel = data.reviewDisclaimerLabel;
    var renderPropertyReviewBreakdownVrbexGeneric = function() {
        return totalCount.raw !== 0 && (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React86.createElement(UitkLayoutFlexItem17, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React86.createElement(ReviewDisclaimer, {
            data: data,
            reviewPage: reviewPage
        }));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    return /* @__PURE__ */ React86.createElement("div", _objectSpread({}, getStructuredDataProps("aggregateRating", withAggregateRating)), totalCount.raw !== 0 && /* @__PURE__ */ React86.createElement(UitkLayoutFlex21, {
        space: "three"
    }, /* @__PURE__ */ React86.createElement(UitkText27, {
        weight: "regular",
        size: 900
    }, /* @__PURE__ */ React86.createElement("span", _objectSpread({}, getStructuredDataProps("ratingValue", withAggregateRating)), averageOverallRating.formatted)), /* @__PURE__ */ React86.createElement(UitkSpacing30, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React86.createElement(UitkLayoutFlex21, {
        direction: "column"
    }, /* @__PURE__ */ React86.createElement(UitkHeading14, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React86.createElement(UitkLayoutFlex21, null, /* @__PURE__ */ React86.createElement(UitkSpacing30, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React86.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React86.createElement(UitkLink9, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React86.createElement("button", _objectSpread({
        type: "button"
    }, getStructuredDataProps("reviewCount", withAggregateRating)), propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React86.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React86.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))), /* @__PURE__ */ React86.createElement(Experiment5, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React86.createElement(ExperimentControl5, null), /* @__PURE__ */ React86.createElement(ExperimentVariant5, {
        bucket: 1
    }, renderPropertyReviewBreakdownVrbexGeneric())), /* @__PURE__ */ React86.createElement(RatingCounts, {
        data: data
    }), /* @__PURE__ */ React86.createElement(SummaryDetails, {
        data: data
    }));
};
PropertyReviewsBreakdown.displayName = "PropertyReviewsBreakdownFragment";
PropertyReviewsBreakdown.fragment = fragment48;
// src/components/property-info-details/__private/__fragments/property-details-reviews-breakdown.tsx
import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";
var fragment49 = gql83(_templateObject83(), PropertyReviewsBreakdown.fragment);
var PropertyDetailsReviewsBreakdown = function(param) {
    var data = param.data, inputs = param.inputs;
    var PropertyFilteredReviewsDialogContent = React87.memo(function() {
        return /* @__PURE__ */ React87.createElement(PropertyFilteredReviews, {
            inputs: _objectSpreadProps(_objectSpread({}, inputs), {
                includeRecentReviews: true
            })
        });
    });
    PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
    return /* @__PURE__ */ React87.createElement(PropertyFilteredReviewsDialogContext.Provider, {
        value: {
            PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
        }
    }, /* @__PURE__ */ React87.createElement(PropertyReviewsBreakdown, {
        data: data
    }));
};
PropertyDetailsReviewsBreakdown.displayName = "PropertyDetailsReviewsBreakdown";
PropertyDetailsReviewsBreakdown.fragment = fragment49;
// src/components/property-info-details/property-info-details.tsx
var __Query4 = gql84(_templateObject84(), PropertyImageGallery.fragment, LodgingEGDSHeading.fragment, LodgingEGDSRating.fragment, PropertyDescriptionAndMoreInfoSection.fragment, PropertyDetailsReviewsBreakdown.fragment);
var PropertyInfoDetails = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi8().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery6 = useQuery6(__Query4, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery6.data, loading = _useQuery6.loading;
    if (loading || !data) {
        return null;
    }
    var _data_propertyInfo_propertyDetails = data.propertyInfo.propertyDetails, heading = _data_propertyInfo_propertyDetails.heading, rating = _data_propertyInfo_propertyDetails.rating, gallery = _data_propertyInfo_propertyDetails.gallery;
    return /* @__PURE__ */ React88.createElement(PropertyInfoDetailsInputsContext.Provider, {
        value: {
            propertyId: inputs.propertyId
        }
    }, gallery && /* @__PURE__ */ React88.createElement(UitkSpacing31, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React88.createElement(PropertyImageGallery, {
        data: gallery
    })), /* @__PURE__ */ React88.createElement(LodgingEGDSHeading, {
        data: heading,
        tag: "h3",
        size: 3
    }), rating && /* @__PURE__ */ React88.createElement(LodgingEGDSRating, {
        data: rating
    }), /* @__PURE__ */ React88.createElement(UitkSpacing31, {
        margin: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React88.createElement("div", null, data.propertyReviewSummaries.length === 1 ? /* @__PURE__ */ React88.createElement(UitkLayoutGrid11, {
        columns: {
            large: [
                "1fr",
                "2fr"
            ]
        }
    }, /* @__PURE__ */ React88.createElement(UitkLayoutGridItem8, null, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(PropertyDetailsReviewsBreakdown, {
        data: data.propertyReviewSummaries[0],
        inputs: inputs
    }))), /* @__PURE__ */ React88.createElement(UitkLayoutGridItem8, null, /* @__PURE__ */ React88.createElement(UitkSpacing31, {
        margin: {
            large: {
                inlinestart: "six",
                blockstart: "unset"
            },
            small: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(PropertyDescriptionAndMoreInfoSection, {
        data: data.propertyInfo.propertyDetails
    }))))) : /* @__PURE__ */ React88.createElement(PropertyDescriptionAndMoreInfoSection, {
        data: data.propertyInfo.propertyDetails
    }))));
};
PropertyInfoDetails.displayName = "PropertyInfoDetails";
// src/components/similar-properties/similar-properties.tsx
import React100 from "react";
import { gql as gql95, useQuery as useQuery7 } from "@apollo/client";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
// src/components/similar-properties/__private/__fragments/similar-properties-footer.tsx
import React89 from "react";
import { gql as gql85 } from "@apollo/client";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
import { UitkText as UitkText28 } from "uitk-react-text";
var __SimilarPropertiesFooterFragment = gql85(_templateObject85());
var SimilarPropertiesFooter = function(param) {
    var data = param.data;
    var footer = data.footer;
    return /* @__PURE__ */ React89.createElement(UitkSpacing32, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React89.createElement(UitkText28, {
        size: 200,
        theme: "default"
    }, footer));
};
SimilarPropertiesFooter.fragment = __SimilarPropertiesFooterFragment;
SimilarPropertiesFooter.displayName = "SimilarPropertiesFooter";
// src/components/similar-properties/__private/__fragments/similar-properties-header.tsx
import React90 from "react";
import { gql as gql86 } from "@apollo/client";
import { UitkHeading as UitkHeading15 } from "uitk-react-text";
var __SimilarPropertiesHeaderFragment = gql86(_templateObject86());
var SimilarPropertiesHeader = function(param) {
    var data = param.data;
    var header = data.header;
    return /* @__PURE__ */ React90.createElement(UitkHeading15, {
        tag: "h3",
        size: 4
    }, header);
};
SimilarPropertiesHeader.fragment = __SimilarPropertiesHeaderFragment;
SimilarPropertiesHeader.displayName = "SimilarPropertiesHeader";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
import React98 from "react";
import { gql as gql94 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker6, useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-egds-image/lodging-egds-image.tsx
import React91 from "react";
import { gql as gql87 } from "@apollo/client";
import { UitkFigure as UitkFigure5, UitkImage as UitkImage4 } from "uitk-react-images";
var fragment50 = gql87(_templateObject87());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React91.createElement(UitkFigure5, _objectSpread({}, figureProps), /* @__PURE__ */ React91.createElement(UitkImage4, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad
    }));
};
LodgingEGDSImage.fragment = fragment50;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// ../internal/src/components/lodging-header/lodging-header.tsx
import React92 from "react";
import { gql as gql88 } from "@apollo/client";
import { UitkHeading as UitkHeading16, UitkText as UitkText29 } from "uitk-react-text";
var fragment51 = gql88(_templateObject88());
var LodgingHeader = function(param) {
    var data = param.data;
    var text = data.text, label = data.label, subText = data.subText;
    return /* @__PURE__ */ React92.createElement(React92.Fragment, null, /* @__PURE__ */ React92.createElement(UitkText29, {
        size: 200,
        theme: "default"
    }, subText), /* @__PURE__ */ React92.createElement(UitkHeading16, {
        tag: "h4",
        size: 7,
        overflow: "truncate-2-lines"
    }, text), /* @__PURE__ */ React92.createElement(UitkText29, {
        size: 200,
        theme: "default"
    }, label));
};
LodgingHeader.fragment = fragment51;
LodgingHeader.displayName = "LodgingHeaderFragment";
// ../internal/src/components/property-reviews-summary/property-reviews-summary.tsx
import React93 from "react";
import { gql as gql89 } from "@apollo/client";
import { UitkSpacing as UitkSpacing33 } from "uitk-react-spacing";
import { UitkText as UitkText30 } from "uitk-react-text";
var fragment52 = gql89(_templateObject89());
var PropertyReviewsSummary = function(param) {
    var data = param.data;
    var localizedScore = data.localizedScore, localizedSubtitleA11y = data.localizedSubtitleA11y, localizedTotal = data.localizedTotal;
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(UitkSpacing33, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React93.createElement("div", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React93.createElement(UitkText30, {
        size: 200,
        theme: "default"
    }, /* @__PURE__ */ React93.createElement(UitkSpacing33, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React93.createElement(UitkText30, {
        weight: "bold",
        theme: "emphasis",
        inline: true
    }, localizedScore)), localizedTotal))), (localizedSubtitleA11y === null || localizedSubtitleA11y === void 0 ? void 0 : localizedSubtitleA11y.accessibilityLabel) && /* @__PURE__ */ React93.createElement("span", {
        className: "is-visually-hidden"
    }, localizedSubtitleA11y.accessibilityLabel));
};
PropertyReviewsSummary.fragment = fragment52;
PropertyReviewsSummary.displayName = "PropertyReviewsSummary";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex24, UitkLayoutFlexItem as UitkLayoutFlexItem19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing37 } from "uitk-react-spacing";
// src/components/similar-properties/utility/analytics.ts
var getRecommendation = function(name, index, imageUrl, price, propertyId) {
    var _price_price, _price_price_options, _price_price_options_, _displayPrice_currencyInfo, _displayPrice_currencyInfo1;
    var displayPrice = price === null || price === void 0 ? void 0 : (_price_price = price.price) === null || _price_price === void 0 ? void 0 : (_price_price_options = _price_price.options) === null || _price_price_options === void 0 ? void 0 : (_price_price_options_ = _price_price_options[0]) === null || _price_price_options_ === void 0 ? void 0 : _price_price_options_.displayPrice;
    return {
        recommendationId: propertyId,
        rank: index,
        presentationDetails: _objectSpread({
            name: name,
            imageUrl: imageUrl,
            badges: ""
        }, (displayPrice === null || displayPrice === void 0 ? void 0 : (_displayPrice_currencyInfo = displayPrice.currencyInfo) === null || _displayPrice_currencyInfo === void 0 ? void 0 : _displayPrice_currencyInfo.name) && {
            price: {
                displayPrice: displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.amount,
                currency: displayPrice === null || displayPrice === void 0 ? void 0 : (_displayPrice_currencyInfo1 = displayPrice.currencyInfo) === null || _displayPrice_currencyInfo1 === void 0 ? void 0 : _displayPrice_currencyInfo1.name
            }
        })
    };
};
var getRecommendations = function(results) {
    return results === null || results === void 0 ? void 0 : results.map(function(resultItem, index) {
        var _resultItem_title, _resultItem_image, _resultItem_image_image;
        return getRecommendation(resultItem === null || resultItem === void 0 ? void 0 : (_resultItem_title = resultItem.title) === null || _resultItem_title === void 0 ? void 0 : _resultItem_title.text, index, resultItem === null || resultItem === void 0 ? void 0 : (_resultItem_image = resultItem.image) === null || _resultItem_image === void 0 ? void 0 : (_resultItem_image_image = _resultItem_image.image) === null || _resultItem_image_image === void 0 ? void 0 : _resultItem_image_image.url, resultItem.price, resultItem === null || resultItem === void 0 ? void 0 : resultItem.propertyId);
    });
};
var getRecommendationSeenMessage = function(egrResponseId, header, properties, from, to, scroll) {
    var _getRecommendations;
    var recommendations = (_getRecommendations = getRecommendations(properties)) === null || _getRecommendations === void 0 ? void 0 : _getRecommendations.slice(from, to + 1);
    var recommendationEvent = {
        eventType: "recommendationInteraction",
        eventName: "recommendationSeen",
        egRecommendationResponseId: egrResponseId,
        recommendationTitle: header,
        component: "carousel",
        componentElement: "thumbnail",
        scroll: scroll,
        recommendations: recommendations
    };
    return (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) ? [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ] : void 0;
};
var getRecommendationClickedMessage = function(index, egrResponseId, name, imageUrl, header, price, propertyId) {
    var recommendationEvent = {
        eventType: "recommendationInteraction",
        eventName: "recommendationClicked",
        egRecommendationResponseId: egrResponseId,
        recommendationTitle: header,
        component: "carousel",
        componentElement: "thumbnail",
        recommendations: [
            getRecommendation(name, index, imageUrl, price, propertyId)
        ]
    };
    return [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ];
};
// src/components/similar-properties/__private/__fragments/similar-properties-action.tsx
import React94 from "react";
import { gql as gql90 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll as useRefTargetScroll2 } from "@shared-ui/ref-context";
import { UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
var __SimilarPropertiesActionFragment = gql90(_templateObject90());
var SimilarPropertiesAction = function(props) {
    var _action_actionDetails;
    var data = props.data, index = props.index, header = props.header, recommendationsResponseId = props.recommendationsResponseId, scrollToTarget = props.scrollTo;
    var action = data.action, title = data.title, image = data.image, price = data.price, propertyId = data.propertyId;
    var scrollTo = useRefTargetScroll2().scrollTo;
    var trackerEvent = useClickTracker27();
    var _useClickstreamAnalytics2 = useClickstreamAnalytics2(), clickStreamTrack = _useClickstreamAnalytics2.track;
    var referrerId = React94.useMemo(function() {
        var rfrrId = (action === null || action === void 0 ? void 0 : action.referrerId) || "HOT.HIS.SIMILAR.PROPERTIES.DATELESS";
        return "".concat(rfrrId, ".").concat(index, ".click");
    }, [
        action,
        index
    ]);
    var isCurrentViewingProperty = referrerId.includes("RESERVE");
    var trackEvent = React94.useCallback(function() {
        var _image_image;
        var additionalUisPrimeMicroMessages = getRecommendationClickedMessage(index, recommendationsResponseId, title === null || title === void 0 ? void 0 : title.text, image === null || image === void 0 ? void 0 : (_image_image = image.image) === null || _image_image === void 0 ? void 0 : _image_image.url, header, price, propertyId);
        var idType = referrerId.includes("NEARBY") ? "nearby" : "similar";
        trackerEvent(referrerId, "Property ".concat(idType, " Carousel"), void 0, recommendationsResponseId ? additionalUisPrimeMicroMessages : void 0);
    }, [
        trackerEvent,
        referrerId,
        index,
        title === null || title === void 0 ? void 0 : title.text,
        image,
        header,
        price,
        recommendationsResponseId,
        propertyId,
        clickStreamTrack
    ]);
    var clickToScroll = React94.useCallback(function(e) {
        if (scrollToTarget) {
            e.preventDefault();
            scrollTo(scrollToTarget, []);
        }
    }, [
        scrollTo,
        scrollToTarget
    ]);
    var buttonProps = {
        href: action.linkUrl,
        onClickCapture: isCurrentViewingProperty && scrollToTarget ? clickToScroll : trackEvent
    };
    return /* @__PURE__ */ React94.createElement(UitkCardLink2, null, /* @__PURE__ */ React94.createElement("a", _objectSpreadProps(_objectSpread({}, buttonProps), {
        rel: "noopener",
        target: "_blank"
    }), action === null || action === void 0 ? void 0 : (_action_actionDetails = action.actionDetails) === null || _action_actionDetails === void 0 ? void 0 : _action_actionDetails.accessibilityLabel));
};
SimilarPropertiesAction.fragment = __SimilarPropertiesActionFragment;
SimilarPropertiesAction.displayName = "SimilarPropertiesAction";
// src/components/similar-properties/__private/__fragments/similar-properties-items.tsx
import React96 from "react";
import { gql as gql92 } from "@apollo/client";
// ../internal/src/components/lodging-enriched-message/lodging-enriched-message.tsx
import React95 from "react";
import { gql as gql91 } from "@apollo/client";
import { UitkIcon as UitkIcon14, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex22 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid12, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
import { UitkMark as UitkMark4, UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing34 } from "uitk-react-spacing";
import { UitkText as UitkText31 } from "uitk-react-text";
import { UitkUnformattedHtml as UitkUnformattedHtml2 } from "uitk-react-unformatted-html";
var fragment53 = gql91(_templateObject91());
var highlightedMessagesThemeToUitkTextTheme = {
    AGGRESSIVE: "negative",
    HIGHLIGHT: "positive",
    LOYALTY: "loyalty"
};
var highlightedMessagesThemeToUitkTextWeight = {
    STRONG: "bold"
};
var LodgingEnrichedMessage = function(param) {
    var data = param.data, markSize = param.markSize, textSize = param.textSize;
    var _egdsMark_url;
    var subText = data.subText, value = data.value, theme = data.theme, icon = data.icon, mark = data.mark, egdsMark = data.egdsMark, state = data.state, accessibilityLabel = data.accessibilityLabel;
    if (!value) {
        return null;
    }
    var stateTheme = state || theme;
    return /* @__PURE__ */ React95.createElement(UitkLayoutGrid12, null, /* @__PURE__ */ React95.createElement(UitkLayoutGridItem9, null, /* @__PURE__ */ React95.createElement(UitkLayoutFlex22, {
        alignItems: "center"
    }, mark && !egdsMark && /* @__PURE__ */ React95.createElement(UitkSpacing34, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React95.createElement(UitkMark4, {
        name: mark.id,
        size: markSize
    })), icon && /* @__PURE__ */ React95.createElement(UitkSpacing34, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React95.createElement(UitkIcon14, {
        name: icon.id,
        size: icon.size ? UitkIconSize8[icon.size] : UitkIconSize8.MEDIUM
    })), egdsMark && /* @__PURE__ */ React95.createElement(UitkSpacing34, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React95.createElement(UitkMark4, {
        url: (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value,
        size: markSize !== null && markSize !== void 0 ? markSize : UitkMarkSize3.MEDIUM
    })), accessibilityLabel && /* @__PURE__ */ React95.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(UitkUnformattedHtml2, {
        htmlToParse: value,
        plainTextElement: function(props) {
            return /* @__PURE__ */ React95.createElement(UitkText31, {
                size: textSize,
                weight: stateTheme && highlightedMessagesThemeToUitkTextWeight[stateTheme] || void 0,
                theme: stateTheme && highlightedMessagesThemeToUitkTextTheme[stateTheme] || void 0
            }, props.children);
        }
    })))), subText && /* @__PURE__ */ React95.createElement(UitkLayoutGridItem9, null, /* @__PURE__ */ React95.createElement(UitkText31, {
        size: 200,
        theme: "default"
    }, subText)));
};
LodgingEnrichedMessage.fragment = fragment53;
LodgingEnrichedMessage.displayName = "LodgingEnrichedMessage";
// src/components/similar-properties/__private/__fragments/similar-properties-items.tsx
import { UitkLayoutFlex as UitkLayoutFlex23, UitkLayoutFlexItem as UitkLayoutFlexItem18 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing35 } from "uitk-react-spacing";
var fragment54 = gql92(_templateObject92(), LodgingEnrichedMessage.fragment);
var SimilarPropertiesItems = function(param) {
    var data = param.data;
    var amenities = data.items;
    if (!amenities || amenities.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React96.createElement(UitkSpacing35, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(UitkLayoutFlex23, {
        direction: "column"
    }, amenities.map(function(amenity, idx) {
        return amenity && /* @__PURE__ */ React96.createElement(UitkLayoutFlexItem18, {
            key: "prop-items-".concat(idx)
        }, /* @__PURE__ */ React96.createElement(LodgingEnrichedMessage, {
            data: amenity,
            textSize: 200
        }));
    }))));
};
SimilarPropertiesItems.fragment = fragment54;
SimilarPropertiesItems.displayName = "SimilarPropertiesItems";
// src/components/similar-properties/__private/__fragments/similar-properties-price.tsx
import React97 from "react";
import { gql as gql93 } from "@apollo/client";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing36 } from "uitk-react-spacing";
import { UitkText as UitkText32 } from "uitk-react-text";
var __SimilarPropertiesPriceFragment = gql93(_templateObject93());
var SimilarPropertiesPrice = function(param) {
    var data = param.data;
    var _price_price_options, _price_qualifier, _price_subText, _options__displayPrice, _options__displayPrice1;
    var price = data.price;
    var options = ((_price_price_options = price === null || price === void 0 ? void 0 : price.price.options) === null || _price_price_options === void 0 ? void 0 : _price_price_options.length) && (price === null || price === void 0 ? void 0 : price.price.options);
    if (!options || !options.length) return null;
    var qualifier = (price === null || price === void 0 ? void 0 : (_price_qualifier = price.qualifier) === null || _price_qualifier === void 0 ? void 0 : _price_qualifier.value) || "";
    var subText = (price === null || price === void 0 ? void 0 : (_price_subText = price.subText) === null || _price_subText === void 0 ? void 0 : _price_subText.text) || "";
    return /* @__PURE__ */ React97.createElement(React97.Fragment, null, options[0].leadingCaption && /* @__PURE__ */ React97.createElement(UitkText32, {
        size: 100,
        theme: "default"
    }, options[0].leadingCaption), /* @__PURE__ */ React97.createElement(UitkSpacing36, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React97.createElement(UitkPriceLockup, {
        align: UitkPriceLockupAlign.LEFT,
        lockupPrice: (_options__displayPrice = options[0].displayPrice) === null || _options__displayPrice === void 0 ? void 0 : _options__displayPrice.formatted,
        priceSubtextFirst: "".concat(qualifier, " ").concat(subText),
        a11yPrice: "".concat((_options__displayPrice1 = options[0].displayPrice) === null || _options__displayPrice1 === void 0 ? void 0 : _options__displayPrice1.formatted, " ").concat(qualifier, " ").concat(subText),
        stids: {
            lockupId: "simlar_properties_lockup_price"
        }
    })));
};
SimilarPropertiesPrice.fragment = __SimilarPropertiesPriceFragment;
SimilarPropertiesPrice.displayName = "SimilarPropertiesPrice";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
var __SimilarPropertiesPropertiesFragment = gql94(_templateObject94(), LodgingHeader.fragment, LodgingEGDSImage.fragment, LodgingEGDSGraphicText.fragment, PropertyReviewsSummary.fragment, SimilarPropertiesItems.fragment, SimilarPropertiesPrice.fragment, SimilarPropertiesAction.fragment);
var SimilarPropertiesProperties = function(param) {
    var data = param.data, scrollTo = param.scrollTo, lazyLoadImages = param.lazyLoadImages;
    var trackEvent = function trackEvent(index, propertiesToTrack, lastShownPropertyIndex) {
        if ((lodgingRecommendationClickstreamEvent === null || lodgingRecommendationClickstreamEvent === void 0 ? void 0 : lodgingRecommendationClickstreamEvent.recommendationResponseId) && index > lastShownPropertyIndex) {
            var microMessages = getRecommendationSeenMessage(lodgingRecommendationClickstreamEvent.recommendationResponseId, header, propertiesToTrack, index, index, lastIndex.current < index ? "right" : "left");
            if (microMessages) {
                trackerEvent("".concat(referrerId, ".scroll"), linkName, void 0, microMessages);
            }
            lastIndex.current = index;
        }
    };
    var _properties_, _properties__action, _properties__action_referrerId, _properties__action1, _properties__action_referrerId1;
    var properties = data.properties, header = data.header, lodgingRecommendationClickstreamEvent = data.lodgingRecommendationClickstreamEvent, galleryCarousel = data.galleryCarousel;
    var splitReferId = (properties === null || properties === void 0 ? void 0 : (_properties_ = properties[0]) === null || _properties_ === void 0 ? void 0 : (_properties__action = _properties_.action) === null || _properties__action === void 0 ? void 0 : (_properties__action_referrerId = _properties__action.referrerId) === null || _properties__action_referrerId === void 0 ? void 0 : _properties__action_referrerId.split(".")) || [];
    var carouselType = (splitReferId === null || splitReferId === void 0 ? void 0 : splitReferId[2]) || "SIMILAR";
    var linkName = "Property ".concat(carouselType.toLowerCase(), " Carousel");
    var datedType = (splitReferId === null || splitReferId === void 0 ? void 0 : splitReferId[4]) || "DATELESS";
    var referrerId = "HOT.HIS.".concat(carouselType, ".PROPERTIES.").concat(datedType);
    var hasCurrentViewingProperty = (_properties__action1 = properties[0].action) === null || _properties__action1 === void 0 ? void 0 : (_properties__action_referrerId1 = _properties__action1.referrerId) === null || _properties__action_referrerId1 === void 0 ? void 0 : _properties__action_referrerId1.includes("RESERVE");
    var trackerEvent = useClickTracker28();
    var lastIndex = React98.useRef(0);
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var propertiesToShow = React98.useMemo(function() {
        if (viewSize !== defaultViewSizes.LARGE && viewSize !== defaultViewSizes.EXTRA_LARGE) {
            return viewSize === defaultViewSizes.SMALL ? 2 : 3;
        }
        return 5;
    }, [
        viewSize
    ]);
    var getRecommendationMicroMessages = React98.useMemo(function() {
        var trackingProperties = hasCurrentViewingProperty ? properties.slice(1) : properties;
        var trackingTo = hasCurrentViewingProperty ? propertiesToShow - 1 : propertiesToShow;
        return (lodgingRecommendationClickstreamEvent === null || lodgingRecommendationClickstreamEvent === void 0 ? void 0 : lodgingRecommendationClickstreamEvent.recommendationResponseId) ? getRecommendationSeenMessage(lodgingRecommendationClickstreamEvent.recommendationResponseId, header, trackingProperties, 0, trackingTo, "") : void 0;
    }, [
        properties,
        propertiesToShow
    ]);
    var itemViewedCallback = React98.useCallback(function(index) {
        if (hasCurrentViewingProperty) {
            if (index > 0) {
                trackEvent(index - 1, properties.slice(1), propertiesToShow - 1);
            }
            return;
        }
        trackEvent(index, properties, propertiesToShow);
    }, [
        header,
        properties,
        trackerEvent,
        propertiesToShow,
        lodgingRecommendationClickstreamEvent === null || lodgingRecommendationClickstreamEvent === void 0 ? void 0 : lodgingRecommendationClickstreamEvent.recommendationResponseId
    ]);
    if (!properties.length) {
        return null;
    }
    var _galleryCarousel_nextButtonText;
    var carouselNextButtonText = (_galleryCarousel_nextButtonText = galleryCarousel === null || galleryCarousel === void 0 ? void 0 : galleryCarousel.nextButtonText) !== null && _galleryCarousel_nextButtonText !== void 0 ? _galleryCarousel_nextButtonText : "";
    var _galleryCarousel_previousButtonText;
    var carouselPrevButtonText = (_galleryCarousel_previousButtonText = galleryCarousel === null || galleryCarousel === void 0 ? void 0 : galleryCarousel.previousButtonText) !== null && _galleryCarousel_previousButtonText !== void 0 ? _galleryCarousel_previousButtonText : "";
    var lazyLoad = lazyLoadImages ? "lazy" : "off";
    return /* @__PURE__ */ React98.createElement(IntersectionTracker6, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getRecommendationMicroMessages
    }, /* @__PURE__ */ React98.createElement(UitkSpacing37, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React98.createElement(UitkCarousel, {
        buttonText: {
            nextButton: carouselNextButtonText,
            prevButton: carouselPrevButtonText
        },
        itemsVisible: {
            lg: 5,
            md: 3,
            sm: 2
        },
        itemViewedCallback: itemViewedCallback,
        pageBy: 1,
        peek: true,
        wrapItems: false
    }, properties.map(function(item, index) {
        return item && /* @__PURE__ */ React98.createElement(UitkLayoutFlex24, {
            key: "".concat(item.title.text, "-").concat(index),
            tag: "li"
        }, /* @__PURE__ */ React98.createElement(UitkLayoutFlexItem19, {
            grow: 1
        }, /* @__PURE__ */ React98.createElement(UitkCard7, null, /* @__PURE__ */ React98.createElement(SimilarPropertiesAction, {
            data: item,
            index: hasCurrentViewingProperty ? index - 1 : index,
            header: header,
            recommendationsResponseId: lodgingRecommendationClickstreamEvent === null || lodgingRecommendationClickstreamEvent === void 0 ? void 0 : lodgingRecommendationClickstreamEvent.recommendationResponseId,
            scrollTo: scrollTo
        }), /* @__PURE__ */ React98.createElement(UitkLayoutFlexItem19, {
            grow: 1
        }, /* @__PURE__ */ React98.createElement(UitkLayoutFlex24, {
            direction: "column",
            blockSize: "full_size"
        }, /* @__PURE__ */ React98.createElement(React98.Fragment, null, item.image && /* @__PURE__ */ React98.createElement(LodgingEGDSImage, {
            data: item.image.image,
            ratio: UitkFigureAspectRatioType5.R16_9,
            lazyLoad: lazyLoad,
            "data-stid": "SimilarPropertiesImage"
        }), /* @__PURE__ */ React98.createElement(UitkLayoutFlexItem19, {
            grow: 1,
            className: "uitk-layout-flex"
        }, /* @__PURE__ */ React98.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React98.createElement(UitkLayoutFlexItem19, {
            grow: 1
        }, /* @__PURE__ */ React98.createElement(UitkLayoutFlex24, {
            direction: "column"
        }, /* @__PURE__ */ React98.createElement(React98.Fragment, null, /* @__PURE__ */ React98.createElement(UitkSpacing37, {
            margin: {
                blockend: "one"
            }
        }, /* @__PURE__ */ React98.createElement("div", null, item.featuredMessages.map(function(graphicText, i) {
            return /* @__PURE__ */ React98.createElement(LodgingEGDSGraphicText, {
                key: i,
                data: graphicText,
                textProps: {
                    theme: "emphasis",
                    weight: "medium"
                }
            });
        }))), /* @__PURE__ */ React98.createElement(LodgingHeader, {
            data: item.title
        }), /* @__PURE__ */ React98.createElement(SimilarPropertiesItems, {
            data: item
        }), item.reviews && /* @__PURE__ */ React98.createElement(PropertyReviewsSummary, {
            data: item.reviews
        }), /* @__PURE__ */ React98.createElement(UitkLayoutFlexItem19, {
            grow: 1
        }, /* @__PURE__ */ React98.createElement(UitkLayoutFlex24, {
            direction: "column",
            justifyContent: "end"
        }, /* @__PURE__ */ React98.createElement(SimilarPropertiesPrice, {
            data: item
        }))))))))))))));
    }))));
};
SimilarPropertiesProperties.fragment = __SimilarPropertiesPropertiesFragment;
SimilarPropertiesProperties.displayName = "SimilarPropertiesProperties";
// src/components/similar-properties/similar-properties-placeholder.tsx
import React99 from "react";
import { UitkCard as UitkCard8, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
import { UitkFigure as UitkFigure6, UitkFigureAspectRatioType as UitkFigureAspectRatioType6 } from "uitk-react-images";
import { UitkBlockSkeleton as UitkBlockSkeleton2, UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing38 } from "uitk-react-spacing";
var carouselProps = {
    carouselName: "SimilarPropertiesPlaceholderCarousel",
    itemsVisible: {
        sm: 2,
        md: 3,
        lg: 4,
        xl: 5
    },
    pageBy: 1,
    peek: true,
    wrapItems: false,
    buttonText: {
        nextButton: "",
        prevButton: ""
    }
};
var numberOfPlaceholders = 6;
var SimilarPropertiesPlaceholder = function() {
    return /* @__PURE__ */ React99.createElement(UitkCarousel2, _objectSpread({}, carouselProps), _toConsumableArray(Array(numberOfPlaceholders)).map(function(_, index) {
        return /* @__PURE__ */ React99.createElement("div", {
            key: "similar-properties-placeholder-".concat(index)
        }, /* @__PURE__ */ React99.createElement(UitkCard8, {
            padded: true
        }, /* @__PURE__ */ React99.createElement(UitkFigure6, {
            ratio: UitkFigureAspectRatioType6.R16_9,
            className: "uitk-card-roundcorner-all"
        }, /* @__PURE__ */ React99.createElement(UitkBlockSkeleton2, null)), /* @__PURE__ */ React99.createElement(UitkCardContentSection6, {
            padded: false
        }, /* @__PURE__ */ React99.createElement(UitkSpacing38, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React99.createElement(UitkLineSkeleton2, {
            animation: true
        })), /* @__PURE__ */ React99.createElement(UitkSpacing38, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React99.createElement(UitkLineSkeleton2, {
            animation: true
        })), /* @__PURE__ */ React99.createElement(UitkSpacing38, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React99.createElement(UitkLineSkeleton2, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React99.createElement(UitkSpacing38, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React99.createElement(UitkLineSkeleton2, {
            animation: true,
            type: "secondary"
        })))));
    }));
};
// src/components/similar-properties/similar-properties.tsx
var __Query5 = gql95(_templateObject95(), SimilarPropertiesHeader.fragment, SimilarPropertiesProperties.fragment, SimilarPropertiesFooter.fragment);
var SimilarProperties = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, scrollTo = param.scrollTo, lazyLoadImages = param.lazyLoadImages;
    var _data_propertyInfo;
    var context = useBexApi9().context;
    var variables = _objectSpread({
        context: context
    }, inputs);
    var _useQuery7 = useQuery7(__Query5, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), loading = _useQuery7.loading, data = _useQuery7.data;
    if (loading) {
        return /* @__PURE__ */ React100.createElement(SimilarPropertiesPlaceholder, null);
    }
    var similarProperties = data === null || data === void 0 ? void 0 : (_data_propertyInfo = data.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : _data_propertyInfo.similarProperties;
    if (!(similarProperties === null || similarProperties === void 0 ? void 0 : similarProperties.properties.length)) {
        return null;
    }
    return /* @__PURE__ */ React100.createElement("div", {
        "data-testid": "similar-properties"
    }, /* @__PURE__ */ React100.createElement(SimilarPropertiesHeader, {
        data: similarProperties
    }), /* @__PURE__ */ React100.createElement(SimilarPropertiesProperties, {
        data: similarProperties,
        scrollTo: scrollTo,
        lazyLoadImages: lazyLoadImages
    }), /* @__PURE__ */ React100.createElement(SimilarPropertiesFooter, {
        data: similarProperties
    }));
};
SimilarProperties.displayName = "SimilarProperties";
var PropertySimilar = function(props) {
    return SimilarProperties(props);
};
// src/components/property-spaces/property-spaces.tsx
import React101 from "react";
import { gql as gql96, useQuery as useQuery8 } from "@apollo/client";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
var __Query6 = gql96(_templateObject96(), PropertyContentSectionGroup.fragment);
var PropertySpaces = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _detailed_sections;
    var context = useBexApi10().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery8 = useQuery8(__Query6, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery8.data, loading = _useQuery8.loading;
    if (loading || !data) {
        return null;
    }
    var summary = data.summary, detailed = data.detailed;
    if (!summary) {
        return null;
    }
    var detailedDialogContent = (detailed === null || detailed === void 0 ? void 0 : (_detailed_sections = detailed.sections) === null || _detailed_sections === void 0 ? void 0 : _detailed_sections.length) ? /* @__PURE__ */ React101.createElement(React101.Fragment, null, detailed.sections.map(function(section, index) {
        return /* @__PURE__ */ React101.createElement(PropertyContentSection, {
            data: section,
            columns: 1,
            key: "detailed-section-".concat(index),
            isInDialog: true,
            actionId: "spaces"
        });
    })) : void 0;
    return /* @__PURE__ */ React101.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React101.createElement(PropertyContentSectionGroup, {
        data: summary,
        columns: 1,
        actionId: "spaces"
    }));
};
PropertySpaces.displayName = "PropertySpaces";
// src/components/property-details.tsx
import React166 from "react";
import { gql as gql151, useQuery as useQuery10 } from "@apollo/client";
import { useBexApi as useBexApi13 } from "@shared-ui/bex-api-context";
// src/components/amenities-simplified-view/amenities-simplified-view.tsx
import React102 from "react";
import { gql as gql97 } from "@apollo/client";
import { UitkSpacing as UitkSpacing39 } from "uitk-react-spacing";
var __AmenitiesSimplifiedViewFragment = gql97(_templateObject97(), PropertyInfoContent.fragment);
var AmenitiesSimplifiedView = function(props) {
    var _data_summary, _data_summary_amenities;
    var data = props.data;
    var topAmenities = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var items = topAmenities === null || topAmenities === void 0 ? void 0 : topAmenities.items;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var smallIconItemsProps = {
        columns: 2,
        space: "two",
        subset: 6
    };
    var largeIconItemsProps = {
        columns: 6,
        rows: 1,
        space: "three",
        subset: 6
    };
    return /* @__PURE__ */ React102.createElement(UitkSpacing39, {
        margin: {
            blockend: "three"
        },
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React102.createElement("div", null, /* @__PURE__ */ React102.createElement(PropertyInfoContent, {
        data: topAmenities,
        small: _objectSpreadProps(_objectSpread({}, smallIconItemsProps), {
            prefix: "highlightedAmenities"
        }),
        large: _objectSpreadProps(_objectSpread({}, largeIconItemsProps), {
            prefix: "highlightedAmenities"
        })
    })));
};
AmenitiesSimplifiedView.displayName = "AmenitiesSimplifiedView";
AmenitiesSimplifiedView.fragment = __AmenitiesSimplifiedViewFragment;
// src/components/amenity-description/amenity-description.tsx
import React108 from "react";
import { gql as gql103 } from "@apollo/client";
import { UitkCard as UitkCard9, UitkCardContentSection as UitkCardContentSection7 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing43 } from "uitk-react-spacing";
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
import React107 from "react";
import { gql as gql102 } from "@apollo/client";
import { ViewLarge as ViewLarge8, Viewport as Viewport12, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
import { UitkLayoutColumns } from "uitk-react-layout-columns";
import { UitkLayoutGrid as UitkLayoutGrid13, UitkLayoutGridItem as UitkLayoutGridItem10 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing42 } from "uitk-react-spacing";
// src/components/amenity-description/amenity-description-jumplink.tsx
import React104 from "react";
import { gql as gql99 } from "@apollo/client";
// ../internal/src/components/lodging-jumplink/lodging-jumplink.tsx
import React103 from "react";
import { gql as gql98 } from "@apollo/client";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll as useRefTargetScroll3 } from "@shared-ui/ref-context";
import { UitkIcon as UitkIcon15 } from "uitk-react-icons";
import { UitkLink as UitkLink10 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing40 } from "uitk-react-spacing";
var __LodgingJumpLinkFragment = gql98(_templateObject98());
var scrollOffsets = [
    {
        sectionName: "wizard",
        offsetMultiplier: 2
    },
    {
        sectionName: "navigation"
    }
];
var LodgingJumpLink = function(param) {
    var data = param.data, trackingDetails = param.trackingDetails;
    var linkText = data.localizedName, icon = data.icon, sectionName = data.sectionName, accessibilityLabel = data.accessibilityLabel;
    var iconId = (icon === null || icon === void 0 ? void 0 : icon.iconId) || "";
    var scrollTo = useRefTargetScroll3().scrollTo;
    var track = useClickTracker29();
    var handleClick = React103.useCallback(function(e) {
        e.preventDefault();
        if (trackingDetails) {
            track(trackingDetails === null || trackingDetails === void 0 ? void 0 : trackingDetails.id, trackingDetails === null || trackingDetails === void 0 ? void 0 : trackingDetails.description, true);
        }
        if (sectionName) {
            scrollTo(sectionName, scrollOffsets);
        }
    }, [
        trackingDetails,
        track,
        scrollTo,
        sectionName
    ]);
    return /* @__PURE__ */ React103.createElement(UitkSpacing40, {
        padding: {
            blockstart: "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React103.createElement(UitkLink10, {
        align: "left",
        onClick: handleClick
    }, /* @__PURE__ */ React103.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React103.createElement("span", {
        "aria-hidden": accessibilityLabel !== null
    }, linkText), accessibilityLabel && /* @__PURE__ */ React103.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React103.createElement(UitkIcon15, {
        name: iconId
    }))));
};
LodgingJumpLink.displayName = "LodgingJumpLink";
LodgingJumpLink.fragment = __LodgingJumpLinkFragment;
// src/components/amenity-description/amenity-description-jumplink.tsx
var __AmenityDescriptionJumpLinkFragment = gql99(_templateObject99(), LodgingJumpLink.fragment);
var AmenityDescriptionJumpLink = function(param) {
    var action = param.data.action;
    if (!action) return null;
    return /* @__PURE__ */ React104.createElement(LodgingJumpLink, {
        data: action
    });
};
AmenityDescriptionJumpLink.displayName = "AmenityDescriptionJumpLink";
AmenityDescriptionJumpLink.fragment = __AmenityDescriptionJumpLinkFragment;
// src/components/amenity-description/__private/__fragments/amenity-content.tsx
import React105 from "react";
import { gql as gql100 } from "@apollo/client";
import { UitkIcon as UitkIcon16, UitkIconSize as UitkIconSize9 } from "uitk-react-icons";
import { UitkLayoutColumnsItem } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex25, UitkLayoutFlexItem as UitkLayoutFlexItem20 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing41 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading17, UitkText as UitkText33 } from "uitk-react-text";
var __AmenityContentFragment = gql100(_templateObject100());
var AmenityContent = function(param) {
    var data = param.data;
    var _ref = data || {}, heading = _ref.heading, items = _ref.items, icon = _ref.icon, structuredData = _ref.structuredData;
    if (!heading) {
        return null;
    }
    var isAmenityFeature = (structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop) === "amenityFeature";
    var isAmenityLanguage = (structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop) === "availableLanguage";
    return /* @__PURE__ */ React105.createElement(UitkSpacing41, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React105.createElement("div", null, /* @__PURE__ */ React105.createElement(UitkLayoutColumnsItem, {
        forceNoBreak: true
    }, /* @__PURE__ */ React105.createElement("div", {
        itemProp: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop,
        itemScope: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemscope,
        itemType: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemtype
    }, /* @__PURE__ */ React105.createElement(UitkLayoutFlex25, {
        space: "two"
    }, /* @__PURE__ */ React105.createElement(UitkLayoutFlexItem20, null, /* @__PURE__ */ React105.createElement(UitkSpacing41, {
        padding: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React105.createElement(UitkIcon16, {
        name: (icon === null || icon === void 0 ? void 0 : icon.iconId) || "",
        size: UitkIconSize9.MEDIUM
    }))), /* @__PURE__ */ React105.createElement("span", {
        itemProp: isAmenityFeature ? "name" : void 0
    }, /* @__PURE__ */ React105.createElement(UitkHeading17, {
        tag: "h3",
        size: 5
    }, heading))), (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */ React105.createElement(UitkSpacing41, {
        padding: {
            inlinestart: "twelve"
        }
    }, /* @__PURE__ */ React105.createElement("ul", {
        className: "no-bullet"
    }, items.map(function(item, index) {
        return /* @__PURE__ */ React105.createElement(UitkSpacing41, {
            margin: {
                blockstart: "two"
            },
            key: index
        }, /* @__PURE__ */ React105.createElement("li", {
            itemProp: isAmenityLanguage ? "name" : void 0
        }, /* @__PURE__ */ React105.createElement(UitkText33, {
            size: 300,
            theme: "default"
        }, item.text), isAmenityFeature && /* @__PURE__ */ React105.createElement("meta", {
            itemProp: "value",
            content: item.text
        })));
    })))))));
};
AmenityContent.displayName = "AmenityContent";
AmenityContent.fragment = __AmenityContentFragment;
// src/components/amenity-description/__private/__fragments/amenity-heading.tsx
import React106 from "react";
import { gql as gql101 } from "@apollo/client";
import { UitkHeading as UitkHeading18, UitkText as UitkText34 } from "uitk-react-text";
var __AmenityHeadingFragment = gql101(_templateObject101());
var AmenityHeading = function(param) {
    var data = param.data;
    var _ref = data || {}, text = _ref.text, subText = _ref.subText;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React106.createElement(React106.Fragment, null, /* @__PURE__ */ React106.createElement(UitkHeading18, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, text), subText && /* @__PURE__ */ React106.createElement(UitkText34, {
        spacing: "two"
    }, subText));
};
AmenityHeading.displayName = "AmenityHeading";
AmenityHeading.fragment = __AmenityHeadingFragment;
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
var __AmenitySectionFragment = gql102(_templateObject102(), AmenityHeading.fragment, AmenityContent.fragment, AmenityDescriptionJumpLink.fragment);
var AmenitySection = function(param) {
    var data = param.data;
    var _ref = data || {}, contents = _ref.contents, header = _ref.header;
    if (!(contents === null || contents === void 0 ? void 0 : contents.length)) {
        return null;
    }
    return /* @__PURE__ */ React107.createElement(Viewport12, null, /* @__PURE__ */ React107.createElement(ViewSmall12, null, /* @__PURE__ */ React107.createElement(React107.Fragment, null, header && /* @__PURE__ */ React107.createElement(UitkSpacing42, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(AmenityHeading, {
        data: header
    }))), contents.map(function(content, index) {
        return /* @__PURE__ */ React107.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))), /* @__PURE__ */ React107.createElement(ViewLarge8, null, /* @__PURE__ */ React107.createElement(UitkLayoutGrid13, {
        columns: {
            medium: 3
        },
        space: "six"
    }, header && /* @__PURE__ */ React107.createElement(UitkLayoutGridItem10, {
        colSpan: 1
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(AmenityHeading, {
        data: header
    }))), /* @__PURE__ */ React107.createElement(UitkLayoutGridItem10, {
        colSpan: 2
    }, /* @__PURE__ */ React107.createElement(UitkLayoutColumns, {
        minWidth: "half_width",
        columns: 2,
        space: "twelve"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React107.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))))));
};
AmenitySection.displayName = "AmenitySection";
AmenitySection.fragment = __AmenitySectionFragment;
// src/components/amenity-description/amenity-description.tsx
var __AmenityDescriptionFragment = gql103(_templateObject103(), AmenitySection.fragment);
var AmenityDescription = function(props) {
    var _data_summary, _data_summary_amenities;
    var data = props.data;
    var amenitySections = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.amenities;
    var amenitySectionLength = amenitySections === null || amenitySections === void 0 ? void 0 : amenitySections.length;
    if (!amenitySections || !amenitySectionLength) {
        return null;
    }
    return /* @__PURE__ */ React108.createElement(UitkSpacing43, {
        padding: {
            block: "six",
            small: {
                inline: "three"
            },
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React108.createElement(UitkCard9, null, amenitySections.map(function(amenitySection, index) {
        var isLastSection = index === amenitySectionLength - 1;
        var border = isLastSection ? void 0 : "bottom";
        return /* @__PURE__ */ React108.createElement(UitkSpacing43, {
            key: "amenity-section-".concat(index),
            margin: isLastSection ? void 0 : {
                blockend: "six"
            },
            padding: isLastSection ? void 0 : {
                blockend: "three"
            }
        }, /* @__PURE__ */ React108.createElement(UitkCardContentSection7, {
            border: border,
            padded: false
        }, /* @__PURE__ */ React108.createElement(AmenitySection, {
            data: amenitySection
        }), /* @__PURE__ */ React108.createElement(AmenityDescriptionJumpLink, {
            data: amenitySection
        })));
    })));
};
AmenityDescription.displayName = "AmenityDescription";
AmenityDescription.fragment = __AmenityDescriptionFragment;
// src/components/book-by-phone/book-by-phone.tsx
import React109 from "react";
import { gql as gql104 } from "@apollo/client";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex26 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink11 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing44 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph4 } from "uitk-react-text";
var __BookByPhoneFragment = gql104(_templateObject104());
var BookByPhone = function(props) {
    var data = props.data, className = props.className;
    var track = useClickTracker30();
    var handleClick = React109.useCallback(function(linkName2, referrerId2) {
        track(referrerId2, linkName2);
    }, [
        track
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.telesales)) {
        return null;
    }
    var telesales = data.telesales;
    var telesalesNumber = telesales.telesalesNumber, description = telesales.description, tracking = telesales.tracking;
    var phoneNumber = telesalesNumber.phoneNumber, teleUri = telesalesNumber.value;
    var teleDescription = description.value;
    var linkName = tracking.linkName, referrerId = tracking.referrerId;
    return /* @__PURE__ */ React109.createElement(UitkLayoutFlex26, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React109.createElement(UitkSpacing44, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React109.createElement(UitkParagraph4, {
        size: 1
    }, teleDescription)), /* @__PURE__ */ React109.createElement(UitkLink11, {
        onClick: function() {
            return handleClick(linkName, referrerId);
        },
        inline: true
    }, /* @__PURE__ */ React109.createElement("a", {
        href: teleUri
    }, /* @__PURE__ */ React109.createElement("span", {
        "data-stid": "telesales-number"
    }, phoneNumber))));
};
BookByPhone.displayName = "BookByPhone";
BookByPhone.fragment = __BookByPhoneFragment;
// src/components/book-by-phone/book-by-phone-placeholder.tsx
import React110 from "react";
import { UitkLayoutFlex as UitkLayoutFlex27 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing45 } from "uitk-react-spacing";
var BookByPhonePlaceholder = function(param) {
    var data = param.data, className = param.className;
    if (data === null || data === void 0 ? void 0 : data.telesales) {
        return /* @__PURE__ */ React110.createElement(BookByPhone, {
            data: data,
            className: className
        });
    }
    return /* @__PURE__ */ React110.createElement(UitkLayoutFlex27, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React110.createElement(UitkSpacing45, {
        margin: "one"
    }, /* @__PURE__ */ React110.createElement(UitkLineSkeleton3, {
        animation: true,
        type: "primary"
    })));
};
// src/components/content-section-groups/policies.tsx
import React111 from "react";
import { gql as gql105 } from "@apollo/client";
var __PoliciesFragment = gql105(_templateObject105(), PropertyContentSectionGroup.fragment);
var Policies = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, columns = props.columns, contentProps = _objectWithoutProperties(props, [
        "data",
        "columns"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.policies;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React111.createElement(PropertyContentSectionGroup, _objectSpreadProps(_objectSpread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
Policies.displayName = "Policies";
Policies.fragment = __PoliciesFragment;
// src/components/content-section-groups/special-features.tsx
import React112 from "react";
import { gql as gql106 } from "@apollo/client";
var __SpecialFeaturesFragment = gql106(_templateObject106(), PropertyContentSectionGroup.fragment);
var SpecialFeatures = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, columns = props.columns, contentProps = _objectWithoutProperties(props, [
        "data",
        "columns"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.specialFeatures;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React112.createElement(PropertyContentSectionGroup, _objectSpreadProps(_objectSpread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
SpecialFeatures.displayName = "SpecialFeatures";
SpecialFeatures.fragment = __SpecialFeaturesFragment;
// src/components/content-section-groups/important-info.tsx
import React113 from "react";
import { gql as gql107 } from "@apollo/client";
var __ImportantInfoFragment = gql107(_templateObject107(), PropertyContentSectionGroup.fragment);
var ImportantInfo = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, columns = props.columns, contentProps = _objectWithoutProperties(props, [
        "data",
        "columns"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.importantInfo;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React113.createElement(PropertyContentSectionGroup, _objectSpreadProps(_objectSpread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
ImportantInfo.displayName = "ImportantInfo";
ImportantInfo.fragment = __ImportantInfoFragment;
// src/components/content-section-groups/about-this-property.tsx
import React114 from "react";
import { gql as gql108 } from "@apollo/client";
var __AboutThisPropertyFragment = gql108(_templateObject108(), PropertyContentSectionGroup.fragment);
var AboutThisProperty = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, columns = props.columns, contentProps = _objectWithoutProperties(props, [
        "data",
        "columns"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisProperty;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React114.createElement(PropertyContentSectionGroup, _objectSpreadProps(_objectSpread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
AboutThisProperty.fragment = __AboutThisPropertyFragment;
AboutThisProperty.displayName = "AboutThisProperty";
// src/components/content-section-groups/host-profile.tsx
import React115 from "react";
import { gql as gql109 } from "@apollo/client";
var __HostProfileFragment = gql109(_templateObject109(), PropertyContentSectionGroup.fragment);
var HostProfile = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _objectWithoutProperties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisHost;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React115.createElement(PropertyContentSectionGroup, _objectSpread({
        data: content
    }, contentProps));
};
HostProfile.fragment = __HostProfileFragment;
HostProfile.displayName = "HostProfile";
// src/components/content-section-groups/property-detailed-amenities.tsx
import React116 from "react";
import { gql as gql110 } from "@apollo/client";
var DetailedAmenitiesFragment = gql110(_templateObject110(), PropertyContentSectionGroup.fragment);
var DetailedAmenities = function(props) {
    var _detailedAmenitiesContent_amenities;
    var data = props.data, contentProps = _objectWithoutProperties(props, [
        "data"
    ]);
    if (!data) {
        return null;
    }
    var amenitiesSummary = data.amenitiesSummary, detailedAmenitiesContent = data.detailedAmenitiesContent;
    if (!amenitiesSummary || !amenitiesSummary.amenities) {
        return null;
    }
    var amenities = amenitiesSummary.amenities;
    var detailedDialogContent = (detailedAmenitiesContent === null || detailedAmenitiesContent === void 0 ? void 0 : (_detailedAmenitiesContent_amenities = detailedAmenitiesContent.amenities) === null || _detailedAmenitiesContent_amenities === void 0 ? void 0 : _detailedAmenitiesContent_amenities.sections.length) ? /* @__PURE__ */ React116.createElement(React116.Fragment, null, detailedAmenitiesContent.amenities.sections.map(function(section, index) {
        return /* @__PURE__ */ React116.createElement(PropertyContentSection, {
            data: section,
            columns: 1,
            key: "detailed-section-".concat(index),
            actionId: "amenities"
        });
    })) : void 0;
    return /* @__PURE__ */ React116.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React116.createElement(PropertyContentSectionGroup, _objectSpreadProps(_objectSpread({
        data: amenities
    }, contentProps), {
        actionId: "amenities"
    })));
};
DetailedAmenities.displayName = "DetailedAmenities";
DetailedAmenities.fragment = DetailedAmenitiesFragment;
// src/components/direct-feedback/direct-feedback-call-to-action.tsx
import React117 from "react";
import { gql as gql111, useQuery as useQuery9 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker7, useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog } from "@shared-ui/retail-customer-direct-feedback";
import { UitkIcon as UitkIcon17, UitkIconSize as UitkIconSize10 } from "uitk-react-icons";
import { UitkLink as UitkLink12 } from "uitk-react-link";
import { UitkLineSkeleton as UitkLineSkeleton4 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing46 } from "uitk-react-spacing";
var query = gql111(_templateObject111());
var DirectFeedbackCallToAction = function(props) {
    var _data_directFeedbackPromptById, _data_directFeedbackPromptById_callToAction, _data_directFeedbackPromptById_callToAction_action, _data_directFeedbackPromptById1, _data_directFeedbackPromptById_callToAction1, _data_directFeedbackPromptById2, _data_directFeedbackPromptById_callToAction2;
    var _props_contextValues = props.contextValues, contextValues = _props_contextValues === void 0 ? [] : _props_contextValues, promptId = props.inputs.promptId;
    var context = useBexApi11().context;
    var _useQuery9 = useQuery9(query, {
        variables: {
            id: promptId,
            context: context
        },
        fetchPolicy: "cache-first"
    }), data = _useQuery9.data, error = _useQuery9.error, loading = _useQuery9.loading;
    var track = useClickTracker31();
    var _useDialog9 = _slicedToArray(useDialog9(promptId, "cdfPromptDialog"), 2), actions = _useDialog9[1];
    var analytics = data === null || data === void 0 ? void 0 : (_data_directFeedbackPromptById = data.directFeedbackPromptById) === null || _data_directFeedbackPromptById === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction = _data_directFeedbackPromptById.callToAction) === null || _data_directFeedbackPromptById_callToAction === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction_action = _data_directFeedbackPromptById_callToAction.action) === null || _data_directFeedbackPromptById_callToAction_action === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction_action.analytics;
    var ctaText = data === null || data === void 0 ? void 0 : (_data_directFeedbackPromptById1 = data.directFeedbackPromptById) === null || _data_directFeedbackPromptById1 === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction1 = _data_directFeedbackPromptById1.callToAction) === null || _data_directFeedbackPromptById_callToAction1 === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction1.primary;
    var ctaIcon = data === null || data === void 0 ? void 0 : (_data_directFeedbackPromptById2 = data.directFeedbackPromptById) === null || _data_directFeedbackPromptById2 === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction2 = _data_directFeedbackPromptById2.callToAction) === null || _data_directFeedbackPromptById_callToAction2 === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction2.icon;
    if (error) {
        return null;
    }
    var handleOnClick = function() {
        actions.openDialog();
        if (analytics) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var skeleton = /* @__PURE__ */ React117.createElement(UitkSpacing46, {
        padding: {
            blockstart: "one",
            blockend: "half"
        }
    }, /* @__PURE__ */ React117.createElement("div", null, /* @__PURE__ */ React117.createElement(UitkLineSkeleton4, null)));
    var callToAction = /* @__PURE__ */ React117.createElement(UitkLink12, {
        onClick: handleOnClick
    }, /* @__PURE__ */ React117.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React117.createElement(UitkIcon17, {
        name: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id) || "",
        key: ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id,
        size: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.size) && UitkIconSize10[ctaIcon.size]
    }), ctaText));
    var impressionAnalytics = {
        // e.g. DirectFeedback.2b633e34-98cb-4d1c-a834-ee11a65ac2ac.CallToAction.impressed
        referrerId: "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".impressed"),
        linkName: "Direct feedback call to action"
    };
    var content = /* @__PURE__ */ React117.createElement(React117.Fragment, null, loading ? skeleton : callToAction, /* @__PURE__ */ React117.createElement(DirectFeedbackDialog, {
        contextValues: contextValues,
        inputs: {
            promptId: promptId
        }
    }));
    return (analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) ? /* @__PURE__ */ React117.createElement(IntersectionTracker7, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.linkName
    }, content) : content;
};
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
// src/components/direct-feedback/direct-feedback-prompt-id-fragment.tsx
import React118 from "react";
import { gql as gql112 } from "@apollo/client";
var PropertyDirectFeedbackPromptIdFragment = gql112(_templateObject112());
var PropertyDirectFeedbackCallToAction = function(param) {
    var directFeedback = param.data.directFeedback, contextValues = param.contextValues;
    return (directFeedback === null || directFeedback === void 0 ? void 0 : directFeedback.promptId) ? /* @__PURE__ */ React118.createElement(DirectFeedbackCallToAction, {
        inputs: directFeedback,
        contextValues: contextValues
    }) : null;
};
PropertyDirectFeedbackCallToAction.displayName = "PropertyDirectFeedbackCallToAction";
PropertyDirectFeedbackCallToAction.fragment = PropertyDirectFeedbackPromptIdFragment;
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
import React121, { useCallback as useCallback2 } from "react";
import { gql as gql114 } from "@apollo/client";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog as DirectFeedbackDialog2 } from "@shared-ui/retail-customer-direct-feedback";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection8 } from "uitk-react-cards";
import { UitkExpandoList as UitkExpandoList2 } from "uitk-react-expando";
import { UitkLayoutFlex as UitkLayoutFlex28, UitkLayoutFlexItem as UitkLayoutFlexItem21 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid14, UitkLayoutGridItem as UitkLayoutGridItem11 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing47 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading19, UitkParagraph as UitkParagraph5 } from "uitk-react-text";
// src/components/frequently-asked-questions/__private/__fragments/faq.tsx
import React119 from "react";
import { gql as gql113 } from "@apollo/client";
import { useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoListItem as UitkExpandoListItem2 } from "uitk-react-expando";
import { UitkText as UitkText35 } from "uitk-react-text";
var __FaqFragment = gql113(_templateObject113());
var Faq = function(param) {
    var data = param.data, rfrr = param.rfrr;
    var _ref = data || {}, question = _ref.question, answer = _ref.answer;
    var _React119_useState = _slicedToArray(React119.useState(false), 2), isVisible = _React119_useState[0], setIsVisible = _React119_useState[1];
    var track = useClickTracker32();
    var onToggle = React119.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var callback = React119.useCallback(function(id, description) {
        track(id, description);
    }, [
        track
    ]);
    if (!(question === null || question === void 0 ? void 0 : question.text) || !(answer === null || answer === void 0 ? void 0 : answer.text)) {
        return null;
    }
    return /* @__PURE__ */ React119.createElement(UitkExpandoListItem2, {
        expandoTitle: /* @__PURE__ */ React119.createElement(UitkText35, {
            size: 400,
            weight: "bold"
        }, question.text),
        expandoDescription: /* @__PURE__ */ React119.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: answer.text
            }
        }),
        isVisible: isVisible,
        onToggle: onToggle,
        analytics: {
            id: "".concat(rfrr, ".").concat(isVisible ? "close" : "open"),
            description: "See frequently asked questions",
            callback: callback
        }
    });
};
Faq.displayName = "Faq";
Faq.fragment = __FaqFragment;
// src/components/frequently-asked-questions/structured-data.tsx
import React120 from "react";
var generateSchema = function(faqs) {
    if (!faqs || !faqs.length) {
        return null;
    }
    var faqsMainEntity = faqs.map(function(faq) {
        var textValue = faq.answer.text.replace(/"/g, '\\"');
        return {
            name: faq.question.text,
            "@type": "Question",
            acceptedAnswer: {
                "@type": "Answer",
                text: textValue
            }
        };
    });
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqsMainEntity
    };
    return JSON.stringify(schemaJson);
};
var FaqStructuredData = function(param) {
    var faqs = param.faqs;
    var structuredData = generateSchema(faqs);
    if (!structuredData) {
        return null;
    }
    return /* @__PURE__ */ React120.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: structuredData
        }
    });
};
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
var __FrequentlyAskedQuestionsFragment = gql114(_templateObject114(), Faq.fragment);
var FrequentlyAskedQuestions = function(param) {
    var data = param.data;
    var _frequentlyAskedQuestions_askAQuestion, _data_offers, _data_offers_pricingFrequentlyAskedQuestions, _frequentlyAskedQuestions_askAQuestion1;
    var frequentlyAskedQuestions = data === null || data === void 0 ? void 0 : data.frequentlyAskedQuestions;
    var title = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.title.text;
    var subTitle = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.title.subText;
    var faqs = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.faqs;
    var directFeedbackDialogPromptId = "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9";
    var _useDialog10 = _slicedToArray(useDialog10(directFeedbackDialogPromptId, "cdfPromptDialog"), 2), openDialog = _useDialog10[1].openDialog;
    var askAQuestionText = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion = frequentlyAskedQuestions.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion.primary;
    var pricingFaq = data === null || data === void 0 ? void 0 : (_data_offers = data.offers) === null || _data_offers === void 0 ? void 0 : (_data_offers_pricingFrequentlyAskedQuestions = _data_offers.pricingFrequentlyAskedQuestions) === null || _data_offers_pricingFrequentlyAskedQuestions === void 0 ? void 0 : _data_offers_pricingFrequentlyAskedQuestions[0];
    var _ref = (frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion1 = frequentlyAskedQuestions.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion1 === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion1.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var track = useClickTracker33();
    var handleAskAQuestionClick = useCallback2(function() {
        openDialog();
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    }, [
        linkName,
        referrerId,
        track,
        openDialog
    ]);
    if (!faqs || faqs.length === 0) {
        return null;
    }
    var mergedFaqs = faqs.slice(0);
    if (pricingFaq) {
        mergedFaqs.splice(1, 0, pricingFaq);
    }
    return /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        padding: {
            block: "six",
            large: {
                inline: "six"
            },
            extra_large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React121.createElement(UitkCard10, null, /* @__PURE__ */ React121.createElement(UitkCardContentSection8, null, /* @__PURE__ */ React121.createElement(DirectFeedbackDialog2, {
        inputs: {
            promptId: "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9"
        },
        contextValues: [
            {
                key: "property_id",
                value: data.id
            }
        ]
    }), /* @__PURE__ */ React121.createElement(UitkLayoutGrid14, {
        space: "six",
        columns: {
            medium: 1,
            large: 3
        }
    }, /* @__PURE__ */ React121.createElement(UitkLayoutGridItem11, {
        colSpan: 1
    }, title && /* @__PURE__ */ React121.createElement(UitkLayoutFlex28, {
        direction: "column"
    }, /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React121.createElement(UitkHeading19, {
        tag: "h2",
        size: 4
    }, title)), subTitle && /* @__PURE__ */ React121.createElement(React121.Fragment, null, /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: {
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React121.createElement(UitkLayoutFlexItem21, null, /* @__PURE__ */ React121.createElement(UitkParagraph5, {
        size: 1
    }, subTitle))), /* @__PURE__ */ React121.createElement(UitkLayoutFlexItem21, {
        alignSelf: "start"
    }, /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React121.createElement(UitkSecondaryButton2, {
        id: "ask-a-question",
        onClick: handleAskAQuestionClick
    }, askAQuestionText)))))), /* @__PURE__ */ React121.createElement(UitkLayoutGridItem11, {
        colSpan: {
            medium: 1,
            large: 2
        }
    }, /* @__PURE__ */ React121.createElement(UitkExpandoList2, null, mergedFaqs.map(function(faq, index) {
        return /* @__PURE__ */ React121.createElement(Faq, {
            key: "faq-".concat(index),
            data: faq,
            rfrr: "HOT.HIS.question.".concat(index)
        });
    })))), /* @__PURE__ */ React121.createElement(FaqStructuredData, {
        faqs: mergedFaqs
    }))));
};
FrequentlyAskedQuestions.displayName = "FrequentlyAskedQuestions";
FrequentlyAskedQuestions.fragment = __FrequentlyAskedQuestionsFragment;
// src/components/gallery/gallery.tsx
import React122 from "react";
import { gql as gql115 } from "@apollo/client";
var __GalleryFragment = gql115(_templateObject115(), PropertyImageGallery.fragment);
var Gallery = function(props) {
    var _propertyGallery_images;
    var data = props.data;
    var propertyGallery = data.propertyGallery, summary = data.summary;
    var _ref = summary || {
        name: ""
    }, propertyName = _ref.name, overview = _ref.overview;
    if (!(propertyGallery === null || propertyGallery === void 0 ? void 0 : (_propertyGallery_images = propertyGallery.images) === null || _propertyGallery_images === void 0 ? void 0 : _propertyGallery_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React122.createElement(React122.Fragment, null, propertyName && /* @__PURE__ */ React122.createElement("h1", {
        className: "is-visually-hidden"
    }, propertyName), propertyName && /* @__PURE__ */ React122.createElement("meta", {
        itemProp: "name",
        content: propertyName
    }), /* @__PURE__ */ React122.createElement(PropertyImageGallery, {
        data: propertyGallery
    }), (overview === null || overview === void 0 ? void 0 : overview.accessibilityLabel) && /* @__PURE__ */ React122.createElement("h2", {
        className: "is-visually-hidden"
    }, overview.accessibilityLabel));
};
Gallery.displayName = "Gallery";
Gallery.fragment = __GalleryFragment;
// src/components/gallery/placeholder.tsx
import React123 from "react";
import { ViewMedium as ViewMedium7, Viewport as Viewport13, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure7, UitkFigureAspectRatioType as UitkFigureAspectRatioType7, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid15, UitkLayoutGridItem as UitkLayoutGridItem12 } from "uitk-react-layout-grid";
var GalleryPlaceholder = /* istanbul ignore next -- @preserve */ function(param) {
    var data = param.data;
    return /* @__PURE__ */ React123.createElement(Viewport13, null, /* @__PURE__ */ React123.createElement(ViewSmall13, null, /* @__PURE__ */ React123.createElement(PlaceholderImage, {
        data: data
    })), /* @__PURE__ */ React123.createElement(ViewMedium7, null, /* @__PURE__ */ React123.createElement(UitkLayoutGrid15, {
        rows: 2,
        columns: 4,
        space: "half"
    }, Array.from(Array(5)).map(function(_, index) {
        return /* @__PURE__ */ React123.createElement(UitkLayoutGridItem12, {
            rowSpan: index === 0 ? 2 : 1,
            colSpan: index === 0 ? 2 : 1,
            key: "gallery-placeholder-".concat(index)
        }, /* @__PURE__ */ React123.createElement(PlaceholderImage, null));
    }))));
};
var PlaceholderImage = function(param) {
    var data = param.data, className = param.className;
    var _data_propertyGallery, _data_propertyGallery_images, _data_propertyGallery_images_;
    var image = (data === null || data === void 0 ? void 0 : (_data_propertyGallery = data.propertyGallery) === null || _data_propertyGallery === void 0 ? void 0 : (_data_propertyGallery_images = _data_propertyGallery.images) === null || _data_propertyGallery_images === void 0 ? void 0 : _data_propertyGallery_images.length) ? (_data_propertyGallery_images_ = data.propertyGallery.images[0]) === null || _data_propertyGallery_images_ === void 0 ? void 0 : _data_propertyGallery_images_.image : void 0;
    if (image) {
        var url = image.url;
        return /* @__PURE__ */ React123.createElement(UitkFigure7, {
            ratio: UitkFigureAspectRatioType7.R16_9,
            className: className
        }, /* @__PURE__ */ React123.createElement(UitkImage5, {
            src: url,
            alt: image.description
        }));
    }
    return /* @__PURE__ */ React123.createElement(UitkFigure7, {
        ratio: UitkFigureAspectRatioType7.R16_9,
        className: className
    }, /* @__PURE__ */ React123.createElement(UitkImage5, {
        placeholderImage: true
    }));
};
// src/components/inputs-context.tsx
import React124 from "react";
var InputsContext = React124.createContext({});
var usePropertyDetailsInputs = function() {
    return React124.useContext(InputsContext);
};
// src/components/inventory-source/inventory-source.tsx
import React125 from "react";
import { gql as gql116 } from "@apollo/client";
import { ViewLarge as ViewLarge9, Viewport as Viewport14, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex29, UitkLayoutFlexItem as UitkLayoutFlexItem22 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark5, UitkMarkSize as UitkMarkSize4 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing48 } from "uitk-react-spacing";
import { UitkText as UitkText36 } from "uitk-react-text";
var __InventorySourceFragment = gql116(_templateObject116());
var InventorySource = function(param) {
    var data = param.data;
    var _data_summary;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.propertySource) || {}, text = _ref.text, graphic = _ref.graphic;
    if (!text || text === "") {
        return null;
    }
    var _ref1 = (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Mark" && graphic || {}, id = _ref1.id, description = _ref1.description, url = _ref1.url;
    return /* @__PURE__ */ React125.createElement(Viewport14, null, /* @__PURE__ */ React125.createElement(ViewSmall14, null, /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlex29, {
        space: "one",
        direction: "column"
    }, /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement(UitkSpacing48, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React125.createElement("div", null, (url === null || url === void 0 ? void 0 : url.value) ? /* @__PURE__ */ React125.createElement(UitkMark5, {
        url: url.value,
        size: UitkMarkSize4.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React125.createElement(UitkMark5, {
        name: id,
        size: UitkMarkSize4.MEDIUM,
        description: description
    }))))), /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React125.createElement(UitkText36, {
        size: 300,
        "data-stid": "inventory-source"
    }, text))))), /* @__PURE__ */ React125.createElement(ViewLarge9, null, /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement(UitkLayoutFlex29, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React125.createElement(React125.Fragment, null, (url === null || url === void 0 ? void 0 : url.value) ? /* @__PURE__ */ React125.createElement(UitkMark5, {
        url: url.value,
        size: UitkMarkSize4.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React125.createElement(UitkSpacing48, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React125.createElement("div", null, /* @__PURE__ */ React125.createElement(UitkMark5, {
        name: id,
        size: UitkMarkSize4.MEDIUM,
        description: description
    }))))), /* @__PURE__ */ React125.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React125.createElement(UitkText36, {
        size: 300,
        overflow: "truncate",
        "data-stid": "property-source"
    }, text))))));
};
InventorySource.fragment = __InventorySourceFragment;
InventorySource.displayName = "InventorySource";
// src/components/location-highlights/location-highlights.tsx
import React126 from "react";
import { gql as gql117 } from "@apollo/client";
var __LocationHighlightsFragment = gql117(_templateObject117(), PropertyInfoContent.fragment);
var LocationHighlights = function(param) {
    var data = param.data, className = param.className;
    var _data_reviewInfo_summary;
    var reviewHighlights = (_data_reviewInfo_summary = data.reviewInfo.summary) === null || _data_reviewInfo_summary === void 0 ? void 0 : _data_reviewInfo_summary.reviewHighlights;
    if (!reviewHighlights || reviewHighlights.items.length === 0) {
        return null;
    }
    var smallIconItemsProps = {
        columns: 1,
        space: "three"
    };
    var largeIconItemsProps = {
        columns: 2,
        rows: 3,
        space: "three"
    };
    return /* @__PURE__ */ React126.createElement("div", {
        className: className
    }, /* @__PURE__ */ React126.createElement(PropertyInfoContent, {
        data: reviewHighlights,
        small: _objectSpreadProps(_objectSpread({}, smallIconItemsProps), {
            prefix: "reviewHighlights"
        }),
        large: _objectSpreadProps(_objectSpread({}, largeIconItemsProps), {
            prefix: "reviewHighlights"
        })
    }));
};
LocationHighlights.displayName = "LocationHighlights";
LocationHighlights.fragment = __LocationHighlightsFragment;
// src/components/navigation-bar/navigation-bar.tsx
import React128 from "react";
import { gql as gql119 } from "@apollo/client";
import { useRefContext } from "@shared-ui/ref-context";
// src/components/navigation-bar/__private/__fragments/navigation-bar-tabs.tsx
import React127 from "react";
import { gql as gql118 } from "@apollo/client";
import { useClickTracker as useClickTracker34 } from "@shared-ui/clickstream-analytics-context";
import { useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { UitkNavigationType, UitkTab as UitkTab2, UitkTabs as UitkTabs2, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
var SCROLL_TIMEOUT2 = 1500;
var VISIBILITY_OPTIONS = {
    rootMargin: -60,
    thresholds: new Array(51).fill(0).map(function(v, i) {
        return i * 0.02;
    })
};
var fragment55 = gql118(_templateObject118());
var NavigationBarTabs = function(props) {
    var data = props.data, targets = props.targets;
    var tabs = data.navigationBarTabs || [];
    var track = useClickTracker34();
    var _React127_useState = _slicedToArray(React127.useState(0), 2), activeTabIndex = _React127_useState[0], setActiveTabIndex = _React127_useState[1];
    var tabList = React127.useMemo(function() {
        return tabs.map(function(tab) {
            return {
                id: tab.sectionName,
                ref: targets[tab.sectionName]
            };
        });
    }, [
        tabs,
        targets
    ]);
    var onVisibilityChange = React127.useCallback(function(visibilityEvents) {
        var newActiveTabIndex = -1;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            if (visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.SPAN_VIEWPORT) {
                newActiveTabIndex = tabs.findIndex(function(tab) {
                    return tab.sectionName === sectionName;
                });
            }
        });
        if (newActiveTabIndex >= 0) {
            setActiveTabIndex(newActiveTabIndex);
        }
    }, [
        tabs
    ]);
    var _useVisibility = useVisibility(tabList, onVisibilityChange, VISIBILITY_OPTIONS), disableObserver = _useVisibility.disableObserver, enableObserver = _useVisibility.enableObserver;
    var onTabSelect = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        disableObserver();
        setTimeout(enableObserver, SCROLL_TIMEOUT2);
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        setActiveTabIndex(selectedTabIndex);
    };
    var onTabClick = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        track("HOT.HIS.NavBar.".concat(navigationTab.sectionName), navigationTab.sectionName);
    };
    return /* @__PURE__ */ React127.createElement(UitkTabs2, {
        navigationType: UitkNavigationType.JUMPLINK,
        onTabSelect: onTabSelect,
        onTabClickCB: onTabClick,
        selectedTab: activeTabIndex,
        tabsType: UitkTabsType2.NATURAL,
        scrollOffsetSelf: true,
        "data-stid": "navigation-tabs"
    }, tabs.map(function(tab) {
        return /* @__PURE__ */ React127.createElement(UitkTab2, {
            id: tab.sectionName,
            key: "uitk-tab-key-".concat(tab.sectionName),
            name: tab.localizedName,
            targetRef: targets[tab.sectionName],
            targetURI: "#".concat(tab.sectionName)
        });
    }));
};
NavigationBarTabs.displayName = "NavigationBarTabs";
NavigationBarTabs.fragment = fragment55;
// src/components/navigation-bar/navigation-bar.tsx
var __NavigationBarFragment = gql119(_templateObject119(), NavigationBarTabs.fragment);
var NavigationBar = function(props) {
    var data = props.data;
    var summary = data === null || data === void 0 ? void 0 : data.summary;
    var tabs = (summary === null || summary === void 0 ? void 0 : summary.navigationBarTabs) || [];
    var getTargets = useRefContext().getTargets;
    var targets = getTargets(tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
        return tab.sectionName;
    }));
    if (!summary || tabs.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React128.createElement(NavigationBarTabs, {
        data: summary,
        targets: targets
    });
};
NavigationBar.displayName = "NavigationBar";
NavigationBar.fragment = __NavigationBarFragment;
// src/components/navigation-bar/navigation-bar-placeholder.tsx
import React129 from "react";
import { UitkTabs as UitkTabs3 } from "uitk-react-tabs";
var NavigationBarPlaceholder = /* istanbul ignore next -- @preserve */ function() {
    return /* @__PURE__ */ React129.createElement(UitkTabs3, null);
};
// src/components/relevant-amenities/relevant-amenities.tsx
import React130 from "react";
import { gql as gql120 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid16, UitkLayoutGridItem as UitkLayoutGridItem13 } from "uitk-react-layout-grid";
import { UitkList as UitkList4, UitkListItem as UitkListItem3 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing49 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading20 } from "uitk-react-text";
var __RelevantAmenitiesItem = gql120(_templateObject120());
var RelevantAmenitiesItem = function(param) {
    var data = param.data;
    var header = data.header, contents = data.contents;
    var listMap = contents.map(function(element) {
        return element.items.map(function(item, idx) {
            return item && /* @__PURE__ */ React130.createElement(UitkListItem3, {
                key: "amenities-list-item-".concat(idx)
            }, item.text);
        });
    });
    return listMap && /* @__PURE__ */ React130.createElement(UitkLayoutGridItem13, {
        colSpan: {
            small: 3,
            medium: 1
        }
    }, /* @__PURE__ */ React130.createElement("div", null, /* @__PURE__ */ React130.createElement(UitkHeading20, {
        tag: "h6",
        size: 6
    }, header === null || header === void 0 ? void 0 : header.text), /* @__PURE__ */ React130.createElement(UitkList4, {
        bullet: "no-bullet"
    }, listMap)));
};
RelevantAmenitiesItem.displayName = "RelevantAmenitiesItem";
RelevantAmenitiesItem.fragment = __RelevantAmenitiesItem;
var __RelevantAmenitiesFragment = gql120(_templateObject121(), RelevantAmenitiesItem.fragment);
var RelevantAmenities = function(param) {
    var data = param.data, className = param.className;
    var _summary_amenities, _summary_amenities_relevantAmenities, _summary_amenities1;
    var summary = data.summary;
    if ((summary === null || summary === void 0 ? void 0 : (_summary_amenities = summary.amenities) === null || _summary_amenities === void 0 ? void 0 : (_summary_amenities_relevantAmenities = _summary_amenities.relevantAmenities) === null || _summary_amenities_relevantAmenities === void 0 ? void 0 : _summary_amenities_relevantAmenities.length) === 0) {
        return null;
    }
    var _summary_amenities_relevantAmenities1;
    var relevantAmenities = (_summary_amenities_relevantAmenities1 = summary === null || summary === void 0 ? void 0 : (_summary_amenities1 = summary.amenities) === null || _summary_amenities1 === void 0 ? void 0 : _summary_amenities1.relevantAmenities) !== null && _summary_amenities_relevantAmenities1 !== void 0 ? _summary_amenities_relevantAmenities1 : null;
    var relevantAmenitiesColumns = relevantAmenities === null || relevantAmenities === void 0 ? void 0 : relevantAmenities.map(function(item, idx) {
        var _item_contents, _item_contents_, _item_contents__items;
        if (!item || !item.header || !item.header.text || ((_item_contents = item.contents) === null || _item_contents === void 0 ? void 0 : _item_contents.length) === 0 || ((_item_contents_ = item.contents[0]) === null || _item_contents_ === void 0 ? void 0 : (_item_contents__items = _item_contents_.items) === null || _item_contents__items === void 0 ? void 0 : _item_contents__items.length) === 0) {
            return null;
        }
        return item && /* @__PURE__ */ React130.createElement(RelevantAmenitiesItem, {
            data: item,
            key: "amenities-list-".concat(idx)
        });
    }).filter(function(element) {
        return element !== null;
    });
    return /* @__PURE__ */ React130.createElement(React130.Fragment, null, relevantAmenitiesColumns && relevantAmenitiesColumns.length > 0 && /* @__PURE__ */ React130.createElement("div", {
        className: className
    }, /* @__PURE__ */ React130.createElement(UitkSpacing49, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React130.createElement(UitkLayoutGrid16, {
        columns: 3,
        space: "six"
    }, relevantAmenitiesColumns))));
};
RelevantAmenities.displayName = "RelevantAmenities";
RelevantAmenities.fragment = __RelevantAmenitiesFragment;
// src/components/save-trip-item/save-trip-item.tsx
import React133 from "react";
import { gql as gql123 } from "@apollo/client";
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React132 from "react";
import { gql as gql122 } from "@apollo/client";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/utils/analytics.ts
var createAdaptExMicroMessage = function(campaignId, events) {
    var allEvents = events === null || events === void 0 ? void 0 : events.reduce(function(acc, curr) {
        return _toConsumableArray(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: (eventType === null || eventType === void 0 ? void 0 : eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React131 from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if ((filteredEvents === null || filteredEvents === void 0 ? void 0 : filteredEvents.length) > 0) {
                    results.push(_objectSpreadProps(_objectSpread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React131.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React131.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
// ../internal/src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql121 } from "@apollo/client";
var AdaptexTrackingFragment = gql121(_templateObject122());
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
var fragment56 = gql122(_templateObject123(), AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics3().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React132.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React132.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React132.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React132.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment56;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// src/components/save-trip-item/save-trip-item.tsx
import { buildStateProvider as buildStateProvider2 } from "@shared-ui/provided-state-context";
import { Source as Source2, TripSaveItem as TripSaveItem2, ValidatedInputsState as ValidatedInputsState2 } from "@shared-ui/trips-save-item";
// src/components/save-trip-item/_private/use-to-update-attributes.tsx
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var EVENTS = {
    SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME: new SystemEvent(SystemEventLevel.INFO, "SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME")
};
function useUpdateAttributesWithSearchCriteria() {
    var loggerEvents = useLoggerEvents(EVENTS);
    return function(param) {
        var dataSaveItemAttributes = param.originalAttributes, searchCriteria = param.searchCriteria;
        return getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents);
    };
}
function getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents) {
    if (!(searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.dateRange) || !dataSaveItemAttributes) {
        return dataSaveItemAttributes;
    }
    switch(dataSaveItemAttributes.__typename){
        case "TripsSaveStayAttributes":
            return _objectSpreadProps(_objectSpread({}, dataSaveItemAttributes), {
                checkInDate: _objectSpread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkInDate),
                checkoutDate: _objectSpread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkOutDate),
                roomConfiguration: searchCriteria.rooms.map(function(room) {
                    return {
                        __typename: "PropertyRoom",
                        numberOfAdults: room.adults,
                        childAges: room.children ? room.children.map(function(child) {
                            return child.age;
                        }) : []
                    };
                })
            });
        default:
            loggerEvents.SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME.log({});
            return dataSaveItemAttributes;
    }
}
// src/components/save-trip-item/save-trip-item.tsx
var __SaveTripItemFragment = gql123(_templateObject124(), LodgingTripsSaveItemAdapter.fragment);
var ValidatedInputsStateProvider2 = buildStateProvider2(new ValidatedInputsState2());
var SaveTripItem = function(param) {
    var data = param.data, searchCriteria = param.searchCriteria;
    var updateAttributes = useUpdateAttributesWithSearchCriteria();
    if (!data.saveTripItem) {
        return null;
    }
    var updatedAttributes = updateAttributes({
        originalAttributes: data.saveTripItem.attributes,
        searchCriteria: searchCriteria
    });
    return /* @__PURE__ */ React133.createElement(ValidatedInputsStateProvider2, null, /* @__PURE__ */ React133.createElement(TripSaveItem2, {
        data: _objectSpreadProps(_objectSpread({}, data.saveTripItem), {
            attributes: updatedAttributes
        }),
        source: Source2.LODGING_DETAILS
    }));
};
SaveTripItem.fragment = __SaveTripItemFragment;
SaveTripItem.displayName = "SaveTripItem";
// src/components/shortlist/shortlist.tsx
import React134 from "react";
import { gql as gql124 } from "@apollo/client";
import { useClickTracker as useClickTracker35 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var __fragment2 = gql124(_templateObject125());
var Shortlist = function(param) {
    var data = param.data;
    var track = useClickTracker35();
    var propertyId = usePropertyDetailsInputs().propertyId;
    var button = (data.shortList || {}).button;
    var name = (data.summary || {}).name;
    if (!button) {
        return null;
    }
    var handleChange = function(previousChecked, currentChecked, dispatch) {
        if (!currentChecked) {
            track(button.uncheckedAnalytics.referrerId, button.uncheckedAnalytics.linkName);
            return;
        }
        track(button.checkedAnalytics.referrerId, button.checkedAnalytics.linkName);
        dispatch({
            message: name
        });
    };
    var _button_checkedAccessibilityLabel;
    return /* @__PURE__ */ React134.createElement(ShortlistToggle, {
        label: (_button_checkedAccessibilityLabel = button.checkedAccessibilityLabel) !== null && _button_checkedAccessibilityLabel !== void 0 ? _button_checkedAccessibilityLabel : "",
        initialChecked: button.checked,
        onChange: handleChange,
        inputs: {
            productId: propertyId,
            productType: ProductType.PROPERTY_DETAILS
        }
    });
};
Shortlist.displayName = "Shortlist";
Shortlist.fragment = __fragment2;
// src/components/space-overview/space-overview.tsx
import React137 from "react";
import { gql as gql127 } from "@apollo/client";
// src/components/space-overview/__private/__fragments/space-overview-info.tsx
import React135 from "react";
import { gql as gql125 } from "@apollo/client";
import { UitkIcon as UitkIcon18 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex30, UitkLayoutFlexItem as UitkLayoutFlexItem23 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing50 } from "uitk-react-spacing";
import { UitkText as UitkText37 } from "uitk-react-text";
var __SpaceOverviewInfoFragment = gql125(_templateObject126());
var SpaceOverviewInfo = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React135.createElement(UitkLayoutFlex30, {
        wrap: "wrap"
    }, /* @__PURE__ */ React135.createElement(React135.Fragment, null, data.items.map(function(item, index) {
        return /* @__PURE__ */ React135.createElement(UitkLayoutFlexItem23, {
            key: "".concat(item.__typename, "-").concat(index),
            grow: 1
        }, /* @__PURE__ */ React135.createElement(UitkText37, {
            size: 300,
            inline: true,
            spacing: "three",
            theme: "default"
        }, item.icon && /* @__PURE__ */ React135.createElement(UitkSpacing50, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React135.createElement(UitkIcon18, {
            name: item.icon.iconId,
            "aria-hidden": "true"
        })), item.text));
    })));
};
SpaceOverviewInfo.fragment = __SpaceOverviewInfoFragment;
SpaceOverviewInfo.displayName = "SpaceOverviewInfo";
// src/components/space-overview/__private/__fragments/space-overview-title.tsx
import React136 from "react";
import { gql as gql126 } from "@apollo/client";
import { UitkHeading as UitkHeading21 } from "uitk-react-text";
var __SpaceOverviewTitleFragment = gql126(_templateObject127());
var SpaceOverviewTitle = function(param) {
    var data = param.data;
    var header = data.header;
    if (!(header === null || header === void 0 ? void 0 : header.text)) {
        return null;
    }
    return /* @__PURE__ */ React136.createElement(UitkHeading21, {
        tag: "h3",
        size: 5
    }, header.text);
};
SpaceOverviewTitle.fragment = __SpaceOverviewTitleFragment;
SpaceOverviewTitle.displayName = "SpaceOverviewTitle";
// src/components/space-overview/space-overview.tsx
var __SpaceOverviewFragment = gql127(_templateObject128(), SpaceOverviewTitle.fragment, SpaceOverviewInfo.fragment);
var SpaceOverview = function(param) {
    var data = param.data, className = param.className;
    var _propertyHighlightedDetails_items;
    var propertyHighlightedDetails = data.propertyHighlightedDetails;
    if (!(propertyHighlightedDetails === null || propertyHighlightedDetails === void 0 ? void 0 : (_propertyHighlightedDetails_items = propertyHighlightedDetails.items) === null || _propertyHighlightedDetails_items === void 0 ? void 0 : _propertyHighlightedDetails_items.length)) {
        return null;
    }
    return /* @__PURE__ */ React137.createElement("div", {
        className: className
    }, /* @__PURE__ */ React137.createElement(SpaceOverviewTitle, {
        data: propertyHighlightedDetails
    }), /* @__PURE__ */ React137.createElement(SpaceOverviewInfo, {
        data: propertyHighlightedDetails
    }));
};
SpaceOverview.fragment = __SpaceOverviewFragment;
SpaceOverview.displayName = "SpaceOverview";
// src/components/summary/summary.tsx
import React156 from "react";
import { Experiment as Experiment7, ExperimentControl as ExperimentControl7, ExperimentVariant as ExperimentVariant7 } from "@shared-ui/experiment-context";
// ../internal/src/utils/find-react-child-by-type.ts
import React138 from "react";
var findReactChildByType = function(children, type) {
    return React138.Children.toArray(children).find(function(child) {
        return React138.isValidElement(child) && child.type === type;
    });
};
// src/components/summary/summary.tsx
import { IdentifierType as IdentifierType2, RelevantContent } from "@shared-ui/retail-product-relevant-content";
import { UitkCard as UitkCard14, UitkCardContentSection as UitkCardContentSection11 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid18, UitkLayoutGridItem as UitkLayoutGridItem15 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing66 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/reviews/index.tsx
import React140 from "react";
import { gql as gql129 } from "@apollo/client";
import { useClickTracker as useClickTracker36 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment6, ExperimentControl as ExperimentControl6, ExperimentVariant as ExperimentVariant6 } from "@shared-ui/experiment-context";
import { IdentifierType, ProductLine, UserGeneratedContentContainer } from "@shared-ui/retail-product-user-generated-content-container";
import { UitkIcon as UitkIcon20 } from "uitk-react-icons";
import { UitkLink as UitkLink13 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing52 } from "uitk-react-spacing";
import { UitkSubheading as UitkSubheading2 } from "uitk-react-text";
// src/components/summary/__private/__fragments/reviews/property-info-top-review.tsx
import React139 from "react";
import { gql as gql128 } from "@apollo/client";
import { UitkIcon as UitkIcon19, UitkIconSize as UitkIconSize11 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex31, UitkLayoutFlexItem as UitkLayoutFlexItem24 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing51 } from "uitk-react-spacing";
import { UitkText as UitkText38 } from "uitk-react-text";
var __PropertyInfoTopReview = gql128(_templateObject129());
var PropertyInfoTopReview = function(param) {
    var data = param.data;
    var _topReviews_highlighted_icon, _topReviews_highlighted_icon1, _topReviews_highlighted_icon2;
    var topReviews = data.topReviews;
    if (!(topReviews === null || topReviews === void 0 ? void 0 : topReviews.highlighted)) {
        return null;
    }
    var icon = ((_topReviews_highlighted_icon = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon === void 0 ? void 0 : _topReviews_highlighted_icon.iconId) || "";
    return /* @__PURE__ */ React139.createElement(UitkSpacing51, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React139.createElement(UitkLayoutFlex31, {
        space: "two"
    }, /* @__PURE__ */ React139.createElement(React139.Fragment, null, /* @__PURE__ */ React139.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React139.createElement(UitkIcon19, {
        name: icon,
        size: UitkIconSize11.SMALL,
        description: (_topReviews_highlighted_icon1 = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon1 === void 0 ? void 0 : _topReviews_highlighted_icon1.description,
        id: (_topReviews_highlighted_icon2 = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon2 === void 0 ? void 0 : _topReviews_highlighted_icon2.iconId
    })), /* @__PURE__ */ React139.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React139.createElement(UitkText38, null, /* @__PURE__ */ React139.createElement("span", {
        "data-stid": "top-review-text",
        className: "truncate-lines-2"
    }, topReviews.highlighted.value))))));
};
PropertyInfoTopReview.displayName = "PropertyInfoTopReview";
PropertyInfoTopReview.fragment = __PropertyInfoTopReview;
// src/components/summary/__private/__fragments/reviews/index.tsx
var __SummaryReviewsFragment = gql129(_templateObject130(), PropertyInfoTopReview.fragment, LodgingEnrichedMessage.fragment);
var SummaryReviews = function(param) {
    var data = param.data, onClickReviews = param.onClickReviews, className = param.className, triggerRef = param.triggerRef;
    var _highlightMessage_subtitle, _highlightMessage_subtitle1, _highlightMessage_subtitle2;
    var summary = data.reviewInfo.summary, topReviews = data.topReviews;
    var averageOverallRating = summary.averageOverallRating, totalCount = summary.totalCount, superlative = summary.superlative, overallScoreWithDescriptionA11y = summary.overallScoreWithDescriptionA11y, propertyReviewCountDetails = summary.propertyReviewCountDetails, highlightMessage = summary.highlightMessage, seoData = summary.seoData;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyId = _usePropertyDetailsInputs.propertyId, shoppingContext = _usePropertyDetailsInputs.shoppingContext;
    var isMultiItem = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.multiItem;
    var track = useClickTracker36();
    var handleClick = React140.useCallback(function(event) {
        event.preventDefault();
        var _SummaryAnalyticsMapping_REVIEWS = _slicedToArray(SummaryAnalyticsMapping["REVIEWS" /* REVIEWS */ ], 2), id = _SummaryAnalyticsMapping_REVIEWS[0], description = _SummaryAnalyticsMapping_REVIEWS[1];
        track(id, description, true);
        onClickReviews();
    }, [
        onClickReviews,
        track
    ]);
    if (!overallScoreWithDescriptionA11y && !propertyReviewCountDetails && !highlightMessage && !(topReviews === null || topReviews === void 0 ? void 0 : topReviews.highlighted)) {
        return null;
    }
    var showAggregateRating = averageOverallRating.raw > 0 && totalCount.raw > 0;
    if (!showAggregateRating) {
        return null;
    }
    var userGeneratedContentVariants = function() {
        return /* @__PURE__ */ React140.createElement(UserGeneratedContentContainer, {
            inputs: {
                productIdentifier: {
                    id: propertyId,
                    type: IdentifierType.PROPERTY_ID,
                    productLine: ProductLine.LODGING
                }
            }
        });
    };
    var userGeneratedContentWrapper = function() {
        return /* @__PURE__ */ React140.createElement(Experiment6, {
            name: "MPD_non_numerical_gex_and_UGC_sentiments"
        }, /* @__PURE__ */ React140.createElement(ExperimentControl6, null), /* @__PURE__ */ React140.createElement(ExperimentVariant6, {
            bucket: 1
        }, userGeneratedContentVariants()), /* @__PURE__ */ React140.createElement(ExperimentVariant6, {
            bucket: 2
        }, userGeneratedContentVariants()));
    };
    return /* @__PURE__ */ React140.createElement("div", {
        className: className,
        "data-stid": "content-hotel-reviewsummary"
    }, /* @__PURE__ */ React140.createElement("div", {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating"
    }, /* @__PURE__ */ React140.createElement("meta", {
        itemProp: "ratingValue",
        content: averageOverallRating.formatted
    }), superlative && /* @__PURE__ */ React140.createElement("meta", {
        itemProp: "description",
        content: superlative
    }), seoData.map(function(param) {
        var itemscope = param.itemscope, itemprop = param.itemprop, content = param.content;
        return !itemscope && content ? /* @__PURE__ */ React140.createElement("meta", {
            itemProp: itemprop,
            content: content
        }) : null;
    }), /* @__PURE__ */ React140.createElement("meta", {
        itemProp: "reviewCount",
        content: totalCount.formatted
    })), /* @__PURE__ */ React140.createElement("div", null, overallScoreWithDescriptionA11y && /* @__PURE__ */ React140.createElement(UitkSpacing52, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React140.createElement("div", null, /* @__PURE__ */ React140.createElement(LodgingEnrichedMessage, {
        data: overallScoreWithDescriptionA11y,
        textSize: 500
    }))), !isMultiItem ? userGeneratedContentWrapper() : null, (highlightMessage === null || highlightMessage === void 0 ? void 0 : (_highlightMessage_subtitle = highlightMessage.subtitle) === null || _highlightMessage_subtitle === void 0 ? void 0 : _highlightMessage_subtitle.text) && /* @__PURE__ */ React140.createElement(UitkSpacing52, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React140.createElement(UitkSubheading2, {
        tag: "h4",
        "aria-label": (highlightMessage === null || highlightMessage === void 0 ? void 0 : (_highlightMessage_subtitle1 = highlightMessage.subtitle) === null || _highlightMessage_subtitle1 === void 0 ? void 0 : _highlightMessage_subtitle1.accessibilityLabel) || void 0
    }, highlightMessage === null || highlightMessage === void 0 ? void 0 : (_highlightMessage_subtitle2 = highlightMessage.subtitle) === null || _highlightMessage_subtitle2 === void 0 ? void 0 : _highlightMessage_subtitle2.text)), (propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription) && /* @__PURE__ */ React140.createElement(UitkSpacing52, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React140.createElement(UitkLink13, {
        onClick: handleClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React140.createElement("button", {
        type: "button",
        "data-stid": "reviews-link"
    }, propertyReviewCountDetails.shortDescription, /* @__PURE__ */ React140.createElement(UitkIcon20, {
        name: "chevron_right"
    }))))), /* @__PURE__ */ React140.createElement(PropertyInfoTopReview, {
        data: data
    }));
};
SummaryReviews.displayName = "SummaryReviews";
SummaryReviews.fragment = __SummaryReviewsFragment;
// src/components/summary/__private/__fragments/amenities/index.tsx
import React144 from "react";
import { gql as gql132 } from "@apollo/client";
import { useClickTracker as useClickTracker38 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge10, Viewport as Viewport16, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/amenities/amenities-dialog.tsx
import React141 from "react";
import { gql as gql130 } from "@apollo/client";
import { ViewMedium as ViewMedium8, Viewport as Viewport15, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet14, UitkSheetContent as UitkSheetContent5 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar8 } from "uitk-react-toolbar";
var __AmenitiesDialog = gql130(_templateObject131(), PropertyTakeoverAmenities.fragment);
var SheetComponent = function(param) {
    var type = param.type, title = param.title, description = param.description, takeover = param.takeover, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, _param_triggerRef = param.triggerRef, triggerRef = _param_triggerRef === void 0 ? null : _param_triggerRef;
    return /* @__PURE__ */ React141.createElement(UitkSheet14, {
        returnFocusOnClose: true,
        triggerRef: triggerRef,
        isVisible: isDialogOpen,
        type: type
    }, /* @__PURE__ */ React141.createElement(UitkToolbar8, {
        toolbarTitle: title !== null && title !== void 0 ? title : void 0,
        navigationContent: {
            onClick: closeDialog,
            navType: "close",
            navIconLabel: description
        }
    }), /* @__PURE__ */ React141.createElement(UitkSheetContent5, null, /* @__PURE__ */ React141.createElement(PropertyTakeoverAmenities, {
        data: takeover
    })));
};
var AmenitiesDialog = function(props) {
    var _amenitiesDialog_toolbar, _amenitiesDialog_toolbar1, _amenitiesDialog_toolbar_icon;
    var closeDialog = props.closeDialog, data = props.data, isDialogOpen = props.isDialogOpen, triggerRef = props.triggerRef;
    var amenitiesDialog = data.amenitiesDialog, takeover = data.takeover;
    if (!amenitiesDialog || !takeover) {
        return null;
    }
    var title = (_amenitiesDialog_toolbar = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar === void 0 ? void 0 : _amenitiesDialog_toolbar.title;
    var description = (_amenitiesDialog_toolbar1 = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar1 === void 0 ? void 0 : (_amenitiesDialog_toolbar_icon = _amenitiesDialog_toolbar1.icon) === null || _amenitiesDialog_toolbar_icon === void 0 ? void 0 : _amenitiesDialog_toolbar_icon.description;
    var sheetProps = {
        title: title,
        description: description,
        takeover: takeover,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React141.createElement(Viewport15, null, /* @__PURE__ */ React141.createElement(ViewSmall15, null, /* @__PURE__ */ React141.createElement(SheetComponent, _objectSpread({
        type: "full"
    }, sheetProps))), /* @__PURE__ */ React141.createElement(ViewMedium8, null, /* @__PURE__ */ React141.createElement(SheetComponent, _objectSpread({
        type: "centered"
    }, sheetProps))));
};
AmenitiesDialog.displayName = "AmenitiesDialog";
AmenitiesDialog.fragment = __AmenitiesDialog;
// src/components/summary/__private/__fragments/amenities/amenities-link.tsx
import React142 from "react";
import { gql as gql131 } from "@apollo/client";
import { useClickTracker as useClickTracker37 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon21 } from "uitk-react-icons";
import { UitkLink as UitkLink14 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing53 } from "uitk-react-spacing";
var __AmenitiesLinkFragment = gql131(_templateObject132());
var AmenitiesLink = function(param) {
    var data = param.data, onClick = param.onClick, triggerRef = param.triggerRef;
    var _SummaryAnalyticsMapping_AMENITIES = _slicedToArray(SummaryAnalyticsMapping["AMENITIES" /* AMENITIES */ ], 2), id = _SummaryAnalyticsMapping_AMENITIES[0], description = _SummaryAnalyticsMapping_AMENITIES[1];
    var track = useClickTracker37();
    var handleClick = React142.useCallback(function(event) {
        event.preventDefault();
        track(id, description, true);
        onClick();
    }, [
        track,
        id,
        description,
        onClick
    ]);
    var amenitiesDialog = data.amenitiesDialog;
    if (!amenitiesDialog) {
        return null;
    }
    var _amenitiesDialog_trigger = amenitiesDialog.trigger, text = _amenitiesDialog_trigger.value, accessibilityLabel = _amenitiesDialog_trigger.accessibilityLabel, icon = _amenitiesDialog_trigger.icon;
    var iconId = (icon === null || icon === void 0 ? void 0 : icon.iconId) || "";
    return /* @__PURE__ */ React142.createElement(React142.Fragment, null, /* @__PURE__ */ React142.createElement(UitkSpacing53, {
        padding: {
            blockstart: "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLink14, {
        align: "left",
        onClick: handleClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React142.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React142.createElement("span", {
        "aria-hidden": true
    }, text), accessibilityLabel && /* @__PURE__ */ React142.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React142.createElement(UitkIcon21, {
        name: iconId
    })))));
};
AmenitiesLink.displayName = "AmenitiesLink";
AmenitiesLink.fragment = __AmenitiesLinkFragment;
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
import React143 from "react";
import { UitkSpacing as UitkSpacing54 } from "uitk-react-spacing";
// src/utils/react-children-to-display-name-map.ts
import { Children } from "react";
function reactChildrenToDisplayNameMap(children) {
    if (!children) {
        return {};
    }
    var map = {};
    Children.forEach(children, function(c) {
        var _c_type;
        var displayName = c === null || c === void 0 ? void 0 : (_c_type = c.type) === null || _c_type === void 0 ? void 0 : _c_type.displayName;
        if (!displayName) {
            return;
        }
        if (!map[displayName]) {
            map[displayName] = [];
        }
        map[displayName].push(c);
    });
    return map;
}
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
var AmenityView = function(param) {
    var children = param.children, data = param.data;
    var _data_summary, _data_summary_amenities, _data_summary1, _data_summary_amenities1;
    var topAmenities = (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var propertyContentPreferences = (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_amenities1 = _data_summary1.amenities) === null || _data_summary_amenities1 === void 0 ? void 0 : _data_summary_amenities1.propertyContentPreferences;
    var items = topAmenities === null || topAmenities === void 0 ? void 0 : topAmenities.items;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), AmenitiesLink2 = _reactChildrenToDisplayNameMap.AmenitiesLink;
    var baseItemsProps = {
        overflow: "wrap",
        prefix: "cleaningAndSafety",
        space: "four",
        subset: 6
    };
    var contentItemsProps2 = _objectSpreadProps(_objectSpread({}, baseItemsProps), {
        columns: 2
    });
    return /* @__PURE__ */ React143.createElement(React143.Fragment, null, propertyContentPreferences && /* @__PURE__ */ React143.createElement(UitkSpacing54, {
        padding: {
            blockend: "six"
        },
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React143.createElement("div", null, /* @__PURE__ */ React143.createElement(PropertyContent, {
        data: propertyContentPreferences
    }))), /* @__PURE__ */ React143.createElement(PropertyInfoContent, {
        data: topAmenities,
        small: contentItemsProps2,
        large: contentItemsProps2
    }), AmenitiesLink2);
};
AmenityView.displayName = "AmenityView";
// src/components/summary/__private/__fragments/amenities/index.tsx
var __SummaryAmenitiesFragment = gql132(_templateObject133(), __PropertyInfoContent, PropertyContent.fragment, AmenitiesLink.fragment, AmenitiesDialog.fragment);
var SummaryAmenities = function(param) {
    var data = param.data, className = param.className;
    var _amenities_topAmenities, _amenities_topAmenities_items, _amenities_amenitiesDialog, _amenities_amenitiesDialog_toolbar;
    var amenities = (data.summary || {}).amenities;
    var _useDialog11 = _slicedToArray(useDialog11("amenities-dialog", "pwaDialog"), 3), isDialogOpen = _useDialog11[0], dialogActions = _useDialog11[1], DialogComponent = _useDialog11[2];
    var analyticsTracker = useClickTracker38();
    var triggerAmenitiesRef = React144.useRef(null);
    if (!(amenities === null || amenities === void 0 ? void 0 : (_amenities_topAmenities = amenities.topAmenities) === null || _amenities_topAmenities === void 0 ? void 0 : (_amenities_topAmenities_items = _amenities_topAmenities.items) === null || _amenities_topAmenities_items === void 0 ? void 0 : _amenities_topAmenities_items.length)) {
        return null;
    }
    var clientSideAnalytics = amenities === null || amenities === void 0 ? void 0 : (_amenities_amenitiesDialog = amenities.amenitiesDialog) === null || _amenities_amenitiesDialog === void 0 ? void 0 : (_amenities_amenitiesDialog_toolbar = _amenities_amenitiesDialog.toolbar) === null || _amenities_amenitiesDialog_toolbar === void 0 ? void 0 : _amenities_amenitiesDialog_toolbar.clientSideAnalytics;
    var onClose = function() {
        dialogActions.closeDialog();
        if (clientSideAnalytics) {
            analyticsTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName, true);
        }
    };
    var amenitiesLink = (amenities === null || amenities === void 0 ? void 0 : amenities.amenitiesDialog) && /* @__PURE__ */ React144.createElement(AmenitiesLink, {
        key: "amenities-link",
        data: amenities,
        onClick: dialogActions.openDialog,
        triggerRef: triggerAmenitiesRef
    });
    return /* @__PURE__ */ React144.createElement(React144.Fragment, null, /* @__PURE__ */ React144.createElement("div", {
        className: className,
        "data-stid": "hotel-amenities-list"
    }, /* @__PURE__ */ React144.createElement(Viewport16, null, /* @__PURE__ */ React144.createElement(ViewSmall16, null, /* @__PURE__ */ React144.createElement(AmenityView, {
        data: data
    }, amenitiesLink)), /* @__PURE__ */ React144.createElement(ViewLarge10, null, /* @__PURE__ */ React144.createElement(AmenityView, {
        data: data
    }, amenitiesLink)))), (amenities === null || amenities === void 0 ? void 0 : amenities.amenitiesDialog) && /* @__PURE__ */ React144.createElement(DialogComponent, null, /* @__PURE__ */ React144.createElement(AmenitiesDialog, {
        data: amenities,
        closeDialog: onClose,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerAmenitiesRef
    })));
};
SummaryAmenities.displayName = "SummaryAmenities";
SummaryAmenities.fragment = __SummaryAmenitiesFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
import React146 from "react";
import { gql as gql134 } from "@apollo/client";
import { useClickTracker as useClickTracker39 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure as UitkFigure8, UitkImage as UitkImage6, UitkImageLink as UitkImageLink2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex33 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing56 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/map-trigger/address.tsx
import React145 from "react";
import { gql as gql133 } from "@apollo/client";
import { UitkIcon as UitkIcon22 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex32, UitkLayoutFlexItem as UitkLayoutFlexItem25 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink15 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing55 } from "uitk-react-spacing";
import { UitkSubheading as UitkSubheading3, UitkText as UitkText39 } from "uitk-react-text";
var __AddressFragment = gql133(_templateObject134());
var Schema = function(param) {
    var coordinates = param.coordinates;
    var latitude = String(coordinates === null || coordinates === void 0 ? void 0 : coordinates.latitude);
    var longitude = String(coordinates === null || coordinates === void 0 ? void 0 : coordinates.longitude);
    return /* @__PURE__ */ React145.createElement(React145.Fragment, null, /* @__PURE__ */ React145.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "http://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "latitude",
        content: latitude
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "longitude",
        content: longitude
    })));
};
Schema.displayName = "Schema";
var Address = function(param) {
    var data = param.data, onClick = param.onClick;
    var _data_address, _data_mapDialog, _data_mapDialog_trigger, _data_address1, _data_address2, _data_address3, _data_address4, _data_mapDialog1, _data_mapDialog_trigger1, _data_mapDialog_trigger_icon;
    var addressLine = (_data_address = data.address) === null || _data_address === void 0 ? void 0 : _data_address.addressLine;
    var triggerLabel = (_data_mapDialog = data.mapDialog) === null || _data_mapDialog === void 0 ? void 0 : (_data_mapDialog_trigger = _data_mapDialog.trigger) === null || _data_mapDialog_trigger === void 0 ? void 0 : _data_mapDialog_trigger.value;
    var city = ((_data_address1 = data.address) === null || _data_address1 === void 0 ? void 0 : _data_address1.city) || void 0;
    var countryCode = ((_data_address2 = data.address) === null || _data_address2 === void 0 ? void 0 : _data_address2.countryCode) || void 0;
    var province = ((_data_address3 = data.address) === null || _data_address3 === void 0 ? void 0 : _data_address3.province) || void 0;
    var streetAddress = ((_data_address4 = data.address) === null || _data_address4 === void 0 ? void 0 : _data_address4.firstAddressLine) || void 0;
    var triggerIcon = ((_data_mapDialog1 = data.mapDialog) === null || _data_mapDialog1 === void 0 ? void 0 : (_data_mapDialog_trigger1 = _data_mapDialog1.trigger) === null || _data_mapDialog_trigger1 === void 0 ? void 0 : (_data_mapDialog_trigger_icon = _data_mapDialog_trigger1.icon) === null || _data_mapDialog_trigger_icon === void 0 ? void 0 : _data_mapDialog_trigger_icon.iconId) || "";
    var _ref = data.ratings || {}, locationRatingsLabel = _ref.primary, locationRatingsAccessibilityLabel = _ref.accessibilityLabel;
    return /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React145.createElement(UitkLayoutFlex32, {
        wrap: "wrap"
    }, /* @__PURE__ */ React145.createElement(UitkLayoutFlexItem25, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React145.createElement(UitkText39, {
        "data-stid": "content-hotel-address"
    }, /* @__PURE__ */ React145.createElement("div", {
        itemProp: "address",
        itemScope: true,
        itemType: "http://schema.org/PostalAddress"
    }, /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "name",
        content: city
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "addressRegion",
        content: province
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "streetAddress",
        content: streetAddress
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "addressCountry",
        content: countryCode
    })), addressLine)), /* @__PURE__ */ React145.createElement(Schema, _objectSpread({}, data)), /* @__PURE__ */ React145.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React145.createElement(UitkLink15, {
        onClick: onClick && onClick
    }, /* @__PURE__ */ React145.createElement("button", {
        type: "button"
    }, triggerLabel, /* @__PURE__ */ React145.createElement(UitkIcon22, {
        name: triggerIcon
    }))))), locationRatingsLabel && /* @__PURE__ */ React145.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React145.createElement(UitkSubheading3, {
        tag: "h4",
        "aria-label": locationRatingsAccessibilityLabel
    }, locationRatingsLabel)))));
};
Address.displayName = "Address";
Address.fragment = __AddressFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
var __SummaryMapTriggerFragment = gql134(_templateObject135(), Address.fragment);
var SummaryMapTrigger = function(param) {
    var data = param.data, onClickMap = param.onClickMap, className = param.className, aspectRatio = param.aspectRatio, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? {} : _param_spacing;
    var _data_summary, _data_summary_location_staticImage, _data_summary_location_staticImage1;
    var track = useClickTracker39();
    var createHandlerClick = React146.useCallback(function(summaryEvent) {
        return function(event) {
            event.preventDefault();
            var _SummaryAnalyticsMapping_summaryEvent = _slicedToArray(SummaryAnalyticsMapping[summaryEvent], 2), id = _SummaryAnalyticsMapping_summaryEvent[0], description2 = _SummaryAnalyticsMapping_summaryEvent[1];
            track(id, description2, true);
            onClickMap();
        };
    }, [
        onClickMap,
        track
    ]);
    if (!((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.location) || !(data.summary.location.staticImage && data.summary.location.mapDialog)) {
        return null;
    }
    var url = (_data_summary_location_staticImage = data.summary.location.staticImage) === null || _data_summary_location_staticImage === void 0 ? void 0 : _data_summary_location_staticImage.url;
    var description = (_data_summary_location_staticImage1 = data.summary.location.staticImage) === null || _data_summary_location_staticImage1 === void 0 ? void 0 : _data_summary_location_staticImage1.description;
    return /* @__PURE__ */ React146.createElement(UitkLayoutFlex33, {
        direction: "column",
        className: className
    }, url && /* @__PURE__ */ React146.createElement(UitkSpacing56, _objectSpread({}, spacing), /* @__PURE__ */ React146.createElement(UitkFigure8, {
        roundcorner: true,
        ratio: aspectRatio
    }, /* @__PURE__ */ React146.createElement(UitkImage6, {
        alt: description,
        src: url
    }), /* @__PURE__ */ React146.createElement(UitkImageLink2, null, /* @__PURE__ */ React146.createElement("button", {
        type: "button",
        onClick: createHandlerClick("MAP_IMAGE" /* MAP_IMAGE */ )
    }, description)))), /* @__PURE__ */ React146.createElement(Address, {
        data: data.summary.location,
        onClick: createHandlerClick("MAP_LINK" /* MAP_LINK */ )
    }));
};
SummaryMapTrigger.displayName = "SummaryMapTrigger";
SummaryMapTrigger.fragment = __SummaryMapTriggerFragment;
// src/components/summary/__private/__fragments/near-by-pois/index.tsx
import React147 from "react";
import { gql as gql135 } from "@apollo/client";
import { UitkIcon as UitkIcon23, UitkIconSize as UitkIconSize12 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex34, UitkLayoutFlexItem as UitkLayoutFlexItem26 } from "uitk-react-layout-flex";
import { UitkList as UitkList5 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing57 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading22 } from "uitk-react-text";
var __SummaryNearByPoisFragment = gql135(_templateObject136());
var Icon2 = /* @__PURE__ */ function(Icon3) {
    Icon3["flight"] = "lob_flights";
    return Icon3;
}(Icon2 || {});
var getIconProps = function(icon, index) {
    return {
        id: "nearByPOIs-".concat(index),
        name: Icon2[icon.iconId] || icon.iconId,
        title: icon.description,
        size: UitkIconSize12.MEDIUM
    };
};
var SummaryNearByPois = function(param) {
    var data = param.data, className = param.className;
    var _data_summary;
    if (!((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.nearbyPOIs)) {
        return null;
    }
    var _data_summary_nearbyPOIs = data.summary.nearbyPOIs, heading = _data_summary_nearbyPOIs.heading, items = _data_summary_nearbyPOIs.items;
    return /* @__PURE__ */ React147.createElement(UitkLayoutFlex34, {
        direction: "column",
        className: className
    }, /* @__PURE__ */ React147.createElement(UitkSpacing57, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React147.createElement(UitkHeading22, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React147.createElement(UitkList5, {
        bullet: "no-bullet"
    }, /* eslint-disable-next-line react/display-name */ items === null || items === void 0 ? void 0 : items.map(function(param, index) {
        var icon = param.icon, text = param.text, moreInfo = param.moreInfo;
        var iconProps = icon && getIconProps(icon, index);
        return /* @__PURE__ */ React147.createElement(UitkLayoutFlex34, {
            key: text,
            space: "two",
            wrap: "nowrap",
            tag: "li"
        }, iconProps && /* @__PURE__ */ React147.createElement(UitkSpacing57, {
            padding: {
                inlineend: "three"
            }
        }, /* @__PURE__ */ React147.createElement(UitkIcon23, _objectSpread({}, iconProps))), /* @__PURE__ */ React147.createElement(UitkLayoutFlexItem26, {
            grow: 1
        }, /* @__PURE__ */ React147.createElement("span", null, text)), /* @__PURE__ */ React147.createElement(UitkLayoutFlexItem26, {
            shrink: 0
        }, /* @__PURE__ */ React147.createElement("span", null, moreInfo)));
    })));
};
SummaryNearByPois.displayName = "SummaryNearByPois";
SummaryNearByPois.fragment = __SummaryNearByPoisFragment;
// src/components/summary/__private/__fragments/banner-message/index.tsx
import React148 from "react";
import { gql as gql136 } from "@apollo/client";
import { UitkCard as UitkCard11 } from "uitk-react-cards";
import { UitkIcon as UitkIcon24, UitkIconSize as UitkIconSize13 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex35, UitkLayoutFlexItem as UitkLayoutFlexItem27 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing58 } from "uitk-react-spacing";
import { UitkText as UitkText40 } from "uitk-react-text";
var __SummaryBannerMessageFragment = gql136(_templateObject137());
var SummaryBannerMessage = function(param) {
    var data = param.data;
    var _data_summary, _bannerMessage_title, _bannerMessage_title_icon, _bannerMessage_title1, _bannerMessage_title_icon1, _bannerMessage_title2, _bannerMessage_title_icon2, _bannerMessage_subtitle;
    var bannerMessage = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.bannerMessage;
    if (!bannerMessage) {
        return null;
    }
    var _bannerMessage_title_icon_id;
    return /* @__PURE__ */ React148.createElement(UitkSpacing58, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React148.createElement(UitkCard11, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React148.createElement(UitkLayoutFlex35, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React148.createElement(UitkLayoutFlexItem27, null, /* @__PURE__ */ React148.createElement("div", null, /* @__PURE__ */ React148.createElement(UitkIcon24, {
        name: (_bannerMessage_title_icon_id = (_bannerMessage_title = bannerMessage.title) === null || _bannerMessage_title === void 0 ? void 0 : (_bannerMessage_title_icon = _bannerMessage_title.icon) === null || _bannerMessage_title_icon === void 0 ? void 0 : _bannerMessage_title_icon.id) !== null && _bannerMessage_title_icon_id !== void 0 ? _bannerMessage_title_icon_id : "",
        size: UitkIconSize13.MEDIUM,
        id: "banner-message-".concat((_bannerMessage_title1 = bannerMessage.title) === null || _bannerMessage_title1 === void 0 ? void 0 : (_bannerMessage_title_icon1 = _bannerMessage_title1.icon) === null || _bannerMessage_title_icon1 === void 0 ? void 0 : _bannerMessage_title_icon1.id),
        title: (_bannerMessage_title2 = bannerMessage.title) === null || _bannerMessage_title2 === void 0 ? void 0 : (_bannerMessage_title_icon2 = _bannerMessage_title2.icon) === null || _bannerMessage_title_icon2 === void 0 ? void 0 : _bannerMessage_title_icon2.description
    }))), /* @__PURE__ */ React148.createElement(UitkSpacing58, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React148.createElement(UitkLayoutFlexItem27, null, /* @__PURE__ */ React148.createElement("div", null, /* @__PURE__ */ React148.createElement(UitkText40, {
        size: 300
    }, (_bannerMessage_subtitle = bannerMessage.subtitle) === null || _bannerMessage_subtitle === void 0 ? void 0 : _bannerMessage_subtitle.text)))))));
};
SummaryBannerMessage.displayName = "SummaryBannerMessage";
SummaryBannerMessage.fragment = __SummaryBannerMessageFragment;
// src/components/summary/__private/__fragments/header/header.tsx
import React149 from "react";
import { gql as gql137 } from "@apollo/client";
import { useExperiment } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge11, Viewport as Viewport17, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
import { UitkVipBadge } from "uitk-react-badge";
import { UitkIcon as UitkIcon25, UitkIconSize as UitkIconSize14 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex36, UitkLayoutFlexItem as UitkLayoutFlexItem28 } from "uitk-react-layout-flex";
import { UitkRating as UitkRating2 } from "uitk-react-rating";
import { UitkSpacing as UitkSpacing59 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading23, UitkSubheading as UitkSubheading4, UitkText as UitkText41 } from "uitk-react-text";
var __SummaryHeaderFragment = gql137(_templateObject138());
var SummaryHeader = function(param) {
    var data = param.data, overrideTag = param.overrideTag;
    var _overview_propertyRating;
    var _ref = data.summary || {}, name = _ref.name, latinAlphabetName = _ref.latinAlphabetName, overview = _ref.overview, starRatingIcon = _ref.starRatingIcon, featuredMessages = _ref.featuredMessages, tagline = _ref.tagline, messages = _ref.messages;
    var shouldDisplayRating = Boolean((overview === null || overview === void 0 ? void 0 : overview.starRating) && starRatingIcon);
    var exposure = useExperiment("Dateless_PDP_Property_Name_in_Page_Context_as_H1").exposure;
    var isPropertyNameVariation = overrideTag && exposure.bucket === 1;
    if (!name) {
        return null;
    }
    var _overview_propertyRating_accessibility;
    return /* @__PURE__ */ React149.createElement(React149.Fragment, null, /* @__PURE__ */ React149.createElement(UitkSpacing59, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React149.createElement(UitkLayoutFlex36, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, (overview === null || overview === void 0 ? void 0 : overview.vipMessaging) && /* @__PURE__ */ React149.createElement(UitkLayoutFlexItem28, null, /* @__PURE__ */ React149.createElement(UitkVipBadge, {
        text: overview.vipMessaging
    })), featuredMessages && featuredMessages.length > 0 && /* @__PURE__ */ React149.createElement(UitkLayoutFlexItem28, null, /* @__PURE__ */ React149.createElement("div", null, featuredMessages.map(function(message, index) {
        return /* @__PURE__ */ React149.createElement(UitkText41, {
            theme: "default",
            key: index,
            inline: true
        }, index !== 0 && /* @__PURE__ */ React149.createElement(UitkSpacing59, {
            margin: {
                inline: "half"
            }
        }, /* @__PURE__ */ React149.createElement("span", {
            "aria-hidden": "true",
            className: "uitk-type-300 uitk-type-bold"
        }, "\xb7")), message.icon && /* @__PURE__ */ React149.createElement(UitkIcon25, {
            name: message.icon.iconId,
            size: UitkIconSize14.SMALL,
            "aria-hidden": "true"
        }), message.value);
    }))))), /* @__PURE__ */ React149.createElement(Viewport17, null, /* @__PURE__ */ React149.createElement(ViewSmall17, null, /* @__PURE__ */ React149.createElement(UitkHeading23, {
        tag: !isPropertyNameVariation ? "h1" : "h2",
        size: 4,
        "aria-hidden": "true"
    }, name)), /* @__PURE__ */ React149.createElement(ViewLarge11, null, /* @__PURE__ */ React149.createElement(UitkHeading23, {
        tag: !isPropertyNameVariation ? "h1" : "h2",
        size: !isPropertyNameVariation ? 3 : 4,
        "aria-hidden": "true"
    }, name))), latinAlphabetName && /* @__PURE__ */ React149.createElement(UitkSubheading4, {
        tag: !isPropertyNameVariation ? "h2" : "h3"
    }, latinAlphabetName), messages === null || messages === void 0 ? void 0 : messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React149.createElement(LodgingEGDSText, {
            key: "message-".concat(messageIndex),
            data: message
        });
    }), shouldDisplayRating && /* @__PURE__ */ React149.createElement(UitkRating2, {
        icon: (starRatingIcon === null || starRatingIcon === void 0 ? void 0 : starRatingIcon.iconId) === "STAR" ? "star" : "alternate",
        rating: String(overview === null || overview === void 0 ? void 0 : overview.starRating),
        a11yText: (_overview_propertyRating_accessibility = overview === null || overview === void 0 ? void 0 : (_overview_propertyRating = overview.propertyRating) === null || _overview_propertyRating === void 0 ? void 0 : _overview_propertyRating.accessibility) !== null && _overview_propertyRating_accessibility !== void 0 ? _overview_propertyRating_accessibility : void 0
    }), tagline && /* @__PURE__ */ React149.createElement(UitkText41, {
        theme: "default"
    }, tagline));
};
SummaryHeader.fragment = __SummaryHeaderFragment;
SummaryHeader.displayName = "SummaryHeader";
// src/components/summary/__private/__fragments/header/placeholder.tsx
import React150 from "react";
import { UitkLineSkeleton as UitkLineSkeleton5 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing60 } from "uitk-react-spacing";
var SummaryHeaderPlaceholder = function(param) {
    var data = param.data;
    if (data === null || data === void 0 ? void 0 : data.summary) {
        return /* @__PURE__ */ React150.createElement(SummaryHeader, {
            data: data
        });
    }
    return /* @__PURE__ */ React150.createElement(React150.Fragment, null, /* @__PURE__ */ React150.createElement(UitkSpacing60, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React150.createElement(UitkLineSkeleton5, {
        animation: true,
        type: "primary"
    })), /* @__PURE__ */ React150.createElement(UitkLineSkeleton5, {
        animation: true,
        type: "secondary"
    }));
};
// src/components/summary/__private/__fragments/chatbot-launch/index.tsx
import React151, { useState as useState4 } from "react";
import { gql as gql138 } from "@apollo/client";
import { useBexApi as useBexApi12 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker40 } from "@shared-ui/clickstream-analytics-context";
import { VirtualAgentControl } from "@shared-ui/customer-virtual-agent-control";
import { VirtualAgentControlExitSurvey, VirtualAgentControlExitSurveyFeedback } from "@shared-ui/customer-virtual-agent-control-exit-survey";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
import { useLogger } from "@shared-ui/logger-context";
import { ViewLarge as ViewLarge12, Viewport as Viewport18, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
import { UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkCard as UitkCard12, UitkCardContentSection as UitkCardContentSection9 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex37, UitkLayoutFlexItem as UitkLayoutFlexItem29 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing61 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading24, UitkText as UitkText42 } from "uitk-react-text";
var __SummaryChatbotLaunchFragment = gql138(_templateObject139());
var SummaryChatbotLaunch = function(param) {
    var data = param.data, applicationName = param.applicationName, pageName = param.pageName;
    var _data_summary, _searchCriteria_primary_dateRange, _searchCriteria_primary_dateRange1, _searchCriteria_primary_rooms__children;
    var _ref = ((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.lodgingChatbot) || {}, header = _ref.header, action = _ref.action, content = _ref.content;
    var context = useBexApi12().context;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyId = _usePropertyDetailsInputs.propertyId, searchCriteria = _usePropertyDetailsInputs.searchCriteria;
    var _useState4 = _slicedToArray(useState4(false), 2), loaded = _useState4[0], setLoad = _useState4[1];
    var _useState41 = _slicedToArray(useState4(false), 2), shouldLoadSurvey = _useState41[0], setShouldLoadSurvey = _useState41[1];
    var _useDialog12 = _slicedToArray(useDialog12("virtual-agent-control-exit-survey-feedback"), 3), isDialogOpen = _useDialog12[0], dialogActions = _useDialog12[1], DialogComponent = _useDialog12[2];
    var clickTracker = useClickTracker40();
    var _useLogger = useLogger(), logInfo = _useLogger.info;
    var message = chatbotAnalyticsSchema("VR-SHOPPING", applicationName, propertyId);
    var currency = context.currency;
    var identity = context.identity;
    var havId = identity === null || identity === void 0 ? void 0 : identity.expUserId;
    var VAC_EVENTS = {
        VAC_WidgetOpened: "chatbot.presented",
        VAC_WidgetClosed: "chatbot.hidden",
        VAC_ConversationCreated: "chatbot_conversation.created",
        VAC_ChatMsgReceived: "chatbot_user_message.submitted",
        VAC_ChatMsgSent: "chatbot_response_message.presented"
    };
    if (!header) {
        return null;
    }
    if (currency == null) {
        currency = void 0;
    }
    if (havId == null) {
        havId = void 0;
    }
    var dateToString = function(date) {
        return "".concat(date.year, "-").concat(date.month, "-").concat(date.day);
    };
    var launchChatUi = function() {
        if (!loaded) {
            clickTracker("HOT.HIS.ChatbotLaunch", "chatbot_entrypoint.selected", void 0, [
                message
            ]);
            setLoad(true);
        } else {
            try {
                window.virtualAgentControl.openChatWidget();
            } catch (e) {
                logInfo("Virtual agent control not loaded");
            }
        }
    };
    var eventHandler = function(event) {
        clickTracker(event.type, VAC_EVENTS[event.type], void 0, [
            message
        ]);
        if (event.type === "VAC_WidgetClosed") {
            setShouldLoadSurvey(true);
        }
    };
    return /* @__PURE__ */ React151.createElement("div", null, /* @__PURE__ */ React151.createElement(Viewport18, null, /* @__PURE__ */ React151.createElement(ViewLarge12, null, /* @__PURE__ */ React151.createElement(React151.Fragment, null, /* @__PURE__ */ React151.createElement(UitkLayoutFlex37, {
        justifyContent: "center",
        wrap: "wrap"
    }, /* @__PURE__ */ React151.createElement(UitkLayoutFlexItem29, {
        minWidth: "full_width",
        alignSelf: "center"
    }, /* @__PURE__ */ React151.createElement(UitkSpacing61, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React151.createElement(UitkText42, {
        size: 300,
        align: "center"
    }, content))), /* @__PURE__ */ React151.createElement(UitkLayoutFlexItem29, null, /* @__PURE__ */ React151.createElement(UitkSpacing61, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React151.createElement("div", null, /* @__PURE__ */ React151.createElement(UitkSecondaryButton3, {
        onClick: launchChatUi
    }, action === null || action === void 0 ? void 0 : action.primary))))))), /* @__PURE__ */ React151.createElement(ViewSmall18, null, /* @__PURE__ */ React151.createElement(React151.Fragment, null, /* @__PURE__ */ React151.createElement(UitkCard12, {
        overflow: false,
        padded: true
    }, /* @__PURE__ */ React151.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React151.createElement(UitkHeading24, {
        size: 5,
        tag: "h2"
    }, header === null || header === void 0 ? void 0 : header.text)), /* @__PURE__ */ React151.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React151.createElement(UitkText42, {
        spacing: "four"
    }, content)), /* @__PURE__ */ React151.createElement(UitkSpacing61, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React151.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React151.createElement(UitkSecondaryButton3, {
        onClick: launchChatUi
    }, action === null || action === void 0 ? void 0 : action.primary))))))), loaded && /* @__PURE__ */ React151.createElement(VirtualAgentControl, {
        applicationName: applicationName,
        pageName: pageName,
        clientOverrides: {
            enableAutoOpenChatWidget: true,
            conversationProperties: {
                listingId: String(propertyId),
                checkin: dateToString((_searchCriteria_primary_dateRange = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange === void 0 ? void 0 : _searchCriteria_primary_dateRange.checkInDate),
                checkout: dateToString((_searchCriteria_primary_dateRange1 = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange1 === void 0 ? void 0 : _searchCriteria_primary_dateRange1.checkOutDate),
                children: (_searchCriteria_primary_rooms__children = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.rooms[0].children) === null || _searchCriteria_primary_rooms__children === void 0 ? void 0 : _searchCriteria_primary_rooms__children.length,
                adults: searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.rooms[0].adults,
                pets: 0,
                device: "WEB",
                currency: currency,
                bookNow: "",
                havId: havId,
                site: "expedia",
                hostname: window.location.hostname,
                chatbotName: "shopping-pwa.pdp",
                chatbotEntryPoint: "VR-SHOPPING"
            },
            subscribedEvents: _toConsumableArray(Object.keys(VAC_EVENTS)),
            eventHandler: eventHandler
        },
        inputs: {}
    }), shouldLoadSurvey && /* @__PURE__ */ React151.createElement(VirtualAgentControlExitSurvey, {
        chatbotEntryPoint: "chat-now-button",
        chatbotName: "shopping-pwa",
        timeoutMs: 1e4,
        onDismiss: function() {
            return setShouldLoadSurvey(false);
        },
        inputs: {
            propertyId: String(propertyId)
        }
    }), isDialogOpen && /* @__PURE__ */ React151.createElement(DialogComponent, null, /* @__PURE__ */ React151.createElement(VirtualAgentControlExitSurveyFeedback, {
        inputs: {
            propertyId: String(propertyId)
        },
        onDismiss: dialogActions.closeDialog
    })));
};
SummaryChatbotLaunch.fragment = __SummaryChatbotLaunchFragment;
SummaryChatbotLaunch.displayName = "SummaryChatbotLaunch";
// src/components/summary/__private/__fragments/experience-score/index.tsx
import React154, { useState as useState5 } from "react";
import { gql as gql141 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3, UitkTertiaryButton as UitkTertiaryButton6 } from "uitk-react-button";
import { UitkCard as UitkCard13, UitkCardContentSection as UitkCardContentSection10 } from "uitk-react-cards";
import { UitkIcon as UitkIcon27 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex40, UitkLayoutFlexItem as UitkLayoutFlexItem32 } from "uitk-react-layout-flex";
import { MinMax, UitkLayoutGrid as UitkLayoutGrid17, UitkLayoutGridItem as UitkLayoutGridItem14 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition8 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing64 } from "uitk-react-spacing";
import { UitkText as UitkText45 } from "uitk-react-text";
// src/components/summary/__private/__fragments/experience-score/experience-score-popover.tsx
import React152 from "react";
import { gql as gql139 } from "@apollo/client";
import { useClickTracker as useClickTracker41 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton as UitkTertiaryButton5 } from "uitk-react-button";
import { UitkIcon as UitkIcon26, UitkIconSize as UitkIconSize15 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex38, UitkLayoutFlexItem as UitkLayoutFlexItem30 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet15, UitkSheetCloseButton as UitkSheetCloseButton2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing62 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading25, UitkText as UitkText43 } from "uitk-react-text";
var __ExperienceScorePopoverFragment = gql139(_templateObject140());
var ExperienceScorePopover = function(param) {
    var data = param.data, isVisible = param.isVisible, triggerRef = param.triggerRef, toggleVisibility = param.toggleVisibility;
    var _seeMoreAction_content, _seeMoreAction_trigger, _seeMoreAction_trigger1, _seeMoreAction_dialog;
    var seeMoreAction = data.seeMoreAction;
    var dialogContents = seeMoreAction === null || seeMoreAction === void 0 ? void 0 : (_seeMoreAction_content = seeMoreAction.content) === null || _seeMoreAction_content === void 0 ? void 0 : _seeMoreAction_content.contents;
    var dialogTitle = seeMoreAction === null || seeMoreAction === void 0 ? void 0 : (_seeMoreAction_trigger = seeMoreAction.trigger) === null || _seeMoreAction_trigger === void 0 ? void 0 : _seeMoreAction_trigger.message;
    var triggerAnalytics = seeMoreAction === null || seeMoreAction === void 0 ? void 0 : (_seeMoreAction_trigger1 = seeMoreAction.trigger) === null || _seeMoreAction_trigger1 === void 0 ? void 0 : _seeMoreAction_trigger1.analytics;
    var closeAnalytics = seeMoreAction === null || seeMoreAction === void 0 ? void 0 : (_seeMoreAction_dialog = seeMoreAction.dialog) === null || _seeMoreAction_dialog === void 0 ? void 0 : _seeMoreAction_dialog.closeAnalytics;
    var track = useClickTracker41();
    var openCallback = React152.useCallback(function() {
        if (triggerAnalytics) {
            track(triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId, triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.linkName, true);
        }
    }, [
        track,
        triggerAnalytics
    ]);
    var closeCallback = React152.useCallback(function() {
        if (closeAnalytics) {
            track(closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.referrerId, closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.linkName, true);
        }
    }, [
        track,
        closeAnalytics
    ]);
    if (!dialogTitle || !(dialogContents === null || dialogContents === void 0 ? void 0 : dialogContents.length)) {
        return null;
    }
    var _dialogContents = _slicedToArray(dialogContents, 1), dialogContent = _dialogContents[0];
    return /* @__PURE__ */ React152.createElement(UitkSheet15, {
        width: 260,
        isVisible: isVisible,
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: toggleVisibility,
        openCallback: openCallback,
        closeCallback: closeCallback
    }, /* @__PURE__ */ React152.createElement(UitkLayoutFlex38, null, /* @__PURE__ */ React152.createElement(UitkSpacing62, {
        padding: {
            blockstart: "six",
            inlinestart: "six",
            blockend: "six",
            inlineend: "two"
        }
    }, /* @__PURE__ */ React152.createElement(UitkLayoutFlexItem30, null, /* @__PURE__ */ React152.createElement("div", null, /* @__PURE__ */ React152.createElement(UitkSpacing62, {
        margin: {
            blockend: "four"
        },
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React152.createElement(UitkHeading25, {
        size: 7,
        tag: "h4"
    }, dialogTitle)), /* @__PURE__ */ React152.createElement(UitkText43, {
        size: 300
    }, dialogContent === null || dialogContent === void 0 ? void 0 : dialogContent.text)))), /* @__PURE__ */ React152.createElement(UitkLayoutFlexItem30, null, /* @__PURE__ */ React152.createElement(UitkSheetCloseButton2, null, /* @__PURE__ */ React152.createElement(UitkSpacing62, {
        margin: {
            inlineend: "half"
        }
    }, /* @__PURE__ */ React152.createElement(UitkTertiaryButton5, {
        onClick: toggleVisibility
    }, /* @__PURE__ */ React152.createElement(UitkIcon26, {
        name: "close",
        size: UitkIconSize15.LARGE
    })))))));
};
ExperienceScorePopover.displayName = "ExperienceScorePopover";
ExperienceScorePopover.fragment = __ExperienceScorePopoverFragment;
// src/components/summary/__private/__fragments/experience-score/experience-score-reviews.tsx
import React153 from "react";
import { gql as gql140 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker8, useClickTracker as useClickTracker42 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex39, UitkLayoutFlexItem as UitkLayoutFlexItem31 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink16 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing63 } from "uitk-react-spacing";
import { UitkSubheading as UitkSubheading5, UitkText as UitkText44 } from "uitk-react-text";
var __ExperienceScoreReviewsFragment = gql140(_templateObject141());
var ExperienceScoreReviews = function(param) {
    var data = param.data, onClickReviews = param.onClickReviews, triggerRef = param.triggerRef;
    var _highlightMessage_subtitle;
    var experienceScoreReviewInfo = data.experienceScoreReviewInfo;
    var summary = experienceScoreReviewInfo === null || experienceScoreReviewInfo === void 0 ? void 0 : experienceScoreReviewInfo.summary;
    var _ref = summary || {}, averageOverallRating = _ref.averageOverallRating, overallScoreWithDescriptionA11y = _ref.overallScoreWithDescriptionA11y, propertyReviewCountDetails = _ref.propertyReviewCountDetails, highlightMessage = _ref.highlightMessage;
    var track = useClickTracker42();
    var handleClick = React153.useCallback(function() {
        var _SummaryAnalyticsMapping_REVIEWS = _slicedToArray(SummaryAnalyticsMapping["REVIEWS" /* REVIEWS */ ], 2), id = _SummaryAnalyticsMapping_REVIEWS[0], description = _SummaryAnalyticsMapping_REVIEWS[1];
        track(id, description, true);
        onClickReviews();
    }, [
        onClickReviews,
        track
    ]);
    if (!averageOverallRating && !overallScoreWithDescriptionA11y && !propertyReviewCountDetails && !highlightMessage) {
        return null;
    }
    return /* @__PURE__ */ React153.createElement(React153.Fragment, null, /* @__PURE__ */ React153.createElement(UitkLayoutFlex39, null, /* @__PURE__ */ React153.createElement(IntersectionTracker8, {
        trackOnce: true,
        referrerId: "HOT.HIS.GuestReviewScore.".concat(averageOverallRating === null || averageOverallRating === void 0 ? void 0 : averageOverallRating.formatted),
        linkName: "Guest review score view impression.",
        intersectionOptions: {
            threshold: 1
        }
    }, /* @__PURE__ */ React153.createElement(UitkLayoutFlexItem31, null, /* @__PURE__ */ React153.createElement(UitkText44, {
        weight: "medium"
    }, overallScoreWithDescriptionA11y === null || overallScoreWithDescriptionA11y === void 0 ? void 0 : overallScoreWithDescriptionA11y.value))), /* @__PURE__ */ React153.createElement(UitkSpacing63, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React153.createElement(UitkLayoutFlexItem31, null, /* @__PURE__ */ React153.createElement("div", null, /* @__PURE__ */ React153.createElement(UitkLink16, {
        onClick: handleClick,
        domRef: triggerRef
    }, /* @__PURE__ */ React153.createElement("button", {
        type: "button"
    }, propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))))), /* @__PURE__ */ React153.createElement(UitkSpacing63, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React153.createElement(UitkSubheading5, {
        tag: "h4"
    }, highlightMessage === null || highlightMessage === void 0 ? void 0 : (_highlightMessage_subtitle = highlightMessage.subtitle) === null || _highlightMessage_subtitle === void 0 ? void 0 : _highlightMessage_subtitle.text)));
};
ExperienceScoreReviews.displayName = "ExperienceScoreReviews";
ExperienceScoreReviews.fragment = __ExperienceScoreReviewsFragment;
// src/components/summary/__private/__fragments/experience-score/index.tsx
var __SummaryExperienceScoreFragment = gql141(_templateObject142(), ExperienceScorePopover.fragment, ExperienceScoreReviews.fragment, SummaryReviews.fragment);
var SummaryExperienceScore = function(param) {
    var onClickReviews = param.onClickReviews, data = param.data, _param_showExperienceScoreReviews = param.showExperienceScoreReviews, showExperienceScoreReviews = _param_showExperienceScoreReviews === void 0 ? false : _param_showExperienceScoreReviews, _param_border = param.border, border = _param_border === void 0 ? false : _param_border, _param_padded = param.padded, padded = _param_padded === void 0 ? false : _param_padded, triggerReviewRef = param.triggerReviewRef;
    var _experienceScoreData_header, _experienceScoreData_header_impressionAnalytics, _experienceScoreData_header1, _experienceScoreData_header_impressionAnalytics1, _experienceScoreData_header2, _experienceScoreData_header3;
    var experienceScoreData = data === null || data === void 0 ? void 0 : data.experienceScore;
    var triggerRef = React154.createRef();
    var _useState5 = _slicedToArray(useState5(false), 2), isPopoverVisible = _useState5[0], setIsPopoveVisible = _useState5[1];
    var togglePopoverVisibility = function() {
        setIsPopoveVisible(!isPopoverVisible);
    };
    if (!experienceScoreData) {
        return /* @__PURE__ */ React154.createElement(SummaryReviews, {
            data: data,
            onClickReviews: onClickReviews,
            triggerRef: triggerReviewRef
        });
    }
    return /* @__PURE__ */ React154.createElement(UitkLayoutGrid17, {
        columns: [
            MinMax("40x", "96x")
        ]
    }, /* @__PURE__ */ React154.createElement(UitkLayoutGridItem14, null, /* @__PURE__ */ React154.createElement(UitkLayoutPosition8, {
        type: "relative"
    }, /* @__PURE__ */ React154.createElement(UitkCard13, {
        border: border
    }, /* @__PURE__ */ React154.createElement(UitkSpacing64, {
        padding: padded ? "four" : "unset"
    }, /* @__PURE__ */ React154.createElement(UitkCardContentSection10, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlex40, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, null, /* @__PURE__ */ React154.createElement(IntersectionTracker9, {
        trackOnce: true,
        referrerId: "".concat(experienceScoreData === null || experienceScoreData === void 0 ? void 0 : (_experienceScoreData_header = experienceScoreData.header) === null || _experienceScoreData_header === void 0 ? void 0 : (_experienceScoreData_header_impressionAnalytics = _experienceScoreData_header.impressionAnalytics) === null || _experienceScoreData_header_impressionAnalytics === void 0 ? void 0 : _experienceScoreData_header_impressionAnalytics.referrerId),
        linkName: "".concat(experienceScoreData === null || experienceScoreData === void 0 ? void 0 : (_experienceScoreData_header1 = experienceScoreData.header) === null || _experienceScoreData_header1 === void 0 ? void 0 : (_experienceScoreData_header_impressionAnalytics1 = _experienceScoreData_header1.impressionAnalytics) === null || _experienceScoreData_header_impressionAnalytics1 === void 0 ? void 0 : _experienceScoreData_header_impressionAnalytics1.event),
        intersectionOptions: {
            threshold: 1
        }
    }, /* @__PURE__ */ React154.createElement(UitkCard13, {
        border: true
    }, /* @__PURE__ */ React154.createElement(UitkSpacing64, {
        padding: "two"
    }, /* @__PURE__ */ React154.createElement(UitkText45, {
        size: 500
    }, experienceScoreData === null || experienceScoreData === void 0 ? void 0 : (_experienceScoreData_header2 = experienceScoreData.header) === null || _experienceScoreData_header2 === void 0 ? void 0 : _experienceScoreData_header2.label))))), /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, {
        alignSelf: "center"
    }, /* @__PURE__ */ React154.createElement(UitkSpacing64, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React154.createElement(UitkLayoutFlex40, {
        direction: "column"
    }, /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlex40, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, {
        alignSelf: "center"
    }, /* @__PURE__ */ React154.createElement(UitkText45, {
        size: 500,
        weight: "medium"
    }, experienceScoreData === null || experienceScoreData === void 0 ? void 0 : (_experienceScoreData_header3 = experienceScoreData.header) === null || _experienceScoreData_header3 === void 0 ? void 0 : _experienceScoreData_header3.text)), /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, null, /* @__PURE__ */ React154.createElement(UitkSpacing64, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React154.createElement(UitkTertiaryButton6, {
        domRef: triggerRef,
        onClick: togglePopoverVisibility,
        size: UitkButtonSize3.SMALL
    }, /* @__PURE__ */ React154.createElement(UitkIcon27, {
        name: "info",
        className: "uitk-layout-position-pointerevents-none"
    })))))), showExperienceScoreReviews && /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem32, null, /* @__PURE__ */ React154.createElement(ExperienceScoreReviews, {
        data: data,
        onClickReviews: onClickReviews,
        triggerRef: triggerReviewRef
    }))))))))), /* @__PURE__ */ React154.createElement(ExperienceScorePopover, {
        data: experienceScoreData,
        isVisible: isPopoverVisible,
        triggerRef: triggerRef,
        toggleVisibility: togglePopoverVisibility
    }), !showExperienceScoreReviews && /* @__PURE__ */ React154.createElement(UitkSpacing64, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React154.createElement(SummaryReviews, {
        data: data,
        onClickReviews: onClickReviews,
        triggerRef: triggerReviewRef
    })))));
};
SummaryExperienceScore.displayName = "SummaryExperienceScore";
SummaryExperienceScore.fragment = __SummaryExperienceScoreFragment;
// src/components/summary/__private/__fragments/geo/index.tsx
import React155 from "react";
import { gql as gql142 } from "@apollo/client";
import { ViewLarge as ViewLarge13, ViewMedium as ViewMedium9, Viewport as Viewport19, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType9 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex41, UitkLayoutFlexItem as UitkLayoutFlexItem33 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing65 } from "uitk-react-spacing";
var __SummaryGeoFragment = gql142(_templateObject143(), SummaryMapTrigger.fragment, SummaryNearByPois.fragment);
var SummaryGeo = function(param) {
    var data = param.data, onClickMap = param.onClickMap;
    var _data_summary, _data_summary_location, _data_summary1, _data_summary_location1;
    var areMapsEnabled = ((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_location = _data_summary.location) === null || _data_summary_location === void 0 ? void 0 : _data_summary_location.staticImage) && ((_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_location1 = _data_summary1.location) === null || _data_summary_location1 === void 0 ? void 0 : _data_summary_location1.mapDialog);
    return /* @__PURE__ */ React155.createElement(Viewport19, null, /* @__PURE__ */ React155.createElement(ViewSmall19, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex41, {
        direction: "column",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType9.R21_9
    }))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))), /* @__PURE__ */ React155.createElement(ViewMedium9, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex41, {
        direction: "row",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType9.R21_9
    }))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))), /* @__PURE__ */ React155.createElement(ViewLarge13, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex41, {
        direction: "column"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, null, /* @__PURE__ */ React155.createElement(UitkSpacing65, {
        padding: {
            large: {
                blockend: "six"
            }
        }
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType9.R16_9
    })))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem33, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))));
};
SummaryGeo.displayName = "SummaryGeo";
SummaryGeo.fragment = __SummaryGeoFragment;
// src/components/summary/summary-fragment.ts
import { gql as gql143 } from "@apollo/client";
var __SummaryFragment = gql143(_templateObject144(), SummaryAmenities.fragment, SummaryHeader.fragment, SummaryMapTrigger.fragment, SummaryNearByPois.fragment, SummaryReviews.fragment, SummaryBannerMessage.fragment, SummaryChatbotLaunch.fragment, LocationHighlights.fragment, RelevantAmenities.fragment, SummaryExperienceScore.fragment);
// src/components/summary/summary.tsx
var CarouselComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React156.createElement(React156.Fragment, null, children);
};
var HighlightedBenefitsComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React156.createElement(React156.Fragment, null, children);
};
var Summary = function(param) {
    var data = param.data, onClickReviews = param.onClickReviews, onClickMap = param.onClickMap, children = param.children, triggerRef = param.triggerRef, _param_overrideTag = param.overrideTag, overrideTag = _param_overrideTag === void 0 ? false : _param_overrideTag;
    var _searchCriteria_secondary;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyId = _usePropertyDetailsInputs.propertyId, searchCriteria = _usePropertyDetailsInputs.searchCriteria;
    var searchCriteriaSelections = (searchCriteria === null || searchCriteria === void 0 ? void 0 : (_searchCriteria_secondary = searchCriteria.secondary) === null || _searchCriteria_secondary === void 0 ? void 0 : _searchCriteria_secondary.selections) || [];
    return /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        margin: {
            blockend: "three"
        },
        padding: {
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React156.createElement(UitkCard14, {
        className: "uitk-flat-border-top"
    }, /* @__PURE__ */ React156.createElement(UitkCardContentSection11, null, /* @__PURE__ */ React156.createElement(UitkLayoutGrid18, {
        columns: {
            small: 1,
            medium: 1,
            large: 12
        }
    }, /* @__PURE__ */ React156.createElement(UitkLayoutGridItem15, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 8
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            large: {
                inlineend: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            small: {
                blockend: "four"
            },
            large: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", {
        "data-stid": "content-hotel-title"
    }, /* @__PURE__ */ React156.createElement(SummaryHeader, {
        data: data,
        overrideTag: overrideTag
    }))), findReactChildByType(children, HighlightedBenefitsComponent), /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryBannerMessage, {
        data: data
    })), /* @__PURE__ */ React156.createElement(Experiment7, {
        name: "MPD_Traveler_GEX_Score_Web"
    }, /* @__PURE__ */ React156.createElement(ExperimentControl7, null, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryReviews, {
        data: data,
        onClickReviews: onClickReviews,
        triggerRef: triggerRef
    }))), /* @__PURE__ */ React156.createElement(ExperimentVariant7, {
        bucket: 1
    }, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryReviews, {
        data: data,
        onClickReviews: onClickReviews,
        triggerRef: triggerRef
    }))), /* @__PURE__ */ React156.createElement(ExperimentVariant7, {
        bucket: 2
    }, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(SummaryExperienceScore, {
        data: data,
        onClickReviews: onClickReviews
    })))), /* @__PURE__ */ React156.createElement(ExperimentVariant7, {
        bucket: 3
    }, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(SummaryExperienceScore, {
        data: data,
        onClickReviews: onClickReviews,
        showExperienceScoreReviews: true,
        border: true,
        padded: true
    }))))), /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(LocationHighlights, {
        data: data
    })), findReactChildByType(children, CarouselComponent), /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryAmenities, {
        data: data
    })), /* @__PURE__ */ React156.createElement(Experiment7, {
        name: "Amenity_Module_Web_"
    }, /* @__PURE__ */ React156.createElement(ExperimentControl7, null), /* @__PURE__ */ React156.createElement(ExperimentVariant7, {
        bucket: 1
    }, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(RelevantContent, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType2.PROPERTY_ID,
                searchCriteriaSelections: searchCriteriaSelections
            }
        }
    }))))))))), /* @__PURE__ */ React156.createElement(UitkLayoutGridItem15, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 4
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        margin: {
            large: {
                inlinestart: "three",
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(SummaryGeo, {
        data: data,
        onClickMap: onClickMap
    })))))), /* @__PURE__ */ React156.createElement(UitkSpacing66, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React156.createElement(RelevantAmenities, {
        data: data
    })))));
};
Summary.displayName = "Summary";
Summary.fragment = __SummaryFragment;
// src/components/summary/placeholder.tsx
import React157 from "react";
import { UitkCard as UitkCard15, UitkCardContentSection as UitkCardContentSection12 } from "uitk-react-cards";
import { UitkLineSkeleton as UitkLineSkeleton6 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing67 } from "uitk-react-spacing";
var SummaryPlaceholder = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React157.createElement(UitkSpacing67, {
        margin: {
            blockend: "three"
        },
        padding: {
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React157.createElement(UitkCard15, {
        className: "uitk-flat-border-top"
    }, /* @__PURE__ */ React157.createElement(UitkCardContentSection12, null, /* @__PURE__ */ React157.createElement(UitkSpacing67, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React157.createElement("div", null, /* @__PURE__ */ React157.createElement(SummaryHeaderPlaceholder, {
        data: data
    }))), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null))));
};
var SummaryComponentPlaceholder = function() {
    return /* @__PURE__ */ React157.createElement(UitkSpacing67, {
        margin: {
            blockstart: "three"
        },
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React157.createElement("div", null, /* @__PURE__ */ React157.createElement(UitkSpacing67, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React157.createElement(UitkLineSkeleton6, {
        animation: false,
        type: "primary"
    })), /* @__PURE__ */ React157.createElement(UitkLineSkeleton6, {
        animation: false,
        type: "secondary"
    })));
};
// src/components/whats-around/whats-around.tsx
import React164 from "react";
import { gql as gql150 } from "@apollo/client";
import { UitkCard as UitkCard17, UitkCardContentSection as UitkCardContentSection14 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid19, UitkLayoutGridItem as UitkLayoutGridItem16 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing73 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading28 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
import React159 from "react";
import { gql as gql145 } from "@apollo/client";
import { UitkSpacing as UitkSpacing69 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading26, UitkText as UitkText46 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-link.tsx
import React158 from "react";
import { gql as gql144 } from "@apollo/client";
import { useClickTracker as useClickTracker43 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium10, Viewport as Viewport20, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon28 } from "uitk-react-icons";
import { UitkLink as UitkLink17 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing68 } from "uitk-react-spacing";
var __WhatsAroundLinkFragment = gql144(_templateObject145());
var WhatsAroundLink = function(param) {
    var data = param.data, index = param.index;
    var _data_link, _data_link_uri;
    var track = useClickTracker43();
    if (!(data === null || data === void 0 ? void 0 : data.value) || !(data === null || data === void 0 ? void 0 : (_data_link = data.link) === null || _data_link === void 0 ? void 0 : (_data_link_uri = _data_link.uri) === null || _data_link_uri === void 0 ? void 0 : _data_link_uri.value)) {
        return null;
    }
    var handleClick = function() {
        if (data.link.clientSideAnalytics) {
            track(data.link.clientSideAnalytics.referrerId, data.link.clientSideAnalytics.linkName);
        }
    };
    var text = data.value;
    var linkUrl = data.link.uri.value;
    var icon = data.icon;
    return /* @__PURE__ */ React158.createElement(Viewport20, null, /* @__PURE__ */ React158.createElement(ViewSmall20, null, /* @__PURE__ */ React158.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick
    }, text)), /* @__PURE__ */ React158.createElement(ViewMedium10, null, /* @__PURE__ */ React158.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick,
        target: "_blank"
    }, text, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React158.createElement(UitkIcon28, {
        id: "".concat(icon.id, "-").concat(index),
        name: icon.id,
        title: icon.description
    }))));
};
WhatsAroundLink.displayName = "WhatsAroundLink";
WhatsAroundLink.fragment = __WhatsAroundLinkFragment;
var Link = function(_param) /* @__PURE__ */ {
    var href = _param.href, target = _param.target, children = _param.children, props = _objectWithoutProperties(_param, [
        "href",
        "target",
        "children"
    ]);
    return React158.createElement(UitkSpacing68, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React158.createElement(UitkLink17, _objectSpread({}, props), /* @__PURE__ */ React158.createElement("a", {
        href: href,
        target: target
    }, children)));
};
var whats_around_link_default = WhatsAroundLink;
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
var __WhatsAroundEditorialFragment = gql145(_templateObject146(), whats_around_link_default.fragment);
var WhatsAroundEditorial = function(param) {
    var data = param.data;
    if (!data || !data.content || data.content.length <= 0) {
        return null;
    }
    var title = data.title, crossLinks = data.crossLinks, contentList = data.content;
    var content = contentList[0];
    return /* @__PURE__ */ React159.createElement("section", null, title && /* @__PURE__ */ React159.createElement(UitkHeading26, {
        tag: "h3",
        size: 5
    }, title), content && /* @__PURE__ */ React159.createElement(React159.Fragment, null, /* @__PURE__ */ React159.createElement(UitkSpacing69, {
        padding: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React159.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "https://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React159.createElement("meta", {
        itemProp: "description",
        content: content
    }), /* @__PURE__ */ React159.createElement(UitkText46, {
        size: 300
    }, content))), crossLinks === null || crossLinks === void 0 ? void 0 : crossLinks.map(function(crossLink, index) {
        return /* @__PURE__ */ React159.createElement(UitkSpacing69, {
            padding: {
                blockend: "two"
            },
            key: index
        }, /* @__PURE__ */ React159.createElement("div", null, /* @__PURE__ */ React159.createElement(whats_around_link_default, {
            data: crossLink,
            index: index
        })));
    })));
};
WhatsAroundEditorial.displayName = "WhatsAroundEditorial";
WhatsAroundEditorial.fragment = __WhatsAroundEditorialFragment;
// src/components/whats-around/__private/__fragments/whats-around-map.tsx
import React160 from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql146 } from "@apollo/client";
import { useClickTracker as useClickTracker44 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { Experiment as Experiment8, ExperimentControl as ExperimentControl8, ExperimentVariant as ExperimentVariant8 } from "@shared-ui/experiment-context";
import { UitkCard as UitkCard16, UitkCardContentSection as UitkCardContentSection13, UitkCardLink as UitkCardLink3 } from "uitk-react-cards";
import { UitkFigure as UitkFigure9, UitkFigureAspectRatioType as UitkFigureAspectRatioType10, UitkImage as UitkImage7 } from "uitk-react-images";
import { UitkLink as UitkLink18 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing70 } from "uitk-react-spacing";
var __WhatsAroundMapFragment = gql146(_templateObject147());
var WhatsAroundMap = function(param) {
    var data = param.data, mapCTALabel = param.mapCTALabel, propertyId = param.propertyId;
    var _useDialog13 = _slicedToArray(useDialog13("whats-around-map"), 3), mapDialogActions = _useDialog13[1], MapDialogWrapper = _useDialog13[2];
    var mapTriggerRef = React160.useRef(null);
    var _ref = (data === null || data === void 0 ? void 0 : data.staticImage) || {}, description = _ref.description, url = _ref.url;
    var hasMapCTALabel = Boolean(mapCTALabel);
    var track = useClickTracker44();
    var handleMapTrigger = React160.useCallback(function(id, desc) {
        return function(e) {
            e.preventDefault();
            track(id, desc);
            mapDialogActions.openDialog();
        };
    }, [
        track,
        mapDialogActions
    ]);
    var closeMapDialog = React160.useCallback(function() {
        mapDialogActions.closeDialog();
    }, [
        mapDialogActions
    ]);
    return /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(MapDialogWrapper, null, /* @__PURE__ */ React160.createElement(Experiment8, {
        name: "EG_Maps_PDP_schema_update"
    }, /* @__PURE__ */ React160.createElement(ExperimentControl8, null, /* @__PURE__ */ React160.createElement(PropertyDetailsMap, {
        inputs: {
            propertyId: propertyId
        },
        onClose: closeMapDialog,
        triggerRef: mapTriggerRef
    })), /* @__PURE__ */ React160.createElement(ExperimentVariant8, {
        bucket: 1
    }, /* @__PURE__ */ React160.createElement(Map, {
        inputs: {
            propertyId: propertyId
        },
        onClose: closeMapDialog,
        triggerRef: mapTriggerRef
    })))), /* @__PURE__ */ React160.createElement(UitkSpacing70, {
        margin: {
            blockend: "six"
        },
        "data-stid": "whats-around-map"
    }, /* @__PURE__ */ React160.createElement(UitkCard16, {
        border: hasMapCTALabel
    }, /* @__PURE__ */ React160.createElement(UitkCardContentSection13, {
        padded: false
    }, /* @__PURE__ */ React160.createElement(LazyLoad, {
        height: 100
    }, /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement("h3", {
        className: "is-visually-hidden"
    }, description), /* @__PURE__ */ React160.createElement(UitkFigure9, {
        ratio: UitkFigureAspectRatioType10.R21_9
    }, /* @__PURE__ */ React160.createElement(UitkImage7, {
        alt: "",
        src: url || ""
    }))))), /* @__PURE__ */ React160.createElement(UitkCardLink3, null, /* @__PURE__ */ React160.createElement("section", {
        className: "uitk-button",
        onClickCapture: handleMapTrigger("HOT.HIS:WhatsAroundMap.Open", "Launch dynamic map")
    }, description)), mapCTALabel && /* @__PURE__ */ React160.createElement(UitkCardContentSection13, {
        className: "uitk-type-300 uitk-type-center"
    }, /* @__PURE__ */ React160.createElement(UitkCardLink3, null, /* @__PURE__ */ React160.createElement("button", {
        ref: mapTriggerRef,
        type: "button",
        onClickCapture: handleMapTrigger("WhatsAroundMap.ClickLinkViewMap", "Launch dynamic map")
    }, mapCTALabel)), /* @__PURE__ */ React160.createElement(UitkLink18, {
        inline: true
    }, /* @__PURE__ */ React160.createElement("button", {
        type: "button"
    }, mapCTALabel))))));
};
WhatsAroundMap.displayName = "WhatsAroundMap";
WhatsAroundMap.fragment = __WhatsAroundMapFragment;
var whats_around_map_default = WhatsAroundMap;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
import React163 from "react";
import { gql as gql149 } from "@apollo/client";
import { UitkLayoutColumns as UitkLayoutColumns2, UitkLayoutColumnsItem as UitkLayoutColumnsItem2 } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex42, UitkLayoutFlexItem as UitkLayoutFlexItem34 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing72 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading27 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-icon.tsx
import React161 from "react";
import { gql as gql147 } from "@apollo/client";
import { UitkIcon as UitkIcon29 } from "uitk-react-icons";
var __WhatsAroundIconFragment = gql147(_templateObject148());
var WhatsAroundIcon = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var icon = data.iconId;
    return /* @__PURE__ */ React161.createElement(UitkIcon29, {
        id: "".concat(icon, "-icon"),
        name: icon
    });
};
WhatsAroundIcon.displayName = "WhatsAroundIcon";
WhatsAroundIcon.fragment = __WhatsAroundIconFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois-item.tsx
import React162 from "react";
import { gql as gql148 } from "@apollo/client";
import { UitkList as UitkList6, UitkListItem as UitkListItem4 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing71 } from "uitk-react-spacing";
import { UitkText as UitkText47 } from "uitk-react-text";
var __WhatsAroundPoisItemFragment = gql148(_templateObject149(), WhatsAroundIcon.fragment);
var WhatsAroundPoisItem = function(param) {
    var data = param.data, hideIcon = param.hideIcon;
    var bullet = hideIcon ? "no-bullet" : "icon-standard";
    return /* @__PURE__ */ React162.createElement(UitkSpacing71, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React162.createElement(UitkList6, {
        bullet: bullet,
        spacing: false
    }, data.items.map(function(item, idx) {
        return /* @__PURE__ */ React162.createElement(UitkListItem4, {
            key: "whats-around-pois-list-".concat(idx)
        }, !hideIcon && /* @__PURE__ */ React162.createElement(WhatsAroundIcon, {
            data: item.icon
        }), /* @__PURE__ */ React162.createElement(UitkText47, null, item.text, item.moreInfo && " - ".concat(item.moreInfo)));
    })));
};
WhatsAroundPoisItem.displayName = "WhatsAroundPoisItem";
WhatsAroundPoisItem.fragment = __WhatsAroundPoisItemFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
var __WhatsAroundPoisFragment = gql149(_templateObject150(), WhatsAroundIcon.fragment, WhatsAroundPoisItem.fragment);
var sortAndByIcon = function(poisType) {
    return poisType.reduce(function(sortedList, item) {
        var _item_icon;
        var newSortedList = _toConsumableArray(sortedList);
        switch((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.iconId){
            case "place":
                newSortedList[0] = item;
                break;
            case "lob_cars":
                newSortedList[1] = item;
                break;
            case "local_dining":
                newSortedList[2] = item;
                break;
            default:
                newSortedList.push(item);
                break;
        }
        return newSortedList;
    }, []);
};
var WhatsAroundPois = function(param) {
    var data = param.data;
    if (!data || !data.nearbyPOIs || data.nearbyPOIs.length <= 0) {
        return null;
    }
    var sortedPois = sortAndByIcon(data.nearbyPOIs);
    return /* @__PURE__ */ React163.createElement(UitkLayoutColumns2, {
        columns: 2,
        minWidth: "seventy_two"
    }, sortedPois.map(function(section, idx) {
        return /* @__PURE__ */ React163.createElement(WhatsAroundPoiSection, _objectSpreadProps(_objectSpread({}, section), {
            key: idx
        }));
    }));
};
var WhatsAroundPoiSection = function(props) {
    var title = props.title, items = props.items, icon = props.icon;
    if (!title || !items || !items.length) {
        return null;
    }
    var hideIcon = (icon === null || icon === void 0 ? void 0 : icon.iconId) !== "lob_cars";
    return /* @__PURE__ */ React163.createElement(UitkLayoutColumnsItem2, {
        forceNoBreak: true
    }, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(UitkSpacing72, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React163.createElement(UitkLayoutFlex42, {
        space: "three"
    }, /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem34, null, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(WhatsAroundIcon, {
        data: icon
    }))), /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem34, null, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(UitkHeading27, {
        tag: "h4",
        size: 5
    }, title), /* @__PURE__ */ React163.createElement(WhatsAroundPoisItem, {
        data: props,
        hideIcon: hideIcon
    })))))));
};
WhatsAroundPois.displayName = "WhatsAroundPois";
WhatsAroundPois.fragment = __WhatsAroundPoisFragment;
// src/components/whats-around/whats-around.tsx
var __WhatsAroundFragment = gql150(_templateObject151(), WhatsAroundEditorial.fragment, WhatsAroundPois.fragment, whats_around_map_default.fragment);
var WhatsAround = function(props) {
    var _data_summary, _data_summary_map, _data_summary1, _data_summary2;
    var data = props.data;
    var mapProps = {
        mapCTALabel: data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = ((data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.location) || {
        whatsAround: null
    }).whatsAround;
    if (!data || !whatsAround) {
        return null;
    }
    return /* @__PURE__ */ React164.createElement(UitkSpacing73, {
        padding: {
            small: {
                block: "six",
                inline: "three"
            },
            large: {
                block: "six",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React164.createElement(UitkCard17, null, /* @__PURE__ */ React164.createElement(UitkCardContentSection14, null, /* @__PURE__ */ React164.createElement(UitkLayoutGrid19, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React164.createElement(UitkLayoutGridItem16, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 1
        }
    }, /* @__PURE__ */ React164.createElement("div", null, /* @__PURE__ */ React164.createElement(UitkSpacing73, {
        padding: {
            inlineend: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React164.createElement(UitkHeading28, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, whatsAround.title)), /* @__PURE__ */ React164.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))), /* @__PURE__ */ React164.createElement(UitkLayoutGridItem16, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 2
        }
    }, /* @__PURE__ */ React164.createElement("div", null, ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map) && /* @__PURE__ */ React164.createElement(whats_around_map_default, _objectSpread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React164.createElement(WhatsAroundPois, {
        data: whatsAround
    })))))));
};
WhatsAround.displayName = "WhatsAround";
WhatsAround.fragment = __WhatsAroundFragment;
// src/components/whats-around/whats-around-pois-view.tsx
import React165 from "react";
import { ViewLarge as ViewLarge14, Viewport as Viewport21, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard18, UitkCardContentSection as UitkCardContentSection15 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid20, UitkLayoutGridItem as UitkLayoutGridItem17 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing74 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading29 } from "uitk-react-text";
var WhatsAroundPoisView = function(param) {
    var data = param.data;
    var _data_summary, _data_summary_map, _data_summary1, _data_summary2;
    var mapProps = {
        mapCTALabel: data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = ((data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.location) || {
        whatsAround: null
    }).whatsAround;
    if (!data || !whatsAround) {
        return null;
    }
    var poisColumn = /* @__PURE__ */ React165.createElement(UitkLayoutGridItem17, {
        colSpan: 1
    }, /* @__PURE__ */ React165.createElement("div", null, /* @__PURE__ */ React165.createElement(UitkSpacing74, {
        padding: {
            inlineend: "three",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React165.createElement(UitkHeading29, {
        tag: "h2",
        size: 4
    }, whatsAround.title)), /* @__PURE__ */ React165.createElement(WhatsAroundPois, {
        data: whatsAround
    })));
    return /* @__PURE__ */ React165.createElement(React165.Fragment, null, /* @__PURE__ */ React165.createElement(Viewport21, null, /* @__PURE__ */ React165.createElement(ViewSmall21, null, whatsAround.nearbyPOIs.length > 0 ? /* @__PURE__ */ React165.createElement(UitkSpacing74, {
        padding: {
            block: "six",
            inline: "three"
        }
    }, /* @__PURE__ */ React165.createElement(UitkCard18, null, /* @__PURE__ */ React165.createElement(UitkCardContentSection15, null, /* @__PURE__ */ React165.createElement(UitkLayoutGrid20, {
        columns: 1,
        space: "six"
    }, poisColumn)))) : /* @__PURE__ */ React165.createElement(React165.Fragment, null)), /* @__PURE__ */ React165.createElement(ViewLarge14, null, /* @__PURE__ */ React165.createElement(UitkSpacing74, {
        padding: {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React165.createElement(UitkCard18, null, /* @__PURE__ */ React165.createElement(UitkCardContentSection15, null, /* @__PURE__ */ React165.createElement(UitkLayoutGrid20, {
        columns: 2,
        space: "six"
    }, poisColumn, /* @__PURE__ */ React165.createElement(UitkLayoutGridItem17, {
        colSpan: 1
    }, /* @__PURE__ */ React165.createElement("div", null, ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map) && /* @__PURE__ */ React165.createElement(WhatsAroundMap, _objectSpread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React165.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))))))))));
};
WhatsAroundPoisView.displayName = "WhatsAroundPoisView";
WhatsAroundPoisView.fragment = __WhatsAroundFragment;
// src/components/property-details.tsx
var __Query7 = gql151(_templateObject152(), AmenityDescription.fragment, Policies.fragment, DetailedAmenities.fragment, ImportantInfo.fragment, FrequentlyAskedQuestions.fragment, NavigationBar.fragment, AboutThisProperty.fragment, WhatsAround.fragment, Gallery.fragment, BookByPhone.fragment, __SummaryFragment, SpaceOverview.fragment, InventorySource.fragment, Shortlist.fragment, SaveTripItem.fragment, AmenitiesSimplifiedView.fragment, RelevantAmenities.fragment, SpecialFeatures.fragment, LocationHighlights.fragment, HostProfile.fragment, PropertyDirectFeedbackPromptIdFragment);
function withPropertyDetailsQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertyDetailsComponent = function(props) {
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi13().context;
        var _inputs_isDateless;
        var variables = _objectSpreadProps(_objectSpread({
            context: context
        }, inputs || {}), {
            isDateless: (_inputs_isDateless = inputs.isDateless) !== null && _inputs_isDateless !== void 0 ? _inputs_isDateless : true
        });
        var _useQuery10 = useQuery10(__Query7, {
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery10.data, loading = _useQuery10.loading;
        var propertyInfo = data === null || data === void 0 ? void 0 : data.propertyInfo;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React166.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React166.createElement(InputsContext.Provider, {
            value: inputs
        }, /* @__PURE__ */ React166.createElement(WrappedComponent, _objectSpread({
            data: propertyInfo
        }, props)));
    };
    PropertyDetailsComponent.displayName = displayName;
    return PropertyDetailsComponent;
}
var PropertyFaq = withPropertyDetailsQuery(FrequentlyAskedQuestions, "PropertyFaq");
var PropertyAmenityDescription = withPropertyDetailsQuery(AmenityDescription, "PropertyAmenityDescription");
var PropertyPolicies = withPropertyDetailsQuery(Policies, "PropertyPolicies");
var PropertyImportantInfo = withPropertyDetailsQuery(ImportantInfo, "PropertyImportantInfo");
var PropertySpecialFeatures = withPropertyDetailsQuery(SpecialFeatures, "PropertySpecialFeatures");
var PropertyNavigationBar = withPropertyDetailsQuery(NavigationBar, "PropertyNavigationBar", NavigationBarPlaceholder);
var PropertyAboutThisProperty = withPropertyDetailsQuery(AboutThisProperty, "PropertyAboutThisProperty");
var PropertyWhatsAround = withPropertyDetailsQuery(WhatsAround, "PropertyImportantInfo");
var PropertyWhatsAroundPoisView = withPropertyDetailsQuery(WhatsAroundPoisView, "PropertyImportantInfo");
var PropertyGallery = withPropertyDetailsQuery(Gallery, "PropertyGallery", GalleryPlaceholder);
var PropertyBookByPhone = withPropertyDetailsQuery(BookByPhone, "PropertyBookByPhone", BookByPhonePlaceholder);
var PropertySpaceOverview = withPropertyDetailsQuery(SpaceOverview, "PropertySpaceOverview");
var PropertyInventorySource = withPropertyDetailsQuery(InventorySource, "PropertyInventorySource");
var PropertyAmenitiesSimplifiedView = withPropertyDetailsQuery(AmenitiesSimplifiedView, "PropertyAmenitiesSimplifiedView");
var PropertyRelevantAmenities = withPropertyDetailsQuery(RelevantAmenities, "PropertyRelevantAmenities");
var PropertyLocationHighlights = withPropertyDetailsQuery(LocationHighlights, "PropertyLocationHighlights");
var PropertyHostProfile = withPropertyDetailsQuery(HostProfile, "PropertyHostProfile");
var PropertySummary = Object.assign(withPropertyDetailsQuery(Summary, "PropertySummary", SummaryPlaceholder), {
    CarouselComponent: CarouselComponent,
    HighlightedBenefitsComponent: HighlightedBenefitsComponent
});
var PropertySummaryHeader = withPropertyDetailsQuery(SummaryHeader, "PropertySummaryHeader", SummaryHeaderPlaceholder);
var PropertySummaryReviews = withPropertyDetailsQuery(SummaryReviews, "PropertySummaryReviews", SummaryComponentPlaceholder);
var PropertySummaryAmenities = withPropertyDetailsQuery(SummaryAmenities, "PropertySummaryAmenities", SummaryComponentPlaceholder);
var PropertyDetailedAmenities = withPropertyDetailsQuery(DetailedAmenities, "PropertyDetailedAmenities", SummaryComponentPlaceholder);
var PropertySummaryNearByPois = withPropertyDetailsQuery(SummaryNearByPois, "PropertySummaryNearByPois");
var PropertySummaryMapTrigger = withPropertyDetailsQuery(SummaryMapTrigger, "PropertySummaryMapTrigger");
var PropertySummaryChatbotLaunch = withPropertyDetailsQuery(SummaryChatbotLaunch, "PropertySummaryChatbotLaunch", SummaryComponentPlaceholder);
var PropertySummaryExperienceScore = withPropertyDetailsQuery(SummaryExperienceScore, "PropertySummaryExperienceScore");
var PropertyShortlist = withPropertyDetailsQuery(Shortlist, "PropertyShortlist");
var PropertySaveTripItem = withPropertyDetailsQuery(SaveTripItem, "PropertySaveTripItem");
var PropertyDirectFeedbackPromptId = withPropertyDetailsQuery(PropertyDirectFeedbackCallToAction, "PropertyDirectFeedbackPromptId");
var PropertySummaryGeo = withPropertyDetailsQuery(SummaryGeo, "PropertySummaryGeo");
var PropertySummaryBannerMessage = withPropertyDetailsQuery(SummaryBannerMessage, "PropertyBannerMessage");
export { GexModule, Map, PropertyAboutThisProperty, PropertyAmenitiesSimplifiedView, PropertyAmenityDescription, PropertyBookByPhone, PropertyCleanliness, PropertyDetailedAmenities, PropertyDetailsMap, PropertyDirectFeedbackPromptId, PropertyFaq, PropertyGallery, PropertyHostProfile, PropertyImportantInfo, PropertyInfoDetails, PropertyInventorySource, PropertyLocationHighlights, PropertyNavigationBar, PropertyPolicies, PropertyRelevantAmenities, PropertySaveTripItem, PropertyShortlist, PropertySimilar, PropertySpaceOverview, PropertySpaces, PropertySpecialFeatures, PropertySummary, PropertySummaryAmenities, PropertySummaryBannerMessage, PropertySummaryChatbotLaunch, PropertySummaryExperienceScore, PropertySummaryGeo, PropertySummaryHeader, PropertySummaryMapTrigger, PropertySummaryNearByPois, PropertySummaryReviews, PropertyWhatsAround, PropertyWhatsAroundPoisView }; /* istanbul ignore file -- @preserve */  // istanbul ignore next -- @preserve
 /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map